import { createElement } from 'react';

var SvgDAppsIcon = function SvgDAppsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "DApps_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M633.387 130.133a85.333 85.333 0 0 1 120.704 0L889.813 265.9a85.333 85.333 0 0 1 0 120.661L754.091 522.325a85.333 85.333 0 0 1-120.704 0L497.62 386.56a85.333 85.333 0 0 1 0-120.661l135.766-135.766zM829.483 326.23 693.76 190.464 557.995 326.229 693.76 461.995l135.765-135.766zM47.829 133.163h362.667V382.42a113.45 113.45 0 0 1-113.45 113.451H47.871V133.205zm85.334 85.333v192h163.882a28.117 28.117 0 0 0 28.16-28.075V218.453h-192zM47.829 570.837h249.216A113.45 113.45 0 0 1 410.54 684.288v249.216H47.872V570.837zm85.334 85.334v192h192V684.288a28.117 28.117 0 0 0-28.118-28.117h-163.84zm465.792 0a28.117 28.117 0 0 0-28.16 28.117v163.883h192v-192h-163.84zM485.46 684.288a113.45 113.45 0 0 1 113.494-113.45h249.173v362.666H485.461V684.288z"
  }));
};

var SvgImIcon = function SvgImIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "IM_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M42.667 262.656c0-99.03 73.6-177.323 162.133-177.323h614.4c88.533 0 162.133 78.294 162.133 177.323v498.688c0 99.03-73.6 177.323-162.133 177.323H204.8c-88.533 0-162.133-78.294-162.133-177.323V262.656zm85.333 0v498.688c0 46.08 34.39 83.456 76.8 83.456h614.4c42.41 0 76.8-37.376 76.8-83.456V262.656c0-46.08-34.39-83.456-76.8-83.456H204.8c-42.41 0-76.8 37.376-76.8 83.456zM446.677 363.52h100.651l69.248 185.6h3.456l69.248-185.6h100.693V691.2h-79.146V501.76h-2.347l-66.347 186.88h-47.701l-66.304-188.16h-2.347V691.2H446.72V363.52zM234.667 691.2v-56.79h44.416V420.268h-44.416V363.52h163.84v56.79H354.09v214.1h44.416v56.79h-163.84z"
  }));
};

var SvgQrCodeIcon = function SvgQrCodeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M2 5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Zm8 1a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3ZM5 13a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3H5Zm-1 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3Zm9-2a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v2.5H20V14a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V15H15v6a1 1 0 1 1-2 0v-7Zm4.5 6a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2h-3.5Z"
  }));
};

var getTheme = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColor0Risk = function SvgTwoColor0Risk(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme(props["data-theme"]),
    d: "M20.011 14.02a.739.739 0 0 1 .945 1.135l-4.474 4.024a2.699 2.699 0 0 1-1.805.693H10a1.75 1.75 0 0 0-1.75 1.75v.614a.75.75 0 0 0 1.5 0v-.614a.25.25 0 0 1 .25-.25h4.677a4.199 4.199 0 0 0 2.808-1.077l4.474-4.025c1.352-1.215.768-3.45-1.006-3.848a2.239 2.239 0 0 0-1.856.41l-3.81 2.93c.114-1.317-.898-2.612-2.396-2.612H8.118a4.796 4.796 0 0 0-4.706 3.878l-.115.588a2.54 2.54 0 0 0-.047.486v4.138a.75.75 0 0 0 1.5 0v-4.138c0-.067.006-.134.02-.2l.114-.587a3.296 3.296 0 0 1 3.234-2.665h4.773a.9.9 0 0 1 .722 1.438.745.745 0 0 0-.058.09H9.5a.75.75 0 0 0 0 1.5h5.16a1.75 1.75 0 0 0 1.067-.362l4.284-3.296Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m20.685 1.8.052.312a2.372 2.372 0 0 0 1.874 1.936 2.372 2.372 0 0 0-1.875 1.936l-.051.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.372 2.372 0 0 0 1.875-1.936l.052-.312ZM4.246 8.5l.052.312a2.372 2.372 0 0 0 1.875 1.936 2.372 2.372 0 0 0-1.875 1.936l-.052.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.372 2.372 0 0 0 1.875-1.936l.052-.312ZM12.503 12.168c-.635 0-1.186-.112-1.652-.336a3.14 3.14 0 0 1-1.162-.994c-.299-.43-.523-.957-.672-1.582-.14-.625-.21-1.34-.21-2.142 0-.793.07-1.503.21-2.128.149-.635.373-1.167.672-1.596a3.02 3.02 0 0 1 1.162-.98c.466-.233 1.017-.35 1.652-.35 1.269 0 2.202.443 2.8 1.33.597.887.896 2.128.896 3.724s-.299 2.837-.896 3.724c-.598.887-1.531 1.33-2.8 1.33Zm0-1.47c.672 0 1.143-.238 1.414-.714.28-.485.42-1.153.42-2.002V6.246c0-.85-.14-1.512-.42-1.988-.271-.485-.742-.728-1.414-.728-.672 0-1.148.243-1.428.728-.271.476-.406 1.139-.406 1.988v1.736c0 .85.135 1.517.406 2.002.28.476.756.714 1.428.714Zm0-2.758c-.327 0-.556-.065-.686-.196a.674.674 0 0 1-.182-.476V6.96c0-.187.06-.345.182-.476.13-.13.359-.196.686-.196.326 0 .55.065.672.196.13.13.196.29.196.476v.308a.648.648 0 0 1-.196.476c-.122.13-.346.196-.672.196Z"
  }));
};

var getTheme$1 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAiScan = function SvgTwoColorAiScan(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1(props["data-theme"]),
    fillRule: "evenodd",
    d: "M3.295 3.295a2.714 2.714 0 0 1 1.92-.795h2.907a.776.776 0 0 1 0 1.551H5.214a1.163 1.163 0 0 0-1.163 1.163v2.908a.776.776 0 0 1-1.551 0V5.214c0-.72.286-1.41.795-1.919Zm11.807-.02c0-.428.347-.775.775-.775h2.909A2.715 2.715 0 0 1 21.5 5.214v2.908a.776.776 0 0 1-1.551 0V5.214a1.163 1.163 0 0 0-1.163-1.163h-2.909a.776.776 0 0 1-.775-.775ZM3.275 15.103c.429 0 .776.347.776.776v2.908a1.164 1.164 0 0 0 1.163 1.163h2.908a.776.776 0 1 1 0 1.551H5.214A2.714 2.714 0 0 1 2.5 18.786v-2.908c0-.429.347-.776.775-.776Zm17.45 0c.428 0 .775.347.775.776v2.908a2.714 2.714 0 0 1-2.714 2.714h-2.909a.775.775 0 1 1 0-1.551h2.909a1.163 1.163 0 0 0 1.163-1.163v-2.908c0-.429.347-.776.775-.776ZM18.4 12a.8.8 0 0 1 .8-.8h3a.8.8 0 0 1 0 1.6h-3a.8.8 0 0 1-.8-.8ZM4.8 12.8h-3a.8.8 0 0 1 0-1.6h3a.8.8 0 0 1 0 1.6Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13.939 15.92v-1.19h1.034V9.27h-1.034V8.08H17.5v1.19h-1.045v5.46H17.5v1.19h-3.561ZM12.038 15.92l-.629-1.999H8.623l-.618 2H6.5L9.129 8.08h1.842l2.606 7.84h-1.539Zm-2-6.492h-.056l-1 3.224h2.068l-1.011-3.224Z"
  }));
};

var getTheme$2 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorApi = function SvgTwoColorApi(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2(props["data-theme"]),
    d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h15a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-15Zm2.25-.75a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-15Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.41 14.01H7.736l-.23.99H6l1.79-6h1.605l1.79 6h-1.54l-.234-.99Zm-.308-1.298-.526-2.157-.523 2.157h1.05ZM11.652 9H14.1c.532 0 .93.16 1.195.479.266.32.4.773.4 1.363 0 .605-.146 1.079-.436 1.42-.288.341-.728.511-1.322.511h-.806V15h-1.478V9Zm1.479 2.558h.36c.284 0 .483-.061.598-.184a.682.682 0 0 0 .172-.479.768.768 0 0 0-.15-.479c-.1-.13-.286-.196-.562-.196h-.418v1.338ZM16.525 9H18v6h-1.475V9Z"
  }));
};

var getTheme$3 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAprBoost = function SvgTwoColorAprBoost(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M18.213 8.307a.748.748 0 0 0-.243.163l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v4.69a.75.75 0 0 0 1.5 0v-4.69l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.748.748 0 0 0-.817-.163Z"
  }), createElement("path", {
    fill: getTheme$3(props["data-theme"]),
    d: "M4.25 12a7.25 7.25 0 0 1 11.78-5.66.75.75 0 1 0 .94-1.17 8.75 8.75 0 1 0 2.11 11.206.75.75 0 1 0-1.3-.751A7.25 7.25 0 0 1 4.25 12Z"
  }), createElement("path", {
    fill: getTheme$3(props["data-theme"]),
    d: "m11.524 8.21-.044-.332-.017.184a4.387 4.387 0 0 1-4.147 3.98l.379.068a4.632 4.632 0 0 1 3.785 4.096 4.967 4.967 0 0 1 4.006-4.135l.159-.03a4.41 4.41 0 0 1-4.121-3.832Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$3(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }));
};

var getTheme$4 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorApyCalculator = function SvgTwoColorApyCalculator(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M9 6.75a.75.75 0 0 0-.75.75v.75H7.5a.75.75 0 0 0 0 1.5h.75v.75a.75.75 0 0 0 1.5 0v-.75h.75a.75.75 0 0 0 0-1.5h-.75V7.5A.75.75 0 0 0 9 6.75ZM13.5 9a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5h-2.25A.75.75 0 0 1 13.5 9Zm-6.091 5.47a.75.75 0 1 1 1.06-1.061l.531.53.53-.53a.75.75 0 1 1 1.061 1.06l-.53.531.53.53a.75.75 0 0 1-1.06 1.06L9 16.06l-.531.531a.75.75 0 0 1-1.061-1.06l.53-.531-.53-.53Z"
  }), createElement("path", {
    fill: getTheme$4(props["data-theme"]),
    d: "M5.25 3A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3H5.25ZM4.5 5.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V5.25Zm10.875 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-1.5.375a.375.375 0 0 0 0 .75h3a.375.375 0 0 0 0-.75h-3Zm2.25 1.875a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
  }));
};

var getTheme$5 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorActiveOrders = function SvgTwoColorActiveOrders(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$5(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19.11 6.926c.145.192.223.426.223.667v8.63c0 .613-.497 1.11-1.11 1.11H9.777a1.111 1.111 0 0 1-1.112-1.11V4.777c0-.614.498-1.111 1.112-1.111h6.333c.35 0 .679.164.889.444l2.11 2.815Zm-4.777 11.74H9.778a2.444 2.444 0 0 1-2.445-2.444V6.667H5.778c-.614 0-1.111.497-1.111 1.11v11.445c0 .614.497 1.111 1.11 1.111h7.445c.614 0 1.111-.497 1.111-1.11v-.556Zm1.333 0v.556a2.444 2.444 0 0 1-2.444 2.445H5.778a2.444 2.444 0 0 1-2.445-2.445V7.778a2.444 2.444 0 0 1 2.445-2.445h1.555v-.555a2.444 2.444 0 0 1 2.445-2.445h6.333c.77 0 1.494.363 1.956.978l2.11 2.815c.318.423.49.938.49 1.467v8.63a2.444 2.444 0 0 1-2.445 2.444h-2.556Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M15 9.75a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5h4Zm2 3a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6Z",
    clipRule: "evenodd"
  }));
};

var getTheme$6 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAddOrders = function SvgTwoColorAddOrders(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$6(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19.25 11V6A2.25 2.25 0 0 0 17 3.75H7A2.25 2.25 0 0 0 4.75 6v12A2.25 2.25 0 0 0 7 20.25h4a.75.75 0 0 1 0 1.5H7A3.75 3.75 0 0 1 3.25 18V6A3.75 3.75 0 0 1 7 2.25h10A3.75 3.75 0 0 1 20.75 6v5a.75.75 0 0 1-1.5 0Zm-2.4-3c0 .47-.38.85-.85.85H8a.85.85 0 0 1 0-1.7h8c.47 0 .85.38.85.85ZM13 12.694a.694.694 0 0 0 0-1.388H8a.694.694 0 1 0 0 1.388h5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M17.75 13a.75.75 0 0 0-1.5 0v3.25H13a.75.75 0 0 0 0 1.5h3.25V21a.75.75 0 0 0 1.5 0v-3.25H21a.75.75 0 0 0 0-1.5h-3.25V13Z",
    clipRule: "evenodd"
  }));
};

var getTheme$7 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAdd = function SvgTwoColorAdd(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$7(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12.75 7.5a.75.75 0 0 0-1.5 0v3.75H7.5a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0v-3.75h3.75a.75.75 0 0 0 0-1.5h-3.75V7.5Z",
    clipRule: "evenodd"
  }));
};

var getTheme$8 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAffiliate = function SvgTwoColorAffiliate(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$8(props["data-theme"]),
    d: "M13 10.25V7h-2v3.25H7.5a2.25 2.25 0 0 0-2.25 2.25v1.75H4A1.75 1.75 0 0 0 2.25 16v3c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 10.75 19v-3A1.75 1.75 0 0 0 9 14.25H6.75V12.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v1.75H15A1.75 1.75 0 0 0 13.25 16v3c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 21.75 19v-3A1.75 1.75 0 0 0 20 14.25h-1.25V12.5a2.25 2.25 0 0 0-2.25-2.25H13Zm7 5.5a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25h5Zm-16 0h5a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25v-3a.25.25 0 0 1 .25-.25Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
  }));
};

var getTheme$9 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAirdrop = function SvgTwoColorAirdrop(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$9(props["data-theme"]),
    fillRule: "evenodd",
    d: "m3.994 11.3-.003.002.002-.002Zm4.51-.004a2.426 2.426 0 0 0-.129-.157 3.325 3.325 0 0 0-.452-.42c-.4-.307-.962-.594-1.673-.594-.711 0-1.273.287-1.673.595a3.324 3.324 0 0 0-.583.58l-.003.002a.75.75 0 0 1-1.235-.85v-.002l.002-.001.002-.003.005-.007.015-.021a3.96 3.96 0 0 1 .224-.276c.15-.168.37-.39.658-.612.576-.442 1.451-.905 2.588-.905s2.012.463 2.588.905c.105.081.2.162.287.24.087-.078.183-.159.287-.24.576-.442 1.451-.905 2.588-.905s2.012.463 2.588.905c.092.071.177.142.255.211.07-.065.145-.132.227-.198.573-.466 1.454-.918 2.68-.918 1.226 0 2.107.452 2.68.918a3.935 3.935 0 0 1 .786.86l.044.072.014.024.005.01.002.003.001.001s0 .002-.657.362l.658-.36a.75.75 0 0 1-1.312.727m-.003-.006v.002l.002.002v.002a1.656 1.656 0 0 0-.099-.141 2.437 2.437 0 0 0-.386-.394c-.35-.284-.907-.582-1.735-.582-.828 0-1.384.298-1.735.582a2.442 2.442 0 0 0-.47.51l-.015.024m4.438-.003v-.002.002Zm-5.71.064-.002-.003a2.431 2.431 0 0 0-.13-.16 3.323 3.323 0 0 0-.452-.42c-.4-.307-.963-.594-1.674-.594s-1.273.287-1.673.595a3.328 3.328 0 0 0-.58.576.741.741 0 0 1-.306.26.745.745 0 0 1-.846-.15.74.74 0 0 1-.091-.11",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$9(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.134 10.54C4.326 6.818 7.713 3.75 12 3.75c4.287 0 7.674 3.067 7.866 6.79l-6.018 5.234 1.848-4.62a.75.75 0 1 0-1.392-.558L12 16.356l-2.304-5.76a.75.75 0 0 0-1.392.557l1.848 4.621-6.018-5.233Zm-1.264.89.016.014 8.62 7.495.01.01a.75.75 0 0 0 .976-.008l8.625-7.5a.747.747 0 0 0 .258-.572m0 0C21.371 6.045 17.11 2.25 12 2.25c-5.112 0-9.375 3.799-9.375 8.625a.747.747 0 0 0 .245.554",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M8.625 19.5a1.5 1.5 0 0 1 1.5-1.5h3.75a1.5 1.5 0 0 1 1.5 1.5v2.25a1.5 1.5 0 0 1-1.5 1.5h-3.75a1.5 1.5 0 0 1-1.5-1.5V19.5ZM20.25.75l.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$9(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }));
};

var getTheme$a = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAlert = function SvgTwoColorAlert(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$a(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12.216 3.87a.25.25 0 0 0-.432 0L2.518 19.876a.25.25 0 0 0 .217.375h18.53a.25.25 0 0 0 .217-.375L12.217 3.87Zm-1.73-.751c.674-1.164 2.355-1.164 3.029 0l9.265 16.004c.676 1.167-.166 2.627-1.514 2.627H2.735c-1.349 0-2.19-1.46-1.515-2.627L10.486 3.12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13 9a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-1.005 7A.998.998 0 0 0 11 17c0 .552.445 1 .995 1h.01c.55 0 .995-.448.995-1s-.445-1-.995-1h-.01Z",
    clipRule: "evenodd"
  }));
};

var getTheme$b = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAnnouncement = function SvgTwoColorAnnouncement(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M9 7.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 9 7.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$b(props["data-theme"]),
    fillRule: "evenodd",
    d: "M21.75 5.94c0-1.94-1.955-3.27-3.76-2.558L9.08 6.9a1.25 1.25 0 0 1-.46.087H5a2.75 2.75 0 0 0-2.75 2.75v4.526c0 1.19.755 2.203 1.812 2.586l.822 2.945a2.676 2.676 0 0 0 5.156-1.44l-.275-.982 8.225 3.246c1.805.713 3.76-.617 3.76-2.558V5.94ZM8.108 17.013H5.665l.664 2.377a1.176 1.176 0 0 0 2.266-.633l-.487-1.744ZM18.54 4.777A1.25 1.25 0 0 1 20.25 5.94v12.12a1.25 1.25 0 0 1-1.709 1.163l-8.912-3.518a2.748 2.748 0 0 0-1.01-.192H5c-.69 0-1.25-.56-1.25-1.25V9.737c0-.69.56-1.25 1.25-1.25h3.62a2.75 2.75 0 0 0 1.01-.192l8.911-3.518Z",
    clipRule: "evenodd"
  }));
};

var getTheme$c = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAnnouncements = function SvgTwoColorAnnouncements(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M6 11.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H6Zm0 4a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H6Z"
  }), createElement("path", {
    fill: getTheme$c(props["data-theme"]),
    d: "M13.485 2.713a1.5 1.5 0 1 0-2.97 0L4.74 7.25H4.5A2.25 2.25 0 0 0 2.25 9.5v10a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-10a2.25 2.25 0 0 0-2.25-2.25h-.24l-5.775-4.537Zm-2.044 1.18a1.497 1.497 0 0 0 1.117 0l4.273 3.357H7.168l4.273-3.357ZM4.5 8.75h15a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-10a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$d = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorApex = function SvgTwoColorApex(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$d(props["data-theme"]),
    d: "M15.012 4.442c-1.095-2.708-4.929-2.708-6.025 0l-3.69 9.118a3.25 3.25 0 0 0 .946 3.728l3.69 3.039a3.25 3.25 0 0 0 4.133 0l3.69-3.04a3.25 3.25 0 0 0 .947-3.727l-3.69-9.118Zm-7.415-.563c1.602-3.957 7.204-3.957 8.806 0l3.69 9.118a4.75 4.75 0 0 1-1.383 5.449l-3.69 3.039a4.75 4.75 0 0 1-6.04 0l-3.69-3.04a4.75 4.75 0 0 1-1.384-5.448l3.69-9.118Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.083 9.481a.383.383 0 0 1 .53.034l1.703 1.786c.162.17.158.45-.014.608A6.298 6.298 0 0 1 12 13.61c-1.6 0-3.111-.6-4.301-1.7a.432.432 0 0 1-.014-.608l1.703-1.786a.384.384 0 0 1 .53-.034 3.197 3.197 0 0 0 4.165 0Zm-3.792 9.774a.3.3 0 0 1 0-.452 2.629 2.629 0 0 1 1.71-.635c.647 0 1.241.238 1.708.635a.3.3 0 0 1 0 .452A2.63 2.63 0 0 1 12 19.89a2.63 2.63 0 0 1-1.709-.635Zm-.903-.577-1.703-1.786a.432.432 0 0 1 .014-.608 6.299 6.299 0 0 1 4.301-1.7c1.6 0 3.112.6 4.302 1.7a.433.433 0 0 1 .014.608l-1.703 1.786a.384.384 0 0 1-.53.033 3.198 3.198 0 0 0-4.165 0 .376.376 0 0 1-.245.091.396.396 0 0 1-.285-.124Zm3.495-3.342a2.172 2.172 0 0 1-1.767 0c-.074-.033-.136.064-.08.124.243.265.585.43.963.43s.72-.165.963-.43c.048-.052.009-.131-.05-.131-.01 0-.02.002-.03.007Z"
  }));
};

var getTheme$e = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAssetUp = function SvgTwoColorAssetUp(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$e(props["data-theme"]),
    fillRule: "evenodd",
    d: "M5.172 20.122a8.75 8.75 0 1 1 13.656 0h.816a.75.75 0 0 1 0 1.5H4.09a.75.75 0 0 1 0-1.5h1.083ZM4.75 14.65a7.25 7.25 0 1 1 12.006 5.472H7.244A7.231 7.231 0 0 1 4.75 14.65Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M4.545 1.093a.657.657 0 0 0-.93 0L1.592 3.116a.657.657 0 1 0 .93.93l.9-.901v4.144a.657.657 0 0 0 1.316 0V3.145l.9.9a.657.657 0 1 0 .93-.93L4.545 1.094ZM11.714 10.488c.154-.5.863-.5 1.018 0l.625 2.023h2.095c.51 0 .728.647.323.956l-1.717 1.312.642 2.077a.533.533 0 0 1-.833.581l-1.644-1.256-1.644 1.256a.533.533 0 0 1-.833-.58l.642-2.078-1.718-1.312a.533.533 0 0 1 .324-.956h2.095l.625-2.023ZM21.63 7.069v2.538a.607.607 0 1 1-1.214 0V7.07l-.734.734a.607.607 0 0 1-.858-.859l1.77-1.77a.607.607 0 0 1 .858 0l1.77 1.77a.607.607 0 1 1-.858.859l-.734-.734Z"
  }));
};

var getTheme$f = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAssetHistory = function SvgTwoColorAssetHistory(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$f(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 5A.75.75 0 0 1 3 4.25h5a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5ZM2.25 12a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM2.25 19a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M16.5 5.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM11.25 9.5a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M16.5 6.5a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5H16.5a.75.75 0 0 1-.75-.75V7.25a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$g = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAssetsTools = function SvgTwoColorAssetsTools(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8.75 2.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm0 4a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$g(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 11a.75.75 0 0 1 .75-.75h3.645a3 3 0 0 1 1.993.758l3.48 3.094 2.332-1.165a5.932 5.932 0 0 1 7.683 2.161.755.755 0 0 1-.261 1.054l-8.276 4.79a6 6 0 0 1-3.006.808H3.5a.75.75 0 0 1 0-1.5h6.687a6 6 0 0 0 3.006-.807l7.202-4.17a4.433 4.433 0 0 0-5.274-.995l-2.77 1.385a.68.68 0 0 1-.03.015l-2.144 1.072H5a.75.75 0 0 1 0-1.5h4.823l.85-.425-2.606-2.317a3 3 0 0 0-1.993-.758H3a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$h = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAssettOrders = function SvgTwoColorAssettOrders(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$h(props["data-theme"]),
    fillRule: "evenodd",
    d: "M18 2.25A2.75 2.75 0 0 1 20.75 5v14A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19V5A2.75 2.75 0 0 1 6 2.25h12ZM19.25 5c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M15.5 9.75a.75.75 0 0 0 0-1.5h-7a.75.75 0 0 0 0 1.5h7Zm0 6a.75.75 0 0 0 0-1.5h-7a.75.75 0 0 0 0 1.5h7Z",
    clipRule: "evenodd"
  }));
};

var getTheme$i = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAudit = function SvgTwoColorAudit(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#TwoColorAudit_svg__a)",
    clipRule: "evenodd"
  }, createElement("path", {
    fill: getTheme$i(props["data-theme"]),
    d: "M13.75 9.855a.625.625 0 1 0 0-1.25h-7.5a.625.625 0 1 0 0 1.25h7.5ZM9.846 13.19a.625.625 0 1 0 0-1.25H6.25a.625.625 0 0 0 0 1.25h3.596Z"
  }), createElement("path", {
    fill: getTheme$i(props["data-theme"]),
    d: "M14.269 4.024a1.876 1.876 0 0 0-1.77-1.252h-5c-.816 0-1.511.523-1.768 1.252a3.125 3.125 0 0 0-3.023 3.123v8.75c0 1.726 1.4 3.125 3.125 3.125H10s.67.041.67-.604c0-.646-.67-.646-.67-.646H5.833a1.875 1.875 0 0 1-1.875-1.875v-8.75c0-1.002.786-1.82 1.774-1.872A1.876 1.876 0 0 0 7.5 6.522h5c.815 0 1.509-.52 1.767-1.247.989.052 1.774.87 1.774 1.872v3.542s.003.56.628.556c.625-.004.622-.556.622-.556V7.147a3.125 3.125 0 0 0-3.022-3.123Zm-1.77-.002a.625.625 0 1 1 0 1.25h-5a.625.625 0 0 1 0-1.25h5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.185 20.602a.833.833 0 0 0 .483-.158l1.35-.967a3.8 3.8 0 0 0 1.592-3.042v-2.808a.832.832 0 0 0-1.008-.808 2.499 2.499 0 0 1-1.942-.4.834.834 0 0 0-.95 0 2.498 2.498 0 0 1-1.942.4.834.834 0 0 0-1 .833v2.783a3.79 3.79 0 0 0 1.584 3.084l1.358.925a.783.783 0 0 0 .475.158Zm-2.175-4.158v-2.35a5.319 5.319 0 0 0 2.175-.567 5.277 5.277 0 0 0 2.175.567v2.35a2.649 2.649 0 0 1-1.103 2.062l-1.03.763-1.114-.763a2.649 2.649 0 0 1-1.103-2.062Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorAudit_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 .897h20v20H0z"
  }))));
};

var getTheme$j = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorAutoSavings = function SvgTwoColorAutoSavings(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M5.837 6.515a8.25 8.25 0 0 1 14.382 4.767.75.75 0 1 0 1.494-.13c-.469-5.365-5.197-9.334-10.561-8.865a9.72 9.72 0 0 0-6.488 3.29l-.106-1.209a.75.75 0 1 0-1.494.13l.26 2.99a.75.75 0 0 0 .813.681l2.989-.26a.75.75 0 0 0-.13-1.495l-1.159.101Z"
  }), createElement("path", {
    fill: getTheme$j(props["data-theme"]),
    d: "M15.852 10.118v-1.8H8.415v1.8h2.742v1.176c-2.229.1-3.907.535-3.907 1.057 0 .522 1.678.958 3.907 1.057v3.774h1.953v-3.775c2.22-.1 3.89-.535 3.89-1.056 0-.52-1.67-.956-3.89-1.056v-1.177h2.742Zm.308 2.127c0 .343-1.297.631-3.05.711l-.113.005h-.012l-.107.004h-.011l-.24.007h-.005l-.109.002h-.03l-.086.001h-.543l-.084-.001h-.03l-.101-.002h-.011l-.355-.01h-.002l-.116-.006c-1.76-.079-3.067-.368-3.067-.713s1.306-.634 3.067-.713v1.091a18.95 18.95 0 0 0 1.954 0v-1.088c1.754.08 3.051.368 3.051.712Zm-13.191-.21a.75.75 0 0 1 .812.682 8.25 8.25 0 0 0 14.382 4.768l-1.158.1a.75.75 0 1 1-.13-1.494l2.988-.26a.75.75 0 0 1 .812.681l.261 2.99a.75.75 0 1 1-1.494.13l-.106-1.21a9.72 9.72 0 0 1-6.488 3.291c-5.364.468-10.093-3.5-10.56-8.865a.75.75 0 0 1 .681-.812Z"
  }));
};

var getTheme$k = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBvn = function SvgTwoColorBvn(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M22 9.75a.75.75 0 0 0 0-1.5H2a.75.75 0 0 0 0 1.5h20Zm-6.523 3.519.46.962L17.25 16.5h1.142v-4.799h-.983v3.231h-.021l-.46-.962-1.314-2.269h-1.141V16.5h.983v-3.231h.02ZM11.115 16.5l-1.547-4.799h1.06l.714 2.303.378 1.506h.021l.364-1.506.715-2.303h1.025l-1.56 4.799h-1.17Zm-3.174-4.799h-2.33V16.5h2.543c.18 0 .344-.034.495-.103.152-.073.282-.172.392-.296a1.503 1.503 0 0 0 .35-.97c.001-.205-.036-.38-.109-.522a1.005 1.005 0 0 0-.261-.343 1.127 1.127 0 0 0-.708-.261v-.042c.123-.004.238-.025.343-.062a.74.74 0 0 0 .282-.185.837.837 0 0 0 .193-.317 1.28 1.28 0 0 0 .075-.467c0-.371-.112-.67-.337-.894-.22-.224-.529-.337-.928-.337ZM7.86 15.62H6.656v-1.1h1.203c.137 0 .245.039.323.117.082.073.124.179.124.316v.234a.423.423 0 0 1-.124.323.452.452 0 0 1-.323.11Zm-.165-1.952H6.656V12.58h1.038c.137 0 .245.04.323.117a.437.437 0 0 1 .117.323v.206a.437.437 0 0 1-.117.324.437.437 0 0 1-.323.117Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$k(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }));
};

var getTheme$l = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBill = function SvgTwoColorBill(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-.97-4.97a.75.75 0 1 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$l(props["data-theme"]),
    fillRule: "evenodd",
    d: "M17.75 3a.75.75 0 0 0-1.143-.639l-2.879 1.77-3.198-1.786a.75.75 0 0 0-.731 0L6.582 4.141 3.366 2.345A.75.75 0 0 0 2.25 3v18c0 .414.336.75.75.75h16.043A2.75 2.75 0 0 0 21.75 19v-6.571c0-.651-.528-1.179-1.179-1.179H17.75V3Zm-1.5 9.429V4.34L14.14 5.64a.75.75 0 0 1-.759.016l-3.217-1.796-3.216 1.796a.75.75 0 0 1-.731 0L3.75 4.278V20.25h12.8c-.192-.375-.3-.8-.3-1.25v-6.571ZM19 20.25c.69 0 1.25-.56 1.25-1.25v-6.25h-2.5V19c0 .69.56 1.25 1.25 1.25Z",
    clipRule: "evenodd"
  }));
};

var getTheme$m = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBiometrics = function SvgTwoColorBiometrics(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$m(props["data-theme"]),
    d: "M3.75 9.7v-4c0-.69.56-1.25 1.25-1.25h4a.75.75 0 1 0 0-1.5H5A2.75 2.75 0 0 0 2.25 5.7v4a.75.75 0 0 0 1.5 0ZM15 4.45h4c.69 0 1.25.56 1.25 1.25v4a.75.75 0 0 0 1.5 0v-4A2.75 2.75 0 0 0 19 2.95h-4a.75.75 0 0 0 0 1.5ZM20.25 18.7v-4a.75.75 0 0 1 1.5 0v4A2.75 2.75 0 0 1 19 21.45h-4a.75.75 0 0 1 0-1.5h4c.69 0 1.25-.56 1.25-1.25ZM9 19.95H5c-.69 0-1.25-.56-1.25-1.25v-4a.75.75 0 0 0-1.5 0v4A2.75 2.75 0 0 0 5 21.45h4a.75.75 0 0 0 0-1.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M10.25 9.7a1.95 1.95 0 1 1 3.9 0 1.95 1.95 0 0 1-3.9 0Zm1.95-3.45a3.45 3.45 0 0 0-2.365 5.962A5.25 5.25 0 0 0 6.95 16.9a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 1 7.5 0 .75.75 0 0 0 1.5 0 5.25 5.25 0 0 0-2.885-4.688A3.45 3.45 0 0 0 12.2 6.25Z"
  }));
};

var getTheme$n = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBirthday = function SvgTwoColorBirthday(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M7 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7.181 13a1.716 1.716 0 1 1-3.431 0 .75.75 0 0 0-1.5 0 3.216 3.216 0 0 0 5.513 2.25 4.795 4.795 0 0 0 8.506.033A3.216 3.216 0 0 0 21.75 13a.75.75 0 0 0-1.499 0 1.716 1.716 0 0 1-3.43.065v-.016l-.001-.043V13a.75.75 0 0 0-1.5 0v.084a3.296 3.296 0 0 1-6.59-.035c0-.215-.09-.409-.236-.546A.748.748 0 0 0 7.181 13ZM13 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM17 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), createElement("path", {
    fill: getTheme$n(props["data-theme"]),
    d: "M7.75 6a.75.75 0 0 0-1.5 0v2.25H6A3.75 3.75 0 0 0 2.25 12v7.25H1a.75.75 0 0 0 0 1.5h22a.75.75 0 0 0 0-1.5h-1.25V12A3.75 3.75 0 0 0 18 8.25h-.25V6a.75.75 0 0 0-1.5 0v2.25h-3.5V6a.75.75 0 0 0-1.5 0v2.25h-3.5V6ZM6 9.75h12A2.25 2.25 0 0 1 20.25 12v7.25H3.75V12A2.25 2.25 0 0 1 6 9.75Z"
  }));
};

var getTheme$o = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBlog = function SvgTwoColorBlog(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#TwoColorBlog_svg__a)"
  }, createElement("path", {
    fill: "#F7A600",
    d: "M11.898.75a.613.613 0 0 0-.648.61v1.204c0 .324.251.59.571.605 4.929.267 8.89 4.266 9.175 9.198.02.32.286.571.606.571h1.222c.35 0 .629-.297.61-.647-.324-6.216-5.32-11.213-11.537-11.54Zm.01 3.657a.614.614 0 0 0-.658.613v1.223c0 .32.248.583.564.605 2.925.24 5.256 2.598 5.518 5.53.03.317.29.56.606.56h1.226c.354 0 .64-.304.613-.659-.32-4.193-3.675-7.548-7.868-7.872Z"
  }), createElement("path", {
    fill: getTheme$o(props["data-theme"]),
    d: "M.75 14.25a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.25 15.115H8.972c-.15 0-.292.061-.398.17a.584.584 0 0 0 0 .815.556.556 0 0 0 .398.17h2.278c.15 0 .292-.062.398-.17a.585.585 0 0 0 0-.816.555.555 0 0 0-.398-.169Zm-2.278-1.73h1.462c.15 0 .293-.061.398-.17a.584.584 0 0 0 0-.815.556.556 0 0 0-.398-.17H8.972c-.15 0-.292.062-.398.17a.585.585 0 0 0 0 .816.555.555 0 0 0 .398.169Zm3.403-.577v.577c0 .153.06.3.165.408a.555.555 0 0 0 .398.168c.149 0 .292.061.397.17a.585.585 0 0 1 .165.408v1.73c0 .46-.178.9-.494 1.224a1.666 1.666 0 0 1-1.194.507H8.438c-.448 0-.877-.182-1.194-.507a1.754 1.754 0 0 1-.494-1.224v-4.038c0-.46.178-.9.494-1.224a1.666 1.666 0 0 1 1.194-.507h2.25c.447 0 .876.182 1.193.507.316.325.494.765.494 1.224v.577Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorBlog_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var getTheme$p = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBonusDerivatives = function SvgTwoColorBonusDerivatives(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$p(props["data-theme"]),
    d: "m21.75 6 .008.06c.05.378.361.668.742.69l-.028.005a.895.895 0 0 0-.722.745.834.834 0 0 0-.681-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M10.5 14h3v7h-3v-7Z"
  }), createElement("path", {
    fill: getTheme$p(props["data-theme"]),
    fillRule: "evenodd",
    d: "M7.583 5.6a.738.738 0 0 1 1.052.007l1.593 1.643H8.19l-.606-.606a.738.738 0 0 1 0-1.045ZM6.17 7.25a2.24 2.24 0 0 1 3.54-2.687l2.32 2.39 2.318-2.39a2.239 2.239 0 0 1 3.54 2.687H20c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 20 12.75h-1.268c.012.082.018.165.018.25v7A1.75 1.75 0 0 1 17 21.75H7A1.75 1.75 0 0 1 5.25 20v-7c0-.085.006-.168.018-.25H4A1.75 1.75 0 0 1 2.25 11V9c0-.966.784-1.75 1.75-1.75h2.171Zm.829 4h13a.25.25 0 0 0 .25-.25V9a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3Zm0 1.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H7Zm8.426-7.143L13.833 7.25h2.038l.607-.606a.738.738 0 1 0-1.052-1.037Z",
    clipRule: "evenodd"
  }));
};

var getTheme$q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBotChart = function SvgTwoColorBotChart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$q(props["data-theme"]),
    d: "M12.6 5.152a1.75 1.75 0 1 0-1 0V7.25h-5A3.75 3.75 0 0 0 2.85 11v2.045a1.973 1.973 0 0 0 0 3.854V19a3.75 3.75 0 0 0 3.75 3.75h11A3.75 3.75 0 0 0 21.35 19v-2.026a1.972 1.972 0 0 0 0-3.892V11a3.75 3.75 0 0 0-3.75-3.75h-5V5.152Zm5 16.098h-11A2.25 2.25 0 0 1 4.35 19v-8A2.25 2.25 0 0 1 6.6 8.75h11A2.25 2.25 0 0 1 19.85 11v8a2.25 2.25 0 0 1-2.25 2.25Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18.53 11.47a.75.75 0 0 1 0 1.06l-3.927 3.927a.75.75 0 0 1-1.01.046l-2.84-2.366L7.03 17.86a.75.75 0 1 1-1.06-1.061l4.207-4.207a.75.75 0 0 1 1.01-.046l2.84 2.366 3.443-3.442a.75.75 0 0 1 1.06 0ZM18.17 3.2l.073.44a3.348 3.348 0 0 0 2.646 2.732 3.348 3.348 0 0 0-2.646 2.732l-.073.44-.07-.42a3.38 3.38 0 0 0-2.649-2.752 3.348 3.348 0 0 0 2.646-2.732l.073-.44Z"
  }));
};

var getTheme$r = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBroker = function SvgTwoColorBroker(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$r(props["data-theme"]),
    d: "M16.243 14.29c0-.433.352-.785.785-.785h3.426a.786.786 0 1 1 0 1.572h-3.426a.786.786 0 0 1-.785-.786Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M5.148 7.502c0-.434.352-.786.786-.786h3.882a.786.786 0 1 1 0 1.571H5.934a.786.786 0 0 1-.786-.785ZM3.79 14.642a.786.786 0 0 1 1.11-.02l6.35 6.112.01.01c.16.16.404.153.55.005l.004-.005a.386.386 0 0 0 .005-.55l-.005-.004-1.304-1.304a.786.786 0 0 1 1.111-1.112l1.302 1.303c.776.765.77 2.01.005 2.776a1.957 1.957 0 0 1-2.774.008l-6.343-6.108a.786.786 0 0 1-.021-1.11Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.325 16.249a.786.786 0 0 1 1.112 0l2.019 2.02c.765.764.822 2.015.034 2.805-.786.797-2.049.733-2.81-.029l-2.02-2.02a.786.786 0 0 1 1.111-1.11l2.02 2.019c.195.195.455.164.58.036l.005-.005c.137-.136.162-.393-.031-.586l-2.02-2.019a.786.786 0 0 1 0-1.111Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13.891 14.453a.786.786 0 0 1 1.112.007l1.994 2.017c.766.768.73 1.993-.023 2.75-.753.762-1.99.79-2.756.025l-2.011-2.011a.786.786 0 0 1 1.11-1.111l2.012 2.011c.13.13.367.143.527-.019l.004-.004c.171-.171.151-.404.024-.531l-.003-.004-1.996-2.019a.786.786 0 0 1 .006-1.111Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.435 9.696a.786.786 0 0 1 1.111 0l5.115 5.115c.766.766.76 2.002-.007 2.77l-.005.004c-.76.747-1.992.775-2.765.003l-1.925-1.925a.786.786 0 0 1 1.112-1.111l1.925 1.925a.39.39 0 0 0 .549-.01c.157-.16.15-.4.005-.545l-5.115-5.115a.786.786 0 0 1 0-1.11Z"
  }), createElement("path", {
    fill: getTheme$r(props["data-theme"]),
    d: "M10.11 6.144a.786.786 0 0 1 .539-.214h7.857a.786.786 0 0 1 0 1.572H10.96L8.51 9.809c-.333.34-.318.88-.05 1.15.288.282.836.288 1.17-.045l2.035-2.035a.786.786 0 0 1 1.115.004l1.964 1.996a.786.786 0 1 1-1.12 1.102l-1.408-1.43-1.475 1.474c-.892.892-2.432.993-3.386.05l-.004-.003c-.954-.954-.83-2.497.055-3.382a.8.8 0 0 1 .017-.016l2.687-2.53Z"
  }), createElement("path", {
    fill: getTheme$r(props["data-theme"]),
    d: "M19.478 5.93h2.956a.786.786 0 1 0 0-1.571h-3.442c-.732 0-1.32.671-1.152 1.425l2.254 10.525a.786.786 0 0 0 1.537-.33L19.478 5.93Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M1.22 5.93c0-.434.352-.786.785-.786h3.05c.726 0 1.309.661 1.155 1.407L4.35 17.152a.786.786 0 0 1-1.547-.271L4.586 6.716h-2.58a.786.786 0 0 1-.786-.786ZM21.648 8.287a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571Z"
  }), createElement("path", {
    fill: getTheme$r(props["data-theme"]),
    d: "M2.79 9.073a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571Z"
  }));
};

var getTheme$s = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBuilding = function SvgTwoColorBuilding(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$s(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.25 4c0-.966.784-1.75 1.75-1.75h12c.966 0 1.75.784 1.75 1.75v16.25H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h1.25V4Zm14 0v16.25h-3.5V15A1.75 1.75 0 0 0 13 13.25h-2A1.75 1.75 0 0 0 9.25 15v5.25h-3.5V4A.25.25 0 0 1 6 3.75h12a.25.25 0 0 1 .25.25Zm-7.5 16.25h2.5V15a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v5.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8 6.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8Zm0 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8ZM13.25 7a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14 9.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z",
    clipRule: "evenodd"
  }));
};

var getTheme$t = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBuyCrypto = function SvgTwoColorBuyCrypto(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5 13.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5H5Zm11 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$t(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.25 14.425a.754.754 0 0 1-.02-.07L2.516 7.66A1.75 1.75 0 0 1 3.779 5.53l11.784-3.013a1.75 1.75 0 0 1 2.13 1.262L19.09 9.25h.91c.966 0 1.75.784 1.75 1.75v9A1.75 1.75 0 0 1 20 21.75H6A1.75 1.75 0 0 1 4.25 20v-5.575ZM17.543 9.25l-1.304-5.1a.25.25 0 0 0-.304-.18L4.15 6.984a.25.25 0 0 0-.18.304L4.638 9.9C4.96 9.504 5.45 9.25 6 9.25h11.543ZM20.25 20a.25.25 0 0 1-.25.25H6a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25h14a.25.25 0 0 1 .25.25v9Z",
    clipRule: "evenodd"
  }));
};

var getTheme$u = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBuy = function SvgTwoColorBuy(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$u(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 18A1.75 1.75 0 0 1 21 19.75H3A1.75 1.75 0 0 1 1.25 18V6c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v12Zm-1.75.25a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h18Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M14 11.5c.597 0 1.133.262 1.5.677a2 2 0 1 1 0 2.646A2 2 0 1 1 14 11.5ZM6 9.25a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5H6Z",
    clipRule: "evenodd"
  }));
};

var getTheme$v = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBybitCardBonus = function SvgTwoColorBybitCardBonus(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$v(props["data-theme"]),
    d: "m21.75 6 .009.06c.049.378.36.668.742.69l-.029.005a.894.894 0 0 0-.721.745.834.834 0 0 0-.682-.738l-.068-.012a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: getTheme$v(props["data-theme"]),
    fillRule: "evenodd",
    d: "M3.75 5.25a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h.75v1.5a1.5 1.5 0 0 0 1.5 1.5h13.5A2.25 2.25 0 0 0 21.75 18V9.75a1.5 1.5 0 0 0-1.5-1.5h-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5H3.75Zm15 4.5v6a1.5 1.5 0 0 1-1.5 1.5H6v1.5h13.5a.75.75 0 0 0 .75-.75V9.75h-1.5Zm-15-3h13.5v9H3.75v-9Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M17.25 10.5H3.75V9h13.5v1.5ZM12 13.5a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$w = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBybitCard = function SvgTwoColorBybitCard(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M2.75 9h14.5V7.5H2.75V9ZM12 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
  }), createElement("path", {
    fill: getTheme$w(props["data-theme"]),
    d: "M3.5 3.25A2.25 2.25 0 0 0 1.25 5.5v9a2.25 2.25 0 0 0 2.25 2.25h.75v1.75a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-8a2.25 2.25 0 0 0-2.25-2.25h-.75V5.5a2.25 2.25 0 0 0-2.25-2.25h-13Zm15.25 6.5h.75a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-1.75H16.5a2.25 2.25 0 0 0 2.25-2.25V9.75Zm-16-4.25a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-9Z"
  }));
};

var getTheme$x = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBybitEarn = function SvgTwoColorBybitEarn(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M18.5 2.75a.75.75 0 0 1 .75.75v1.75H21a.75.75 0 0 1 0 1.5h-1.75V8.5a.75.75 0 0 1-1.5 0V6.75H16a.75.75 0 0 1 0-1.5h1.75V3.5a.75.75 0 0 1 .75-.75ZM15.602 9.8V8H8.165v1.8h2.742v1.176C8.678 11.076 7 11.51 7 12.033c0 .522 1.678.958 3.907 1.057v3.774h1.953v-3.775c2.22-.1 3.89-.536 3.89-1.056 0-.521-1.67-.956-3.89-1.056V9.8h2.742Zm.308 2.127c0 .343-1.297.631-3.05.711l-.113.005h-.012l-.107.004h-.011l-.24.007h-.005l-.109.002h-.03l-.086.001h-.543l-.085-.001h-.029l-.101-.002h-.011a23.22 23.22 0 0 1-.355-.011h-.002l-.116-.005c-1.761-.079-3.067-.368-3.067-.713s1.306-.634 3.067-.713v1.091a18.834 18.834 0 0 0 1.954 0v-1.088c1.754.08 3.051.368 3.051.712Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$x(props["data-theme"]),
    d: "M3.75 12a8.25 8.25 0 0 1 9.752-8.114.75.75 0 0 0 .271-1.475A9.801 9.801 0 0 0 12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75c0-.503-.038-.997-.112-1.48a.75.75 0 1 0-1.483.226A8.25 8.25 0 1 1 3.75 12Z"
  }));
};

var getTheme$y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBybitSaving = function SvgTwoColorBybitSaving(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m19.982 2 .048.465a2.697 2.697 0 0 0 2.34 2.394 2.87 2.87 0 0 0-2.329 2.539l-.06.602-.054-.607a2.839 2.839 0 0 0-2.304-2.534 2.665 2.665 0 0 0 2.313-2.39L19.982 2ZM14.29 4.5a.5.5 0 0 1 .483.368l1.09 4a.5.5 0 0 1-.481.632H8.619a.5.5 0 0 1-.483-.632l1.091-4A.5.5 0 0 1 9.71 4.5h4.582ZM9.71 3a2 2 0 0 0-1.93 1.474l-1.091 4A2 2 0 0 0 8.619 11h6.763a2 2 0 0 0 1.93-2.526l-1.092-4A2 2 0 0 0 14.29 3H9.71Z"
  }), createElement("path", {
    fill: getTheme$y(props["data-theme"]),
    d: "M3.71 13.5a.5.5 0 0 0-.483.368l-1.09 4a.5.5 0 0 0 .482.632h6.763a.5.5 0 0 0 .482-.632l-1.091-4a.5.5 0 0 0-.482-.368H3.709Zm-1.93-.026A2 2 0 0 1 3.71 12h4.58a2 2 0 0 1 1.93 1.474l1.091 4A2 2 0 0 1 9.381 20H2.62a2 2 0 0 1-1.93-2.526l1.09-4Zm13.93.026a.5.5 0 0 0-.483.368l-1.09 4a.5.5 0 0 0 .482.632h6.763a.5.5 0 0 0 .482-.632l-1.091-4a.5.5 0 0 0-.482-.368h-4.582Zm-1.93-.026A2 2 0 0 1 15.71 12h4.58a2 2 0 0 1 1.93 1.474l1.091 4A2 2 0 0 1 21.381 20H14.62a2 2 0 0 1-1.93-2.526l1.09-4Z"
  }));
};

var getTheme$z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBybitMall = function SvgTwoColorBybitMall(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M9.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v5.5h-1.5v-4.75h-2.5v4.75h-1.5V15Z"
  }), createElement("path", {
    fill: getTheme$z(props["data-theme"]),
    d: "M5.387 2.25a1.15 1.15 0 0 0-1.03.639L1.828 7.984a.752.752 0 0 0-.04.572l.001.002.001.003.003.009.01.03.038.1a7.07 7.07 0 0 0 .698 1.362c.35.527.915 1.195 1.71 1.5V19.5a2.25 2.25 0 0 0 2.25 2.25h11a2.25 2.25 0 0 0 2.25-2.25v-8.037c.72-.357 1.27-.98 1.632-1.475a8.294 8.294 0 0 0 .788-1.33l.012-.026.003-.008.001-.003.001-.001a.75.75 0 0 0 .01-.58l-2.01-5.064a1.15 1.15 0 0 0-1.069-.726H5.387ZM21.5 8.317l.686.303-.686-.303Zm-3.25 3.412V19.5a.75.75 0 0 1-.75.75h-11a.75.75 0 0 1-.75-.75v-7.846c.39-.09.757-.256 1.081-.445a7.437 7.437 0 0 0 1.325-1.017c.223-.21.425-.42.599-.61.127.176.274.365.438.554.588.683 1.575 1.59 2.807 1.59s2.219-.907 2.807-1.59c.145-.168.276-.335.393-.493.166.205.36.428.575.648.374.382.837.781 1.362 1.064.332.18.708.322 1.113.374ZM2.5 8.317l-.711.24s0-.002.71-.24Zm.852.111a5.858 5.858 0 0 1-.033-.074L5.604 3.75h13.275l1.8 4.534-.028.054a6.777 6.777 0 0 1-.48.765c-.442.603-.95 1.05-1.436 1.134-.25.042-.543-.017-.886-.202-.343-.185-.686-.47-1.002-.793a8.374 8.374 0 0 1-1.026-1.293l-.013-.02-.002-.003a.75.75 0 0 0-1.301.038l-.002.003-.009.016-.04.072a7.506 7.506 0 0 1-.783 1.102c-.558.647-1.154 1.07-1.671 1.07-.517 0-1.114-.423-1.671-1.07a7.519 7.519 0 0 1-.824-1.174l-.009-.016-.001-.003a.75.75 0 0 0-1.267-.09l-.003.004-.013.018a9.588 9.588 0 0 1-.284.354c-.197.234-.475.544-.8.851-.329.31-.69.6-1.051.811-.368.214-.685.314-.938.314-.473 0-.937-.371-1.35-.994a5.57 5.57 0 0 1-.437-.804Z"
  }));
};

var getTheme$A = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBystart = function SvgTwoColorBystart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$A(props["data-theme"]),
    d: "M11.25 1.817a1.5 1.5 0 0 1 1.5 0l7.694 4.442a1.5 1.5 0 0 1 .75 1.299v8.884a1.5 1.5 0 0 1-.75 1.299l-7.694 4.442a1.5 1.5 0 0 1-1.5 0l-7.694-4.442a1.5 1.5 0 0 1-.75-1.3V7.559a1.5 1.5 0 0 1 .75-1.3l7.694-4.441ZM12 3.116 5.347 6.957 11.815 11h.37l6.468-4.043L12 3.116Zm-.75 9.3-6.944-4.34v8.366l6.944 4.009v-8.035Zm1.5 8.035 6.944-4.01V8.077l-6.944 4.34v8.035Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};

var getTheme$B = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCsLiveChat = function SvgTwoColorCsLiveChat(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$B(props["data-theme"]),
    fillRule: "evenodd",
    d: "M9.134 5.085c.916-.187 1.938-.335 2.866-.335.928 0 1.95.148 2.866.335A3.863 3.863 0 0 1 17.8 7.76c.159.526.29 1.047.355 1.493.073.498.097 1.123.095 1.745a.75.75 0 0 0 1.5.006c.002-.65-.022-1.362-.111-1.97a12.331 12.331 0 0 0-.403-1.707 5.363 5.363 0 0 0-4.07-3.71C14.203 3.418 13.07 3.25 12 3.25c-1.07 0-2.202.168-3.167.366a5.363 5.363 0 0 0-4.07 3.71c-.168.56-.321 1.16-.402 1.708-.089.607-.113 1.319-.11 1.969a.75.75 0 0 0 1.5-.006c-.003-.622.021-1.247.094-1.745.066-.446.196-.967.355-1.493a3.863 3.863 0 0 1 2.934-2.674Zm7.962 15.503a2.812 2.812 0 0 0 2.65-2.506l-1.491-.164a1.311 1.311 0 0 1-1.235 1.172c-1.443.073-3.486.16-5.02.16a.75.75 0 1 0 0 1.5c1.575 0 3.65-.088 5.096-.162Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5.5 10.25a3.25 3.25 0 0 0-3.25 3.25v2a3.25 3.25 0 0 0 6.5 0v-2a3.25 3.25 0 0 0-3.25-3.25ZM3.75 13.5a1.75 1.75 0 1 1 3.5 0v2a1.75 1.75 0 1 1-3.5 0v-2Zm14.75-3.25a3.25 3.25 0 0 0-3.25 3.25v2a3.25 3.25 0 0 0 6.5 0v-2a3.25 3.25 0 0 0-3.25-3.25Zm-1.75 3.25a1.75 1.75 0 1 1 3.5 0v2a1.75 1.75 0 1 1-3.5 0v-2Z",
    clipRule: "evenodd"
  }));
};

var getTheme$C = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCtAutomatedStrategy = function SvgTwoColorCtAutomatedStrategy(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M10.915 11.516a.75.75 0 1 0-1.06-1.06L8.048 12.26a.75.75 0 1 0 1.061 1.06l1.805-1.805ZM13.562 14.163a.75.75 0 0 0-1.06-1.06l-1.806 1.804a.75.75 0 0 0 1.061 1.061l1.805-1.805Z"
  }), createElement("path", {
    fill: getTheme$C(props["data-theme"]),
    d: "M21.984 2.274a.75.75 0 0 1 0 1.061l-1.329 1.329a5.674 5.674 0 0 1-.605 7.308l-1.934 1.934a.75.75 0 0 1-1.06 0l-6.961-6.961a.75.75 0 0 1 0-1.061l1.933-1.934a5.673 5.673 0 0 1 7.6-.381l1.295-1.295a.75.75 0 0 1 1.06 0Zm-8.882 2.724-.013.013-1.403 1.403 5.9 5.9 1.403-1.403a4.172 4.172 0 0 0-5.887-5.913ZM11.972 20.05l1.933-1.934a.75.75 0 0 0 0-1.06l-6.96-6.961a.75.75 0 0 0-1.061 0L3.95 12.028l-.015.016a5.674 5.674 0 0 0-.59 7.293l-1.329 1.328a.75.75 0 0 0 1.061 1.06l1.294-1.294a5.673 5.673 0 0 0 7.6-.381Zm-1.074-1.048a4.172 4.172 0 0 1-5.887-5.913l1.403-1.403 5.9 5.9-1.403 1.403-.013.013Z"
  }));
};

var getTheme$D = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCtMySubscriber = function SvgTwoColorCtMySubscriber(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$D(props["data-theme"]),
    d: "M15.065 12.058a.75.75 0 0 0-1.061-1.06l-3.007 3.006a.75.75 0 0 0 1.06 1.06l3.008-3.006Z"
  }), createElement("path", {
    fill: getTheme$D(props["data-theme"]),
    d: "M21.616 16.139a2.75 2.75 0 0 0 0-3.89l-8.253-8.252a2.75 2.75 0 0 0-1.842-.803l-5.688-.211a2.75 2.75 0 0 0-2.85 2.85l.21 5.688a2.75 2.75 0 0 0 .804 1.842l8.253 8.253a2.75 2.75 0 0 0 3.889 0l5.477-5.477Zm-1.06-2.828a1.25 1.25 0 0 1 0 1.767l-5.478 5.477a1.25 1.25 0 0 1-1.768 0l-8.252-8.252a1.25 1.25 0 0 1-.365-.838l-.211-5.688a1.25 1.25 0 0 1 1.295-1.295l5.688.21c.315.012.615.143.838.366l8.252 8.253Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.029 9.573a2.255 2.255 0 1 1-4.51 0 2.255 2.255 0 0 1 4.51 0Z"
  }));
};

var getTheme$E = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCtWatchlist = function SvgTwoColorCtWatchlist(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$E(props["data-theme"]),
    d: "M18.918 8.865h-2.717A1.864 1.864 0 0 1 14.338 7V3.597H4.892c-.605 0-1.095.49-1.095 1.095v14.615c0 .604.49 1.094 1.095 1.094h7.69a.799.799 0 0 1 0 1.598h-7.69A2.692 2.692 0 0 1 2.2 19.306V4.692A2.692 2.692 0 0 1 4.892 2h9.985c.847 0 1.645.399 2.153 1.077l2.947 3.929c.35.466.538 1.032.538 1.615v2.846a.799.799 0 1 1-1.597 0V8.865Zm-.741-1.598L15.934 4.28V7c0 .147.12.266.266.266h1.976Z"
  }), createElement("path", {
    fill: getTheme$E(props["data-theme"]),
    d: "M11.518 9.987a.799.799 0 1 0 0-1.598H6.193a.799.799 0 1 0 0 1.598h5.325ZM12.316 13.448a.799.799 0 0 1-.798.798H6.193a.799.799 0 1 1 0-1.597h5.325c.44 0 .798.358.798.799Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M17.904 13.479c.163-.527.909-.527 1.072 0l.846 2.74h2.816c.536 0 .767.68.34 1.006l-2.301 1.759.864 2.796c.162.522-.442.944-.877.612l-2.224-1.7-2.225 1.7c-.434.332-1.038-.09-.877-.611l.865-2.797-2.302-1.759a.561.561 0 0 1 .34-1.007h2.816l.847-2.739Z"
  }));
};

var getTheme$F = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCtProfitShare = function SvgTwoColorCtProfitShare(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$F(props["data-theme"]),
    d: "M7.072 14.958a8.5 8.5 0 1 1 14.627-.797c.066.01.132.024.198.04 1.65.412 2.192 2.485.956 3.653l-4.555 4.302a4.374 4.374 0 0 1-3.003 1.194H2.2a.75.75 0 0 1 0-1.5h13.095c.734 0 1.44-.28 1.973-.785l4.555-4.302a.652.652 0 0 0-.846-.991l-4.3 3.308a1.75 1.75 0 0 1-1.067.363h-5.16a.75.75 0 0 1 0-1.5h4.055a.767.767 0 0 1 .05-.079.99.99 0 0 0-.806-1.564H8.166a2.362 2.362 0 0 0-2.292 1.79 1.787 1.787 0 0 1-1.734 1.353H2.2a.75.75 0 0 1 0-1.5h1.94c.132 0 .247-.09.279-.218a3.863 3.863 0 0 1 2.653-2.767Zm.078-4.708a6.97 6.97 0 0 0 1.68 4.55h4.92c1.557 0 2.613 1.355 2.482 2.73l2.332-1.794a.75.75 0 0 1 .153-.18A7 7 0 1 0 7.15 10.25Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m14.218 6 .091.55a4.185 4.185 0 0 0 3.307 3.415 4.185 4.185 0 0 0-3.307 3.415l-.091.55-.088-.526a4.226 4.226 0 0 0-3.31-3.439 4.185 4.185 0 0 0 3.306-3.415l.092-.55Z"
  }));
};

var getTheme$G = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCalendarChart = function SvgTwoColorCalendarChart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$G(props["data-theme"]),
    d: "M8.335 2.1c.394 0 .714.32.714.713v1.094h5.983V2.813a.713.713 0 1 1 1.427 0v1.094h2.625A2.616 2.616 0 0 1 21.7 6.523v12.461a2.616 2.616 0 0 1-2.616 2.616H4.816A2.616 2.616 0 0 1 2.2 18.984V6.524a2.616 2.616 0 0 1 2.616-2.617h2.806V2.813c0-.394.32-.713.713-.713Zm6.697 3.234H9.05v1.094a.713.713 0 1 1-1.427 0V5.334H4.816c-.657 0-1.19.532-1.19 1.19v1.54h16.647v-1.54c0-.658-.532-1.19-1.189-1.19H16.46v1.094a.713.713 0 0 1-1.427 0V5.334ZM3.627 9.491v9.493c0 .657.532 1.19 1.189 1.19h14.268c.657 0 1.19-.533 1.19-1.19V9.491H3.626Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18.136 11.62a.713.713 0 0 0-.713-.713l-3.514-.002a.713.713 0 1 0-.001 1.427h1.739l-2.94 2.765a.238.238 0 0 1-.304.019l-.781-.573a1.665 1.665 0 0 0-2.074.084l-3.95 3.418a.713.713 0 0 0 .933 1.08l3.951-3.42a.238.238 0 0 1 .296-.011l.782.572c.647.475 1.54.42 2.124-.13l3.024-2.843v1.841a.713.713 0 0 0 1.426.001l.002-3.514Z"
  }));
};

var getTheme$H = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCalendar = function SvgTwoColorCalendar(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$H(props["data-theme"]),
    fillRule: "evenodd",
    d: "M8.75 3a.75.75 0 0 0-1.5 0v.25H6A3.75 3.75 0 0 0 2.25 7v11A3.75 3.75 0 0 0 6 21.75h12A3.75 3.75 0 0 0 21.75 18V7A3.75 3.75 0 0 0 18 3.25h-1.25V3a.75.75 0 0 0-1.5 0v.25h-6.5V3Zm11.5 6.25V7A2.25 2.25 0 0 0 18 4.75h-1.25V7a.75.75 0 0 1-1.5 0V4.75h-6.5V7a.75.75 0 0 1-1.5 0V4.75H6A2.25 2.25 0 0 0 3.75 7v2.25h16.5Zm-16.5 1.5h16.5V18A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18v-7.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }));
};

var getTheme$I = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCamera = function SvgTwoColorCamera(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$I(props["data-theme"]),
    fillRule: "evenodd",
    d: "M10.68 4.75a1.25 1.25 0 0 0-.956.444L8.672 6.44a2.75 2.75 0 0 1-2.101.977H5c-.69 0-1.25.56-1.25 1.25V18c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.667c0-.69-.56-1.25-1.25-1.25h-1.437a2.75 2.75 0 0 1-2.28-1.212l-.61-.904a1.25 1.25 0 0 0-1.036-.551h-2.958Zm-2.102-.523a2.75 2.75 0 0 1 2.101-.977h2.958a2.75 2.75 0 0 1 2.28 1.211l.61.905c.232.344.62.55 1.036.55H19a2.75 2.75 0 0 1 2.75 2.75V18A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18V8.667A2.75 2.75 0 0 1 5 5.917h1.57c.369 0 .719-.163.956-.444l1.052-1.246Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 10.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM8.25 13a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z",
    clipRule: "evenodd"
  }));
};

var getTheme$J = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCampaignList = function SvgTwoColorCampaignList(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$J(props["data-theme"]),
    d: "M9.75 6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H9.75Zm0 6a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H9.75ZM9 18c0 .414.336.75.75.75h10.5a.75.75 0 0 0 0-1.5H9.75A.75.75 0 0 0 9 18Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6.747 4.802c.022-.118-.068-.26-.18-.26l-1.282-.188-.584-1.226a.18.18 0 0 0-.09-.095c-.113-.07-.248-.023-.315.095l-.562 1.226-1.282.189c-.067 0-.112.023-.135.07a.236.236 0 0 0 0 .33l.922.944-.225 1.344c0 .047 0 .094.023.141.067.118.202.166.315.095l1.146-.637 1.147.637c.022.023.067.023.112.023h.045a.244.244 0 0 0 .18-.283l-.225-1.344.922-.943a.13.13 0 0 0 .068-.118ZM6 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};

var getTheme$K = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCandleChart = function SvgTwoColorCandleChart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$K(props["data-theme"]),
    d: "M6.75 4a.75.75 0 0 0-1.5 0v1.75H4.3c-.58 0-1.05.47-1.05 1.05v9.4c0 .58.47 1.05 1.05 1.05h.95V19a.75.75 0 0 0 1.5 0v-1.75h.75c.58 0 1.05-.47 1.05-1.05V6.8c0-.58-.47-1.05-1.05-1.05h-.75V4Zm.3 3.25v8.5h-2.3v-8.5h2.3ZM13.75 7a.75.75 0 0 0-1.5 0v1.75h-.95c-.58 0-1.05.47-1.05 1.05v9.4c0 .58.47 1.05 1.05 1.05h.95V22a.75.75 0 0 0 1.5 0v-1.75h.75c.58 0 1.05-.47 1.05-1.05V9.8c0-.58-.47-1.05-1.05-1.05h-.75V7Zm.3 3.25v8.5h-2.3v-8.5h2.3Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M20.46 6.54a.65.65 0 0 0-.92 0l-2 2a.65.65 0 1 0 .92.92l.89-.89v5.097a.65.65 0 0 0 1.3 0V8.569l.89.89a.65.65 0 1 0 .92-.919l-2-2ZM17.246 1l.052.312a2.373 2.373 0 0 0 1.875 1.936 2.373 2.373 0 0 0-1.875 1.936l-.052.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.373 2.373 0 0 0 1.875-1.936L17.246 1Z"
  }));
};

var getTheme$L = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCapital = function SvgTwoColorCapital(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M6.419 6.208A8.75 8.75 0 0 1 21.25 12.5a.75.75 0 0 0 1.5 0c0-5.66-4.59-10.25-10.25-10.25-2.79 0-5.32 1.115-7.167 2.922v-1.38a.75.75 0 1 0-1.5 0v3.166c0 .415.336.75.75.75H7.75a.75.75 0 1 0 0-1.5H6.419Z"
  }), createElement("path", {
    fill: getTheme$L(props["data-theme"]),
    d: "M3.75 12.5a.75.75 0 0 0-1.5 0c0 5.66 4.59 10.25 10.25 10.25 2.79 0 5.32-1.115 7.167-2.922v1.38a.75.75 0 0 0 1.5 0v-3.166a.75.75 0 0 0-.75-.75H17.25a.75.75 0 0 0 0 1.5h1.331A8.75 8.75 0 0 1 3.75 12.5Z"
  }), createElement("path", {
    fill: getTheme$L(props["data-theme"]),
    d: "M8.91 12.56a.4.4 0 0 1 0-.392l3.105-5.545a.4.4 0 0 1 .698 0l3.107 5.545a.4.4 0 0 1 0 .392l-3.107 5.545a.4.4 0 0 1-.698 0l-3.106-5.546Zm2.064.615 1.39 2.484 1.442-2.574-.992.496a1.15 1.15 0 0 1-1.029 0l-.811-.406Zm2.73-1.716-1.34-2.39-1.367 2.441 1.303.651 1.404-.702Z"
  }));
};

var getTheme$M = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCelebration = function SvgTwoColorCelebration(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M20.694 4.24a.75.75 0 1 1 0 1.5c-.622 0-.893.157-1.03.29-.158.15-.268.386-.36.77-.037.158-.067.318-.1.497l-.02.108a6.56 6.56 0 0 1-.156.68c-.137.458-.41 1.027-1.07 1.296a3.966 3.966 0 0 1-2.147.26 3.531 3.531 0 0 1-.844-.25 1.886 1.886 0 0 1-.058-.027l-.02-.01-.008-.004-.003-.002-.002-.001.356-.66-.312.577-.044.083a.75.75 0 0 1 .705-1.324l.012.005a2.033 2.033 0 0 0 .46.131c.324.053.792.057 1.34-.167.036-.015.112-.05.2-.339.042-.143.077-.312.116-.523l.018-.096c.033-.179.07-.383.118-.582.112-.47.307-1.052.78-1.506.494-.473 1.18-.706 2.069-.706ZM19.815 14.711a.75.75 0 0 0 0-1.06l-.53.53.53-.53-.001-.002h-.002l-.002-.003-.006-.007-.017-.015a2.855 2.855 0 0 0-.217-.18 4 4 0 0 0-.606-.372c-.53-.266-1.3-.519-2.304-.52-.985-.002-1.821.6-2.335 1.065a6.97 6.97 0 0 0-.878.966l-.015.02-.005.006-.001.002v.001a.75.75 0 0 0 1.222.87v-.002l.007-.009.033-.044a5.433 5.433 0 0 1 .644-.698c.452-.409.926-.678 1.325-.678.745.002 1.288.188 1.634.362a2.492 2.492 0 0 1 .458.294l.011.01a.75.75 0 0 0 1.055-.006Zm-5.778.335.612.434-.612-.434Zm-.035-.024-.577-.41.577.41ZM10.114 4.55a.75.75 0 0 0-1.06 0l-.007 1.055.01.01a2.49 2.49 0 0 1 .294.458c.174.347.36.89.36 1.637 0 .4-.272.877-.683 1.33a5.502 5.502 0 0 1-.745.68l-.01.007v.001a.75.75 0 0 0 .87 1.222l.003-.002.006-.005.02-.014a5.143 5.143 0 0 0 .292-.232 7 7 0 0 0 .676-.65c.466-.514 1.07-1.352 1.07-2.337 0-1.006-.252-1.778-.517-2.307a3.985 3.985 0 0 0-.372-.608 2.84 2.84 0 0 0-.18-.217l-.016-.017-.006-.006-.002-.002-.002-.002Zm0 0-.066.067-.464.464.53-.53Zm-1.399 5.8.427.6-.427-.6Zm-.441-.623.223.315.002.003.209.294-.434-.612ZM14.114 11.21a.75.75 0 0 0-1.06-1.06l-2.122 2.121a.75.75 0 0 0 1.061 1.061l2.121-2.121ZM6.205 7.002a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414ZM19.968 11.532a1.25 1.25 0 1 0 1.768-1.768 1.25 1.25 0 0 0-1.768 1.768ZM14.266 4.063a1.5 1.5 0 1 1-2.121-2.122 1.5 1.5 0 0 1 2.121 2.122ZM16.952 17.82a.75.75 0 1 0 1.06-1.06.75.75 0 0 0-1.06 1.06ZM14.145 6.941a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707ZM16.438 2.941a.5.5 0 1 0 .707-.707.5.5 0 0 0-.707.707Z"
  }), createElement("path", {
    fill: getTheme$M(props["data-theme"]),
    d: "M2.312 23.035c-.83.356-1.67-.483-1.313-1.313L6.434 9.048a1 1 0 0 1 1.627-.313l7.238 7.239a1 1 0 0 1-.313 1.626L2.312 23.035Zm6.81-4.552-3.57-3.57-2.682 6.25 6.252-2.68Zm1.485-.637 3.11-1.334-6.195-6.194-1.334 3.11 4.419 4.418Z"
  }));
};

var getTheme$N = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorChartScreen = function SvgTwoColorChartScreen(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$N(props["data-theme"]),
    d: "M19.6 17.75A2.75 2.75 0 0 0 22.35 15V6a2.75 2.75 0 0 0-2.75-2.75h-15A2.75 2.75 0 0 0 1.85 6v9a2.75 2.75 0 0 0 2.75 2.75h4.7v3.5H7.6a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-1.8v-3.5h4.8Zm-6.3 0v3.5h-2.5v-3.5h2.5ZM20.85 15c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v9Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18.53 7.07a.75.75 0 0 1 0 1.06l-4.097 4.098a.75.75 0 0 1-1.01.046l-2.987-2.489-3.906 3.906a.75.75 0 1 1-1.06-1.06l4.39-4.39a.75.75 0 0 1 1.01-.046l2.986 2.488L17.47 7.07a.75.75 0 0 1 1.06 0Z"
  }));
};

var getTheme$O = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorChaseLimitOrders = function SvgTwoColorChaseLimitOrders(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$O(props["data-theme"]),
    d: "M4.6 20.25c-.69 0-1.25-.56-1.25-1.25V5.105c0-.69.56-1.25 1.25-1.25h11.79c.69 0 1.25.56 1.25 1.25V15.58a.75.75 0 1 0 1.5 0V8.592H20c.69 0 1.25.56 1.25 1.25V19c0 .69-.56 1.25-1.25 1.25H4.6ZM19.14 7.092V5.105a2.75 2.75 0 0 0-2.75-2.75H4.6a2.75 2.75 0 0 0-2.75 2.75V19a2.75 2.75 0 0 0 2.75 2.75H20A2.75 2.75 0 0 0 22.75 19V9.842A2.75 2.75 0 0 0 20 7.092h-.86Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.6 9.75a.75.75 0 0 0 0-1.5h-9a.75.75 0 1 0 0 1.5h9ZM14.6 13.15a.75.75 0 1 0 0-1.5h-2.4a.75.75 0 0 0 0 1.5h2.4ZM15.35 15.7a.75.75 0 0 1-.75.75h-2.4a.75.75 0 0 1 0-1.5h2.4a.75.75 0 0 1 .75.75ZM6.6 16.75h2A1.75 1.75 0 0 0 10.35 15v-2a1.75 1.75 0 0 0-1.75-1.75h-2A1.75 1.75 0 0 0 4.85 13v2c0 .967.783 1.75 1.75 1.75Zm2-1.5h-2a.25.25 0 0 1-.25-.25v-2a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25v2a.25.25 0 0 1-.25.25Z"
  }));
};

var getTheme$P = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorClaimYields = function SvgTwoColorClaimYields(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$P(props["data-theme"]),
    d: "M18.011 14.02a.739.739 0 0 1 .945 1.135l-4.474 4.024a2.699 2.699 0 0 1-1.805.693H8a1.75 1.75 0 0 0-1.75 1.75v.614a.75.75 0 0 0 1.5 0v-.614a.25.25 0 0 1 .25-.25h4.677a4.199 4.199 0 0 0 2.808-1.077l4.474-4.025c1.352-1.215.768-3.45-1.006-3.848a2.239 2.239 0 0 0-1.856.41l-3.81 2.93c.114-1.317-.898-2.612-2.396-2.612H6.118a4.796 4.796 0 0 0-4.706 3.878l-.115.588a2.54 2.54 0 0 0-.047.486v4.138a.75.75 0 0 0 1.5 0v-4.138c0-.067.006-.134.02-.2l.114-.587a3.296 3.296 0 0 1 3.234-2.665h4.773a.9.9 0 0 1 .722 1.438.745.745 0 0 0-.058.09H7.5a.75.75 0 0 0 0 1.5h5.16a1.75 1.75 0 0 0 1.067-.362l4.284-3.296Z"
  }), createElement("path", {
    fill: getTheme$P(props["data-theme"]),
    d: "M12.5 2.75a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5ZM6.75 7a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.25 7a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0ZM20.685 2.8l.052.312a2.372 2.372 0 0 0 1.874 1.936 2.372 2.372 0 0 0-1.875 1.936l-.051.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.372 2.372 0 0 0 1.875-1.936l.052-.312Z"
  }));
};

var getTheme$Q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCnpj = function SvgTwoColorCnpj(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M23.624 9a.75.75 0 0 1-.75.75h-20a.75.75 0 0 1 0-1.5h20a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$Q(props["data-theme"]),
    fillRule: "evenodd",
    d: "M23.624 17a2.75 2.75 0 0 1-2.75 2.75h-16A2.75 2.75 0 0 1 2.124 17V7a2.75 2.75 0 0 1 2.75-2.75h16A2.75 2.75 0 0 1 23.624 7v10Zm-2.75 1.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25h-16c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6.955 16.08a2.24 2.24 0 0 1-.825-.146 1.714 1.714 0 0 1-.627-.449 2.053 2.053 0 0 1-.396-.732 3.425 3.425 0 0 1-.139-1.023c0-.388.046-.73.139-1.03.092-.304.224-.557.396-.759.176-.207.385-.363.627-.469.246-.105.521-.158.825-.158.413 0 .757.088 1.03.264.272.176.49.442.653.799l-.746.396a1.028 1.028 0 0 0-.323-.495c-.15-.128-.355-.192-.614-.192-.326 0-.585.11-.779.33-.19.22-.284.528-.284.924v.726c0 .4.095.709.284.924.194.211.453.317.779.317.26 0 .47-.07.633-.211.168-.141.289-.315.363-.522l.707.416c-.168.343-.39.612-.667.805-.277.19-.623.284-1.036.284Zm3.766-2.443-.475-.957h-.02V16H9.4v-4.607h.957l1.386 2.363.475.957h.02v-3.32h.825V16h-.957l-1.386-2.363ZM14.145 16v-4.607h2.072c.211 0 .4.035.568.106.171.066.316.163.435.29.119.123.21.273.27.449.062.176.093.37.093.58 0 .216-.03.412-.092.588a1.29 1.29 0 0 1-.27.449 1.26 1.26 0 0 1-.436.29 1.536 1.536 0 0 1-.568.1h-1.201V16h-.871Zm.87-2.508h1.123c.167 0 .299-.044.396-.132a.513.513 0 0 0 .145-.39v-.303c0-.167-.048-.295-.145-.383a.567.567 0 0 0-.396-.132h-1.122v1.34Zm5.499-2.099v3.313c0 .207-.035.394-.106.561a1.16 1.16 0 0 1-.29.43 1.279 1.279 0 0 1-.455.277c-.18.066-.383.099-.608.099-.426 0-.759-.11-.996-.33-.238-.225-.39-.522-.456-.891l.806-.165a.94.94 0 0 0 .21.462.58.58 0 0 0 .43.158.585.585 0 0 0 .422-.158c.115-.11.172-.278.172-.502v-2.541H18.19v-.713h2.323Z"
  }));
};

var getTheme$R = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCollateral = function SvgTwoColorCollateral(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$R(props["data-theme"]),
    d: "M4.055 11.823A8.75 8.75 0 1 1 5.973 18a.75.75 0 0 0-1.166.943 10.232 10.232 0 0 0 7.972 3.807c5.661 0 10.25-4.59 10.25-10.25S18.44 2.25 12.78 2.25c-5.413 0-9.845 4.195-10.224 9.512l-.678-.9a.75.75 0 0 0-1.198.902l1.702 2.26a.75.75 0 0 0 1.05.147l2.26-1.702a.75.75 0 1 0-.903-1.198l-.733.552Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.329 10.49a.581.581 0 0 1-.576.586.581.581 0 0 1-.576-.586c0-.324.258-.586.576-.586.318 0 .576.262.576.586Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m17.893 7.966-.128-.51-.503-.133c-.904-.243-2.09-.03-3.216.456a9.175 9.175 0 0 0-3.108 2.229c-.908.065-1.667.468-2.371 1.185l-.758.77 1.957 1.34c-.035.603.24 1.212.65 1.63.407.414 1 .694 1.584.666l1.32 2.022.761-.775c.72-.733 1.123-1.51 1.178-2.45a9.47 9.47 0 0 0 2.181-3.16c.479-1.144.692-2.348.453-3.27Zm-3.266 1.206c.753-.325 1.409-.448 1.877-.436.012.475-.111 1.14-.432 1.906a7.939 7.939 0 0 1-2.039 2.84l-.269.238.013.362c.014.394-.06.74-.27 1.092l-.93-1.425-.597.328c-.003.001-.053.022-.16-.004a.759.759 0 0 1-.353-.21.763.763 0 0 1-.204-.355c-.025-.111-.002-.164.002-.17l.328-.607-1.385-.948c.337-.203.673-.28 1.054-.27l.352.008.23-.273a7.68 7.68 0 0 1 2.783-2.076ZM9.979 16.584c-.584.606-2.135.877-2.135.877s.323-1.673.846-2.216c.443-.46 1.086-.544 1.449-.167s.283 1.046-.16 1.506Z"
  }));
};

var getTheme$S = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorColumnChart = function SvgTwoColorColumnChart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$S(props["data-theme"]),
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.95 9a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0V9ZM16.5 9.964a.75.75 0 0 1 .75.75V15a.75.75 0 1 1-1.5 0v-4.286a.75.75 0 0 1 .75-.75ZM8 10.564a.75.75 0 0 1 .75.75v3.6a.75.75 0 0 1-1.5 0v-3.6a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$T = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCommunity = function SvgTwoColorCommunity(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M17.37 23.372c-1.084 1.16-3.03.394-3.03-1.194v-3.51a.75.75 0 1 1 1.5 0v3.51a.25.25 0 0 0 .433.17l4.679-5.01a.75.75 0 0 1 1.096 1.024l-4.678 5.01Z"
  }), createElement("path", {
    fill: getTheme$T(props["data-theme"]),
    d: "M5 3.3a2.75 2.75 0 0 0-2.75 2.75v10.4A2.75 2.75 0 0 0 5 19.2h15a2.75 2.75 0 0 0 2.75-2.75V6.05A2.75 2.75 0 0 0 20 3.3H5ZM3.75 6.05c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v10.4c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25V6.05Zm4.818 6.793a.75.75 0 0 0-.772 1.287 9.143 9.143 0 0 0 9.408 0 .75.75 0 0 0-.772-1.287 7.643 7.643 0 0 1-7.864 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M8.614 11.141a1.295 1.295 0 1 0 0-2.59 1.295 1.295 0 0 0 0 2.59Zm7.773 0a1.295 1.295 0 1 0 0-2.59 1.295 1.295 0 0 0 0 2.59Z"
  }));
};

var getTheme$U = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorConnection = function SvgTwoColorConnection(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$U(props["data-theme"]),
    d: "M3.25 16.194V8A4.75 4.75 0 0 1 8 3.25h8.106v1.5H8A3.25 3.25 0 0 0 4.75 8v8.194h-1.5Zm5.178 3.056H16A3.25 3.25 0 0 0 19.25 16V8.783h1.5V16A4.75 4.75 0 0 1 16 20.75H8.428v-1.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18.6 3.55a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM14.85 5.8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM6 15.85a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM2.25 18.1a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
  }));
};

var getTheme$V = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorContactSupport = function SvgTwoColorContactSupport(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M3.042 5.06a.75.75 0 0 1 1.047-.168l7.83 5.654a1.25 1.25 0 0 0 1.463 0l7.829-5.654a.75.75 0 0 1 .878 1.216l-7.829 5.654a2.75 2.75 0 0 1-3.22 0L3.21 6.108a.75.75 0 0 1-.168-1.047ZM6.15 13.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5Z"
  }), createElement("path", {
    fill: getTheme$V(props["data-theme"]),
    d: "M10 17.25h10c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6a.75.75 0 0 1-1.5 0V6A2.75 2.75 0 0 1 5 3.25h15A2.75 2.75 0 0 1 22.75 6v10A2.75 2.75 0 0 1 20 18.75H10a.75.75 0 0 1 0-1.5Z"
  }));
};

var getTheme$W = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorContracttransaction = function SvgTwoColorContracttransaction(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M16.5 12.355a.375.375 0 0 1-.26.645H9.75a.75.75 0 0 1 0-1.5h4.302v-1.03a.2.2 0 0 1 .339-.144l2.11 2.029Zm-9 2.29A.375.375 0 0 1 7.76 14h6.49a.75.75 0 0 1 0 1.5H9.948v1.03a.2.2 0 0 1-.339.144L7.5 14.645Z"
  }), createElement("path", {
    fill: getTheme$W(props["data-theme"]),
    d: "M6.75 3a.75.75 0 0 1 1.5 0h7.5a.75.75 0 0 1 1.5 0H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h.75Zm9 1.5h-7.5a.75.75 0 0 1-1.5 0H6A1.5 1.5 0 0 0 4.5 6v.75h15V6A1.5 1.5 0 0 0 18 4.5h-.75a.75.75 0 0 1-1.5 0ZM4.5 8.25V18A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5V8.25h-15Z"
  }));
};

var getTheme$X = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorConvert = function SvgTwoColorConvert(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$X(props["data-theme"]),
    d: "M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-9 2.25a.75.75 0 0 1 .75.75 8.25 8.25 0 0 0 13.913 6H16.5a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-1.214A9.719 9.719 0 0 1 12 21.75c-5.385 0-9.75-4.365-9.75-9.75a.75.75 0 0 1 .75-.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6.338 6a8.25 8.25 0 0 1 13.912 6 .75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75a9.72 9.72 0 0 0-6.75 2.714V3.75a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H6.338Z"
  }));
};

var getTheme$Y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCopyTrading = function SvgTwoColorCopyTrading(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M5.837 6.515a8.25 8.25 0 0 1 14.382 4.767.75.75 0 1 0 1.494-.13c-.468-5.365-5.197-9.334-10.561-8.865a9.72 9.72 0 0 0-6.488 3.291l-.106-1.21a.75.75 0 0 0-1.494.13l.26 2.99a.75.75 0 0 0 .813.681l2.989-.26a.75.75 0 0 0-.13-1.495l-1.16.101Z"
  }), createElement("path", {
    fill: getTheme$Y(props["data-theme"]),
    d: "M10.5 8.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm0 6a3.375 3.375 0 1 1 6.75 0V15a.75.75 0 0 1-.75.75h-5.25a.75.75 0 0 1-.75-.75v-.375Zm5.212-.375a1.876 1.876 0 0 0-3.675 0h3.675Zm-1.837-3.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm-4.125 0A3.75 3.75 0 0 0 6 14.25c0 .414.336.75.75.75H9a.75.75 0 0 0 0-1.5H7.628A2.25 2.25 0 0 1 9.75 12a.75.75 0 0 0 0-1.5Zm-6.781 1.536a.75.75 0 0 1 .812.681 8.25 8.25 0 0 0 14.382 4.768l-1.159.1a.75.75 0 1 1-.13-1.494l2.988-.26a.75.75 0 0 1 .813.681l.26 2.99a.75.75 0 0 1-1.493.13l-.106-1.21a9.719 9.719 0 0 1-6.488 3.291c-5.365.468-10.093-3.5-10.561-8.865a.75.75 0 0 1 .682-.812Z"
  }));
};

var getTheme$Z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCouponBuyCrypto = function SvgTwoColorCouponBuyCrypto(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M3.25 13a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM15.25 17a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$Z(props["data-theme"]),
    fillRule: "evenodd",
    d: "M21.75 20A1.75 1.75 0 0 1 20 21.75H5A1.75 1.75 0 0 1 3.25 20V10c0-.966.783-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v10Zm-1.75.25a.25.25 0 0 0 .25-.25V10a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h15Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$Z(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.057 13.88a.854.854 0 0 1-1.003-.672l-1.08-5.49a1.992 1.992 0 0 1 1.57-2.34l11.453-2.253a1.992 1.992 0 0 1 2.338 1.561l.815 4.045a.854.854 0 1 1-1.673.338l-.816-4.045a.285.285 0 0 0-.334-.223L3.874 7.053a.285.285 0 0 0-.224.335l1.08 5.49a.854.854 0 0 1-.673 1.003Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$Z(props["data-theme"]),
    d: "m21.75 6 .008.06c.05.378.361.668.742.69l-.028.005a.895.895 0 0 0-.722.745.834.834 0 0 0-.681-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }));
};

var getTheme$_ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCouponDerivatives = function SvgTwoColorCouponDerivatives(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$_(props["data-theme"]),
    fillRule: "evenodd",
    d: "m18.09 8.25-.653-2.045a.25.25 0 0 0-.314-.162l-6.89 2.207h7.858Zm-12.556 0a.747.747 0 0 1 .275-.158l10.856-3.477a1.75 1.75 0 0 1 2.2 1.133l.829 2.59A2.751 2.751 0 0 1 21.75 11v1.17a.75.75 0 0 1-.5.708 2.251 2.251 0 0 0 0 4.244c.3.106.5.39.5.707V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.17c0-.319.2-.602.5-.708a2.251 2.251 0 0 0 0-4.244.75.75 0 0 1-.5-.707V11A2.75 2.75 0 0 1 5 8.25h.534ZM3.75 11c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v.683a3.749 3.749 0 0 0 0 6.634V19c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-.683a3.75 3.75 0 0 0 0-6.634V11Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364ZM11.725 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L12 16.16l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
  }));
};

var getTheme$$ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCpf = function SvgTwoColorCpf(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M21.999 9.75a.75.75 0 0 0 0-1.5h-20a.75.75 0 0 0 0 1.5h20Zm-6.69 1.592v5.35h1.012v-2.26h2.115v-.898h-2.115V12.24h2.43v-.897h-3.442Zm-4.911 5.35v-5.35h2.406c.245 0 .465.041.66.123.199.077.367.189.505.337.138.143.243.317.315.521.071.205.107.43.107.675 0 .25-.036.478-.107.682-.072.2-.177.373-.315.521a1.465 1.465 0 0 1-.505.338 1.785 1.785 0 0 1-.66.115H11.41v2.038h-1.011Zm1.011-2.912h1.303c.194 0 .348-.051.46-.153.113-.108.169-.259.169-.453v-.352c0-.195-.056-.343-.169-.445-.112-.102-.266-.153-.46-.153H11.41v1.556ZM6.6 16.616c.286.112.606.168.958.168.48 0 .882-.11 1.204-.33.321-.224.58-.536.774-.935l-.82-.482a1.4 1.4 0 0 1-.422.605c-.19.164-.434.245-.736.245-.378 0-.68-.122-.904-.368-.22-.25-.33-.608-.33-1.073v-.843c0-.46.11-.817.33-1.073.225-.255.526-.383.904-.383.302 0 .54.074.713.222.174.143.299.335.376.575l.866-.46c-.19-.414-.442-.723-.76-.927-.316-.205-.715-.307-1.195-.307-.352 0-.672.061-.958.184a1.993 1.993 0 0 0-.728.544c-.2.235-.353.53-.46.882a4.055 4.055 0 0 0-.161 1.195c0 .45.054.846.161 1.188.107.338.26.621.46.851.204.23.447.404.728.521Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$$(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.749 17a2.75 2.75 0 0 1-2.75 2.75h-16A2.75 2.75 0 0 1 1.249 17V7a2.75 2.75 0 0 1 2.75-2.75h16A2.75 2.75 0 0 1 22.749 7v10Zm-2.75 1.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25h-16c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }));
};

var getTheme$10 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorCreateBot = function SvgTwoColorCreateBot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
  }), createElement("path", {
    fill: getTheme$10(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 10.3A2.75 2.75 0 0 1 5 7.55h14a2.75 2.75 0 0 1 2.75 2.75v4.5a.75.75 0 1 1-1.5 0v-4.5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5H5a2.75 2.75 0 0 1-2.75-2.75v-9Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M18 15.05a.75.75 0 0 1 .75.75v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M14.25 18.8a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M16 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }));
};

var getTheme$11 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDcaTradingBot = function SvgTwoColorDcaTradingBot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$11(props["data-theme"]),
    d: "M8 3.25a.75.75 0 0 1 .75.75v1.25h6.5V4a.75.75 0 0 1 1.5 0v1.25h1.75a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-11A2.25 2.25 0 0 1 5.5 5.25h1.75V4A.75.75 0 0 1 8 3.25Zm7.25 3.5h-6.5V8a.75.75 0 0 1-1.5 0V6.75H5.5a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-1.75V8a.75.75 0 0 1-1.5 0V6.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M16.178 13.84a.75.75 0 1 0 1.453-.374l-.75-2.905a.75.75 0 0 0-.914-.539l-2.905.75a.75.75 0 0 0 .375 1.453l1.18-.305-2.345 3.098-3.517-3.198a.75.75 0 0 0-1.129.139l-1.5 2.25a.75.75 0 0 0 1.248.832l1.017-1.525 3.48 3.164a.75.75 0 0 0 1.102-.102l2.917-3.855.288 1.118Z"
  }));
};

var getTheme$12 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDcaTrading = function SvgTwoColorDcaTrading(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$12(props["data-theme"]),
    d: "M8 3.25a.75.75 0 0 1 .75.75v1.25h6.5V4a.75.75 0 0 1 1.5 0v1.25h1.75a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-11A2.25 2.25 0 0 1 5.5 5.25h1.75V4A.75.75 0 0 1 8 3.25Zm7.25 3.5h-6.5V8a.75.75 0 0 1-1.5 0V6.75H5.5a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-1.75V8a.75.75 0 0 1-1.5 0V6.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M16.178 13.84a.75.75 0 1 0 1.453-.374l-.75-2.905a.75.75 0 0 0-.914-.539l-2.905.75a.75.75 0 0 0 .375 1.453l1.18-.305-2.345 3.098-3.517-3.198a.75.75 0 0 0-1.129.139l-1.5 2.25a.75.75 0 0 0 1.248.832l1.017-1.525 3.48 3.164a.75.75 0 0 0 1.102-.102l2.917-3.855.288 1.118Z"
  }));
};

var getTheme$13 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDemoTrading = function SvgTwoColorDemoTrading(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$13(props["data-theme"]),
    d: "M6.25 8.5A2.25 2.25 0 0 1 8.5 6.25h11a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-11Zm2.25-.75a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-11Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v11a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-11Zm2.25-.75a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-11a.75.75 0 0 0-.75-.75h-11Z"
  }));
};

var getTheme$14 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDeposit = function SvgTwoColorDeposit(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$14(props["data-theme"]),
    d: "M3.632 5.496a2.25 2.25 0 0 0-1.733 2.669l1.35 6.356V18.5a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-.948l-.49-2.308a2.25 2.25 0 0 0-2.67-1.733L3.633 5.496ZM16.017 7.25H5.5a2.25 2.25 0 0 0-2.002 1.222l-.132-.619a.75.75 0 0 1 .578-.89l10.76-2.286a.75.75 0 0 1 .89.577l.423 1.996ZM4.75 9.5a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-9Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.469 10.914a.75.75 0 0 1 .117 1.055L14.56 13.25H23a.75.75 0 0 1 0 1.5h-8.44l1.026 1.282a.75.75 0 0 1-1.172.936L12.04 14l2.374-2.969a.75.75 0 0 1 1.055-.117Z"
  }));
};

var getTheme$15 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDerivatives = function SvgTwoColorDerivatives(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$15(props["data-theme"]),
    fillRule: "evenodd",
    d: "M9.653 6.404a5.75 5.75 0 1 1 7.942 7.942.75.75 0 0 0 .81 1.264A7.25 7.25 0 1 0 8.39 5.596a.75.75 0 0 0 1.262.808ZM3.75 14.5a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0ZM9.5 7.25a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.225 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L9.5 16.16l-1.522 1.057a.29.29 0 0 1-.442-.332l.575-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
  }));
};

var getTheme$16 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDerivatves = function SvgTwoColorDerivatves(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$16(props["data-theme"]),
    d: "M2.25 5.5A2.25 2.25 0 0 1 4.5 3.25h15a2.25 2.25 0 0 1 2.25 2.25v13a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-13Zm2.25-.75a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-13a.75.75 0 0 0-.75-.75h-15Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.5 6h1v2h1v6h-1v2h-1v-2h-1V8h1V6Zm-6 2h1v2h1v6h-1v2h-1v-2h-1v-6h1V8Z"
  }));
};

var getTheme$17 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDiscountBuy = function SvgTwoColorDiscountBuy(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$17(props["data-theme"]),
    d: "M3 12a8.25 8.25 0 1 1 16.5 0 .75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75S1.5 6.615 1.5 12a9.743 9.743 0 0 0 4.551 8.25H2.25a.75.75 0 0 0 0 1.5h10.447a2.25 2.25 0 0 0 1.573-.641L18 17.464a.75.75 0 0 1 .524-.214h3.227a.75.75 0 0 0 0-1.5h-3.227a2.25 2.25 0 0 0-1.573.641l-3.728 3.645a.75.75 0 0 1-.525.214H11.25A8.25 8.25 0 0 1 3 12Zm15 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 18 21Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.586 7.704a.756.756 0 0 1 0 1.07L8.1 16.26a.756.756 0 0 1-1.07-1.07l7.488-7.487a.756.756 0 0 1 1.07 0ZM13.917 14.062a.605.605 0 1 0 0 1.21.605.605 0 0 0 0-1.21Zm-1.664.605a1.664 1.664 0 1 1 3.328 0 1.664 1.664 0 0 1-3.328 0ZM8.623 8.768a.605.605 0 1 0 0 1.21.605.605 0 0 0 0-1.21Zm-1.664.605a1.664 1.664 0 1 1 3.327 0 1.664 1.664 0 0 1-3.327 0Z"
  }));
};

var getTheme$18 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDocuments = function SvgTwoColorDocuments(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$18(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19 2.25c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0 1 19 21.75H5A1.75 1.75 0 0 1 3.25 20V4c0-.966.783-1.75 1.75-1.75h14ZM19.25 4a.25.25 0 0 0-.25-.25H5a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V4Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "m16.158 15.068.016-.216v.217h.014c.266 0 .703 0 1.077-.153.194-.08.382-.206.519-.401.137-.195.212-.444.213-.75a1.112 1.112 0 0 0-.339-.888c-.295-.287-.791-.48-1.575-.496h-.005c-.657 0-1.311.089-1.956.209a9.492 9.492 0 0 1-1.826-2.367c.26-.875.4-1.622.425-2.23.025-.624-.071-1.133-.322-1.48l-.002-.004a1.281 1.281 0 0 0-1-.506c-.49-.034-.956.194-1.193.625-.17.287-.23.63-.226.977.003.35.07.722.165 1.079.178.667.462 1.307.658 1.708A22.714 22.714 0 0 1 9.178 14.2c-1.491.65-2.282 1.186-2.702 1.611a1.752 1.752 0 0 0-.403.58 1.167 1.167 0 0 0 .58 1.45c.182.128.42.159.592.159.484 0 .969-.27 1.444-.734.467-.455.948-1.121 1.438-1.984a22.764 22.764 0 0 1 3.613-1.161 4.319 4.319 0 0 0 2.418.947Zm-4.705-7.882Zm1.018 6.16c-.47.119-.957.262-1.428.42.231-.488.448-.988.65-1.49l.012.012.001-.002c.227.32.481.634.751.932h-.114l.128.129Z",
    clipRule: "evenodd"
  }));
};

var getTheme$19 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDoubleWin = function SvgTwoColorDoubleWin(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M8.99 7.5A5.989 5.989 0 0 0 7 7.841a6 6 0 1 0 7 8.976l1.25.83A7.5 7.5 0 1 1 9.416 6.012L9.354 7.51 8.99 7.5Z"
  }), createElement("path", {
    fill: getTheme$19(props["data-theme"]),
    d: "M15 4.5a6 6 0 0 0-6 6 .75.75 0 0 1-1.5 0 7.5 7.5 0 1 1 3.679 6.455.75.75 0 1 1 .765-1.29A6 6 0 1 0 15 4.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m17.064 8.618-3.258-.873a.75.75 0 0 0-.388 1.448l1.51.405-8.175 4.72a.75.75 0 1 0 .75 1.3l8.176-4.72-.405 1.51a.75.75 0 1 0 1.449.389l.873-3.259v-.001a.746.746 0 0 0-.53-.919h-.002Z"
  }));
};

var getTheme$1a = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDownTrend = function SvgTwoColorDownTrend(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1a(props["data-theme"]),
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m16.418 13.956-4.26-1.81.408-1.38a.75.75 0 0 0-.388-.886L6.532 7.1a.75.75 0 1 0-.663 1.346l5.08 2.501-.418 1.416a.75.75 0 0 0 .426.902l4.739 2.014-1.728.486c-.407.114-.648.523-.538.913.11.39.53.613.937.498l3.434-.965c.4-.113.641-.51.543-.896l-.841-3.31c-.1-.393-.514-.626-.924-.522-.41.105-.66.508-.561.9l.4 1.573Z"
  }));
};

var getTheme$1b = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDriver = function SvgTwoColorDriver(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1b(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5.923 8.585A.6.6 0 0 1 6.5 8.15h5a.6.6 0 0 1 .577.435l.533 1.865H13a.6.6 0 1 1 0 1.2h-.047l.124.435a.6.6 0 0 1 .022.205l-.2 3a.6.6 0 0 1-.6.56H11a.6.6 0 0 1-.536-.332l-.334-.668H7.871l-.334.668A.6.6 0 0 1 7 15.85H5.7a.6.6 0 0 1-.599-.56l-.2-3a.6.6 0 0 1 .022-.205l.124-.435H5a.6.6 0 1 1 0-1.2h.39l.533-1.865Zm.372 3.065-.085.3H7a.5.5 0 0 1 0 1h-.852l.113 1.7h.368l.334-.668a.6.6 0 0 1 .537-.332h3a.6.6 0 0 1 .537.332l.334.668h.368l.113-1.7H10.5a.5.5 0 1 1 0-1h1.29l-.085-.3h-5.41Zm5.067-1.2H6.638l.314-1.1h4.095l.315 1.1ZM18 11.6a.6.6 0 1 0 0-1.2h-2a.6.6 0 0 0 0 1.2h2Zm1 3a.6.6 0 1 0 0-1.2h-3a.6.6 0 0 0 0 1.2h3Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1c = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorDualAsset = function SvgTwoColorDualAsset(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M14.939 5.915a.75.75 0 0 1 .83-.66 6.751 6.751 0 0 1 .111 13.4.75.75 0 1 1-.194-1.488A5.251 5.251 0 0 0 15.6 6.745a.75.75 0 0 1-.661-.83Z"
  }), createElement("path", {
    fill: getTheme$1c(props["data-theme"]),
    d: "M10 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM1.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }));
};

var getTheme$1d = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorEth20 = function SvgTwoColorEth20(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m11 7.31-2.728 4.288L11 12.726l2.728-1.128L11 7.311Zm.723-2.056 3.988 6.267a.861.861 0 0 1 .012.94l-4 6.285a.857.857 0 0 1-1.446 0L6.283 12.47a.856.856 0 0 1 .004-.946l3.99-6.27a.857.857 0 0 1 1.446 0ZM9.18 13.83l1.82 2.86 1.82-2.86-1.492.617a.857.857 0 0 1-.656 0L9.18 13.83Z"
  }), createElement("path", {
    fill: getTheme$1d(props["data-theme"]),
    d: "M11 3.75A8.25 8.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0c0 5.385-4.365 9.75-9.75 9.75S1.25 17.385 1.25 12 5.615 2.25 11 2.25c2.003 0 3.867.605 5.417 1.642a.75.75 0 1 1-.834 1.247A8.208 8.208 0 0 0 11 3.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M20.53 4.47a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22V12a.75.75 0 0 0 1.5 0V6.81l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5Z"
  }));
};

var getTheme$1e = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorEdit = function SvgTwoColorEdit(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1e(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.471 12.845a.75.75 0 0 1 .21-.403l8.63-8.631a4.638 4.638 0 0 1 6.56 6.56L11.24 19a.75.75 0 0 1-.403.21l-6.643 1.144a.75.75 0 0 1-.867-.867l1.144-6.643Zm1.233 1.682 3.451 3.451-4.17.718.719-4.17Zm5.005 2.884 6.727-6.726-4.438-4.439-6.727 6.727 4.438 4.438Zm3.35-12.225 4.437 4.438.315-.314a3.138 3.138 0 1 0-4.439-4.438l-.314.314Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }));
};

var getTheme$1f = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorEmail = function SvgTwoColorEmail(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M2.392 5.06a.75.75 0 0 1 1.047-.168l7.83 5.654a1.25 1.25 0 0 0 1.463 0l7.829-5.654a.75.75 0 0 1 .878 1.216l-7.829 5.654a2.75 2.75 0 0 1-3.22 0L2.56 6.108a.75.75 0 0 1-.168-1.047Z"
  }), createElement("path", {
    fill: getTheme$1f(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1g = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorEndedBots = function SvgTwoColorEndedBots(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
  }), createElement("path", {
    fill: getTheme$1g(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 10.3A2.75 2.75 0 0 1 5 7.55h14a2.75 2.75 0 0 1 2.75 2.75v9A2.75 2.75 0 0 1 19 22.05H5a2.75 2.75 0 0 1-2.75-2.75v-9ZM5 9.05c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-9c0-.69-.56-1.25-1.25-1.25H5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 11.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1h = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorEvents = function SvgTwoColorEvents(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1h(props["data-theme"]),
    fillRule: "evenodd",
    d: "M5.75 21.25H4.5a.75.75 0 0 0 0 1.5h4.6a.75.75 0 0 0 0-1.5H7.25v-6.5H20.5a.75.75 0 0 0 .675-1.075L19.166 9.5l2.01-4.175A.75.75 0 0 0 20.5 4.25H7.25V3a.75.75 0 1 0-1.5 0v18.25Zm1.5-15.5v7.5h12.056l-1.649-3.425a.75.75 0 0 1 0-.65l1.65-3.425H7.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.7 8.4c0-.22.179-.4.4-.4h4.7c.22 0 .4.18.4.4v2.2a.4.4 0 0 1-.4.4h-4.7a.4.4 0 0 1-.4-.4V8.4Z"
  }));
};

var getTheme$1i = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorExplore = function SvgTwoColorExplore(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1i(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m10.995 10.995 3.076-1.066-1.066 3.076-3.076 1.066 1.066-3.076ZM10 9.753a.4.4 0 0 0-.247.247L7.77 15.72a.4.4 0 0 0 .509.51L14 14.246a.4.4 0 0 0 .247-.247L16.23 8.28a.4.4 0 0 0-.509-.51L10 9.754Z"
  }));
};

var getTheme$1j = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFaceId = function SvgTwoColorFaceId(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1j(props["data-theme"]),
    d: "M4.158 8.726V6.095a2.337 2.337 0 0 1 2.337-2.337h2.631a.779.779 0 1 0 0-1.558H6.495A3.895 3.895 0 0 0 2.6 6.095v2.631a.779.779 0 1 0 1.558 0ZM14.874 2.2a.779.779 0 0 0 0 1.558h2.631a2.337 2.337 0 0 1 2.337 2.337v2.631a.779.779 0 0 0 1.558 0V6.095A3.895 3.895 0 0 0 17.505 2.2h-2.631ZM19.842 18.062v-2.63a.779.779 0 1 1 1.558 0v2.63a3.895 3.895 0 0 1-3.895 3.895h-2.631a.779.779 0 0 1 0-1.558h2.63a2.337 2.337 0 0 0 2.338-2.337ZM9.126 21.957a.779.779 0 0 0 0-1.558H6.495a2.337 2.337 0 0 1-2.337-2.337v-2.63a.779.779 0 0 0-1.558 0v2.63a3.895 3.895 0 0 0 3.895 3.895h2.631Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.092 8.016c.43 0 .779.35.779.78v1.557a.779.779 0 0 1-1.558 0V8.795c0-.43.349-.779.779-.779ZM15.323 8.016c.43 0 .78.35.78.78v1.557a.779.779 0 0 1-1.559 0V8.795c0-.43.349-.779.78-.779ZM12.208 8.016c.43 0 .78.35.78.78v3.894c0 .99-.803 1.792-1.792 1.792a.779.779 0 0 1 0-1.558c.129 0 .233-.105.233-.234V8.795c0-.43.35-.779.78-.779ZM8.5 15.377a.779.779 0 0 1 1.099-.085 3.41 3.41 0 0 0 4.438 0 .779.779 0 1 1 1.014 1.183 4.968 4.968 0 0 1-6.466 0 .779.779 0 0 1-.085-1.098Z"
  }));
};

var getTheme$1k = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFeeDiscountMaker = function SvgTwoColorFeeDiscountMaker(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$1k(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.975 11.15c-.435 0-.806-.154-1.113-.461A1.518 1.518 0 0 1 8.4 9.575c0-.435.154-.806.462-1.114A1.518 1.518 0 0 1 9.975 8c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.113-.461a1.518 1.518 0 0 1-.462-1.114c0-.435.154-.806.462-1.114a1.518 1.518 0 0 1 1.113-.461c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63L14.97 8l.63.63-6.57 6.57Z"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.644 20.531c-.264.288-.754.824-1.644.824-.378 0-.705-.062-.991-.218-.279-.152-.45-.36-.548-.478l-.002-.003a1.164 1.164 0 0 0-.207-.22c-.052-.038-.155-.099-.38-.146-.287-.06-.497.022-.904.332-.055.043-.116.09-.181.143-.37.296-.903.722-1.585.912-.823.23-1.585-.125-2.1-.482a5.295 5.295 0 0 1-1.212-1.203.75.75 0 0 1 1.22-.872c.17.238.487.591.85.844.382.266.662.318.838.269.365-.102.626-.307.993-.596.083-.064.171-.134.267-.207.482-.368 1.16-.81 2.122-.608.4.084.708.22.959.404.22.161.37.344.456.45l.022.026a.51.51 0 0 0 .11.117s.059.036.273.036c.218 0 .283-.067.613-.42.146-.155.383-.401.725-.55.374-.163.785-.176 1.233-.051.76.212 1.305.633 1.691.931l.036.027c.451.348.588.413.702.413.06 0 .175-.021.356-.103.175-.079.37-.195.577-.336.208-.14.41-.293.607-.442l.02-.014c.18-.136.374-.284.54-.388a.75.75 0 1 1 .8 1.269c-.106.066-.25.175-.456.33l-.005.004a15.93 15.93 0 0 1-.664.483 5.483 5.483 0 0 1-.802.461c-.28.126-.616.236-.973.236-.682 0-1.216-.413-1.562-.682-.02-.014-.037-.028-.055-.042-.406-.313-.75-.572-1.217-.703-.17-.047-.223-.021-.228-.018-.035.015-.09.053-.232.203-.02.02-.04.044-.062.068Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1k(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 4.75a7.25 7.25 0 0 0-4.795 12.688.75.75 0 1 1-.993 1.124 8.75 8.75 0 1 1 11.576 0 .75.75 0 1 1-.993-1.124A7.25 7.25 0 0 0 12 4.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1l = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFeeDiscountRewards = function SvgTwoColorFeeDiscountRewards(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M7.975 11.55c-.435 0-.806-.154-1.113-.461A1.518 1.518 0 0 1 6.4 9.975c0-.435.154-.806.462-1.114A1.518 1.518 0 0 1 7.975 8.4c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.518 1.518 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.113-.461a1.518 1.518 0 0 1-.462-1.114c0-.435.154-.806.462-1.114a1.518 1.518 0 0 1 1.113-.461c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63 6.57-6.57.63.63-6.57 6.57ZM20.25.75l.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$1l(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: getTheme$1l(props["data-theme"]),
    fillRule: "evenodd",
    d: "M10 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM1.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1l(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19.671 8.459a.75.75 0 0 1 1.06.022 7.253 7.253 0 0 1-3.56 12.075.75.75 0 0 1-.343-1.46 5.753 5.753 0 0 0 2.821-9.577.75.75 0 0 1 .022-1.06Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1m = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFeeDiscountTaker = function SvgTwoColorFeeDiscountTaker(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M9.075 12.15c-.435 0-.806-.154-1.114-.461a1.518 1.518 0 0 1-.461-1.114c0-.435.154-.806.461-1.114A1.518 1.518 0 0 1 9.075 9c.435 0 .806.154 1.114.461.307.308.461.679.461 1.114 0 .435-.154.806-.461 1.114a1.518 1.518 0 0 1-1.114.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.114-.461a1.518 1.518 0 0 1-.461-1.114c0-.435.154-.806.461-1.114a1.517 1.517 0 0 1 1.114-.461c.435 0 .806.154 1.114.461.307.308.461.679.461 1.114 0 .435-.154.806-.461 1.114a1.518 1.518 0 0 1-1.114.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63L14.07 9l.63.63-6.57 6.57Z"
  }), createElement("path", {
    fill: getTheme$1m(props["data-theme"]),
    fillRule: "evenodd",
    d: "M11.5 4.75a7.25 7.25 0 1 0 6.28 10.874.75.75 0 1 1 1.299.751 8.75 8.75 0 1 1-2.11-11.206.75.75 0 1 1-.938 1.17A7.216 7.216 0 0 0 11.5 4.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M17.97 8.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-1.47-1.47-1.47 1.47a.75.75 0 1 1-1.06-1.06l2-2Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M18.5 8.25a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$1m(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }));
};

var getTheme$1n = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFeedbacks = function SvgTwoColorFeedbacks(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1n(props["data-theme"]),
    fillRule: "evenodd",
    d: "M17.122 3.752A2.25 2.25 0 0 0 15 2.25H9a2.25 2.25 0 0 0-2.123 1.502A3.75 3.75 0 0 0 3.25 7.5V18A3.75 3.75 0 0 0 7 21.75h10A3.75 3.75 0 0 0 20.75 18V7.5a3.75 3.75 0 0 0-3.628-3.748Zm-.001 1.501A2.251 2.251 0 0 1 15 6.75H9a2.25 2.25 0 0 1-2.121-1.497A2.25 2.25 0 0 0 4.749 7.5V18A2.25 2.25 0 0 0 7 20.25h10A2.25 2.25 0 0 0 19.25 18V7.5a2.25 2.25 0 0 0-2.128-2.247ZM15 3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 1 1 0-1.5h6Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.5 10.75a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6Zm3 5a.75.75 0 0 0 0-1.5h-9a.75.75 0 0 0 0 1.5h9Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1o = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFiatDeposit = function SvgTwoColorFiatDeposit(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M19.25 3.5a.75.75 0 0 0-1.5 0v1.75H16a.75.75 0 0 0 0 1.5h1.75V8.5a.75.75 0 0 0 1.5 0V6.75H21a.75.75 0 0 0 0-1.5h-1.75V3.5Z"
  }), createElement("path", {
    fill: getTheme$1o(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 1 0 8.155 6.996.75.75 0 1 1 1.483-.226c.074.483.112.977.112 1.48 0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25c.605 0 1.197.055 1.773.161a.75.75 0 0 1-.271 1.475A8.301 8.301 0 0 0 12 3.75ZM12.689 7a.75.75 0 0 0-1.5 0v.72h-.352a2.587 2.587 0 0 0 0 5.173h2.204a1.087 1.087 0 1 1 0 2.173H9.734a.75.75 0 0 0 0 1.5h1.455v.72a.75.75 0 0 0 1.5 0v-.72h.352a2.587 2.587 0 1 0 0-5.173h-2.204a1.087 1.087 0 0 1 0-2.174h3.306a.75.75 0 0 0 0-1.5h-1.454V7Z"
  }));
};

var getTheme$1p = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFile = function SvgTwoColorFile(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1p(props["data-theme"]),
    fillRule: "evenodd",
    d: "M17.824 8.75h-2.13c-.691 0-1.25-.56-1.25-1.25V4.965l3.38 3.785Zm-4.88-5V7.5a2.75 2.75 0 0 0 2.75 2.75h3.056V19c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h6.443ZM20.25 9.5V19a2.75 2.75 0 0 1-2.75 2.75h-11A2.75 2.75 0 0 1 3.75 19V5A2.75 2.75 0 0 1 6.5 2.25h7.193a.75.75 0 0 1 .56.25L20.059 9a.75.75 0 0 1 .19.5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M7.25 8A.75.75 0 0 1 8 7.25h2a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Zm0 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM8 16.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFingerprint = function SvgTwoColorFingerprint(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1q(props["data-theme"]),
    d: "M4.501 9.396c3.46-5.265 11.13-5.414 14.792-.287l.219.306a.6.6 0 0 0 .976-.697l-.219-.307C16.117 2.598 7.422 2.767 3.5 8.737a.6.6 0 1 0 1.002.66Z"
  }), createElement("path", {
    fill: getTheme$1q(props["data-theme"]),
    d: "M11.667 10.36c-2.238 0-4.067 1.958-4.067 5.067 0 1.213.39 2.495.948 3.605.563 1.117 1.262 1.992 1.818 2.42a.6.6 0 0 1-.732.95c-.744-.572-1.545-1.614-2.157-2.83C6.86 18.348 6.4 16.88 6.4 15.427c0-3.558 2.17-6.267 5.267-6.267 1.062 0 1.958.163 2.777.66.808.489 1.477 1.265 2.164 2.361a15.397 15.397 0 0 1 .639 1.3 29.76 29.76 0 0 1 .285.662l.017.041.005.012.002.004a.6.6 0 0 1-1.111.454l-.006-.013-.016-.039-.06-.145a28.873 28.873 0 0 0-.212-.49c-.173-.387-.385-.84-.566-1.159-.643-1.023-1.19-1.615-1.763-1.962-.564-.342-1.218-.486-2.155-.486Z"
  }), createElement("path", {
    fill: getTheme$1q(props["data-theme"]),
    d: "M12.378 14.698a4.555 4.555 0 0 0 4.964 4.289.6.6 0 1 1 .11 1.195 5.755 5.755 0 0 1-6.272-5.419.6.6 0 0 1 1.198-.065Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6.621 4.26a10.886 10.886 0 0 1 10.425 0 .6.6 0 0 0 .575-1.053 12.086 12.086 0 0 0-11.575 0 .6.6 0 1 0 .575 1.053ZM10.767 7.993c2.662-.45 4.807.565 6.442 2.497.92 1.086 1.455 2.472 1.569 3.653.057.59.005 1.095-.13 1.473-.132.373-.33.588-.56.69a.55.55 0 0 0-.031.016c-.566.294-1.054.283-1.462.125-.428-.164-.812-.507-1.093-.935-.222-.337-.363-.713-.527-1.149-.049-.13-.1-.266-.156-.408-.22-.561-.525-1.228-1.15-1.65-1.216-.82-2.874-.823-4.096.414-1.277 1.294-1.147 3.484-.11 5.583.56 1.135 1.645 2.194 2.678 2.967.523.392 1.05.724 1.522.967.45.232.912.416 1.285.45a.6.6 0 0 0 .104-1.196c-.127-.011-.414-.102-.84-.32a9.903 9.903 0 0 1-1.352-.862c-.968-.724-1.882-1.647-2.322-2.538-.964-1.952-.833-3.476-.11-4.208.777-.787 1.786-.791 2.57-.262.293.198.488.545.705 1.095l.12.318c.17.453.373.998.676 1.459.385.584.95 1.12 1.665 1.395.729.28 1.57.271 2.431-.172.595-.273.975-.788 1.184-1.377.21-.588.262-1.28.194-1.99-.137-1.419-.767-3.036-1.848-4.313-1.863-2.201-4.411-3.436-7.558-2.905-2.191.37-4.783 2.028-5.803 5.13-.362 1.1-.497 2.516-.48 3.814.017 1.288.185 2.554.49 3.342a.6.6 0 0 0 1.12-.432c-.23-.592-.394-1.69-.41-2.926-.016-1.228.115-2.498.42-3.423.864-2.627 3.054-4.017 4.863-4.322Z"
  }));
};

var getTheme$1r = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFunding = function SvgTwoColorFunding(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1r(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M10.767 7.787a1.75 1.75 0 0 1 2.475 0l2.97 2.97a1.75 1.75 0 0 1 0 2.475l-2.97 2.97a1.75 1.75 0 0 1-2.475 0l-2.97-2.97a1.75 1.75 0 0 1 0-2.475l2.97-2.97Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.97 2.97a.25.25 0 0 0 0 .354l2.97 2.97a.25.25 0 0 0 .354 0l2.97-2.97a.25.25 0 0 0 0-.354l-2.97-2.97Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1s = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFuturesComboBot = function SvgTwoColorFuturesComboBot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1s(props["data-theme"]),
    fillRule: "evenodd",
    d: "M13.634 7.376a1 1 0 0 0-.869 0l-5.2 2.51a1 1 0 0 0-.565.9v7.07a1 1 0 0 0 .523.879l5.2 2.823a1 1 0 0 0 .954 0l5.2-2.823a1 1 0 0 0 .523-.88v-7.069a1 1 0 0 0-.566-.9l-5.2-2.51Zm-1.39-1.08a2.2 2.2 0 0 1 1.912 0l5.2 2.51a2.2 2.2 0 0 1 1.244 1.98v7.07a2.2 2.2 0 0 1-1.15 1.933l-5.2 2.824a2.2 2.2 0 0 1-2.1 0l-5.2-2.824a2.2 2.2 0 0 1-1.15-1.933v-7.07a2.2 2.2 0 0 1 1.244-1.98l5.2-2.51Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1s(props["data-theme"]),
    fillRule: "evenodd",
    d: "M11.632 2.372a1 1 0 0 0-.864 0l-5.6 2.68a1 1 0 0 0-.568.902v7.513a1 1 0 0 0 .526.88l.058.033a.6.6 0 1 1-.569 1.056l-.058-.031A2.2 2.2 0 0 1 3.4 13.466V5.954A2.2 2.2 0 0 1 4.65 3.97l5.6-2.68a2.2 2.2 0 0 1 1.9 0l5.6 2.68A2.2 2.2 0 0 1 19 5.954V6.3a.6.6 0 1 1-1.2 0v-.346a1 1 0 0 0-.568-.902l-5.6-2.68Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M16.065 12.7c.047.614-.18 1.043-.681 1.289.387.102.674.281.862.538.188.256.255.618.202 1.085a1.926 1.926 0 0 1-.175.627c-.089.18-.2.327-.332.442-.132.116-.295.21-.49.286a2.927 2.927 0 0 1-.61.161 5.95 5.95 0 0 1-.727.06l-.027 1.288-.768-.017.026-1.266a27.417 27.417 0 0 1-.608-.018l-.027 1.272-.768-.017.027-1.287a19.96 19.96 0 0 1-.27-.008l-.274-.008-.998-.02.174-.921.554.011c.166.004.265-.08.295-.25l.042-2.03.08.002a.498.498 0 0 0-.08-.007l.03-1.448c-.038-.23-.183-.348-.436-.353l-.554-.011.018-.828 1.057.027c.213.005.374.006.484.005l.027-1.272.768.016-.026 1.247c.273-.001.476 0 .609.003l.026-1.237.768.016-.027 1.272c.263.03.495.072.696.128.202.057.389.136.56.24.17.102.305.236.403.402.098.165.154.359.17.581Zm-1.13 2.728a.678.678 0 0 0-.069-.324.756.756 0 0 0-.18-.236.945.945 0 0 0-.283-.16 2.413 2.413 0 0 0-.325-.1c-.099-.023-.222-.04-.368-.054a5.262 5.262 0 0 0-.344-.022c-.083-.002-.19-.002-.322-.002h-.237l-.036 1.706c.027 0 .089.003.185.007l.24.007a6.315 6.315 0 0 0 .556-.016c.082-.007.177-.019.285-.037.11-.018.202-.04.279-.065.077-.025.157-.059.24-.1a.691.691 0 0 0 .2-.148.676.676 0 0 0 .18-.456Zm-.36-2.706a.702.702 0 0 0-.148-.215.744.744 0 0 0-.237-.146c-.099-.041-.19-.071-.272-.09a2.7 2.7 0 0 0-.306-.046 2.847 2.847 0 0 0-.29-.019 33.337 33.337 0 0 1-.466-.002l-.033 1.55.172.005a5.15 5.15 0 0 0 .482 0c.11-.002.202-.01.275-.022.074-.012.16-.028.258-.05a.842.842 0 0 0 .244-.088c.064-.037.127-.082.188-.133a.485.485 0 0 0 .138-.191.708.708 0 0 0 .05-.257.67.67 0 0 0-.056-.296Z"
  }));
};

var getTheme$1t = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFuturesGrid = function SvgTwoColorFuturesGrid(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1t(props["data-theme"]),
    d: "M3 5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25v13.5A2.25 2.25 0 0 1 18.75 21H5.25A2.25 2.25 0 0 1 3 18.75v-4.875a.75.75 0 0 1 1.5 0v4.875c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75H5.25a.75.75 0 0 0-.75.75v4.5h1.94l2.03-2.03a.75.75 0 0 1 1.085.025l3.153 3.47 3.577-4.553a.75.75 0 1 1 1.18.926l-4.125 5.25a.75.75 0 0 1-1.145.042l-3.22-3.543L7.28 11.03a.75.75 0 0 1-.53.22h-3A.75.75 0 0 1 3 10.5V5.25Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6 16.5a.75.75 0 0 1 .75-.75h10.875a.75.75 0 0 1 0 1.5H6.75A.75.75 0 0 1 6 16.5Z"
  }));
};

var getTheme$1u = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorFuturesMartingale = function SvgTwoColorFuturesMartingale(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m13.815 7.79 7.248 8.214-1.125.992-7.027-7.964-1.942 1.554a.75.75 0 0 1-.937-1.172l2.202-1.762a1.15 1.15 0 0 1 1.58.138Z"
  }), createElement("path", {
    fill: getTheme$1u(props["data-theme"]),
    d: "M12.75 1.817a1.5 1.5 0 0 0-1.5 0L3.556 6.259a1.5 1.5 0 0 0-.75 1.299v8.884a1.5 1.5 0 0 0 .75 1.299l7.694 4.442a1.5 1.5 0 0 0 1.5 0l7.694-4.442a1.5 1.5 0 0 0 .75-1.3V7.559a1.5 1.5 0 0 0-.75-1.3L12.75 1.818ZM12 3.116l7.694 4.442v8.884L12 20.884l-7.694-4.442V9.547l5.874 6.657a1.15 1.15 0 0 0 1.599.123l2.701-2.251a.75.75 0 1 0-.96-1.152l-2.44 2.033-6.611-7.493 7.53-4.348Z"
  }));
};

var getTheme$1v = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGeneralRewards = function SvgTwoColorGeneralRewards(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$1v(props["data-theme"]),
    d: "m21.75 6 .009.06c.049.378.36.668.742.69l-.029.005a.894.894 0 0 0-.721.745.834.834 0 0 0-.682-.738l-.068-.012a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: getTheme$1v(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 4.208a7.792 7.792 0 1 0 0 15.584 7.792 7.792 0 0 0 0-15.584ZM2.792 12a9.208 9.208 0 1 1 18.416 0 9.208 9.208 0 0 1-18.416 0Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.622 7.972a.395.395 0 0 1 .756 0l.861 2.789h2.843c.378 0 .54.48.24.709l-2.317 1.77.875 2.829a.395.395 0 0 1-.618.43L12 14.771 9.738 16.5a.395.395 0 0 1-.618-.43l.875-2.83-2.316-1.769a.395.395 0 0 1 .24-.71h2.842l.861-2.788Z"
  }));
};

var getTheme$1w = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGift = function SvgTwoColorGift(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M6.142 6.588c-.486-.739-.476-1.441-.21-1.929.264-.483.864-.909 1.881-.909.835 0 1.665.397 2.327.95.325.273.59.568.778.837.197.284.271.487.285.576a.75.75 0 0 0 .77.637.75.75 0 0 0 .768-.637c.014-.09.088-.292.285-.576.188-.27.453-.564.779-.837.661-.553 1.491-.95 2.326-.95 1.017 0 1.617.426 1.88.909.267.488.278 1.19-.208 1.929a.75.75 0 0 0 1.253.824c.743-1.13.843-2.426.272-3.472-.573-1.05-1.736-1.69-3.197-1.69-1.296 0-2.455.603-3.288 1.3-.335.28-.63.584-.87.891a6.057 6.057 0 0 0-.871-.891c-.833-.697-1.993-1.3-3.289-1.3-1.46 0-2.623.64-3.197 1.69-.57 1.046-.47 2.343.273 3.472a.75.75 0 0 0 1.253-.824Z"
  }), createElement("path", {
    fill: getTheme$1w(props["data-theme"]),
    d: "M1.25 8c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 21 11.75h-.25V21A1.75 1.75 0 0 1 19 22.75H5A1.75 1.75 0 0 1 3.25 21v-9.25H3A1.75 1.75 0 0 1 1.25 10V8Zm11.5 3.75v9.5H19a.25.25 0 0 0 .25-.25v-9.25h-6.5Zm0-1.5H21a.25.25 0 0 0 .25-.25V8a.25.25 0 0 0-.25-.25h-8.25v2.5Zm-1.5-2.5H3a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h8.25v-2.5Zm0 4h-6.5V21c0 .138.112.25.25.25h6.25v-9.5Z"
  }));
};

var getTheme$1x = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGiveawayCreate = function SvgTwoColorGiveawayCreate(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1x(props["data-theme"]),
    d: "M16.132 10.229c.13-.537.566-.991 1.118-.991h.5v.012h1.85A2.75 2.75 0 0 1 22.35 12v7a2.75 2.75 0 0 1-2.75 2.75h-15A2.75 2.75 0 0 1 1.85 19v-7A2.75 2.75 0 0 1 4.6 9.25h1.806v-.012h.5c.552 0 .987.454 1.118.99a4.174 4.174 0 0 0 8.108 0Zm1.414.521a5.675 5.675 0 0 1-10.937 0H4.6c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25h-2.054Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.82 1.47a.75.75 0 0 0-1.06 0L7.97 5.26a.75.75 0 0 0 1.06 1.06l2.51-2.509v6.82a.75.75 0 1 0 1.5 0v-6.82l2.509 2.509a.75.75 0 0 0 1.06-1.06l-3.79-3.79Z"
  }));
};

var getTheme$1y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGiveawayJoin = function SvgTwoColorGiveawayJoin(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1y(props["data-theme"]),
    d: "M21.957 19.06a2.75 2.75 0 0 1-2.696 3.29H5.14a2.75 2.75 0 0 1-2.697-3.29l2.2-11A2.75 2.75 0 0 1 7.34 5.85h1.11a.75.75 0 1 1 0 1.5H7.34a1.25 1.25 0 0 0-1.226 1.005l-2.2 11A1.25 1.25 0 0 0 5.14 20.85h14.12a1.25 1.25 0 0 0 1.226-1.495l-2.2-11a1.25 1.25 0 0 0-1.225-1.005h-1.11a.75.75 0 0 1 0-1.5h1.11c1.31 0 2.44.925 2.696 2.21l2.2 11Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13.04 2.6a.75.75 0 0 0-1.5 0v11.821l-2.51-2.51a.75.75 0 1 0-1.06 1.062l3.79 3.789a.75.75 0 0 0 1.06 0l3.79-3.79a.75.75 0 0 0-1.061-1.06L13.04 14.42V2.6Z"
  }));
};

var getTheme$1z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGiveaway = function SvgTwoColorGiveaway(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M16.014 6v1.938H13.06v1.268c2.39.108 4.189.576 4.189 1.137 0 .56-1.798 1.029-4.189 1.137v3.27h-2.104v-3.269c-2.4-.107-4.207-.575-4.207-1.138s1.807-1.031 4.207-1.138V7.938H8.005V6h8.009Zm-2.953 4.995c1.887-.086 3.285-.396 3.285-.766s-1.398-.68-3.287-.767v1.172a20.1 20.1 0 0 1-2.103 0V9.46c-1.897.086-3.304.396-3.304.768s1.407.683 3.304.768l.124.005h.002c.126.005.253.01.382.012h.012l.11.002h.031l.091.002h.585l.092-.002h.033l.117-.002h.005l.259-.007h.012l.115-.005h.013l.122-.005Z"
  }), createElement("path", {
    fill: getTheme$1z(props["data-theme"]),
    d: "M12 2.7c-4.362 0-7.875 3.469-7.875 7.719 0 2.397 1.114 4.542 2.871 5.96a7.906 7.906 0 0 0 2.494 1.359.75.75 0 0 1-.469 1.425 9.409 9.409 0 0 1-1.146-.463 3 3 0 0 0 .879 2.118l.886.886c.31.31.485.732.485 1.171a.75.75 0 0 1-1.5 0 .155.155 0 0 0-.046-.11l-.886-.886a4.5 4.5 0 0 1-1.318-3.182v-.902a9.5 9.5 0 0 1-.321-.248c-2.09-1.688-3.429-4.253-3.429-7.128C2.625 5.315 6.835 1.2 12 1.2s9.375 4.115 9.375 9.219a9.096 9.096 0 0 1-2.25 5.992v2.513a3.95 3.95 0 0 1-1.157 2.794l-.407.407a1.06 1.06 0 0 0-.311.75.75.75 0 0 1-1.5 0c0-.68.27-1.33.75-1.81l.407-.408a2.45 2.45 0 0 0 .718-1.733V12.75a.75.75 0 0 0-1.5 0v3.375h-.75a2.625 2.625 0 0 0-2.625 2.625v.375a.75.75 0 0 1-1.5 0v-.375a4.126 4.126 0 0 1 3.375-4.057V12.75a2.25 2.25 0 0 1 4.5 0v.961a7.56 7.56 0 0 0 .75-3.292c0-4.25-3.513-7.719-7.875-7.719Z"
  }));
};

var getTheme$1A = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGlobe = function SvgTwoColorGlobe(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12.547 2.487a.75.75 0 0 0-1.141.056c-1.33 1.727-3 4.49-3.5 7.818-.044.292-.078.589-.103.889H3.225a.75.75 0 0 0 0 1.5h4.542c.094 2.755 1.1 5.748 3.664 8.738a.75.75 0 0 0 1.118.023c1.362-1.462 3.189-4.235 3.767-7.64.063-.367.11-.74.142-1.121h4.317a.75.75 0 0 0 0-1.5h-4.284c-.109-2.793-1.185-5.823-3.944-8.763Zm2.442 8.763c-.098-2.224-.9-4.64-2.932-7.057-1.112 1.603-2.283 3.83-2.667 6.39-.033.22-.06.442-.081.667h5.68Zm-5.722 1.5c.087 2.209.84 4.615 2.748 7.082 1.115-1.404 2.381-3.614 2.823-6.212.048-.285.087-.575.114-.87H9.267Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1A(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1B = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGoUp = function SvgTwoColorGoUp(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.25 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .553 1.257l-5.5 6a.75.75 0 0 1-1.033.07l-2.57-2.142-4.034 2.689a.75.75 0 1 1-.832-1.248l4.5-3a.75.75 0 0 1 .896.048l2.45 2.042 3.865-4.216H14a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1B(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 0 0-7.566 11.544.75.75 0 1 1-1.375.6A9.728 9.728 0 0 1 2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75a9.713 9.713 0 0 1-4.334-1.014.75.75 0 1 1 .668-1.343A8.25 8.25 0 1 0 12 3.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1C = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGuideBook = function SvgTwoColorGuideBook(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M7.375 2.75h5.156V11L9.953 8.545 7.375 11V2.75Z"
  }), createElement("path", {
    fill: getTheme$1C(props["data-theme"]),
    d: "M5.25 22.063a2.75 2.75 0 0 1-2.75-2.75V4.75A2.75 2.75 0 0 1 5.25 2h12.5a2.75 2.75 0 0 1 2.75 2.75v14.563a2.75 2.75 0 0 1-2.75 2.75H5.25ZM4 19.313c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V4.75c0-.69-.56-1.25-1.25-1.25H5.25C4.56 3.5 4 4.06 4 4.75v14.563Z"
  }));
};

var getTheme$1D = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGuide = function SvgTwoColorGuide(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1D(props["data-theme"]),
    fillRule: "evenodd",
    d: "M6 2.25A3.75 3.75 0 0 0 2.25 6v13A2.75 2.75 0 0 0 5 21.75h12a.75.75 0 0 0 0-1.5H5a1.25 1.25 0 1 1 0-2.5h15A1.75 1.75 0 0 0 21.75 16V6A3.75 3.75 0 0 0 18 2.25H6Zm8.667 14H20a.25.25 0 0 0 .25-.25V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v10.55c.375-.192.8-.3 1.25-.3h9.667Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M10.204 7.62c.06-.163.512-.87 1.785-.87.307 0 .684.128 1.025.38.34.25.585.578.684.906.093.306.074.641-.165 1.003-.253.383-.788.845-1.826 1.266a.75.75 0 0 0 .564 1.39c1.203-.488 2.036-1.106 2.514-1.83.493-.747.567-1.548.348-2.265-.21-.694-.682-1.275-1.229-1.678-.546-.402-1.227-.672-1.915-.672-1.913 0-2.921 1.111-3.194 1.856a.75.75 0 1 0 1.41.515ZM12 14.45a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1E = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHnwi = function SvgTwoColorHnwi(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M11.239 17.499a1.75 1.75 0 0 0 1.95 0l1.749-1.173a1.75 1.75 0 0 0 .731-1.842l-1.652-7.258a.75.75 0 0 0-1.462.333l1.652 7.258a.25.25 0 0 1-.105.263l-1.748 1.173a.25.25 0 0 1-.279 0l-1.752-1.176a.25.25 0 0 1-.104-.261l1.592-7.262a.75.75 0 1 0-1.465-.322l-1.593 7.263a1.75 1.75 0 0 0 .734 1.828l1.752 1.176Z"
  }), createElement("path", {
    fill: getTheme$1E(props["data-theme"]),
    d: "M12.558 2.401a.75.75 0 0 0-.902 0L8.977 4.419a.75.75 0 0 0-.218.936l.9 1.786a.75.75 0 0 0 .67.413h3.557a.75.75 0 0 0 .67-.413l.9-1.786a.75.75 0 0 0-.22-.936L12.559 2.4ZM10.79 6.054l-.41-.814 1.727-1.301 1.727 1.3-.41.815H10.79Z"
  }), createElement("path", {
    fill: getTheme$1E(props["data-theme"]),
    d: "M7.222 6.834a.75.75 0 1 0-.844-1.24L3.89 7.287a3.75 3.75 0 0 0-1.64 3.1v7.827A3.75 3.75 0 0 0 6 21.964h12a3.75 3.75 0 0 0 3.75-3.75v-7.827a3.75 3.75 0 0 0-1.64-3.1l-2.488-1.693a.75.75 0 1 0-.844 1.24l2.488 1.693a2.25 2.25 0 0 1 .984 1.86v7.827a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25v-7.827c0-.744.369-1.44.984-1.86l2.488-1.693Z"
  }));
};

var getTheme$1F = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHelpCenter = function SvgTwoColorHelpCenter(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1F(props["data-theme"]),
    d: "M11.25 3.75a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm-9 7.5a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
  }), createElement("path", {
    fill: getTheme$1F(props["data-theme"]),
    d: "M16.72 16.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.75 9.75a1.5 1.5 0 0 1 3 0v.45c0 .58-.47 1.05-1.05 1.05a.95.95 0 0 0-.95.95v1.3a.75.75 0 0 0 1.5 0v-.81a2.55 2.55 0 0 0 2-2.49v-.45a3 3 0 1 0-6 0v.435a.75.75 0 0 0 1.5 0V9.75ZM11.5 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

var getTheme$1G = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHelp = function SvgTwoColorHelp(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1G(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M10.204 9.62c.06-.163.512-.87 1.785-.87.307 0 .684.128 1.025.38.34.25.585.578.684.906.093.306.074.641-.165 1.003-.253.383-.788.845-1.826 1.266a.75.75 0 0 0 .564 1.39c1.203-.488 2.036-1.106 2.514-1.83.493-.747.567-1.548.348-2.265-.21-.694-.682-1.275-1.229-1.678-.546-.402-1.227-.672-1.915-.672-1.913 0-2.921 1.111-3.194 1.856a.75.75 0 0 0 1.41.515ZM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1H = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHighLeverage = function SvgTwoColorHighLeverage(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1H(props["data-theme"]),
    d: "M22 7.685C22 6.755 21.25 6 20.325 6H18.6a1.68 1.68 0 0 0-1.675 1.685v12.63c0 .93.75 1.685 1.675 1.685h1.724A1.68 1.68 0 0 0 22 20.315V7.685Zm-1.675-.24a.24.24 0 0 1 .239.24v12.63a.24.24 0 0 1-.24.24h-1.723a.24.24 0 0 1-.24-.24V7.685a.24.24 0 0 1 .24-.24h1.724ZM15.298 13.61c0-.93-.75-1.684-1.676-1.684h-1.628a1.68 1.68 0 0 0-1.675 1.685v6.704c0 .93.75 1.685 1.675 1.685h1.628a1.68 1.68 0 0 0 1.676-1.685V13.61Zm-1.676-.24a.24.24 0 0 1 .24.24v6.705a.24.24 0 0 1-.24.24h-1.628a.24.24 0 0 1-.239-.24V13.61a.24.24 0 0 1 .24-.24h1.627ZM7.207 15.815A1.68 1.68 0 0 1 8.883 17.5v2.815c0 .93-.75 1.685-1.676 1.685H5.676A1.68 1.68 0 0 1 4 20.315V17.5c0-.93.75-1.685 1.676-1.685h1.531Zm.24 1.685a.24.24 0 0 0-.24-.24H5.676a.24.24 0 0 0-.24.24v2.815c0 .133.107.24.24.24h1.531a.24.24 0 0 0 .24-.24V17.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m14.927 2.478.053.499c.12 1.044-.3 2.357-1.03 3.586a10.867 10.867 0 0 1-3.046 3.287c-.193 1.061-.758 1.878-1.703 2.603l-.82.63-1.148-2.443c-.655-.022-1.294-.416-1.695-.958-.405-.548-.6-1.288-.428-1.942L3.152 5.95l.817-.627c.922-.708 1.843-1.031 2.883-.94a10.527 10.527 0 0 1 3.945-2.085c1.364-.374 2.721-.418 3.672-.013l.458.192Zm-1.288.986c-.583-.14-1.462-.115-2.494.168a9.162 9.162 0 0 0-3.633 1.99l-.242.218-.318-.052a2.4 2.4 0 0 0-1.632.283l1.53 1.397-.374.506c-.082.112-.145.477.149.874.295.4.66.437.775.394l.581-.22.893 1.901c.454-.469.665-.951.727-1.544l.035-.329.273-.18a9.468 9.468 0 0 0 2.88-3.017c.554-.932.82-1.782.85-2.39ZM11.031 6.04a.679.679 0 0 0 .761-.584.679.679 0 0 0-.57-.772.679.679 0 0 0-.762.585.679.679 0 0 0 .57.771ZM2 12.304s1.838-.062 2.612-.668c.587-.46.788-1.22.43-1.716-.359-.494-1.116-.502-1.703-.042C2.645 10.422 2 12.304 2 12.304Z"
  }));
};

var getTheme$1I = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHigherDiagram = function SvgTwoColorHigherDiagram(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1I(props["data-theme"]),
    d: "M21.75 10.97A1.75 1.75 0 0 0 20 9.22h-1.8a1.75 1.75 0 0 0-1.75 1.75v10c0 .966.783 1.75 1.75 1.75H20a1.75 1.75 0 0 0 1.75-1.75v-10ZM20 10.72a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25h-1.8a.25.25 0 0 1-.25-.25v-10a.25.25 0 0 1 .25-.25H20ZM14.75 12.97A1.75 1.75 0 0 0 13 11.22h-1.7a1.75 1.75 0 0 0-1.75 1.75v8c0 .966.783 1.75 1.75 1.75H13a1.75 1.75 0 0 0 1.75-1.75v-8ZM13 12.72a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25h-1.7a.25.25 0 0 1-.25-.25v-8a.25.25 0 0 1 .25-.25H13ZM6.3 14.22c.966 0 1.75.783 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75H4.7a1.75 1.75 0 0 1-1.75-1.75v-5c0-.967.783-1.75 1.75-1.75h1.6Zm.25 1.75a.25.25 0 0 0-.25-.25H4.7a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1.6a.25.25 0 0 0 .25-.25v-5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M19.729 2.768a.75.75 0 0 1 .53.918l-.926 3.457a.75.75 0 1 1-1.45-.388l.48-1.786-4.965 3.475a.75.75 0 0 1-.96-.084l-1.08-1.08-6.388 4.502a.75.75 0 0 1-.864-1.226l6.903-4.867a.75.75 0 0 1 .962.083l1.083 1.082 4.465-3.126-1.636-.438a.75.75 0 1 1 .389-1.449l3.457.927Z"
  }));
};

var getTheme$1J = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHistory = function SvgTwoColorHistory(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1J(props["data-theme"]),
    fillRule: "evenodd",
    d: "M18.25 8.75V11a.75.75 0 1 0 1.5 0V8a.75.75 0 0 0-.236-.546l-5.306-5a.75.75 0 0 0-.515-.204H6.5A2.75 2.75 0 0 0 3.75 5v14a2.75 2.75 0 0 0 2.75 2.75h5a.75.75 0 0 0 0-1.5h-5c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h6.443V6a2.75 2.75 0 0 0 2.75 2.75h2.557Zm-1.14-1.5h-1.417c-.69 0-1.25-.56-1.25-1.25V4.737L17.11 7.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8 7.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8Zm0 4a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H8Zm9 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM12.25 17a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0Zm5.5-2a.75.75 0 0 0-1.5 0v2c0 .414.336.75.75.75h2a.75.75 0 0 0 0-1.5h-1.25V15Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1K = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHoldMoney = function SvgTwoColorHoldMoney(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1K(props["data-theme"]),
    d: "m10.527 5.172-.763-.774c-.387-.392-.47-1.06-.055-1.532.861-.98 2.102-1.607 3.49-1.607 1.39 0 2.63.626 3.492 1.607.415.473.332 1.14-.055 1.532l-.763.774c1.082.56 2.035 1.442 2.809 2.531 1.213 1.708 2.026 3.97 2.266 6.476.31-.062.634-.057.949.022 1.65.412 2.192 2.485.956 3.653l-4.555 4.302a4.374 4.374 0 0 1-3.003 1.194H2.2a.75.75 0 0 1 0-1.5h13.095c.734 0 1.44-.28 1.973-.785l4.555-4.302a.652.652 0 0 0-.846-.991l-4.3 3.308a1.75 1.75 0 0 1-1.067.363h-5.16a.75.75 0 0 1 0-1.5h4.055a.767.767 0 0 1 .05-.079.99.99 0 0 0-.806-1.564H8.166a2.362 2.362 0 0 0-2.292 1.789 1.787 1.787 0 0 1-1.734 1.354H2.2a.75.75 0 0 1 0-1.5h1.94c.132 0 .247-.09.279-.218a3.853 3.853 0 0 1 .993-1.77.75.75 0 0 1-.033-.222c0-3.022.825-5.792 2.2-7.827.797-1.183 1.8-2.14 2.948-2.734Zm1.56-.554a5.625 5.625 0 0 1 2.226 0l1.002-1.017A3.106 3.106 0 0 0 13.2 2.76c-.802 0-1.542.313-2.116.842l1.003 1.017Zm4.145 12.912 3.272-2.518c-.123-2.563-.899-4.826-2.045-6.44-1.174-1.652-2.684-2.565-4.259-2.565-1.628 0-3.19.978-4.378 2.738-1.082 1.602-1.807 3.798-1.926 6.27.4-.14.828-.215 1.27-.215h5.583c1.558 0 2.614 1.355 2.483 2.73Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m10.573 10.874 1.714-.677.677-1.7a.313.313 0 0 1 .288-.202.35.35 0 0 1 .303.202l.677 1.7 1.7.677a.35.35 0 0 1 .201.302.35.35 0 0 1-.201.303l-1.7.677-.677 1.714a.364.364 0 0 1-.303.187.35.35 0 0 1-.302-.202l-.677-1.714-1.714-.677a.323.323 0 0 1-.188-.288.35.35 0 0 1 .202-.302ZM20.684 1.8l.052.312a2.372 2.372 0 0 0 1.875 1.936 2.372 2.372 0 0 0-1.875 1.936l-.052.312-.05-.298a2.396 2.396 0 0 0-1.876-1.95 2.372 2.372 0 0 0 1.874-1.936l.052-.312Z"
  }));
};

var getTheme$1L = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorHourgrass = function SvgTwoColorHourgrass(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8 10h8l-1 2H9l-1-2ZM6 19.3h12v2H6v-2Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$1L(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4 1.25a.75.75 0 0 0 0 1.5h1.25c0 1.88.016 3.692.535 5.327.479 1.508 1.372 2.836 2.961 3.993a9.796 9.796 0 0 0-1.902 2.44c-.876 1.578-1.556 3.753-1.593 6.74H4a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5h-1.252c-.036-2.987-.716-5.162-1.592-6.74a9.797 9.797 0 0 0-1.902-2.44c1.589-1.157 2.482-2.485 2.96-3.993.52-1.635.536-3.447.536-5.327H20a.75.75 0 0 0 0-1.5H4Zm13.25 1.5H6.75c.001 1.917.026 3.49.465 4.873.44 1.386 1.314 2.62 3.17 3.734a.75.75 0 0 1 .065 1.243 8.215 8.215 0 0 0-2.294 2.64c-.744 1.338-1.369 3.26-1.404 6.01h10.496c-.035-2.75-.66-4.672-1.404-6.01a8.215 8.215 0 0 0-2.294-2.64.75.75 0 0 1 .064-1.243c1.857-1.114 2.731-2.348 3.171-3.734.44-1.383.464-2.956.465-4.873Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1M = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorId = function SvgTwoColorId(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1M(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M7.8 10.5a1.2 1.2 0 1 1 1.207 1.2h-.014A1.2 1.2 0 0 1 7.8 10.5Zm-.543 1.65a2.4 2.4 0 1 1 3.487 0A3.599 3.599 0 0 1 12.6 15.3a.6.6 0 0 1-1.2 0 2.4 2.4 0 0 0-2.392-2.4h-.016A2.4 2.4 0 0 0 6.6 15.3a.6.6 0 0 1-1.2 0 3.6 3.6 0 0 1 1.857-3.15ZM17.6 10a.6.6 0 0 1-.6.6h-2a.6.6 0 1 1 0-1.2h2a.6.6 0 0 1 .6.6Zm.4 3.6a.6.6 0 0 0 0-1.2h-3a.6.6 0 0 0 0 1.2h3Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1N = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorIceberg = function SvgTwoColorIceberg(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M22.65 20a.75.75 0 0 1-.75.75H2.5a.75.75 0 0 1 0-1.5h19.4a.75.75 0 0 1 .75.75Z"
  }), createElement("path", {
    fill: getTheme$1N(props["data-theme"]),
    d: "M15.5 3.213a1.15 1.15 0 0 0-2.03 0l-4.129 7.77-1.14-2.106a1 1 0 0 0-1.76 0L2.3 16.524A1 1 0 0 0 3.179 18h8.284c.073 0 .143-.008.21-.022h9.758a1.15 1.15 0 0 0 1.016-1.69L15.501 3.214Zm-3.182 13.265-2.162-3.99.066.035L14.485 4.5l6.364 11.98h-8.531Zm-8.3.022 3.303-6.097 3.302 6.097H4.018Z"
  }));
};

var getTheme$1O = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorInfo = function SvgTwoColorInfo(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1O(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.052 7.4a.937.937 0 0 0-.934.94c0 .518.418.938.934.938h.01c.515 0 .934-.42.934-.939a.937.937 0 0 0-.935-.939h-.009ZM10.1 10.922c0-.433.35-.783.783-.783h1.565a.783.783 0 0 1 .782.81v3.886h.783a.783.783 0 0 1 0 1.565h-3.13a.783.783 0 0 1 0-1.565h.782v-3.13h-.782a.783.783 0 0 1-.783-.783Z"
  }));
};

var getTheme$1P = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorInstitutes = function SvgTwoColorInstitutes(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1P(props["data-theme"]),
    d: "M6.75 5.5a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5h-1.5v4.256l5.547 7.627c1.322 1.817.023 4.367-2.224 4.367H4.928c-2.248 0-3.546-2.55-2.224-4.367L8.25 9.756V5.5h-1.5ZM9.2 11l-5.283 7.265a1.25 1.25 0 0 0 1.01 1.985h14.146a1.25 1.25 0 0 0 1.01-1.985L14.8 11H9.2Zm5.05-1.5V5.75h-4.5V9.5h4.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M10.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm4.5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

var getTheme$1Q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorInviteFriends = function SvgTwoColorInviteFriends(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1Q(props["data-theme"]),
    fillRule: "evenodd",
    d: "M9.75 6a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 2.25a3.75 3.75 0 0 0-1.6 7.143C5.728 10.238 2.25 14.725 2.25 20a.75.75 0 0 0 1.5 0c0-5.185 3.766-9.25 8.25-9.25s8.25 4.065 8.25 9.25a.75.75 0 0 0 1.5 0c0-5.275-3.477-9.762-8.15-10.607A3.75 3.75 0 0 0 12 2.25Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.219 12.409a.75.75 0 0 1 .532.917l-.087.33.781.207a.75.75 0 1 1-.385 1.45l-1.5-.398-.006-.002-.006-.002-.697-.185a.705.705 0 0 0-.361 1.362l1.405.374a2.204 2.204 0 0 1-1.109 4.267l-.087.33a.75.75 0 0 1-1.45-.385l.087-.33-.78-.207a.75.75 0 1 1 .384-1.45l2.21.586a.705.705 0 0 0 .36-1.362l-1.405-.373a2.205 2.205 0 0 1 1.109-4.267l.087-.33a.75.75 0 0 1 .918-.532ZM21 16.249a.75.75 0 0 1 .75.75v1.25H23a.75.75 0 0 1 0 1.5h-1.25V21a.75.75 0 1 1-1.5 0v-1.25H19a.75.75 0 1 1 0-1.5h1.25V17a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1R = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorKycId = function SvgTwoColorKycId(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1R(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 19A1.75 1.75 0 0 1 21 20.75H3A1.75 1.75 0 0 1 1.25 19V5c0-.966.784-1.75 1.75-1.75h18c.967 0 1.75.784 1.75 1.75v14Zm-1.75.25a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h18Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12.75 11a.75.75 0 0 1-.75.75H5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75ZM19.75 8a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75ZM12.75 16a.75.75 0 0 1-.75.75H5a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$1S = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorKyc = function SvgTwoColorKyc(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M9.75 9.15a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm4.732 2.812a3.75 3.75 0 1 0-4.963 0A5.75 5.75 0 0 0 6.25 17.15a.75.75 0 0 0 1.5 0 4.25 4.25 0 0 1 8.5 0 .75.75 0 0 0 1.5 0 5.75 5.75 0 0 0-3.268-5.188Z"
  }), createElement("path", {
    fill: getTheme$1S(props["data-theme"]),
    d: "M5 21.321a2.75 2.75 0 0 1-2.75-2.75V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v13.571a2.75 2.75 0 0 1-2.75 2.75h-4.154l-1.515 1.775a1.75 1.75 0 0 1-2.662 0l-1.515-1.775H5Zm-1.25-2.75c0 .69.56 1.25 1.25 1.25h4.5a.75.75 0 0 1 .57.263l1.74 2.038c.1.117.28.117.38 0l1.74-2.038a.75.75 0 0 1 .57-.263H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v13.571Z"
  }));
};

var getTheme$1T = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorKey = function SvgTwoColorKey(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1T(props["data-theme"]),
    fillRule: "evenodd",
    d: "M15.88 1.25h5.87v6.5h-1.92v2h-1.92v2h-2.198l-.003.005a7.25 7.25 0 1 1-6.557-3.497L15.88 1.25Zm.64 1.5-6.72 7h-.318a5.75 5.75 0 1 0 4.752 2.486l-.247-.358.781-1.628h1.642v-2h1.92v-2h1.92v-3.5h-3.73Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9.347 13.506a2 2 0 1 0 .306 3.989 2 2 0 0 0-.306-3.99Z"
  }));
};

var getTheme$1U = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLpYields = function SvgTwoColorLpYields(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1U(props["data-theme"]),
    d: "M12 20.25a8.25 8.25 0 0 0 7.566-11.544.75.75 0 1 1 1.375-.6l.044.102A9.723 9.723 0 0 1 21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25a.75.75 0 0 1 0 1.5 8.25 8.25 0 1 0 0 16.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M17.75 2.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5ZM7.6 9.3v6.25h3.742v-1.21H8.961V9.3H7.6ZM12.348 9.3v6.25h1.36v-2.257h1.594c.293 0 .555-.048.788-.143.233-.102.43-.239.59-.412a1.76 1.76 0 0 0 .386-.627c.09-.244.134-.516.134-.814 0-.293-.045-.562-.134-.806a1.746 1.746 0 0 0-.385-.636 1.652 1.652 0 0 0-.591-.403 1.953 1.953 0 0 0-.788-.152h-2.954Zm2.793 2.811h-1.433v-1.63h1.433c.203 0 .361.055.474.162.12.101.18.254.18.457v.393c0 .204-.06.359-.18.466-.113.101-.271.152-.474.152Z"
  }));
};

var getTheme$1V = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLaunch = function SvgTwoColorLaunch(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M6.921 3.743a1.333 1.333 0 0 1 2 .029l.213.249a1.333 1.333 0 0 1-.07 1.81L6.937 7.958l-1.61 1.61c-.25.25-.588.39-.942.39h-.1c-1.158 0-1.766-1.373-.987-2.23l3.623-3.985Z"
  }), createElement("path", {
    fill: getTheme$1V(props["data-theme"]),
    d: "M13.265 4.463a1.384 1.384 0 0 0-1.989 0l-7.17 7.314a1.49 1.49 0 0 0 0 2.072l4.328 4.414a5.373 5.373 0 0 0 7.674 0l4.327-4.414a1.49 1.49 0 0 0 0-2.072l-7.17-7.314Zm-3.06-1.05a2.884 2.884 0 0 1 4.132 0l7.169 7.314a2.99 2.99 0 0 1 0 4.172l-4.327 4.414a6.873 6.873 0 0 1-9.816 0L3.036 14.9a2.99 2.99 0 0 1 0-4.172l7.17-7.314Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m10.27 15.292 1.312-6h1.983l-1.068 4.46h2.44l-.243 1.54H10.27Z"
  }));
};

var getTheme$1W = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLaunchpad = function SvgTwoColorLaunchpad(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1W(props["data-theme"]),
    d: "M18.532 3.338a2.197 2.197 0 0 1 1.973 1.973l.284 2.904a4.092 4.092 0 0 1-1.179 3.292L9.62 21.499a.75.75 0 0 0 1.06 1.06l9.992-9.991a5.591 5.591 0 0 0 1.611-4.5l-.285-2.904a3.697 3.697 0 0 0-3.318-3.318l-2.904-.285a5.591 5.591 0 0 0-4.5 1.61l-7.014 7.016a.75.75 0 0 0 1.06 1.06l7.015-7.014a4.091 4.091 0 0 1 3.292-1.18l2.904.285Zm-3.909 3.37a1.67 1.67 0 1 1 2.363 2.362 1.67 1.67 0 0 1-2.363-2.362Zm3.424-1.061a3.17 3.17 0 1 0-4.484 4.484 3.17 3.17 0 0 0 4.484-4.484Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.747 10.82a.75.75 0 1 0-1.06-1.061L4.9 15.545a.75.75 0 0 0 1.061 1.06l5.786-5.785Zm-.236 5.122a.75.75 0 0 0-1.06-1.06l-5.787 5.785a.75.75 0 1 0 1.06 1.061l5.787-5.786Z"
  }));
};

var getTheme$1X = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLaunchpool = function SvgTwoColorLaunchpool(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1X(props["data-theme"]),
    d: "M12 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 11a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM2.238 18.225c.339-.282.914-.301 1.285-.044l1.81 1.257c.376.261.962.237 1.297-.055l.52-.45c1.122-.974 3.139-.917 4.16.118.345.35 1.035.35 1.38 0 1.021-1.035 3.038-1.092 4.16-.119l.52.451c.335.292.92.316 1.297.055l1.81-1.257c.371-.257.946-.238 1.285.044.339.281.313.718-.058.975l-1.81 1.257c-1.129.784-2.886.71-3.893-.164l-.52-.451c-.36-.313-1.009-.295-1.337.038-1.072 1.085-3.216 1.085-4.288 0-.328-.333-.977-.351-1.338-.038l-.52.45c-1.006.875-2.763.95-3.892.165L2.296 19.2c-.37-.257-.397-.694-.058-.975Z"
  }));
};

var getTheme$1Y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLeaderboard = function SvgTwoColorLeaderboard(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1Y(props["data-theme"]),
    d: "M9.75 9a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-1.5a1.5 1.5 0 0 1-1.5-1.5V9Zm3 0h-1.5v10.5h1.5V9ZM3 13.5A1.5 1.5 0 0 1 4.5 12H6a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 6 21H4.5A1.5 1.5 0 0 1 3 19.5v-6Zm3 0H4.5v6H6v-6Zm12-3.75a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 18 21h1.5a1.5 1.5 0 0 0 1.5-1.5v-8.25a1.5 1.5 0 0 0-1.5-1.5H18Zm0 1.5h1.5v8.25H18v-8.25Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.246 3.302c.023-.118-.067-.26-.18-.26l-1.28-.188-.585-1.226a.18.18 0 0 0-.09-.095c-.113-.07-.248-.023-.315.095l-.562 1.226-1.282.189c-.067 0-.112.023-.135.07a.236.236 0 0 0 0 .33l.922.944-.225 1.344c0 .047 0 .094.023.141.067.118.202.166.315.095l1.146-.637 1.147.637c.022.023.067.023.112.023h.045a.244.244 0 0 0 .18-.283l-.225-1.344.922-.943a.13.13 0 0 0 .067-.118Z"
  }));
};

var getTheme$1Z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLearn = function SvgTwoColorLearn(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M14.4 12.636a.24.24 0 0 1-.4-.177V5.727L18 5v7.46a.24.24 0 0 1-.4.176l-1.398-1.906a.25.25 0 0 0-.404 0L14.4 12.636Z"
  }), createElement("path", {
    fill: getTheme$1Z(props["data-theme"]),
    d: "M2.25 5.017a1.75 1.75 0 0 1 2.157-1.702l7.535 1.802a.25.25 0 0 0 .116 0l7.535-1.802a1.75 1.75 0 0 1 2.157 1.702V16.65a1.75 1.75 0 0 1-1.218 1.667l-8 2.55a1.75 1.75 0 0 1-1.064 0l-8-2.55A1.75 1.75 0 0 1 2.25 16.65V5.017Zm1.808-.243a.25.25 0 0 0-.308.243V16.65c0 .109.07.205.174.238l8 2.55c.05.016.103.016.152 0l8-2.55a.25.25 0 0 0 .174-.238V5.017a.25.25 0 0 0-.308-.243l-7.535 1.802a1.75 1.75 0 0 1-.814 0L4.058 4.774Z"
  }));
};

var getTheme$1_ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLendingCoinList = function SvgTwoColorLendingCoinList(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$1_(props["data-theme"]),
    d: "m12.617 10.221.008.004L18.69 7.17a.8.8 0 0 1 1.16.715v4.444c.777.288 1.322.622 1.876.961l.114.07a.75.75 0 0 1-.782 1.28l-.1-.06c-.386-.237-.721-.443-1.108-.625v.942a.8.8 0 0 1-.44.715l-6.5 3.274a.8.8 0 0 1-.979-.207l-6.56-3.305a.8.8 0 0 1-.44-.714v-.898c-.266.13-.479.276-.734.45-.184.126-.389.267-.652.428a.75.75 0 0 1-.783-1.28c.166-.101.323-.209.483-.32.444-.304.917-.628 1.686-.892v-4.5a.8.8 0 0 1 1.16-.715l6.527 3.288Zm-.867 1.242-5.32-2.68v5.446l5.32 2.68v-5.446Zm1.5 5.572 5.1-2.569V9.021l-5.1 2.57v5.444ZM22.799 18.938a.75.75 0 1 0-.998-1.12c-1.16 1.031-3.528 1.914-6.587 2.268a.75.75 0 1 0 .172 1.49c3.17-.367 5.91-1.3 7.413-2.638ZM1.74 17.879a.75.75 0 0 1 1.058-.062c1.16 1.032 3.529 1.915 6.588 2.269a.75.75 0 1 1-.172 1.49c-3.171-.367-5.91-1.3-7.413-2.638a.75.75 0 0 1-.061-1.06ZM2.8 16.1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM22.3 17.1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.332 1.978a.359.359 0 0 1 .336 0l6.12 3.205c.288.152.288.596 0 .747l-6.12 3.206a.359.359 0 0 1-.336 0L6.212 5.93c-.288-.151-.288-.595 0-.747l6.12-3.205Zm-3.53 3.579L12.5 7.494l3.698-1.937L12.5 3.619 8.802 5.557ZM12.3 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

var getTheme$1$ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLending = function SvgTwoColorLending(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12 3.75a8.21 8.21 0 0 0-4.745 1.5H9.3a.75.75 0 0 1 0 1.5H5.511a.75.75 0 0 1-.823-1.2A9.728 9.728 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0A8.25 8.25 0 0 0 12 3.75Zm.133 5.217a.25.25 0 0 0-.265 0l-3.47 2.169a.75.75 0 0 1-.796-1.272l3.47-2.169a1.75 1.75 0 0 1 1.856 0l3.47 2.169a.75.75 0 0 1-.796 1.272l-3.47-2.169Zm-.265 6.066a.25.25 0 0 0 .264 0l3.47-2.169a.75.75 0 0 1 .796 1.272l-3.47 2.169a1.75 1.75 0 0 1-1.856 0l-3.47-2.169a.75.75 0 1 1 .796-1.272l3.47 2.169Z"
  }), createElement("path", {
    fill: getTheme$1$(props["data-theme"]),
    d: "M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.733 9.733 0 0 0 7.611-3.656.75.75 0 0 0 .134-.684.75.75 0 0 0-.745-.66h-4a.75.75 0 0 0 0 1.5h2.386A8.25 8.25 0 0 1 3.75 12Z"
  }));
};

var getTheme$20 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLeveragedTokens = function SvgTwoColorLeveragedTokens(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$20(props["data-theme"]),
    d: "M21.358 6.84a1.878 1.878 0 0 0-1.817-2.34 1.875 1.875 0 0 0-1.577 2.89L6.896 9.783a2.25 2.25 0 1 0-2.512.543l-.876.19a.75.75 0 0 0 .317 1.466l7.034-1.522-4.97 7.457c-.665.997.05 2.332 1.247 2.332h10.395c1.198 0 1.912-1.335 1.248-2.332l-5.197-7.796a1.524 1.524 0 0 0-.171-.213l7.748-1.676a.75.75 0 0 0 .2-1.392Zm-9.024 4.114 5.197 7.796H7.136l5.198-7.796Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.667 15.75a.75.75 0 1 1 1.5 0v3h-1.5v-3Z"
  }));
};

var getTheme$21 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLineChart = function SvgTwoColorLineChart(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M20.119 5.452a.748.748 0 0 0-.294-.155l-3.189-.854a.75.75 0 1 0-.388 1.449l1.748.468-3.84 2.688-.963-.964A.75.75 0 0 0 12.23 8l-6.367 4.49a.75.75 0 0 0 .864 1.226l5.852-4.126.962.962a.75.75 0 0 0 .96.084l5.636-3.944a.75.75 0 0 0-.018-1.241Z"
  }), createElement("path", {
    fill: getTheme$21(props["data-theme"]),
    d: "M22.5 21.962a.75.75 0 1 0 0-1.5h-2.603v-9.309a.75.75 0 1 0-1.5 0v9.309H14.31v-4.838a.75.75 0 1 0-1.5 0v4.838H8.72v-4.838a.75.75 0 1 0-1.5 0v4.838H4.25V4.447a.75.75 0 0 0-1.5 0v16.765c0 .414.336.75.75.75h19Z"
  }));
};

var getTheme$22 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLiquidityMining = function SvgTwoColorLiquidityMining(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m9.293 7.659-3.157 4.058.488 2.441a.75.75 0 1 1-1.47.295l-.502-2.509a1.35 1.35 0 0 1 .258-1.094l3.303-4.246a1.35 1.35 0 0 1 2.02-.126l5.206 5.206a1.35 1.35 0 0 1 0 1.91l-2.809 2.808c-.148.148-.328.26-.527.326l-1.533.511a.75.75 0 0 1-.474-1.423l1.499-.5 2.678-2.677-4.98-4.98Z"
  }), createElement("path", {
    fill: getTheme$22(props["data-theme"]),
    d: "M2 14.111a.75.75 0 0 0 0 1.5h5.76c.36 0 .702.156.94.427l2.694 3.078a2.75 2.75 0 0 0 2.07.94H22a.75.75 0 0 0 0-1.5h-8.537a1.25 1.25 0 0 1-.94-.427L9.828 15.05a2.75 2.75 0 0 0-2.07-.939H2Zm14.806 1.861a.75.75 0 0 1 .75-.75H22a.75.75 0 0 1 0 1.5h-4.444a.75.75 0 0 1-.75-.75ZM1.25 19.305a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75ZM14.803 2.664a.75.75 0 0 1 1.06 0l3.334 3.333a.75.75 0 0 1-1.06 1.061L17 5.922l-6.692 6.692a.75.75 0 0 1-1.06-1.061l6.691-6.692-1.136-1.136a.75.75 0 0 1 0-1.061Z"
  }));
};

var getTheme$23 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLock = function SvgTwoColorLock(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M16.5 9.75a.75.75 0 0 1-.75-.75V7.5a3.75 3.75 0 0 0-7.5 0V9a.75.75 0 1 1-1.5 0V7.5a5.25 5.25 0 0 1 10.5 0V9a.75.75 0 0 1-.75.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$23(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19 9.25A2.75 2.75 0 0 1 21.75 12v7A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-7A2.75 2.75 0 0 1 5 9.25h14ZM20.25 12c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 12.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$24 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorLowerDiagram = function SvgTwoColorLowerDiagram(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$24(props["data-theme"]),
    d: "M2.75 10.5c0-.966.784-1.75 1.75-1.75h1.8c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75H4.5a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h1.8a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25H4.5ZM9.75 12.5c0-.966.784-1.75 1.75-1.75h1.7c.966 0 1.75.784 1.75 1.75v8a1.75 1.75 0 0 1-1.75 1.75h-1.7a1.75 1.75 0 0 1-1.75-1.75v-8Zm1.75-.25a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h1.7a.25.25 0 0 0 .25-.25v-8a.25.25 0 0 0-.25-.25h-1.7ZM18.2 13.75a1.75 1.75 0 0 0-1.75 1.75v5c0 .967.784 1.75 1.75 1.75h1.6a1.75 1.75 0 0 0 1.75-1.75v-5a1.75 1.75 0 0 0-1.75-1.75h-1.6Zm-.25 1.75a.25.25 0 0 1 .25-.25h1.6a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-1.6a.25.25 0 0 1-.25-.25v-5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M5.13 1.886a.75.75 0 1 0-.86 1.228l6.109 4.277a.75.75 0 0 0 .96-.084l1.081-1.081 5.676 4.002h-1.765a.75.75 0 0 0 0 1.5h3.58a.75.75 0 0 0 .75-.75v-3.58a.75.75 0 0 0-1.5 0v1.744l-6.393-4.506a.75.75 0 0 0-.962.083L10.724 5.8 5.13 1.886Z"
  }));
};

var getTheme$25 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMt4 = function SvgTwoColorMt4(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$25(props["data-theme"]),
    fillRule: "evenodd",
    d: "M22.75 19A1.75 1.75 0 0 1 21 20.75H3A1.75 1.75 0 0 1 1.25 19V5c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v14Zm-1.75.25a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h18Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M15.75 6H15v1.5h-.75v6H15V15h.75v-1.5h.75v-6h-.75V6Zm-6 4.5H9V9h-.75v1.5H7.5v6h.75V18H9v-1.5h.75v-6Z",
    clipRule: "evenodd"
  }));
};

var getTheme$26 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMap = function SvgTwoColorMap(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$26(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 2.75c-3.988 0-7.25 3.311-7.25 7.432 0 .954.382 2.13 1.042 3.409.651 1.264 1.538 2.56 2.463 3.73a29.185 29.185 0 0 0 2.638 2.925c.383.366.71.646.956.83.058.043.108.079.151.107.043-.028.093-.064.15-.107.247-.184.574-.464.957-.83a29.186 29.186 0 0 0 2.638-2.926c.925-1.17 1.812-2.465 2.463-3.729.66-1.278 1.042-2.455 1.042-3.41 0-4.12-3.262-7.431-7.25-7.431Zm-.161 18.527.011-.005a.08.08 0 0 1-.011.005Zm.31-.005a.06.06 0 0 1 .012.005l-.011-.005ZM3.25 10.182C3.25 5.265 7.152 1.25 12 1.25s8.75 4.015 8.75 8.932c0 1.305-.506 2.735-1.208 4.096-.71 1.376-1.656 2.753-2.62 3.972-.965 1.221-1.96 2.301-2.78 3.082-.407.389-.782.714-1.095.947a3.84 3.84 0 0 1-.454.298 1.275 1.275 0 0 1-.593.173c-.257 0-.48-.112-.593-.173a3.84 3.84 0 0 1-.454-.298 12.48 12.48 0 0 1-1.096-.947 30.676 30.676 0 0 1-2.779-3.082c-.964-1.219-1.91-2.596-2.62-3.972-.701-1.36-1.208-2.79-1.208-4.096Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 7.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM8.25 10a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z",
    clipRule: "evenodd"
  }));
};

var getTheme$27 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMarginTrading = function SvgTwoColorMarginTrading(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$27(props["data-theme"]),
    d: "M9.75 7a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM14 1.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5Zm6.412 14.209a.693.693 0 0 0-.905-.143l-4.547 2.888-.766.658a2.75 2.75 0 0 1-2.716.504l-1.67-.596.504-1.413 1.67.596c.423.151.894.064 1.234-.229l.135-.116-1.109-.926a6.19 6.19 0 0 0-3.373-1.41 7.395 7.395 0 0 0-2.354.152l-.765.174V20c1.611-.09 3.227.067 4.791.468l2.063.528A1.72 1.72 0 0 0 14 20.751l6.27-4.278c.336-.23.403-.7.142-1.014Zm-5.84 1.214 4.13-2.624a2.193 2.193 0 0 1 2.413 3.663l-6.27 4.278a3.22 3.22 0 0 1-2.613.46l-2.063-.53a14.25 14.25 0 0 0-4.473-.414l-.114.007a1.25 1.25 0 0 1-1.332-1.247v-5.04c0-.482.334-.9.804-1.007l1.127-.258a8.896 8.896 0 0 1 2.832-.181 7.69 7.69 0 0 1 4.19 1.75l1.37 1.143ZM1.75 14a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M16 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }));
};

var getTheme$28 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMenuOverview = function SvgTwoColorMenuOverview(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$28(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.75 5c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-5A1.75 1.75 0 0 1 2.75 10V5Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25h-5ZM2.75 15c0-.966.784-1.75 1.75-1.75h5c.966 0 1.75.784 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-5A1.75 1.75 0 0 1 2.75 20v-5Zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h5a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25h-5Zm10-1.5A1.75 1.75 0 0 0 12.75 15v5c0 .966.784 1.75 1.75 1.75h5A1.75 1.75 0 0 0 21.25 20v-5a1.75 1.75 0 0 0-1.75-1.75h-5ZM14.25 15a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-5a.25.25 0 0 1-.25-.25v-5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M15.763 3.177a1.75 1.75 0 0 1 2.474 0l2.829 2.828a1.75 1.75 0 0 1 0 2.475l-2.829 2.829a1.75 1.75 0 0 1-2.474 0L12.934 8.48a1.75 1.75 0 0 1 0-2.475l2.829-2.828Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.828 2.829a.25.25 0 0 0 0 .353l2.828 2.829a.25.25 0 0 0 .354 0l2.828-2.829a.25.25 0 0 0 0-.353l-2.828-2.829Z",
    clipRule: "evenodd"
  }));
};

var getTheme$29 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMore = function SvgTwoColorMore(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$29(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M9 12a1.125 1.125 0 1 1-2.25 0A1.125 1.125 0 0 1 9 12Zm4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm3 1.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
  }));
};

var getTheme$2a = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorMyFeeRates = function SvgTwoColorMyFeeRates(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2a(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 5.75a.75.75 0 0 1 .75.75v.75h1.393a.75.75 0 0 1 0 1.5H11a1.25 1.25 0 1 0 0 2.5h2a2.75 2.75 0 1 1 0 5.5h-.25v.75a.75.75 0 0 1-1.5 0v-.75H9.857a.75.75 0 0 1 0-1.5H13a1.25 1.25 0 1 0 0-2.5h-2a2.75 2.75 0 1 1 0-5.5h.25V6.5a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2b = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorNft = function SvgTwoColorNft(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2b(props["data-theme"]),
    d: "M11.25 1.817a1.5 1.5 0 0 1 1.5 0l7.694 4.442a1.5 1.5 0 0 1 .75 1.299v8.884a1.5 1.5 0 0 1-.75 1.299l-7.694 4.442a1.5 1.5 0 0 1-1.5 0l-7.694-4.442a1.5 1.5 0 0 1-.75-1.3V7.559a1.5 1.5 0 0 1 .75-1.3l7.694-4.441Zm8.444 5.74L12 3.117 4.306 7.558v8.884L12 20.884l7.694-4.442V7.558Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m9.33 15.011.305-5.261h-1.04l-.187 3.222L6.483 9.75h-.928l-.305 5.261h1.04l.188-3.229 1.924 3.229h.928ZM14.076 10.666l.053-.916h-3.511l-.306 5.261h1.041l.124-2.135h2.104l.053-.917H11.53l.075-1.293h2.47ZM18.676 10.666l.054-.916h-3.826l-.053.916h1.392l-.252 4.345h1.04l.253-4.345h1.392Z"
  }));
};

var getTheme$2c = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorNetwork = function SvgTwoColorNetwork(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2c(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.647 3c0-.488.395-.883.882-.883 10.137 0 18.354 8.217 18.354 18.354a.882.882 0 1 1-1.765 0c0-9.162-7.427-16.589-16.589-16.589A.882.882 0 0 1 2.647 3Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2c(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.647 10.412c0-.488.395-.883.882-.883 6.043 0 10.942 4.9 10.942 10.942a.882.882 0 0 1-1.765 0 9.177 9.177 0 0 0-9.177-9.177.882.882 0 0 1-.882-.882Z",
    clipRule: "evenodd"
  }), createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2,
    fill: "#F7A600"
  }));
};

var getTheme$2d = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorNews = function SvgTwoColorNews(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2d(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.5 3.75h11.727A2.25 2.25 0 0 1 18.477 6v.89H19.5a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25h-15A2.25 2.25 0 0 1 2.25 18V6A2.25 2.25 0 0 1 4.5 3.75Zm12.477 10.333a.75.75 0 0 0 1.5 0V8.39H19.5a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .75-.75h11.727a.75.75 0 0 1 .75.75v8.083Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6.75 8.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM11.625 12a.375.375 0 0 0 0 .75h3a.375.375 0 0 0 0-.75h-3Zm-.375 2.625c0-.207.168-.375.375-.375h3a.375.375 0 0 1 0 .75h-3a.375.375 0 0 1-.375-.375Zm-4.5-3c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125h1.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-1.5Zm-.375 1.125c0-.207.168-.375.375-.375h1.5c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375h-1.5a.375.375 0 0 1-.375-.375v-1.5Z"
  }));
};

var getTheme$2e = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorNotificationCenter = function SvgTwoColorNotificationCenter(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M15 18.998a3 3 0 1 1-6 0c0-1.658 1.343-.75 3-.75s3-.908 3 .75Z"
  }), createElement("path", {
    fill: getTheme$2e(props["data-theme"]),
    d: "M12 1a1 1 0 0 0-1 1v1.325a6.585 6.585 0 0 0-5.583 6.508v3.492l-2.35 2.468c-1.062 1.114-.272 2.957 1.266 2.957h15.334c1.538 0 2.328-1.843 1.267-2.957l-2.35-2.468V9.833A6.585 6.585 0 0 0 13 3.325V2a1 1 0 0 0-1-1ZM6.917 9.833a5.083 5.083 0 0 1 10.166 0v4.092l2.765 2.903a.25.25 0 0 1-.181.422H4.333a.25.25 0 0 1-.18-.422l2.764-2.903V9.833Z"
  }));
};

var getTheme$2f = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorOtcFeeRate = function SvgTwoColorOtcFeeRate(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2f(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.2 9.3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16.2 14.3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.73 9.33a.75.75 0 1 0-1.06-1.06l-6.364 6.364a.75.75 0 1 0 1.06 1.06L15.73 9.33Z"
  }));
};

var getTheme$2g = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorOtcPremiumPricing = function SvgTwoColorOtcPremiumPricing(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M14.997 9.05a.75.75 0 0 1 .746.85.749.749 0 0 1-.213.63l-4 4a.75.75 0 0 1-.808.166L8.68 13.88l-3.65 3.65a.75.75 0 1 1-1.061-1.06l4-4a.75.75 0 0 1 .809-.166l2.04.816 2.564-2.564-2.38.01a.75.75 0 1 1-.006-1.5l4-.016Z"
  }), createElement("path", {
    fill: getTheme$2g(props["data-theme"]),
    d: "M12 3.75a8.25 8.25 0 0 0-6.861 12.833.75.75 0 0 1-1.247.834A9.708 9.708 0 0 1 2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75a9.708 9.708 0 0 1-5.417-1.642.75.75 0 1 1 .834-1.247A8.25 8.25 0 1 0 12 3.75Z"
  }));
};

var getTheme$2h = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorOtcTrading = function SvgTwoColorOtcTrading(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2h(props["data-theme"]),
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m6 12 6-6 6 6-6 6-6-6Zm2.121 0L12 15.879 15.879 12 12 8.121 8.121 12Z"
  }));
};

var getTheme$2i = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorOneClickBuy = function SvgTwoColorOneClickBuy(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2i(props["data-theme"]),
    d: "M1.25 5.5A2.25 2.25 0 0 1 3.5 3.25h15a2.25 2.25 0 0 1 2.25 2.25v1.654h-1.5V5.5a.75.75 0 0 0-.75-.75h-15a.75.75 0 0 0-.75.75v11c0 .414.336.75.75.75h5.912v1.5H3.5a2.25 2.25 0 0 1-2.25-2.25v-11Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M6 7.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H6Zm16.487 1.292.134.532c.288 1.114.034 2.603-.57 4.046a11.903 11.903 0 0 1-2.803 4.03c-.047 1.18-.536 2.152-1.45 3.082l-.794.809-1.616-2.475c-.714.076-1.467-.254-1.985-.78-.523-.533-.846-1.306-.76-2.042l-2.397-1.64.791-.805c.892-.909 1.842-1.4 2.984-1.46a11.527 11.527 0 0 1 3.96-2.862c1.422-.614 2.888-.868 3.981-.574l.525.139Zm-1.246 1.265c-.654-.062-1.603.098-2.679.563a10.034 10.034 0 0 0-3.637 2.712l-.23.273-.352-.008a2.629 2.629 0 0 0-1.727.555l1.872 1.282-.328.606c-.072.134-.085.54.294.925.382.389.784.374.901.31l.597-.328 1.258 1.926c.421-.578.576-1.133.553-1.786l-.012-.362.268-.237a10.368 10.368 0 0 0 2.665-3.71c.457-1.095.617-2.058.557-2.721ZM18.805 13a.744.744 0 0 0 .737-.75c0-.414-.33-.75-.737-.75a.744.744 0 0 0-.737.75c0 .414.33.75.737.75Zm-8.84 8.168s1.985-.347 2.732-1.122c.566-.589.669-1.444.204-1.926-.464-.482-1.287-.375-1.853.213-.67.695-1.082 2.835-1.082 2.835Z"
  }));
};

var getTheme$2j = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorOptions = function SvgTwoColorOptions(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2j(props["data-theme"]),
    d: "M11.25 18.75H6a.75.75 0 0 1-.75-.75V6A.75.75 0 0 1 6 5.25h6.75V7.5A2.25 2.25 0 0 0 15 9.75h2.25v.75c0 .199.079.39.22.53.14.141.53.22.53.22s.39-.079.53-.22a.75.75 0 0 0 .22-.53V8.955a.982.982 0 0 0-.045-.203v-.067a.804.804 0 0 0-.142-.21l-4.5-4.5a.803.803 0 0 0-.21-.143.24.24 0 0 0-.068 0l-.24-.082H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25h5.25a.75.75 0 1 0 0-1.5Zm3-12.442 1.942 1.942H15a.75.75 0 0 1-.75-.75V6.308Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.25 16.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm2.625-4.125a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25Zm0 3a.75.75 0 0 0-1.5 0v1.125a1.5 1.5 0 0 0 1.5 1.5H18a.75.75 0 0 0 0-1.5h-1.125V15.75Z"
  }));
};

var getTheme$2k = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorP2P = function SvgTwoColorP2P(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "m9.759 14.531.16-.975 2.119-1.541c.141-.103.263-.199.365-.288.104-.091.187-.185.25-.28a.817.817 0 0 0 .125-.32.572.572 0 0 0-.03-.33.425.425 0 0 0-.19-.211.642.642 0 0 0-.316-.074.776.776 0 0 0-.343.076.683.683 0 0 0-.26.222.85.85 0 0 0-.137.356h-1.285a1.96 1.96 0 0 1 .387-.907c.201-.254.456-.449.764-.585.31-.137.658-.205 1.045-.205.399 0 .735.064 1.008.192.272.127.47.306.591.537.124.23.159.501.105.812a1.656 1.656 0 0 1-.217.57c-.11.19-.288.399-.533.63-.243.229-.581.502-1.013.82l-.53.39-.005.028h1.947l-.18 1.083H9.76Zm4.422 0 .828-4.994h2.152c.37 0 .682.073.935.22.254.146.435.351.546.617.11.264.136.574.078.929a2.04 2.04 0 0 1-.39.934c-.2.26-.454.46-.764.602-.309.14-.654.21-1.037.21h-.746l-.248 1.482h-1.354Zm2.25-2.536h-.473l.23-1.375h.477c.159 0 .29.027.392.083a.452.452 0 0 1 .219.234c.044.1.054.223.032.366a.765.765 0 0 1-.448.61 1.039 1.039 0 0 1-.429.082ZM6.078 9.537 5.25 14.53h1.354l.247-1.483h.746c.383 0 .729-.07 1.037-.21.31-.14.565-.341.765-.602.2-.261.33-.573.39-.934.058-.354.032-.664-.079-.929a1.252 1.252 0 0 0-.545-.617c-.253-.146-.565-.22-.935-.22H6.078ZM7.5 11.995h-.473l.23-1.375h.476c.16 0 .29.027.392.083a.452.452 0 0 1 .22.234c.043.1.054.222.031.365a.766.766 0 0 1-.448.61 1.04 1.04 0 0 1-.428.083Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12 3.75a8.21 8.21 0 0 0-4.745 1.5H9.3a.75.75 0 0 1 0 1.5H5.511a.75.75 0 0 1-.823-1.2A9.728 9.728 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0A8.25 8.25 0 0 0 12 3.75Z"
  }), createElement("path", {
    fill: getTheme$2k(props["data-theme"]),
    d: "M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.733 9.733 0 0 0 7.611-3.656.75.75 0 0 0 .134-.684.75.75 0 0 0-.745-.66h-4a.75.75 0 0 0 0 1.5h2.386A8.25 8.25 0 0 1 3.75 12Z"
  }));
};

var getTheme$2l = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPassport = function SvgTwoColorPassport(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2l(props["data-theme"]),
    fillRule: "evenodd",
    d: "M20.75 4A1.75 1.75 0 0 0 19 2.25H3.25v19.5H19A1.75 1.75 0 0 0 20.75 20V4ZM19 3.75a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25H4.75V3.75H19ZM8 16.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M10.043 7.098a3.519 3.519 0 0 0-.907.89c.211.08.43.152.653.214.067-.378.152-.75.254-1.104Zm1.248-.526c-.229.52-.407 1.165-.523 1.838a8.406 8.406 0 0 0 2.467 0c-.111-.67-.282-1.315-.5-1.833a3.513 3.513 0 0 0-1.444-.005Zm-1.632 2.63a8.613 8.613 0 0 1-.977-.318C8.564 9.234 8.5 9.61 8.5 10c0 .468.092.914.258 1.322.292-.111.593-.208.904-.29-.03-.3-.044-.605-.044-.914 0-.296.014-.604.04-.915Zm.989 1.63a8.503 8.503 0 0 1-.03-.714c0-.233.01-.473.027-.715a9.41 9.41 0 0 0 2.71 0c.017.243.027.483.027.715 0 .242-.01.48-.03.715a9.414 9.414 0 0 0-2.704 0Zm-.835 1.195c-.183.05-.363.107-.538.17.22.272.479.51.769.706a8.836 8.836 0 0 1-.23-.876Zm1.506 1.407a7.6 7.6 0 0 1-.527-1.611 8.4 8.4 0 0 1 2.415 0 7.604 7.604 0 0 1-.527 1.61 3.513 3.513 0 0 1-1.36 0Zm2.653-6.326c.098.35.179.72.242 1.093a7.61 7.61 0 0 0 .65-.213 3.52 3.52 0 0 0-.892-.88Zm-.016 5.795c.09-.284.168-.576.23-.876.184.05.363.107.539.17a3.52 3.52 0 0 1-.77.706ZM15.5 10c0 .468-.092.914-.258 1.322a8.65 8.65 0 0 0-.904-.29c.029-.3.044-.605.044-.914 0-.294-.014-.602-.04-.915.336-.088.662-.195.976-.319.118.35.182.726.182 1.116Zm-8 0a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2m = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPayout = function SvgTwoColorPayout(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2m(props["data-theme"]),
    fillRule: "evenodd",
    d: "M20.25 12A8.25 8.25 0 1 1 12 3.75a.75.75 0 0 0 0-1.5c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75a9.723 9.723 0 0 0-.809-3.893.75.75 0 0 0-1.375.599l.037.086c.416.985.647 2.069.647 3.208Zm-7.5-3a.75.75 0 0 0-1.5 0v.341a2.205 2.205 0 0 0 .023 4.409h1.454a.704.704 0 1 1 0 1.41h-2.285a.75.75 0 0 0 0 1.5h.808V17a.75.75 0 0 0 1.5 0v-.341a2.205 2.205 0 0 0-.023-4.409h-1.454a.705.705 0 0 1 0-1.41h2.286a.75.75 0 0 0 0-1.5h-.809V9Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M16.47 2.47a.75.75 0 0 1 1.06 0l3 3A.75.75 0 0 1 20 6.75h-7a.75.75 0 0 1 0-1.5h5.19l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2n = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPhone = function SvgTwoColorPhone(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2n(props["data-theme"]),
    fillRule: "evenodd",
    d: "M18 2.25A2.75 2.75 0 0 1 20.75 5v14A2.75 2.75 0 0 1 18 21.75H6A2.75 2.75 0 0 1 3.25 19V5A2.75 2.75 0 0 1 6 2.25h12ZM19.25 5c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8.25 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2o = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPicture = function SvgTwoColorPicture(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "m8.552 9.655 10.919 10.876 1.058-1.062-6.483-6.458 1.345-1.353a2.25 2.25 0 0 1 3.183-.01l2.897 2.884 1.058-1.064-2.897-2.882a3.75 3.75 0 0 0-5.305.015l-1.343 1.351-3.373-3.36a3.75 3.75 0 0 0-5.312.02l-2.832 2.86 1.066 1.056 2.832-2.862a2.25 2.25 0 0 1 3.187-.01Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2o(props["data-theme"]),
    fillRule: "evenodd",
    d: "M1.25 7A3.75 3.75 0 0 1 5 3.25h14A3.75 3.75 0 0 1 22.75 7v10A3.75 3.75 0 0 1 19 20.75H5A3.75 3.75 0 0 1 1.25 17V7ZM5 4.75A2.25 2.25 0 0 0 2.75 7v10A2.25 2.25 0 0 0 5 19.25h14A2.25 2.25 0 0 0 21.25 17V7A2.25 2.25 0 0 0 19 4.75H5Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2p = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPledgedEth = function SvgTwoColorPledgedEth(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2p(props["data-theme"]),
    d: "M12 20.25a8.25 8.25 0 0 0 7.566-11.544.75.75 0 1 1 1.375-.6l.044.102A9.723 9.723 0 0 1 21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25a.75.75 0 0 1 0 1.5 8.25 8.25 0 1 0 0 16.5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M17.75 2.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5ZM8.651 12.56a.4.4 0 0 1 0-.392l3.106-5.545a.4.4 0 0 1 .698 0l3.107 5.545a.4.4 0 0 1 0 .392l-3.107 5.545a.4.4 0 0 1-.698 0L8.65 12.559Zm2.064.615 1.391 2.484 1.442-2.574-.992.496a1.15 1.15 0 0 1-1.029 0l-.812-.406Zm2.73-1.716-1.339-2.39-1.367 2.441 1.302.651 1.404-.702Z"
  }));
};

var getTheme$2q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPositionBuilder = function SvgTwoColorPositionBuilder(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m12.1 3.81 7.153 3.747-7.153 3.747-7.153-3.747L12.1 3.809Zm.42-1.51a.897.897 0 0 0-.84 0L3.427 6.622c-.721.379-.721 1.489 0 1.867l8.255 4.324a.897.897 0 0 0 .839 0l8.254-4.324c.722-.378.722-1.488 0-1.867L12.52 2.3Z"
  }), createElement("path", {
    fill: getTheme$2q(props["data-theme"]),
    d: "M20.968 13.481c.359-.184.512-.649.34-1.037-.17-.388-.6-.553-.96-.368l-8.13 4.175a.225.225 0 0 1-.216-.005l-8.46-4.867c-.352-.202-.788-.059-.975.32-.188.38-.055.851.297 1.053l8.46 4.867c.47.27 1.032.285 1.514.038l8.13-4.176Z"
  }), createElement("path", {
    fill: getTheme$2q(props["data-theme"]),
    d: "M20.968 18.081c.359-.184.512-.649.34-1.037-.17-.388-.6-.553-.96-.368l-8.13 4.175a.225.225 0 0 1-.216-.005l-8.46-4.867c-.352-.202-.788-.059-.975.32-.188.38-.055.851.297 1.053l8.46 4.867c.47.27 1.032.285 1.514.037l8.13-4.175Z"
  }));
};

var getTheme$2r = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorProtection = function SvgTwoColorProtection(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12 11.65a.75.75 0 0 1 .75.75v5.958a3.5 3.5 0 1 1-7 0 .75.75 0 1 1 1.5 0 2 2 0 0 0 4 0V12.4a.75.75 0 0 1 .75-.75Z"
  }), createElement("path", {
    fill: getTheme$2r(props["data-theme"]),
    d: "M12.5 2.95a.75.75 0 0 0-1.5 0V4.2c-4.915.501-8.75 4.653-8.75 9.7 0 .03.002.059.005.087a.75.75 0 0 0 1.464.301c.276-.93 1.18-1.638 2.281-1.638 1.097 0 1.999.704 2.278 1.628a.75.75 0 0 0 1.444 0c.28-.924 1.18-1.628 2.278-1.628 1.097 0 1.999.704 2.278 1.628a.749.749 0 0 0 1.444 0c.28-.924 1.18-1.628 2.278-1.628 1.101 0 2.005.709 2.281 1.638a.75.75 0 0 0 1.464-.3.766.766 0 0 0 .005-.088c0-5.217-4.098-9.477-9.25-9.737V2.95Zm-.5 2.7a8.254 8.254 0 0 1 7.941 6.005A3.95 3.95 0 0 0 18 11.15a3.914 3.914 0 0 0-3 1.38 3.914 3.914 0 0 0-3-1.38 3.914 3.914 0 0 0-3 1.38 3.914 3.914 0 0 0-3-1.38c-.704 0-1.368.183-1.941.505A8.254 8.254 0 0 1 12 5.65Z"
  }));
};

var getTheme$2s = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorPublicInformation = function SvgTwoColorPublicInformation(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M17.25 16.5a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0 0 1.5h10.5ZM11 12.625c0 .345-.28.625-.625.625h-3.75a.625.625 0 1 1 0-1.25h3.75c.345 0 .625.28.625.625Zm-.625-2.375a.625.625 0 1 0 0-1.25h-3.75a.625.625 0 1 0 0 1.25h3.75Zm0-3a.625.625 0 1 0 0-1.25h-3.75a.625.625 0 1 0 0 1.25h3.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2s(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19 3.5H5a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5ZM5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V7Z"
  }));
};

var getTheme$2t = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReceive = function SvgTwoColorReceive(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2t(props["data-theme"]),
    d: "M22.25 16.658a3.75 3.75 0 0 1-3.75 3.75h-12a3.75 3.75 0 0 1-3.75-3.75v-2.684a.75.75 0 0 1 1.5 0v2.684a2.25 2.25 0 0 0 2.25 2.25h12a2.25 2.25 0 0 0 2.25-2.25v-2.684a.75.75 0 0 1 1.5 0v2.684Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m13.55 12.939 3.22-3.22a.75.75 0 1 1 1.06 1.061l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V4.5a.75.75 0 0 1 1.5 0v8.439Z"
  }));
};

var getTheme$2u = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorRedeem = function SvgTwoColorRedeem(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2u(props["data-theme"]),
    d: "M13 10.05a.75.75 0 1 0 0-1.5H8.5a2.75 2.75 0 0 0-2.75 2.75v7.222l-2.22-2.22a.75.75 0 0 0-1.06 1.061l3.477 3.477a.75.75 0 0 0 1.06 0l3.477-3.477a.75.75 0 0 0-1.06-1.06L7.25 18.477V11.3c0-.69.56-1.25 1.25-1.25H13Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M19.053 2.77a.75.75 0 0 0-1.061 0l-3.477 3.476a.75.75 0 0 0 1.06 1.061l2.175-2.174V12.3c0 .69-.56 1.25-1.25 1.25H12a.75.75 0 0 0 0 1.5h4.5a2.75 2.75 0 0 0 2.75-2.75V5.088l2.219 2.22a.75.75 0 0 0 1.06-1.062L19.053 2.77Z"
  }));
};

var getTheme$2v = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReduce = function SvgTwoColorReduce(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M17.25 12a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2v(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2w = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReferral1 = function SvgTwoColorReferral1(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2w(props["data-theme"]),
    d: "M5.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm6.108 3.794a4.75 4.75 0 1 0-5.717 0A7.753 7.753 0 0 0 1.25 19v.5a.75.75 0 0 0 1.5 0V19a6.25 6.25 0 1 1 12.5 0v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15 3.25a.75.75 0 0 0 0 1.5 3.25 3.25 0 0 1 0 6.5.75.75 0 0 0 0 1.5A6.25 6.25 0 0 1 21.25 19v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206A4.75 4.75 0 0 0 15 3.25Z"
  }));
};

var getTheme$2x = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReferral = function SvgTwoColorReferral(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M13.233 14.184a.754.754 0 0 0-.546-.912.746.746 0 0 0-.908.544l-.127.514a2.027 2.027 0 0 0-1.51.24 2.05 2.05 0 0 0-.927 1.262 2.07 2.07 0 0 0 .229 1.554c.278.469.73.808 1.257.942l1.504.38a.54.54 0 0 1 .331.25.564.564 0 0 1-.19.766.534.534 0 0 1-.408.061l-2.256-.571a.746.746 0 0 0-.908.544c-.1.402.145.81.547.912l.877.222-.115.466c-.1.402.145.81.546.912a.746.746 0 0 0 .908-.544l.116-.467c.504.107 1.03.018 1.472-.25a2.05 2.05 0 0 0 .927-1.26 2.07 2.07 0 0 0-.229-1.555 2.047 2.047 0 0 0-1.257-.941l-1.504-.381a.54.54 0 0 1-.331-.249.564.564 0 0 1 .19-.766.534.534 0 0 1 .408-.062l2.256.572a.746.746 0 0 0 .907-.544.754.754 0 0 0-.546-.912l-.84-.213.127-.514ZM18.75 21v-1.75H17a.75.75 0 0 1 0-1.5h1.75V16a.75.75 0 0 1 1.5 0v1.75H22a.75.75 0 0 1 0 1.5h-1.75V21a.75.75 0 0 1-1.5 0Z"
  }), createElement("path", {
    fill: getTheme$2x(props["data-theme"]),
    d: "M8.75 7a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm6.168 3.748a4.75 4.75 0 1 0-5.836 0A8.754 8.754 0 0 0 3.25 19v2.5a.75.75 0 0 0 1.5 0V19a7.25 7.25 0 0 1 12.392-5.111.749.749 0 1 0 1.146-.962l.006-.006a8.757 8.757 0 0 0-3.376-2.173Z"
  }));
};

var getTheme$2y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReferral2 = function SvgTwoColorReferral2(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2y(props["data-theme"]),
    d: "M5.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm6.108 3.794a4.75 4.75 0 1 0-5.717 0A7.753 7.753 0 0 0 1.25 19v.5a.75.75 0 0 0 1.5 0V19a6.25 6.25 0 1 1 12.5 0v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15 3.25a.75.75 0 0 0 0 1.5 3.25 3.25 0 0 1 0 6.5.75.75 0 0 0 0 1.5A6.25 6.25 0 0 1 21.25 19v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206A4.75 4.75 0 0 0 15 3.25Z"
  }));
};

var getTheme$2z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorRepayment = function SvgTwoColorRepayment(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.543 11.482a.75.75 0 0 1-.025 1.06l-2.836 2.708H21a.75.75 0 0 1 0 1.5H8.81a.75.75 0 0 1-.518-1.293l4.19-4a.75.75 0 0 1 1.06.025Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2z(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h16a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 18V6Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2A = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReset = function SvgTwoColorReset(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M10.174 3.953a8.25 8.25 0 0 1 7.655 2.215l.01.01.007.006L21.11 9.25H17a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-1.5 0v4.264l-3.368-3.165a9.75 9.75 0 0 0-16.08 3.648.75.75 0 0 0 1.415.5 8.25 8.25 0 0 1 5.957-5.294Z"
  }), createElement("path", {
    fill: getTheme$2A(props["data-theme"]),
    d: "M13.826 20.047a8.25 8.25 0 0 1-7.666-2.225l-.007-.006-3.262-3.066H7a.75.75 0 0 0 0-1.5H1a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-4.264l3.368 3.165a9.75 9.75 0 0 0 16.079-3.648.75.75 0 1 0-1.414-.5 8.251 8.251 0 0 1-5.957 5.294Z"
  }));
};

var getTheme$2B = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorResidence = function SvgTwoColorResidence(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2B(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19.312 21.75a2.75 2.75 0 0 0 2.634-3.54l-1.8-6a2.75 2.75 0 0 0-2.634-1.96H15.4a.75.75 0 0 0 0 1.5h2.112a1.25 1.25 0 0 1 1.197.89l1.8 6a1.25 1.25 0 0 1-1.197 1.61H4.688a1.25 1.25 0 0 1-1.197-1.61l.267-.89H8a.75.75 0 0 0 .75-.75v-2.25h2.55a.75.75 0 1 0 0-1.5H8a.75.75 0 0 0-.75.75v2.25H4.208l1.083-3.61a1.25 1.25 0 0 1 1.197-.89H8.73a.75.75 0 0 0 0-1.5H6.488a2.75 2.75 0 0 0-2.634 1.96l-1.8 6a2.75 2.75 0 0 0 2.634 3.54h14.624Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8.1 7.602C8.1 5.38 9.859 3.6 12 3.6s3.9 1.78 3.9 4.002c0 .495-.2 1.127-.566 1.836-.36.698-.852 1.417-1.367 2.07a16.245 16.245 0 0 1-1.467 1.627 6.282 6.282 0 0 1-.5.436 6.282 6.282 0 0 1-.5-.437 16.245 16.245 0 0 1-1.467-1.627c-.516-.652-1.007-1.37-1.367-2.069C8.3 8.73 8.1 8.097 8.1 7.602Zm3.733 6.08.012-.005a.071.071 0 0 1-.012.006Zm.322-.005a.057.057 0 0 1 .012.006l-.012-.006ZM12 2.4c-2.83 0-5.1 2.342-5.1 5.202 0 .776.3 1.61.7 2.386.405.787.945 1.572 1.492 2.263a17.445 17.445 0 0 0 1.58 1.752c.232.222.449.41.632.547.091.067.186.131.278.181a.894.894 0 0 0 .418.119.894.894 0 0 0 .418-.119 2.34 2.34 0 0 0 .277-.181c.184-.137.4-.325.633-.547a17.442 17.442 0 0 0 1.58-1.752c.547-.691 1.087-1.476 1.492-2.263.4-.775.7-1.61.7-2.386 0-2.86-2.27-5.202-5.1-5.202Zm-1.088 5.1a1.088 1.088 0 1 1 2.175 0 1.088 1.088 0 0 1-2.175 0ZM12 5.213a2.288 2.288 0 1 0 0 4.575 2.288 2.288 0 0 0 0-4.575Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2C = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorReturns = function SvgTwoColorReturns(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2C(props["data-theme"]),
    d: "M9.253 6.859 7.577 4.476c-.31-.44-.29-1.09.165-1.493C8.82 2.027 10.342 1.45 12 1.45c1.659 0 3.18.577 4.258 1.533.455.404.475 1.052.165 1.493l-1.527 2.171a5.947 5.947 0 0 0 1.548-.066c.767-.144 1.466-.478 1.956-1.131a.75.75 0 0 1 1.2.9c-.756 1.008-1.8 1.486-2.79 1.688 2.968 2.324 4.563 6.833 4.683 11.626.039 1.55-1.278 2.736-2.83 2.736H5.334c-1.526 0-2.832-1.149-2.834-2.675C2.492 13.691 4.838 8.408 9.253 6.86Zm1.569-.377a8.878 8.878 0 0 1 1.212-.082c.402 0 .793.028 1.17.083.03-.068.067-.133.111-.196L15 3.892c-.77-.575-1.82-.942-3-.942s-2.23.367-3 .942l1.822 2.59ZM4 19.723c0 .59.523 1.177 1.334 1.177h13.33c.825 0 1.344-.604 1.33-1.198-.082-3.269-.893-6.294-2.293-8.452-1.375-2.12-3.265-3.35-5.667-3.35-2.528 0-4.473 1.217-5.846 3.291-1.404 2.122-2.193 5.14-2.188 8.532Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.496 11.03c.153-.496.854-.496 1.007 0l.56 1.808h1.879c.504 0 .72.64.32.945l-1.543 1.18.575 1.862a.527.527 0 0 1-.823.574L12 16.275 10.529 17.4a.527.527 0 0 1-.823-.574l.575-1.863-1.543-1.179a.527.527 0 0 1 .32-.945h1.88l.558-1.809Z"
  }));
};

var getTheme$2D = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorRewardsHub = function SvgTwoColorRewardsHub(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M10.5 14h3v7h-3v-7Z"
  }), createElement("path", {
    fill: getTheme$2D(props["data-theme"]),
    fillRule: "evenodd",
    d: "M13.541 6.25H15.5L16.55 5a.75.75 0 1 0-1.15-.965L13.542 6.25Zm3.916 0H20c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 20 11.75h-.25v7.75a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-7.75H4A1.75 1.75 0 0 1 2.25 10V8c0-.966.784-1.75 1.75-1.75h2.735l-.241-.287a2.25 2.25 0 1 1 3.447-2.892l2.155 2.568L14.25 3.07a2.25 2.25 0 0 1 3.447 2.892l-.24.287Zm-8.764 0h1.958L8.792 4.035a.75.75 0 1 0-1.149.964l1.05 1.251Zm-4.443 4H20a.25.25 0 0 0 .25-.25V8a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h.25Zm1.5 1.5v7.75c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-7.75H5.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2E = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorRewards = function SvgTwoColorRewards(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M11.725 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L12 16.16l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
  }), createElement("path", {
    fill: getTheme$2E(props["data-theme"]),
    fillRule: "evenodd",
    d: "m16.64 7.25-1.806-3.003a.25.25 0 0 0-.343-.086L9.355 7.25h7.285Zm-10.134 0a.75.75 0 0 1 .169-.138l7.042-4.236a1.75 1.75 0 0 1 2.402.597l2.272 3.777H19A2.75 2.75 0 0 1 21.75 10v1.67a.75.75 0 0 1-.5.708 2.251 2.251 0 0 0 0 4.244c.3.106.5.39.5.707V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.67c0-.319.2-.602.5-.708a2.251 2.251 0 0 0 0-4.244.75.75 0 0 1-.5-.707V10A2.75 2.75 0 0 1 5 7.25h1.506ZM3.75 10c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v1.183a3.749 3.749 0 0 0 0 6.634V19c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-1.183a3.75 3.75 0 0 0 0-6.634V10Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2F = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorScaledOrder = function SvgTwoColorScaledOrder(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M20.2 4.3a.75.75 0 0 0 0-1.5h-16a.75.75 0 0 0 0 1.5h16ZM13.2 8.3a.75.75 0 0 0 0-1.5H4.666a.75.75 0 1 0 0 1.5H13.2Z"
  }), createElement("path", {
    fill: getTheme$2F(props["data-theme"]),
    d: "M20.95 11.55a.75.75 0 0 1-.75.75h-16a.75.75 0 1 1 0-1.5h16a.75.75 0 0 1 .75.75ZM18.95 15.55a.75.75 0 0 1-.75.75h-14a.75.75 0 1 1 0-1.5h14a.75.75 0 0 1 .75.75ZM13.2 20.3a.75.75 0 1 0 0-1.5H4.667a.75.75 0 0 0 0 1.5H13.2Z"
  }));
};

var getTheme$2G = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSearch = function SvgTwoColorSearch(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2G(props["data-theme"]),
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v5a.75.75 0 0 1-1.5 0V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H5Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14 8.25a5.75 5.75 0 1 0 3.501 10.312l1.969 1.968a.75.75 0 1 0 1.06-1.06L18.562 17.5A5.75 5.75 0 0 0 14 8.25ZM9.75 14a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0Z"
  }));
};

var getTheme$2H = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSecurityAlert = function SvgTwoColorSecurityAlert(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2H(props["data-theme"]),
    d: "M11.006 1.764a1.881 1.881 0 0 1 1.988 0 10.07 10.07 0 0 0 5.814 1.516c.986-.045 1.942.708 1.942 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.712 1.993-2.694 2.763a18.872 18.872 0 0 1-2.823 1.828c-.414.216-.79.39-1.102.51-.155.061-.302.112-.435.149a1.68 1.68 0 0 1-.436.069 1.68 1.68 0 0 1-.436-.07 4.609 4.609 0 0 1-.435-.148 11.343 11.343 0 0 1-1.102-.51 18.874 18.874 0 0 1-2.823-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.259-2.283-1.259-3.613V5.08c0-1.091.957-1.844 1.942-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.402 0 11.57 11.57 0 0 1-6.674 1.741.392.392 0 0 0-.277.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.593 1.68.377.197.703.345.95.442a3.133 3.133 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.83 9.83 0 0 0 .951-.443 17.37 17.37 0 0 0 2.594-1.679c.907-.71 1.764-1.54 2.388-2.438.625-.899.991-1.828.991-2.757V5.08a.27.27 0 0 0-.098-.205.392.392 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.75 7.8a.75.75 0 0 0-1.5 0V12a.75.75 0 0 0 1.5 0V7.8ZM12 16.2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

var getTheme$2I = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSecurityKey = function SvgTwoColorSecurityKey(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2I(props["data-theme"]),
    d: "M11.006 1.764a1.881 1.881 0 0 1 1.988 0 10.07 10.07 0 0 0 5.814 1.516c.986-.045 1.942.708 1.942 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.712 1.993-2.694 2.763a18.872 18.872 0 0 1-2.823 1.828c-.414.216-.79.39-1.102.51-.155.061-.302.112-.435.149a1.68 1.68 0 0 1-.436.069 1.68 1.68 0 0 1-.436-.07 4.609 4.609 0 0 1-.435-.148 11.343 11.343 0 0 1-1.102-.51 18.874 18.874 0 0 1-2.823-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.259-2.283-1.259-3.613V5.08c0-1.091.957-1.844 1.942-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.402 0 11.57 11.57 0 0 1-6.674 1.741.392.392 0 0 0-.277.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.593 1.68.377.197.703.345.95.442a3.133 3.133 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.83 9.83 0 0 0 .951-.443 17.37 17.37 0 0 0 2.594-1.679c.907-.71 1.764-1.54 2.388-2.438.625-.899.991-1.828.991-2.757V5.08a.27.27 0 0 0-.098-.205.392.392 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.9 11.787a2 2 0 1 0-1.7.047v3.316a.85.85 0 1 0 1.7 0v-3.363Z"
  }));
};

var getTheme$2J = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSecurityLock = function SvgTwoColorSecurityLock(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2J(props["data-theme"]),
    d: "M11.006 1.764a1.881 1.881 0 0 1 1.988 0 10.07 10.07 0 0 0 5.814 1.516c.986-.045 1.942.708 1.942 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.712 1.993-2.694 2.763a18.872 18.872 0 0 1-2.823 1.828c-.414.216-.79.39-1.102.51-.155.061-.302.112-.435.149a1.68 1.68 0 0 1-.436.069 1.68 1.68 0 0 1-.436-.07 4.609 4.609 0 0 1-.435-.148 11.343 11.343 0 0 1-1.102-.51 18.874 18.874 0 0 1-2.823-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.259-2.283-1.259-3.613V5.08c0-1.091.957-1.844 1.942-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.402 0 11.57 11.57 0 0 1-6.674 1.741.392.392 0 0 0-.277.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.593 1.68.377.197.703.345.95.442a3.133 3.133 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.83 9.83 0 0 0 .951-.443 17.37 17.37 0 0 0 2.594-1.679c.907-.71 1.764-1.54 2.388-2.438.625-.899.991-1.828.991-2.757V5.08a.27.27 0 0 0-.098-.205.392.392 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M14.725 10.1h.075c.966 0 1.75.783 1.75 1.75v3.201a1.75 1.75 0 0 1-1.75 1.75H9.5a1.75 1.75 0 0 1-1.75-1.75V11.85c0-.967.783-1.75 1.75-1.75h.075V9.025a2.575 2.575 0 1 1 5.15 0V10.1Zm-3.65 0h2.15V9.025a1.075 1.075 0 1 0-2.15 0V10.1ZM14.8 15.3a.25.25 0 0 0 .25-.25V11.85a.25.25 0 0 0-.25-.25H9.5a.25.25 0 0 0-.25.25v3.201c0 .138.112.25.25.25h5.3Z"
  }));
};

var getTheme$2K = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSecurity = function SvgTwoColorSecurity(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2K(props["data-theme"]),
    fillRule: "evenodd",
    d: "M11.005 1.764a1.882 1.882 0 0 1 1.989 0 10.07 10.07 0 0 0 5.813 1.516c.986-.045 1.943.708 1.943 1.8v8.738c0 1.33-.523 2.554-1.26 3.613-.736 1.06-1.713 1.993-2.694 2.763a18.872 18.872 0 0 1-2.824 1.828c-.413.216-.79.39-1.1.51-.156.061-.303.112-.436.149-.119.032-.277.069-.436.069-.16 0-.318-.037-.437-.07a4.628 4.628 0 0 1-.435-.148 11.342 11.342 0 0 1-1.1-.51 18.871 18.871 0 0 1-2.824-1.828c-.982-.77-1.958-1.703-2.695-2.763-.736-1.059-1.26-2.283-1.26-3.613V5.08c0-1.091.957-1.844 1.943-1.8a10.07 10.07 0 0 0 5.813-1.516ZM12.2 3.037a.382.382 0 0 0-.4 0 11.57 11.57 0 0 1-6.676 1.741.393.393 0 0 0-.276.096.27.27 0 0 0-.098.205v8.74c0 .928.366 1.857.99 2.756.625.898 1.482 1.727 2.39 2.438.904.71 1.837 1.284 2.592 1.68.378.197.703.345.951.442a3.123 3.123 0 0 0 .327.11l.036-.01c.07-.02.166-.052.29-.1a9.84 9.84 0 0 0 .951-.443c.756-.395 1.689-.97 2.593-1.679.908-.71 1.764-1.54 2.389-2.438.625-.899.99-1.828.99-2.757V5.08a.27.27 0 0 0-.097-.205.393.393 0 0 0-.277-.096A11.57 11.57 0 0 1 12.2 3.037Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M15.509 9.449a.75.75 0 0 1 .042 1.06l-3.692 4a.75.75 0 0 1-1.102 0l-2.308-2.5A.75.75 0 1 1 9.55 10.99l1.757 1.903 3.14-3.403a.75.75 0 0 1 1.06-.042Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2L = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSend = function SvgTwoColorSend(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2L(props["data-theme"]),
    d: "M22.25 16.658a3.75 3.75 0 0 1-3.75 3.75h-12a3.75 3.75 0 0 1-3.75-3.75v-2.684a.75.75 0 0 1 1.5 0v2.684a2.25 2.25 0 0 0 2.25 2.25h12a2.25 2.25 0 0 0 2.25-2.25v-2.684a.75.75 0 0 1 1.5 0v2.684Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13.33 3.97a.75.75 0 0 0-1.06 0l-4.5 4.5a.75.75 0 0 0 1.06 1.06l3.22-3.219v8.439a.75.75 0 0 0 1.5 0V6.31l3.22 3.22a.75.75 0 1 0 1.06-1.06l-4.5-4.5Z"
  }));
};

var getTheme$2M = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSettings = function SvgTwoColorSettings(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12 9.675a2.325 2.325 0 1 0 0 4.65 2.325 2.325 0 0 0 0-4.65ZM8.175 12a3.825 3.825 0 1 1 7.65 0 3.825 3.825 0 0 1-7.65 0Z"
  }), createElement("path", {
    fill: getTheme$2M(props["data-theme"]),
    d: "m12.825 3.25.807 1.2a2.5 2.5 0 0 0 2.553 1.057l1.419-.277 1.166 1.166-.277 1.419a2.5 2.5 0 0 0 1.058 2.553l1.199.807v1.65l-1.2.807a2.5 2.5 0 0 0-1.057 2.553l.277 1.419-1.166 1.166-1.419-.277a2.5 2.5 0 0 0-2.553 1.058l-.807 1.199h-1.65l-.807-1.2a2.5 2.5 0 0 0-2.553-1.057l-1.42.277-1.165-1.166.277-1.419a2.5 2.5 0 0 0-1.058-2.553l-1.199-.807v-1.65l1.2-.807a2.5 2.5 0 0 0 1.057-2.553L5.23 6.396 6.396 5.23l1.419.277a2.5 2.5 0 0 0 2.553-1.058l.807-1.199h1.65Zm1.096-1.058a1 1 0 0 0-.83-.442h-2.182a1 1 0 0 0-.83.442l-.955 1.42a1 1 0 0 1-1.022.423l-1.68-.329a1 1 0 0 0-.899.275L3.981 5.524a1 1 0 0 0-.275.898l.329 1.68a1 1 0 0 1-.423 1.022l-1.42.955a1 1 0 0 0-.442.83v2.182a1 1 0 0 0 .442.83l1.42.955a1 1 0 0 1 .423 1.022l-.329 1.68a1 1 0 0 0 .275.899l1.542 1.542a1 1 0 0 0 .9.275l1.68-.329a1 1 0 0 1 1.02.423l.957 1.42a1 1 0 0 0 .83.442h2.18a1 1 0 0 0 .83-.442l.956-1.42a1 1 0 0 1 1.022-.423l1.68.329a1 1 0 0 0 .899-.275l1.542-1.542a1 1 0 0 0 .275-.9l-.329-1.68a1 1 0 0 1 .423-1.02l1.42-.957a1 1 0 0 0 .442-.83v-2.18a1 1 0 0 0-.442-.83l-1.42-.956a1 1 0 0 1-.423-1.022l.329-1.68a1 1 0 0 0-.275-.898L18.477 3.98a1 1 0 0 0-.9-.275l-1.68.329a1 1 0 0 1-1.02-.423l-.957-1.42Z"
  }));
};

var getTheme$2N = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSettlement = function SvgTwoColorSettlement(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2N(props["data-theme"]),
    d: "M12 3.75a8.224 8.224 0 0 0-5.958 2.544.75.75 0 0 1-1.084-1.038A9.724 9.724 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75a9.71 9.71 0 0 1-5.959-2.032.75.75 0 0 1 .918-1.187A8.25 8.25 0 1 0 12 3.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M8.75 9.4a.75.75 0 0 1-.75.75H3a.75.75 0 1 1 0-1.5h5a.75.75 0 0 1 .75.75ZM7.75 12.4a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75ZM8 16.15a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5h5Z"
  }), createElement("path", {
    fill: getTheme$2N(props["data-theme"]),
    d: "M16.45 12.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V7.7a.75.75 0 0 1 1.5 0v4.05h2.75a.75.75 0 0 1 .75.75Z"
  }));
};

var getTheme$2O = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSharkfin = function SvgTwoColorSharkfin(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#TwoColorSharkfin_svg__a)"
  }, createElement("path", {
    fill: getTheme$2O(props["data-theme"]),
    d: "M13.328 7.684c-3.304 2.284-7.324 6.522-9.836 12.538a.75.75 0 0 1-1.384-.578c2.63-6.3 6.844-10.758 10.367-13.194 1.747-1.208 3.388-1.963 4.625-2.152.602-.093 1.254-.073 1.76.26.583.384.755 1.026.669 1.667-.343 2.553-.515 5.642-.515 8.255 0 1.306.043 2.48.127 3.402.042.46.094.848.152 1.15.062.32.122.488.155.55a.75.75 0 0 1-1.326.702c-.14-.266-.233-.613-.301-.966-.072-.37-.129-.81-.174-1.3-.09-.982-.133-2.205-.133-3.538 0-2.667.175-5.824.528-8.454a.477.477 0 0 0-.007-.215c-.042-.027-.236-.103-.708-.03-.912.139-2.333.75-4 1.903Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M13.438 20.117c-.375.41-.983 1.072-2.105 1.072-.503 0-.912-.084-1.258-.273-.341-.186-.551-.44-.689-.607l-.012-.014c-.139-.169-.217-.263-.34-.353-.115-.085-.305-.187-.662-.262-.551-.115-.949.078-1.543.531-.086.066-.177.139-.275.216-.529.422-1.229.98-2.13 1.231-1.035.29-2.016-.152-2.72-.641a7.215 7.215 0 0 1-1.648-1.634.75.75 0 0 1 1.22-.873c.259.362.734.892 1.286 1.276.571.398 1.07.536 1.458.428.584-.163 1.011-.5 1.54-.915.114-.09.233-.184.36-.28.668-.511 1.534-1.064 2.76-.807.532.112.927.29 1.241.52.28.205.468.435.592.586l.03.037c.132.16.185.209.25.244.06.033.201.09.54.09.45 0 .635-.199 1.049-.64l.054-.057c.207-.22.505-.526.927-.71.453-.197.961-.22 1.54-.058 1.021.286 1.755.851 2.306 1.276l.044.034c.619.476.901.652 1.191.652.148 0 .358-.049.636-.174a6 6 0 0 0 .87-.505c.302-.205.596-.427.876-.638l.02-.016c.262-.197.53-.4.754-.541a.75.75 0 0 1 .8 1.27c-.165.103-.382.266-.67.484l-.006.004c-.275.207-.596.45-.933.679-.338.23-.712.457-1.094.63-.376.17-.808.307-1.253.307-.858 0-1.537-.524-2.042-.915l-.064-.049c-.575-.442-1.108-.849-1.838-1.053-.31-.087-.456-.047-.538-.012-.114.05-.231.148-.433.363l-.09.097ZM20.643 1l.043.38c.115 1.017.976 1.831 2.073 1.961-1.113.193-1.952 1.04-2.064 2.083l-.052.49-.05-.497c-.1-1.034-.936-1.884-2.04-2.076 1.095-.13 1.944-.94 2.05-1.958l.04-.383Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorSharkfin_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var getTheme$2P = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSmartContract = function SvgTwoColorSmartContract(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M9 1.8a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1H9ZM15.5 9.55a.75.75 0 0 0 0-1.5h-7a.75.75 0 0 0 0 1.5h7ZM16.25 12.8a.75.75 0 0 1-.75.75h-7a.75.75 0 1 1 0-1.5h7a.75.75 0 0 1 .75.75ZM14.778 22.084c-.583.606-2.134.877-2.134.877s.322-1.672.845-2.215c.443-.46 1.086-.545 1.45-.168.362.377.282 1.046-.16 1.506ZM19.552 16.576a.581.581 0 0 0 .576-.586.581.581 0 0 0-.576-.586.581.581 0 0 0-.576.586c0 .324.258.586.576.586Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m22.692 13.466-.128-.51-.503-.133c-.904-.242-2.09-.03-3.215.457a9.175 9.175 0 0 0-3.108 2.228c-.909.065-1.668.468-2.372 1.185l-.758.77 1.957 1.34c-.035.603.24 1.213.65 1.63.407.415 1 .694 1.584.667l1.32 2.021.761-.775c.721-.733 1.123-1.51 1.178-2.45a9.47 9.47 0 0 0 2.182-3.16c.478-1.144.69-2.348.452-3.27Zm-3.266 1.207c.753-.325 1.41-.45 1.877-.437.012.475-.11 1.14-.431 1.906a7.94 7.94 0 0 1-2.04 2.841l-.268.237.012.362c.014.394-.06.74-.27 1.093l-.93-1.426-.597.328c-.003.001-.052.022-.16-.004a.758.758 0 0 1-.352-.21.764.764 0 0 1-.204-.355c-.025-.111-.003-.164 0-.17l.33-.607-1.386-.948c.338-.203.673-.28 1.054-.27l.353.008.229-.273a7.68 7.68 0 0 1 2.783-2.075Z"
  }), createElement("path", {
    fill: getTheme$2P(props["data-theme"]),
    d: "M19.25 5.8c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H6a2.75 2.75 0 0 1-2.75-2.75V5.8A2.75 2.75 0 0 1 6 3.05h12a2.75 2.75 0 0 1 2.75 2.75v5a.75.75 0 1 1-1.5 0v-5Z"
  }));
};

var getTheme$2Q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSmartLeverage = function SvgTwoColorSmartLeverage(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m5.487 5.5.041.387A2.26 2.26 0 0 0 7.5 7.882a2.403 2.403 0 0 0-1.963 2.116l-.05.502-.046-.506A2.376 2.376 0 0 0 3.5 7.882a2.233 2.233 0 0 0 1.95-1.99l.037-.392Z"
  }), createElement("path", {
    fill: getTheme$2Q(props["data-theme"]),
    fillRule: "evenodd",
    d: "M16.826 8.138a.8.8 0 0 1 1.115-.19 9.847 9.847 0 0 1 2.74 2.944.8.8 0 1 1-1.37.827 8.247 8.247 0 0 0-2.294-2.466.8.8 0 0 1-.19-1.115Zm-11.98 2.888a.8.8 0 0 1 .165 1.12c-.463.62-.924 1.943-.91 3.283a.8.8 0 1 1-1.6.015c-.017-1.63.522-3.307 1.226-4.253a.8.8 0 0 1 1.119-.165ZM2.018 18.521a.806.806 0 0 1 .608-.964l18.408-4.763a.806.806 0 0 1 .948.634.806.806 0 0 1-.608.964L2.966 19.155a.806.806 0 0 1-.948-.634Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2Q(props["data-theme"]),
    fillRule: "evenodd",
    d: "M10.845 16.55c.513-.733 1.796-.733 2.31 0l2.664 3.802c.514.732-.128 1.648-1.154 1.648h-5.33c-1.026 0-1.668-.916-1.154-1.648l2.664-3.803ZM12 17.605l-2.132 3.042h4.264L12 17.606Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.937 2.002c.4.027.703.358.675.74l-.067.923 1.347.09c.401.028.703.36.676.742-.028.382-.376.67-.777.643l-3.04-.204c-.668-.045-1.247.435-1.293 1.072-.047.637.457 1.19 1.125 1.235l1.935.13c1.47.098 2.577 1.315 2.475 2.716-.102 1.402-1.375 2.458-2.845 2.36l-.242-.017-.067.923c-.028.382-.375.67-.776.643-.4-.027-.703-.358-.675-.74l.067-.923-1.347-.09c-.401-.028-.703-.36-.675-.741.027-.383.375-.67.776-.644l3.04.204c.668.045 1.247-.435 1.293-1.072.047-.637-.457-1.19-1.125-1.235l-1.935-.13c-1.47-.098-2.578-1.314-2.475-2.716.102-1.402 1.375-2.458 2.845-2.36l.242.017.067-.923c.028-.382.375-.67.776-.643Z"
  }));
};

var getTheme$2R = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSpotGrid = function SvgTwoColorSpotGrid(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2R(props["data-theme"]),
    d: "M2.25 5A.75.75 0 0 1 3 4.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5Zm0 14a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM4.635 8.6a.75.75 0 1 0-1.27.8l2.13 3.38a.75.75 0 1 0 1.269-.799l-2.13-3.38Zm13.2 1.501a.75.75 0 0 0-1.145.97l3.738 4.414a.75.75 0 1 0 1.145-.97l-3.738-4.414Zm-9.677 3.83a.75.75 0 0 0-1.221.871l.453.634a.75.75 0 1 0 1.22-.872l-.452-.634Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.783 7.756a.75.75 0 1 0-1.129.988l.438.5a.75.75 0 1 0 1.129-.988l-.438-.5Zm-1.642 3.092a.75.75 0 1 0-1.082-1.04l-3.15 3.278a.75.75 0 0 0 1.08 1.04l3.152-3.278Z"
  }));
};

var getTheme$2S = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSpotX = function SvgTwoColorSpotX(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M16.11 10.705c-.148.894-.624 1.43-1.427 1.604.518.283.866.64 1.045 1.073.178.433.147.974-.093 1.624-.124.331-.281.61-.471.836-.19.226-.4.399-.63.517-.23.118-.497.197-.801.236a4.307 4.307 0 0 1-.93.016 8.755 8.755 0 0 1-1.062-.169l-.491 1.832-1.094-.293.483-1.803a40.125 40.125 0 0 1-.864-.24l-.486 1.811-1.093-.293.49-1.832a31.237 31.237 0 0 1-.382-.107l-.39-.108-1.42-.38.572-1.256.789.21c.236.064.406-.021.51-.255l.774-2.889.113.03a.74.74 0 0 0-.111-.037l.552-2.062c.026-.343-.141-.562-.5-.658l-.79-.212.316-1.178 1.504.41c.303.082.534.141.691.178L11.4 5.5l1.094.292-.475 1.775c.39.095.68.167.87.218l.472-1.76 1.094.293-.486 1.81c.366.134.683.277.952.429.269.151.507.33.716.538.208.207.353.446.436.717.082.272.095.569.038.893Zm-2.576 3.507c.046-.173.052-.335.017-.489a1.114 1.114 0 0 0-.175-.4 1.393 1.393 0 0 0-.35-.33 3.541 3.541 0 0 0-.429-.257 4.284 4.284 0 0 0-.508-.205 7.824 7.824 0 0 0-.945-.269 21.873 21.873 0 0 1-.339-.083l-.65 2.429c.037.01.124.034.261.074l.34.095a9.253 9.253 0 0 0 .803.172c.119.02.26.035.42.048.162.012.303.014.422.005.12-.01.245-.03.378-.06a1.02 1.02 0 0 0 .338-.141.995.995 0 0 0 .417-.59Zm.435-4a1.036 1.036 0 0 0-.135-.36c-.064-.102-.16-.2-.287-.293a2.505 2.505 0 0 0-.36-.223 3.998 3.998 0 0 0-.42-.174 4.223 4.223 0 0 0-.408-.129 53.276 53.276 0 0 1-.667-.167l-.59 2.206.243.07a7.791 7.791 0 0 0 .69.169c.158.034.291.056.4.065.11.008.24.015.388.019.148.004.275-.01.38-.04a2.03 2.03 0 0 0 .315-.125.716.716 0 0 0 .266-.225c.072-.099.126-.215.162-.35a.986.986 0 0 0 .024-.443Z"
  }), createElement("path", {
    fill: getTheme$2S(props["data-theme"]),
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12Z"
  }));
};

var getTheme$2T = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSpot = function SvgTwoColorSpot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2T(props["data-theme"]),
    fillRule: "evenodd",
    d: "M14.796 7.256a5.752 5.752 0 1 0-7.54 7.54 7.25 7.25 0 0 1 7.54-7.54Zm1.32.175a.75.75 0 0 0 .078-.72A7.252 7.252 0 0 0 2.25 9.5a7.252 7.252 0 0 0 4.461 6.694.75.75 0 0 0 .72-.078 7.25 7.25 0 1 0 8.685-8.685ZM20.25 14.5a5.75 5.75 0 1 0-11.5 0 5.75 5.75 0 0 0 11.5 0Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M18.53 2.47a.75.75 0 0 1 .08.967c.345.116.69.284 1.014.515.942.673 1.626 1.827 1.626 3.548a.75.75 0 1 1-1.5 0c0-1.279-.483-1.959-.998-2.327-.557-.398-1.233-.49-1.646-.43a.75.75 0 0 1-.636-1.273l1-1a.75.75 0 0 1 1.06 0ZM5.47 21.53a.75.75 0 0 1-.08-.967 3.868 3.868 0 0 1-1.013-.515c-.943-.673-1.627-1.826-1.627-3.548a.75.75 0 0 1 1.5 0c0 1.279.483 1.959.998 2.327.557.398 1.234.49 1.646.43a.75.75 0 0 1 .636 1.273l-1 1a.75.75 0 0 1-1.06 0Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2U = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorStakeAssets = function SvgTwoColorStakeAssets(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2U(props["data-theme"]),
    d: "M3.045 5.69Zm.023-.036a.93.93 0 0 0 .21.184c.26.181.688.375 1.283.55 1.18.346 2.856.571 4.737.571 1.882 0 3.557-.225 4.738-.571.595-.175 1.022-.369 1.283-.55a.929.929 0 0 0 .21-.184.929.929 0 0 0-.21-.183c-.261-.181-.688-.375-1.283-.55-1.18-.346-2.856-.571-4.738-.571-1.881 0-3.557.225-4.737.571-.595.175-1.022.369-1.284.55a.93.93 0 0 0-.21.183Zm12.483.037V5.69Zm0-.072Zm-12.505 0Zm1.092-2.137c1.353-.397 3.177-.632 5.16-.632 1.984 0 3.808.235 5.16.632.672.197 1.27.446 1.716.757.425.294.873.76.873 1.415s-.448 1.122-.873 1.416c-.447.31-1.044.56-1.716.757-1.352.397-3.176.632-5.16.632-1.983 0-3.807-.235-5.16-.632-.67-.197-1.269-.446-1.716-.757-.425-.294-.872-.76-.872-1.416 0-.654.447-1.12.872-1.415.447-.31 1.045-.56 1.716-.757ZM3.05 10.723a.75.75 0 0 0-1.5.028c0 .655.447 1.12.872 1.416.447.31 1.045.56 1.716.756 1.353.397 3.177.632 5.16.632.387 0 .768-.009 1.14-.026a.75.75 0 1 0-.07-1.498 23.01 23.01 0 0 1-1.07.024c-1.881 0-3.557-.224-4.737-.571-.595-.175-1.022-.368-1.284-.55-.165-.114-.215-.187-.228-.211Zm-.004-.007v-.001Z"
  }), createElement("path", {
    fill: getTheme$2U(props["data-theme"]),
    d: "M2.3 4.632a.75.75 0 0 1 .75.75v10.345c.004.008.039.116.275.31.272.223.707.469 1.295.697 1.172.453 2.829.788 4.678.788.358 0 .71-.012 1.053-.036a.75.75 0 0 1 .103 1.496c-.377.026-.763.04-1.156.04-2.015 0-3.858-.362-5.22-.89-.677-.262-1.267-.578-1.704-.935-.408-.335-.824-.827-.824-1.454V5.383a.75.75 0 0 1 .75-.75Zm13.997 0a.75.75 0 0 1 .75.75v5.84a.75.75 0 0 1-1.5 0v-5.84a.75.75 0 0 1 .75-.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.137 13.048s0-.002.003-.005a.017.017 0 0 1-.003.005Zm.077-.08c.021.018.049.04.084.064.208.144.558.304 1.058.451.99.291 2.403.481 3.995.481s3.005-.19 3.995-.48c.5-.148.85-.308 1.059-.452a1.17 1.17 0 0 0 .084-.064 1.17 1.17 0 0 0-.084-.064c-.208-.144-.558-.304-1.059-.451-.99-.291-2.403-.481-3.995-.481s-3.004.19-3.995.48c-.5.148-.85.308-1.058.452a1.194 1.194 0 0 0-.084.064Zm10.351.08-.002-.005a.022.022 0 0 1 .003.005Zm-.002-.155a.021.021 0 0 1 .003-.005l-.003.005Zm-10.423 0a.022.022 0 0 1-.003-.005l.003.005Zm.794-1.88c1.162-.34 2.724-.541 4.417-.541 1.694 0 3.255.2 4.418.542.576.169 1.097.385 1.491.658.372.258.79.684.79 1.296s-.418 1.038-.79 1.296c-.394.273-.915.49-1.491.659-1.163.34-2.724.541-4.418.541-1.693 0-3.255-.2-4.417-.542-.577-.169-1.098-.385-1.492-.658-.371-.258-.79-.684-.79-1.296s.419-1.038.79-1.296c.394-.273.915-.49 1.492-.659Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.153 12.968a.75.75 0 0 0-1.5 0v6.577c0 .612.418 1.038.79 1.296.393.273.914.49 1.49.659 1.163.34 2.725.541 4.418.541 1.694 0 3.255-.2 4.418-.541.576-.17 1.097-.386 1.491-.66.372-.257.79-.683.79-1.295v-6.577a.75.75 0 0 0-1.5 0v3.23a.774.774 0 0 1-.145.122c-.208.145-.558.305-1.059.452-.99.29-2.403.48-3.995.48s-3.004-.19-3.995-.48c-.5-.147-.85-.307-1.058-.452a.769.769 0 0 1-.145-.122v-3.23Zm0 4.967c.242.103.505.195.78.276 1.163.341 2.725.542 4.418.542 1.694 0 3.255-.2 4.418-.542.276-.081.539-.173.781-.276v1.551a.775.775 0 0 1-.145.123c-.208.144-.558.304-1.059.451-.99.291-2.403.481-3.995.481s-3.004-.19-3.995-.48c-.5-.148-.85-.308-1.058-.452a.77.77 0 0 1-.145-.123v-1.551Zm10.412 1.53-.002.005.003-.005Z"
  }));
};

var getTheme$2V = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorStakingAssets = function SvgTwoColorStakingAssets(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2V(props["data-theme"]),
    d: "M12 4.75a8.25 8.25 0 0 0-5.457 14.438.75.75 0 1 1-.992 1.124A9.728 9.728 0 0 1 2.25 13c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75a9.728 9.728 0 0 1-3.3 7.312.75.75 0 1 1-.993-1.124A8.25 8.25 0 0 0 12 4.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M15.36 10.375c.06.767-.224 1.304-.85 1.61.484.129.843.353 1.077.674.235.32.32.772.253 1.355-.036.298-.109.56-.22.785-.11.225-.248.409-.413.553-.166.144-.37.262-.613.356a3.659 3.659 0 0 1-.762.202c-.265.04-.569.066-.91.076l-.034 1.608-.96-.02.033-1.583a34.038 34.038 0 0 1-.76-.023l-.034 1.59-.96-.02.034-1.609a27.537 27.537 0 0 1-.337-.01l-.343-.01-1.247-.026.217-1.15.693.014c.207.004.33-.1.368-.314l.053-2.537.1.003a.61.61 0 0 0-.1-.009l.038-1.81c-.048-.288-.23-.434-.546-.441l-.692-.015.022-1.034 1.322.034c.266.005.467.008.605.006l.033-1.59.96.02-.032 1.559c.34-.001.595 0 .76.003l.033-1.546.96.02-.033 1.59c.328.037.618.09.87.16.253.071.486.17.7.3.213.128.38.296.503.502.123.207.194.45.213.727Zm-1.412 3.41a.85.85 0 0 0-.085-.405.945.945 0 0 0-.225-.295 1.18 1.18 0 0 0-.354-.2 2.988 2.988 0 0 0-.406-.126 3.643 3.643 0 0 0-.46-.066 6.685 6.685 0 0 0-.833-.03h-.296l-.045 2.132.23.008.3.01a7.896 7.896 0 0 0 .696-.02c.102-.009.221-.024.357-.047.135-.022.251-.049.348-.08.096-.032.196-.074.299-.127a.865.865 0 0 0 .25-.184.895.895 0 0 0 .158-.25.841.841 0 0 0 .066-.32Zm-.45-3.383a.878.878 0 0 0-.185-.268.931.931 0 0 0-.295-.183 2.124 2.124 0 0 0-.341-.112 3.4 3.4 0 0 0-.383-.058 3.586 3.586 0 0 0-.361-.024 43.635 43.635 0 0 1-.583-.002l-.04 1.936.214.008a6.546 6.546 0 0 0 .602 0c.138-.003.252-.012.344-.027a6.3 6.3 0 0 0 .323-.063 1.05 1.05 0 0 0 .305-.11c.08-.047.158-.102.234-.166a.607.607 0 0 0 .173-.24.887.887 0 0 0 .063-.32.835.835 0 0 0-.07-.37ZM19.427 2l.08.475a3.62 3.62 0 0 0 2.86 2.955 3.62 3.62 0 0 0-2.86 2.954l-.08.475-.076-.455a3.655 3.655 0 0 0-2.864-2.974 3.62 3.62 0 0 0 2.86-2.955l.08-.475ZM22.42 18.378a.75.75 0 0 1 .201 1.042c-.619.917-1.766 2.13-3.6 2.13-1.136 0-1.796-.618-2.262-1.054a56.283 56.283 0 0 0-.05-.048c-.473-.44-.781-.698-1.376-.698-.497 0-.707.208-1.11.654l-.022.023c-.412.455-1.017 1.123-2.201 1.123-1.184 0-1.79-.668-2.2-1.123l-.022-.023c-.404-.446-.614-.654-1.111-.654-.533 0-.835.247-1.34.706l-.035.031c-.485.44-1.171 1.063-2.313 1.063-.884 0-1.612-.411-2.16-.827a9.746 9.746 0 0 1-.747-.64 48.17 48.17 0 0 1-.167-.156c-.148-.139-.272-.255-.39-.354a.75.75 0 1 1 .97-1.146c.15.127.313.281.47.428l.139.13c.207.193.414.378.63.542.44.334.848.523 1.255.523.532 0 .834-.247 1.34-.706l.035-.031c.485-.44 1.17-1.063 2.313-1.063 1.184 0 1.789.668 2.2 1.123l.022.023c.404.445.614.654 1.111.654s.707-.209 1.11-.654l.023-.023c.411-.455 1.016-1.123 2.2-1.123 1.218 0 1.903.639 2.394 1.098l.005.004c.495.462.765.698 1.29.698 1.087 0 1.841-.707 2.357-1.47a.75.75 0 0 1 1.04-.202Z"
  }));
};

var getTheme$2W = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorStaking = function SvgTwoColorStaking(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2W(props["data-theme"]),
    d: "M18.744 2.25c-.886 0-1.666.46-2.112 1.157a.75.75 0 1 1-1.264-.809 4.006 4.006 0 1 1 5.533 5.533.75.75 0 1 1-.808-1.263 2.506 2.506 0 0 0-1.349-4.618ZM22.75 21.5A1.75 1.75 0 0 1 21 23.25H3a1.75 1.75 0 0 1-1.75-1.75v-7c0-.966.784-1.75 1.75-1.75h1.5a.75.75 0 0 1 0 1.5H3a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h18a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25h-1.5a.75.75 0 0 1 0-1.5H21c.966 0 1.75.784 1.75 1.75v7Z"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5.45 11.35a6.5 6.5 0 1 1 9.516 5.76.75.75 0 0 0 .697 1.328 8 8 0 1 0-7.297.066.75.75 0 0 0 .673-1.34A6.5 6.5 0 0 1 5.45 11.35Zm10.61-1.16a.75.75 0 0 0-.53-.919l-2.359-.632a.75.75 0 1 0-.388 1.45l.557.148-1.473.933-.396-.34a.75.75 0 0 0-.936-.032l-2.783 2.07a.75.75 0 1 0 .895 1.204l2.303-1.713.362.31a.75.75 0 0 0 .89.065l1.957-1.24-.18.667a.75.75 0 1 0 1.45.388l.632-2.36Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$2W(props["data-theme"]),
    d: "M19.75 17.8a.75.75 0 0 1-.75.75H5a.75.75 0 1 1 0-1.5h14a.75.75 0 0 1 .75.75Z"
  }));
};

var getTheme$2X = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorStrategyAlert = function SvgTwoColorStrategyAlert(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#TwoColorStrategy_Alert_svg__a)"
  }, createElement("path", {
    fill: "#F7A600",
    d: "M15.043 8.864a.421.421 0 0 0-.464-.554l-3.45.55a.421.421 0 0 0-.156.773l1.488.926.654 1.627a.421.421 0 0 0 .789-.02l1.14-3.302Z"
  }), createElement("path", {
    fill: getTheme$2X(props["data-theme"]),
    d: "M18.393 3.924a1.531 1.531 0 0 1 1.694 2.02l-5.239 14.86c-.47 1.335-2.345 1.371-2.867.055l-2.928-7.378-6.757-4.164c-1.206-.743-.844-2.583.552-2.814l15.545-2.58Zm.257 1.479h-.012L3.094 7.983c-.012.001-.016.004-.017.004 0 0-.006.007-.009.02a.043.043 0 0 0 0 .022s.004.005.015.011l7.18 4.425 3.112 7.841a.058.058 0 0 0 .008.015c0 .001.009.005.022.005s.02-.004.02-.005c.001 0 0 0 0 0 .001 0 .005-.005.009-.016l5.239-14.86a.044.044 0 0 0 .003-.012V5.43a.037.037 0 0 0-.009-.015.036.036 0 0 0-.013-.01l-.004-.001Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorStrategy_Alert_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var getTheme$2Y = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSubaccount = function SvgTwoColorSubaccount(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2Y(props["data-theme"]),
    fillRule: "evenodd",
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M9.75 9.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm4.732 2.812a3.75 3.75 0 1 0-4.963 0A5.75 5.75 0 0 0 6.25 17.5a.75.75 0 0 0 1.5 0 4.25 4.25 0 0 1 8.5 0 .75.75 0 0 0 1.5 0 5.75 5.75 0 0 0-3.268-5.188Z",
    clipRule: "evenodd"
  }));
};

var getTheme$2Z = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTwap = function SvgTwoColorTwap(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2Z(props["data-theme"]),
    d: "M6.33 1.67a.75.75 0 0 1 0 1.06L3.784 5.276a.75.75 0 0 1-1.06-1.06L5.269 1.67a.75.75 0 0 1 1.061 0ZM17.67 1.67a.75.75 0 0 1 1.06 0l2.546 2.545a.75.75 0 1 1-1.06 1.061L17.67 2.73a.75.75 0 0 1 0-1.06ZM12 2.75c-5.385 0-9.75 4.365-9.75 9.75a9.719 9.719 0 0 0 2.825 6.864l-1.607 1.607a.75.75 0 1 0 1.06 1.06l1.685-1.683A9.706 9.706 0 0 0 12 22.25a9.707 9.707 0 0 0 5.787-1.902l1.683 1.682a.75.75 0 0 0 1.06-1.06l-1.606-1.606A9.719 9.719 0 0 0 21.75 12.5c0-5.385-4.365-9.75-9.75-9.75ZM3.75 12.5a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.043 17.5a.536.536 0 0 1-.536-.536V8.036a.536.536 0 1 1 1.072 0v8.928c0 .296-.24.536-.536.536Zm1.543-6.7a.97.97 0 0 0-.445-.734c-.262-.174-.618-.261-1.068-.261-.305 0-.563.039-.773.117a1.09 1.09 0 0 0-.484.316.714.714 0 0 0-.164.461.609.609 0 0 0 .1.375c.074.107.176.2.306.278.13.075.28.141.45.199.17.054.35.101.544.14l.795.172c.386.078.74.183 1.063.313.322.13.602.29.838.48s.42.414.549.672c.132.258.2.554.203.887-.003.49-.141.914-.415 1.273-.27.357-.662.634-1.175.832-.51.196-1.125.293-1.845.293-.715 0-1.337-.099-1.867-.297-.527-.197-.939-.49-1.236-.878-.293-.391-.448-.874-.462-1.45h1.81c.02.269.106.492.255.672.153.177.356.311.61.402.256.089.546.133.868.133.317 0 .592-.041.825-.125.237-.083.42-.199.55-.347a.756.756 0 0 0 .194-.512c0-.18-.06-.33-.177-.453a1.357 1.357 0 0 0-.51-.313 5.602 5.602 0 0 0-.817-.234l-.964-.219c-.746-.164-1.335-.42-1.767-.77-.432-.348-.647-.818-.644-1.41a1.96 1.96 0 0 1 .428-1.269c.291-.362.69-.645 1.197-.848.507-.203 1.083-.304 1.728-.304.657 0 1.23.101 1.72.304.493.203.876.486 1.15.848.273.362.414.781.423 1.258h-1.793Z"
  }));
};

var getTheme$2_ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTarget = function SvgTwoColorTarget(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m18.425 8.413 3.327-3.333h-2.666V2.413l-3.334 3.334v1.726l-3.14 3.14a1.986 1.986 0 0 0-.86-.2c-1.107 0-2 .893-2 2s.893 2 2 2 2-.893 2-2c0-.306-.073-.593-.2-.86l3.14-3.14h1.733Z"
  }), createElement("path", {
    fill: getTheme$2_(props["data-theme"]),
    d: "M3.405 12.623a8.25 8.25 0 0 1 10.68-8.096.75.75 0 1 0 .442-1.433 9.74 9.74 0 0 0-3.122-.428c-5.383.137-9.636 4.612-9.5 9.995.137 5.383 4.612 9.636 9.995 9.499 5.383-.137 9.636-4.611 9.499-9.995a9.76 9.76 0 0 0-.388-2.495.75.75 0 0 0-1.44.421c.196.671.31 1.379.328 2.113a8.25 8.25 0 1 1-16.494.419Z"
  }), createElement("path", {
    fill: getTheme$2_(props["data-theme"]),
    d: "M7.404 12.521a4.25 4.25 0 0 1 5.164-4.26.75.75 0 0 0 .322-1.464 5.75 5.75 0 1 0 4.392 4.439.75.75 0 0 0-1.469.305 4.25 4.25 0 1 1-8.41.98Z"
  }));
};

var getTheme$2$ = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTasks = function SvgTwoColorTasks(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$2$(props["data-theme"]),
    d: "M18.75 15.5a.75.75 0 0 1-.75.75h-4.6a.75.75 0 0 1 0-1.5H18a.75.75 0 0 1 .75.75ZM10.4 15.7a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Zm-1.5 0a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Z"
  }), createElement("path", {
    fill: getTheme$2$(props["data-theme"]),
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.38 7.364a.75.75 0 1 0-1.06-1.06L7.667 8.954 6.43 7.718a.75.75 0 0 0-1.06 1.06l1.767 1.768a.75.75 0 0 0 1.06 0l3.183-3.182ZM18 9.95a.75.75 0 0 0 0-1.5h-4.6a.75.75 0 0 0 0 1.5H18Z"
  }));
};

var getTheme$30 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTerminate = function SvgTwoColorTerminate(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$30(props["data-theme"]),
    d: "M6.16 6.11a.75.75 0 0 1 0 1.06 8.25 8.25 0 1 0 11.67 0 .75.75 0 1 1 1.06-1.06 9.75 9.75 0 1 1-13.79 0 .75.75 0 0 1 1.06 0Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12 1.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$31 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorThumbsUp = function SvgTwoColorThumbsUp(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M7.95 9.9a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0V10.65a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$31(props["data-theme"]),
    fillRule: "evenodd",
    d: "M10.406 2.714a.75.75 0 0 1 .694-.464c2.209 0 3.21 1.501 3.428 2.368.014.06.022.12.022.182v3.75h4.27a2.55 2.55 0 0 1 2.505 3.032l-1.417 7.37a3.45 3.45 0 0 1-3.388 2.798H5.7a3.45 3.45 0 0 1-3.45-3.45v-4.95A3.45 3.45 0 0 1 5.7 9.9h1.748l2.958-7.186Zm1.18 1.076-2.942 7.146a.75.75 0 0 1-.694.464H5.7a1.95 1.95 0 0 0-1.95 1.95v4.95a1.95 1.95 0 0 0 1.95 1.95h10.82a1.95 1.95 0 0 0 1.915-1.582l1.417-7.37a1.05 1.05 0 0 0-1.031-1.248H13.8a.75.75 0 0 1-.75-.75V4.908c-.114-.325-.518-.953-1.464-1.118Z",
    clipRule: "evenodd"
  }));
};

var getTheme$32 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTime = function SvgTwoColorTime(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V6a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$32(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }));
};

var getTheme$33 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorToPledgeMoney = function SvgTwoColorToPledgeMoney(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$33(props["data-theme"]),
    d: "M6.65 10.704c0 1.52.52 2.906 1.38 3.982a4.728 4.728 0 0 1 2.172-.528h3.762a1.5 1.5 0 0 1 1.12.501l.478.537 1.443-1.312c.267-.242.58-.406.909-.492a6.42 6.42 0 0 0 .583-2.688c0-3.456-2.681-6.204-5.924-6.204-3.242 0-5.923 2.748-5.923 6.204Zm.173 4.874a7.856 7.856 0 0 1-1.673-4.873C5.15 6.478 8.444 3 12.573 3c4.13 0 7.424 3.479 7.424 7.704a7.94 7.94 0 0 1-.531 2.868 2.16 2.16 0 0 1 .498 3.46l-2.897 2.814a4.317 4.317 0 0 1-3.008 1.221H4.038v-1.5h10.02c.734 0 1.438-.286 1.964-.796l2.896-2.815a.66.66 0 0 0-.904-.962l-1.95 1.773-.7.934a.75.75 0 0 1-.6.3h-3.526v-1.5h3.15l.15-.2-.574-.643h-3.762a3.23 3.23 0 0 0-2.68 1.427 2.077 2.077 0 0 1-1.723.917H4v-1.5h1.799a.577.577 0 0 0 .479-.255c.162-.241.345-.465.545-.67Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.398 7.652a.24.24 0 0 1 .454 0l.57 1.64h1.797a.24.24 0 0 1 .135.438l-1.44.978.559 1.607a.24.24 0 0 1-.362.278l-1.486-1.01-1.486 1.01a.24.24 0 0 1-.362-.277l.559-1.608-1.44-.978a.24.24 0 0 1 .135-.438h1.797l.57-1.64Z"
  }));
};

var getTheme$34 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTokenSplash = function SvgTwoColorTokenSplash(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M4.5 17.25a.75.75 0 0 0-.67.415l-1.5 3A.75.75 0 0 0 3 21.75h18a.75.75 0 0 0 .67-1.085l-1.5-3a.75.75 0 0 0-.67-.415h-2.25a.75.75 0 0 0 0 1.5h1.787l.75 1.5H4.213l.75-1.5H6.75a.75.75 0 0 0 0-1.5H4.5Z"
  }), createElement("path", {
    fill: getTheme$34(props["data-theme"]),
    d: "M12.935 4.155a1.284 1.284 0 0 0-1.87 0L4.15 11.328a1.473 1.473 0 0 0 0 2.02l5.707 5.902h4.322l5.668-5.9v-.001a1.473 1.473 0 0 0 0-2.021l-6.912-7.173Zm-2.95-1.041a2.784 2.784 0 0 1 4.03 0l6.914 7.173a2.973 2.973 0 0 1 0 4.102l-6.11 6.361H9.221l-6.15-6.36a2.973 2.973 0 0 1 0-4.103l6.914-7.173Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.939 6.893a.75.75 0 0 1 .75.75v.536h1.178a.75.75 0 0 1 0 1.5h-2.893a.857.857 0 0 0 0 1.714h1.929a2.357 2.357 0 0 1 0 4.714h-.214v.536a.75.75 0 0 1-1.5 0v-.536H10.01a.75.75 0 0 1 0-1.5h2.893a.857.857 0 1 0 0-1.714h-1.929a2.357 2.357 0 1 1 0-4.714h.215v-.536a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$35 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorToolsDiscovery = function SvgTwoColorToolsDiscovery(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#TwoColorTools_Discovery_svg__a)"
  }, createElement("path", {
    fill: "#F7A600",
    d: "M12 0a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1Zm0 20a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm8-8a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM1 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H1ZM9 12a3 3 0 1 1 6 0 3 3 0 1 1-6 0Z"
  }), createElement("path", {
    fill: getTheme$35(props["data-theme"]),
    d: "M12 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorTools_Discovery_svg__a"
  }, createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  }))));
};

var getTheme$36 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTradingVoucher = function SvgTwoColorTradingVoucher(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$36(props["data-theme"]),
    fillRule: "evenodd",
    d: "M4.92 7.1c-.324.314-.42.575-.42.775 0 .2.096.461.42.775.326.315.837.634 1.53.917 1.383.566 3.345.933 5.55.933 2.205 0 4.167-.367 5.55-.933.693-.283 1.204-.602 1.53-.917.324-.314.42-.575.42-.775 0-.2-.096-.461-.42-.775-.326-.315-.837-.634-1.53-.917-1.383-.566-3.345-.933-5.55-.933-2.205 0-4.167.367-5.55.933-.693.283-1.204.602-1.53.917Zm.962-2.306C7.486 4.138 9.65 3.75 12 3.75c2.351 0 4.514.388 6.118 1.044.8.328 1.496.736 2.005 1.228.511.494.877 1.12.877 1.853 0 .732-.366 1.359-.877 1.853-.509.492-1.206.9-2.005 1.228C16.514 11.612 14.35 12 12 12c-2.35 0-4.514-.388-6.118-1.044-.8-.328-1.496-.736-2.005-1.228C3.366 9.234 3 8.608 3 7.875c0-.732.366-1.359.877-1.853.509-.492 1.206-.9 2.005-1.228ZM4.723 15.174a.75.75 0 0 1 .071 1.058c-.224.256-.294.47-.294.643 0 .2.096.461.42.774.326.316.837.635 1.53.918 1.383.566 3.345.933 5.55.933 2.205 0 4.167-.367 5.55-.933.693-.283 1.204-.602 1.53-.918.324-.313.42-.575.42-.774 0-.154-.055-.337-.22-.554a.75.75 0 1 1 1.19-.91c.322.42.53.915.53 1.464 0 .732-.366 1.358-.877 1.853-.509.492-1.206.9-2.005 1.227C16.514 20.611 14.35 21 12 21c-2.35 0-4.514-.389-6.118-1.045-.8-.327-1.496-.735-2.005-1.227-.511-.495-.877-1.12-.877-1.853 0-.625.268-1.176.665-1.63a.75.75 0 0 1 1.058-.071Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M4.723 10.685a.75.75 0 0 1 .071 1.059c-.224.256-.294.47-.294.643 0 .2.096.46.42.774.326.316.837.634 1.53.918 1.383.565 3.345.932 5.55.932 2.205 0 4.167-.367 5.55-.932.693-.284 1.204-.602 1.53-.918.324-.313.42-.575.42-.774 0-.154-.055-.337-.22-.554a.75.75 0 1 1 1.19-.911c.322.42.53.915.53 1.464 0 .733-.366 1.36-.877 1.853-.509.492-1.206.9-2.005 1.228-1.604.656-3.767 1.045-6.118 1.045-2.35 0-4.514-.389-6.118-1.045-.8-.327-1.496-.736-2.005-1.228C3.366 13.745 3 13.12 3 12.386c0-.624.268-1.175.665-1.63a.75.75 0 0 1 1.058-.07Z",
    clipRule: "evenodd"
  }));
};

var getTheme$37 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTradingBot = function SvgTwoColorTradingBot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
  }), createElement("path", {
    fill: getTheme$37(props["data-theme"]),
    d: "M2.25 9.864a2.25 2.25 0 0 1 2.25-2.25h15a2.25 2.25 0 0 1 2.25 2.25v10.09a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V9.864Zm2.25-.75a.75.75 0 0 0-.75.75v10.09c0 .415.336.75.75.75h15a.75.75 0 0 0 .75-.75V9.864a.75.75 0 0 0-.75-.75h-15Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M10.364 13.273a.818.818 0 1 1-1.637 0 .818.818 0 0 1 1.637 0Zm4.909 0a.818.818 0 1 1-1.637 0 .818.818 0 0 1 1.637 0Zm-5.728 3.34a.75.75 0 0 0 0 1.5h4.91a.75.75 0 0 0 0-1.5h-4.91Z"
  }));
};

var getTheme$38 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTradingGpt = function SvgTwoColorTradingGpt(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M12.075 3.553a1.5 1.5 0 1 0-.75 0V6.6h.75V3.553Zm5.684-.717a.34.34 0 0 0-.359.337v.667c0 .179.14.327.317.335 2.73.148 4.924 2.362 5.082 5.094.01.177.158.316.336.316h.677a.34.34 0 0 0 .337-.358 6.767 6.767 0 0 0-6.39-6.391Zm.006 2.025a.34.34 0 0 0-.365.34v.676c0 .177.137.323.312.336 1.62.132 2.912 1.438 3.058 3.062.016.175.16.31.335.31h.68a.342.342 0 0 0 .339-.365 4.746 4.746 0 0 0-4.359-4.36ZM12.75 19.052v2.93c0 1.352 1.648 2.014 2.583 1.038l3.959-4.134a.75.75 0 1 0-1.084-1.038l-3.958 4.134v-2.93a.75.75 0 0 0-1.5 0Zm-3.075-8.064a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Zm5.625 0a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
  }), createElement("path", {
    fill: getTheme$38(props["data-theme"]),
    d: "M6 6a3.75 3.75 0 0 0-3.75 3.75v6A3.75 3.75 0 0 0 6 19.5h11.25A3.75 3.75 0 0 0 21 15.75v-6A3.75 3.75 0 0 0 17.25 6H6ZM3.75 9.75A2.25 2.25 0 0 1 6 7.5h11.25a2.25 2.25 0 0 1 2.25 2.25v6A2.25 2.25 0 0 1 17.25 18H6a2.25 2.25 0 0 1-2.25-2.25v-6Zm5.061 3.407a.75.75 0 0 0-.772 1.286 6.824 6.824 0 0 0 7.022 0 .75.75 0 1 0-.772-1.286 5.324 5.324 0 0 1-5.478 0Z"
  }));
};

var getTheme$39 = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTransferIn = function SvgTwoColorTransferIn(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$39(props["data-theme"]),
    fillRule: "evenodd",
    d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h9a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h9a.75.75 0 0 1 0 1.5H6Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M14.48 7.424a.75.75 0 0 1 .096 1.056l-3.975 4.77H20a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.576-1.23l5-6a.75.75 0 0 1 1.056-.096Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3a = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTransferOut = function SvgTwoColorTransferOut(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3a(props["data-theme"]),
    fillRule: "evenodd",
    d: "M6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h9a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h9a.75.75 0 0 1 0 1.5H6Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M14.52 16.576a.75.75 0 0 1-.096-1.056l3.975-4.77H9a.75.75 0 0 1 0-1.5h11a.75.75 0 0 1 .576 1.23l-5 6a.75.75 0 0 1-1.056.096Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3b = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTransfer1 = function SvgTwoColorTransfer1(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M10.046 17.05a.75.75 0 0 1-1.06-.04l-2.786-3a.75.75 0 0 1 .55-1.26h10.5a.75.75 0 0 1 0 1.5H8.47l1.615 1.74a.75.75 0 0 1-.039 1.06Z"
  }), createElement("path", {
    fill: getTheme$3b(props["data-theme"]),
    d: "M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3.014 4.74a.75.75 0 0 0-1.1 1.02l1.616 1.74H6.75a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 .55-1.26l-2.786-3Z"
  }));
};

var getTheme$3c = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorTransfer = function SvgTwoColorTransfer(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3c(props["data-theme"]),
    fillRule: "evenodd",
    d: "M15.498 3.443a.75.75 0 0 1 1.06.055l4.5 5A.75.75 0 0 1 20.5 9.75h-17a.75.75 0 0 1 0-1.5h15.316l-3.373-3.748a.75.75 0 0 1 .055-1.06Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M8.502 20.558a.75.75 0 0 1-1.06-.056l-4.5-5A.75.75 0 0 1 3.5 14.25h17a.75.75 0 0 1 0 1.5H5.184l3.373 3.748a.75.75 0 0 1-.055 1.06Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3d = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUsdc = function SvgTwoColorUsdc(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3d(props["data-theme"]),
    fillRule: "evenodd",
    d: "M3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM12 1.75C6.34 1.75 1.75 6.34 1.75 12S6.34 22.25 12 22.25 22.25 17.66 22.25 12 17.66 1.75 12 1.75Zm-1.77 4.777A.75.75 0 0 0 9.77 5.1a7.253 7.253 0 0 0 0 13.8.75.75 0 1 0 .46-1.427 5.753 5.753 0 0 1 0-10.946Zm4-1.427a.75.75 0 0 0-.46 1.427 5.753 5.753 0 0 1 0 10.946.75.75 0 0 0 .46 1.427 7.253 7.253 0 0 0 0-13.8Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.665 16.688c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.313v-.984c-1.367-.187-2.03-.945-2.21-1.992a.288.288 0 0 1 .289-.336h.71c.149 0 .274.11.305.25.133.617.492 1.094 1.586 1.094.805 0 1.383-.453 1.383-1.125 0-.672-.336-.93-1.523-1.125-1.75-.235-2.579-.766-2.579-2.133 0-1.055.805-1.883 2.04-2.055v-.969c0-.171.14-.312.312-.312h.625c.172 0 .313.14.313.313v.992c1.007.18 1.648.75 1.859 1.703a.287.287 0 0 1-.29.344h-.655a.31.31 0 0 1-.297-.227c-.18-.602-.61-.867-1.36-.867-.828 0-1.258.398-1.258.96 0 .595.243.891 1.516 1.071 1.719.234 2.61.727 2.61 2.188 0 1.109-.829 2.007-2.118 2.21v1h-.008Z"
  }));
};

var getTheme$3e = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUta = function SvgTwoColorUta(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5.75 6.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM11 8.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-3.75 3.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm8.25-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$3e(props["data-theme"]),
    fillRule: "evenodd",
    d: "M3 3.25A1.75 1.75 0 0 0 1.25 5v14c0 .966.784 1.75 1.75 1.75h18A1.75 1.75 0 0 0 22.75 19V5A1.75 1.75 0 0 0 21 3.25H3ZM2.75 5A.25.25 0 0 1 3 4.75h18a.25.25 0 0 1 .25.25v4.5H17.5a2.5 2.5 0 0 0 0 5h3.75V19a.25.25 0 0 1-.25.25H3a.25.25 0 0 1-.25-.25V5Zm16.5 6.975a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3f = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUnlock = function SvgTwoColorUnlock(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M7.5 9.75A.75.75 0 0 1 6.75 9V7.5c0-2.9 2.35-5.25 5.25-5.25h.5A4.75 4.75 0 0 1 17.25 7a.75.75 0 0 1-1.5 0 3.25 3.25 0 0 0-3.25-3.25H12A3.75 3.75 0 0 0 8.25 7.5V9a.75.75 0 0 1-.75.75Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$3f(props["data-theme"]),
    fillRule: "evenodd",
    d: "M19 9.25A2.75 2.75 0 0 1 21.75 12v7A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-7A2.75 2.75 0 0 1 5 9.25h14ZM20.25 12c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M12 12.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3g = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUpTrend = function SvgTwoColorUpTrend(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3g(props["data-theme"]),
    d: "M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M18.104 8.454c.383.108.606.515.504.918l-.881 3.457c-.105.41-.508.662-.9.563-.393-.1-.627-.513-.523-.923l.444-1.74-4.114 3.097a.75.75 0 0 1-.994-.082l-1.017-1.07-4.706 3.15a.75.75 0 0 1-.834-1.247l5.23-3.5a.75.75 0 0 1 .961.106l.992 1.043 3.697-2.783-1.561-.44c-.39-.11-.614-.53-.5-.937.115-.407.524-.648.914-.538l3.287.926Z"
  }));
};

var getTheme$3h = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUpdates = function SvgTwoColorUpdates(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M5.75 3a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5H6.084A8.25 8.25 0 0 1 20.25 12a.75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75a9.713 9.713 0 0 0-6.25 2.266V3Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: getTheme$3h(props["data-theme"]),
    fillRule: "evenodd",
    d: "M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.719 9.719 0 0 0 6.75-2.714V21a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0 0 1.5h2.416A8.25 8.25 0 0 1 3.75 12Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3i = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorUpgrade = function SvgTwoColorUpgrade(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3i(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M11.713 7.307a.748.748 0 0 0-.243.163l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72V16a.75.75 0 0 0 1.5 0V9.81l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4a.748.748 0 0 0-.817-.163Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3j = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorVip = function SvgTwoColorVip(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M7.5 2.875 8.786 6.5h6.428L16.5 2.875l-2.893.938L12 1l-1.607 2.813L7.5 2.875Zm1.65 10.366a1 1 0 1 0-1.3 1.518l2.848 2.442a2 2 0 0 0 2.604 0l2.849-2.442a1 1 0 0 0-1.302-1.518L12 15.683 9.15 13.24Z"
  }), createElement("path", {
    fill: getTheme$3j(props["data-theme"]),
    d: "M4.762 7.204a2.25 2.25 0 0 1 1.84-.954h10.796a2.25 2.25 0 0 1 1.84.954l3.084 4.377a2.25 2.25 0 0 1-.388 3.015l-8.483 7.16a2.25 2.25 0 0 1-2.902 0l-8.482-7.16a2.25 2.25 0 0 1-.388-3.015l3.083-4.377Zm1.84.546a.75.75 0 0 0-.613.318l-3.084 4.377a.75.75 0 0 0 .13 1.005l8.481 7.16a.75.75 0 0 0 .968 0l8.482-7.16a.75.75 0 0 0 .13-1.005l-3.084-4.377a.75.75 0 0 0-.614-.318H6.602Z"
  }));
};

var getTheme$3k = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorVerifiedAd = function SvgTwoColorVerifiedAd(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3k(props["data-theme"]),
    fillRule: "evenodd",
    d: "M10.397 1.911a2.273 2.273 0 0 1 3.206 0l.001.002 1.744 1.744h2.73a2.273 2.273 0 0 1 2.265 2.266V8.652l1.746 1.746a2.273 2.273 0 0 1 0 3.204l-.002.002-1.744 1.744V18.077a2.273 2.273 0 0 1-2.266 2.266H15.348l-1.744 1.744-.001.002a2.273 2.273 0 0 1-3.205 0l-.002-.002-1.744-1.744H5.923a2.273 2.273 0 0 1-2.266-2.266V15.348l-1.744-1.744-.002-.001a2.273 2.273 0 0 1 0-3.205l.002-.002 1.744-1.744V5.923a2.273 2.273 0 0 1 2.266-2.266H8.652l1.744-1.744.001-.002Zm1.058 1.064L9.273 5.157H5.927a.773.773 0 0 0-.77.77v3.346l-2.182 2.182a.775.775 0 0 0 0 1.09l2.182 2.182v3.346a.773.773 0 0 0 .77.77h3.346l2.182 2.182a.775.775 0 0 0 1.09 0l2.182-2.182h3.347a.773.773 0 0 0 .77-.77v-3.346l2.181-2.182a.775.775 0 0 0 0-1.09l-2.181-2.182V5.926a.773.773 0 0 0-.77-.77h-3.347l-2.182-2.181a.776.776 0 0 0-1.09 0Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m12 17.581-4.784-8.77h2.392L12 13.595l2.392-4.784h2.392L12 17.58Z"
  }));
};

var getTheme$3l = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorVolatileMarket = function SvgTwoColorVolatileMarket(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3l(props["data-theme"]),
    d: "M7.82 5.47a.75.75 0 0 0-1.06 0L2.97 9.26a.75.75 0 0 0 1.06 1.06L6.54 7.81v10.82a.75.75 0 0 0 1.5 0V7.812l2.509 2.509a.75.75 0 0 0 1.06-1.06L7.82 5.47Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M17.46 6a.75.75 0 0 0-1.5 0v10.821l-2.509-2.51a.75.75 0 0 0-1.06 1.061l3.79 3.79a.75.75 0 0 0 1.06 0l3.79-3.79a.75.75 0 1 0-1.061-1.06l-2.51 2.508V6Z"
  }));
};

var getTheme$3m = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorVotes = function SvgTwoColorVotes(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M8.528 12.682a.949.949 0 0 0 0 1.342l2.753 2.753a.948.948 0 0 0 1.434.018l2.757-2.757a.949.949 0 1 0-1.343-1.342l-1.173 1.173v-5.42a.95.95 0 0 0-1.901.002v5.415l-1.184-1.184a.949.949 0 0 0-1.343 0ZM4.5 17.25a.75.75 0 0 0-.67.415l-1.5 3A.75.75 0 0 0 3 21.75h18a.75.75 0 0 0 .67-1.085l-1.5-3a.75.75 0 0 0-.67-.415h-2.25a.75.75 0 0 0 0 1.5h1.787l.75 1.5H4.213l.75-1.5H6.75a.75.75 0 0 0 0-1.5H4.5Z"
  }), createElement("path", {
    fill: getTheme$3m(props["data-theme"]),
    d: "M12.935 4.155a1.284 1.284 0 0 0-1.87 0L4.15 11.328a1.473 1.473 0 0 0 0 2.02l5.707 5.902h4.322l5.668-5.9v-.001a1.473 1.473 0 0 0 0-2.021l-6.912-7.173Zm-2.95-1.041a2.784 2.784 0 0 1 4.03 0l6.914 7.173a2.973 2.973 0 0 1 0 4.102l-6.11 6.361H9.221l-6.15-6.36a2.973 2.973 0 0 1 0-4.103l6.914-7.173Z"
  }));
};

var getTheme$3n = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorVotingVoucher = function SvgTwoColorVotingVoucher(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
  }), createElement("path", {
    fill: getTheme$3n(props["data-theme"]),
    d: "m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
  }), createElement("path", {
    fill: getTheme$3n(props["data-theme"]),
    fillRule: "evenodd",
    d: "M2.25 17c0-.966.784-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 20.75H4A1.75 1.75 0 0 1 2.25 19v-2ZM4 16.75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h15a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25H4Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M13.629 3.363c.3-.058.605.013.856.2.72.536 2.352 2.105 3.438 3.177.55.544.591 1.413.108 2.008l-4.224 5.198a1.5 1.5 0 0 1-1.164.554h-2.74a1.5 1.5 0 0 1-.977-.361l-1.83-1.57a1.5 1.5 0 0 1-.14-2.142l6.013-6.68a1.2 1.2 0 0 1 .66-.384Zm.24 1.626-5.797 6.442L9.902 13h2.741l4.222-5.196c-.974-.962-2.271-2.208-2.996-2.815Z",
    clipRule: "evenodd"
  }));
};

var getTheme$3o = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorWeathManagement = function SvgTwoColorWeathManagement(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#TwoColorWeath__Management_svg__a)"
  }, createElement("path", {
    fill: getTheme$3o(props["data-theme"]),
    d: "M16.207 10c0-.99.803-1.793 1.793-1.793h1c.99 0 1.793.803 1.793 1.793v10c0 .99-.803 1.793-1.793 1.793h-1c-.99 0-1.793-.803-1.793-1.793V10ZM18 9.793a.207.207 0 0 0-.207.207v10c0 .114.093.207.207.207h1a.207.207 0 0 0 .207-.207V10A.207.207 0 0 0 19 9.793h-1ZM2.207 15c0-.99.803-1.793 1.793-1.793h1c.99 0 1.793.803 1.793 1.793v5c0 .99-.803 1.793-1.793 1.793H4c-.99 0-1.793-.803-1.793-1.793v-5ZM4 14.793a.207.207 0 0 0-.207.207v5c0 .114.092.207.207.207h1A.207.207 0 0 0 5.207 20v-5A.207.207 0 0 0 5 14.793H4Zm7-4.586c-.99 0-1.793.803-1.793 1.793v8c0 .99.803 1.793 1.793 1.793h1c.99 0 1.793-.803 1.793-1.793v-8c0-.99-.803-1.793-1.793-1.793h-1ZM10.793 12c0-.114.093-.207.207-.207h1c.114 0 .207.093.207.207v8a.207.207 0 0 1-.207.207h-1a.207.207 0 0 1-.207-.207v-8Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.331 2.461c0-.438.355-.793.793-.793h7.575a.793.793 0 0 1 .363 1.498L3.938 11.47a.793.793 0 1 1-.726-1.41l13.216-6.806h-4.304a.793.793 0 0 1-.793-.793Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "TwoColorWeath__Management_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var getTheme$3p = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorWeb3 = function SvgTwoColorWeb3(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3p(props["data-theme"]),
    d: "M7.634 5.583C6.293 7.075 5.7 9.173 5.616 10.589a.75.75 0 0 1-.366.6c-.28.167-.691.512-1.021.925-.35.438-.489.801-.478 1.016 0 .007.003.152.475.317.428.149.984.21 1.426.225a.75.75 0 0 1 .725.75v3.34h3.9a.75.75 0 0 1 .73.926l-.605 2.489a.75.75 0 0 1-1.457-.354l.379-1.562H5.627a.75.75 0 0 1-.75-.75v-3.395a5.609 5.609 0 0 1-1.145-.253c-.587-.204-1.431-.669-1.48-1.66-.038-.777.391-1.508.805-2.025.329-.412.724-.783 1.093-1.055.171-1.636.862-3.867 2.369-5.543.822-.915 1.894-1.67 3.253-2.055 1.359-.385 2.956-.387 4.81.128 2.87.797 4.432 2.492 5.078 4.5a.75.75 0 1 1-1.428.458c-.481-1.495-1.636-2.842-4.052-3.513-1.634-.454-2.948-.428-3.999-.13-1.05.298-1.886.88-2.547 1.615Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M10.25 8a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .624.334l1.777 2.666h2.6a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.625-.334L15.6 8.75H11a.75.75 0 0 1-.75-.75Zm1 8c0 .414.336.75.75.75h4a.75.75 0 0 0 .53-.22l1.78-1.78H21a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.53.22l-1.78 1.78H12a.75.75 0 0 0-.75.75ZM15 12.75a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5h4Z"
  }));
};

var getTheme$3q = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorWebhookSignal = function SvgTwoColorWebhookSignal(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "m12.757 6.937 2.355-2.354a.778.778 0 0 0 0-1.1l-2.355-2.355a.778.778 0 1 0-1.1 1.1l1.027 1.026h-7.91A3.475 3.475 0 0 0 1.3 6.73v1.882a.778.778 0 1 0 1.556 0V6.729c0-1.06.859-1.919 1.919-1.919h7.91l-1.028 1.027a.778.778 0 1 0 1.1 1.1ZM11.216 21.14l1.027 1.027a.778.778 0 0 1-1.1 1.1l-2.355-2.355a.778.778 0 0 1 0-1.1l2.355-2.355a.778.778 0 1 1 1.1 1.1l-1.027 1.027h7.91c1.06 0 1.918-.859 1.918-1.918v-1.882a.778.778 0 0 1 1.556 0v1.882a3.475 3.475 0 0 1-3.475 3.474h-7.909Z"
  }), createElement("path", {
    fill: getTheme$3q(props["data-theme"]),
    d: "M11.282 8.092H4.899v3.546h2.837v4.965h3.546v-8.51ZM14.26 11.638a1.773 1.773 0 1 0 0-3.546 1.773 1.773 0 0 0 0 3.546ZM21.494 8.092h-3.546l-3.546 8.51h3.546l3.546-8.51Z"
  }));
};

var getTheme$3r = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorWithdraw = function SvgTwoColorWithdraw(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M11.75 2.25c.204 0 .4.083.541.231l5.75 6A.75.75 0 1 1 16.96 9.52L12.5 4.867V15a.75.75 0 0 1-1.5 0V4.867L6.541 9.519A.75.75 0 1 1 5.46 8.48l5.75-6a.75.75 0 0 1 .541-.231Z"
  }), createElement("path", {
    fill: getTheme$3r(props["data-theme"]),
    d: "M3 12.75a.75.75 0 0 1 .75.75v5c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-5a.75.75 0 0 1 1.5 0v5A2.75 2.75 0 0 1 19 21.25H5a2.75 2.75 0 0 1-2.75-2.75v-5a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$3s = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorYield = function SvgTwoColorYield(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3s(props["data-theme"]),
    d: "M11.9 4.11a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm-9.75 8.25c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.496 7.99c.153-.496.854-.496 1.007 0l.795 2.572h2.644c.504 0 .72.64.32.946l-2.161 1.65.811 2.627a.527.527 0 0 1-.823.574l-2.09-1.596-2.088 1.596a.527.527 0 0 1-.824-.574L9.9 13.16l-2.161-1.651a.527.527 0 0 1 .32-.946H10.7l.795-2.572ZM18.9 1.9l.091.55a4.185 4.185 0 0 0 3.307 3.415 4.185 4.185 0 0 0-3.307 3.415l-.091.55-.088-.526a4.226 4.226 0 0 0-3.31-3.439 4.185 4.185 0 0 0 3.306-3.415l.092-.55Z"
  }));
};

var getTheme$3t = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBail = function SvgTwoColorBail(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3t(props["data-theme"]),
    d: "m11.085 21.535-.334-.171c-1.684-.863-5.029-2.575-7.209-6.208-.738-1.231-1.087-2.9-1.277-4.368C2.066 9.253 2.008 7.644 2 6.354A2.382 2.382 0 0 1 3.794 4.04l7.478-1.948a2.89 2.89 0 0 1 1.456 0l7.478 1.948-.378 1.451-7.478-1.947a1.39 1.39 0 0 0-.7 0L4.172 5.492a.882.882 0 0 0-.672.852c.008 1.261.065 2.802.252 4.252.186 1.433.506 2.838 1.077 3.788 1.941 3.237 4.933 4.788 6.606 5.645h.002l.34.176.218.113.219-.109c.227-.112.508-.229.767-.337l.032-.013c1.735-.723 4.681-1.975 6.246-5.523.942-2.133 1.218-5.508 1.241-7.99a.88.88 0 0 0-.672-.854l.378-1.451A2.38 2.38 0 0 1 22 6.359c-.023 2.493-.292 6.144-1.368 8.583-1.82 4.126-5.277 5.566-7.042 6.301-.286.12-.528.22-.71.31l-.903.447-.892-.465Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M11.999 5.593a.75.75 0 0 1 .75.75v.72h1.454a.75.75 0 0 1 0 1.5H12.01a.757.757 0 0 1-.023 0h-1.09a1.087 1.087 0 0 0 0 2.173H13.1a2.587 2.587 0 1 1 0 5.173h-.352v.72a.75.75 0 0 1-1.5 0v-.72H9.795a.75.75 0 0 1 0-1.5H13.1a1.087 1.087 0 0 0 0-2.173h-2.204a2.587 2.587 0 0 1 0-5.174h.352v-.72a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$3u = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorBlockTrade = function SvgTwoColorBlockTrade(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3u(props["data-theme"]),
    d: "M6.77 5.25h10.46l3.555 5.17L12 19.545 3.215 10.42 6.769 5.25Zm11.25-1.5H5.98l-4.695 6.83L12 21.705 22.715 10.58 18.019 3.75Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "m7.345 10.655 1.06-1.06L12 13.189l3.595-3.594 1.06 1.06L12 15.311l-4.655-4.656Z"
  }));
};

var getTheme$3v = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorGrade = function SvgTwoColorGrade(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3v(props["data-theme"]),
    d: "M8.25 7.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm6.78 4.289a5.25 5.25 0 1 0-6.058 0A8.754 8.754 0 0 0 3.249 20v1a.75.75 0 0 0 1.5 0v-1a7.25 7.25 0 1 1 14.5 0v1a.75.75 0 0 0 1.5 0v-1a8.754 8.754 0 0 0-5.72-8.211Z"
  }), createElement("path", {
    fill: "#F7A600",
    d: "M12.853 13.244a1.2 1.2 0 1 0-1.706 0l-1.478 4.927a.4.4 0 0 0 .1.398l1.807 1.807a.6.6 0 0 0 .848 0l1.807-1.807a.4.4 0 0 0 .1-.398l-1.478-4.927Z"
  }));
};

var getTheme$3w = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorSpeedAction = function SvgTwoColorSpeedAction(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "#F7A600",
    d: "M13.271 1.3a.75.75 0 0 1 .473.792L12.85 9.25h6.65a.75.75 0 0 1 .612 1.184l-8.5 12a.75.75 0 0 1-1.356-.527l.894-7.156H4.5a.75.75 0 0 1-.612-1.184l8.5-12a.75.75 0 0 1 .883-.266Zm-7.32 11.95H12a.75.75 0 0 1 .744.842l-.63 5.036 5.936-8.379H12a.75.75 0 0 1-.744-.843l.63-5.035-5.936 8.378Z"
  }), createElement("path", {
    fill: getTheme$3w(props["data-theme"]),
    d: "M3.055 3.055A2.75 2.75 0 0 1 5 2.25h2a.75.75 0 0 1 0 1.5H5A1.25 1.25 0 0 0 3.75 5v2a.75.75 0 1 1-1.5 0V5c0-.73.29-1.43.805-1.945ZM16.25 3a.75.75 0 0 1 .75-.75h2A2.75 2.75 0 0 1 21.75 5v2a.75.75 0 0 1-1.5 0V5A1.25 1.25 0 0 0 19 3.75h-2a.75.75 0 0 1-.75-.75ZM3 16.25a.75.75 0 0 1 .75.75v2A1.25 1.25 0 0 0 5 20.25h2a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 19v-2a.75.75 0 0 1 .75-.75Zm18 0a.75.75 0 0 1 .75.75v2A2.75 2.75 0 0 1 19 21.75h-2a.75.75 0 0 1 0-1.5h2A1.25 1.25 0 0 0 20.25 19v-2a.75.75 0 0 1 .75-.75Z"
  }));
};

var getTheme$3x = function getTheme(theme) {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
var SvgTwoColorbot = function SvgTwoColorbot(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: getTheme$3x(props["data-theme"]),
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 0-.75.75v2.25H7A2.75 2.75 0 0 0 4.25 8v1.26a3.25 3.25 0 0 0-3 3.24v1a3.25 3.25 0 0 0 3 3.24V18A2.75 2.75 0 0 0 7 20.75h10A2.75 2.75 0 0 0 19.75 18v-1.26a3.25 3.25 0 0 0 3-3.24v-1a3.25 3.25 0 0 0-3-3.24V8A2.75 2.75 0 0 0 17 5.25h-4.25v-1.5H14a.75.75 0 0 0 0-1.5h-2Zm0 4.5H7c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25h-5ZM2.75 12.5a1.75 1.75 0 0 1 1.5-1.732v4.464a1.75 1.75 0 0 1-1.5-1.732v-1Zm17-1.732v4.464a1.75 1.75 0 0 0 1.5-1.732v-1a1.75 1.75 0 0 0-1.5-1.732Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#F7A600",
    fillRule: "evenodd",
    d: "M9.75 11a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Zm6 0a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z",
    clipRule: "evenodd"
  }));
};

var SvgAccountswitchIcon = function SvgAccountswitchIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "accountswitch_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M189.61 91.008A189.61 189.61 0 0 0 0 280.661v455.083a189.61 189.61 0 0 0 189.61 189.653h455.126a37.93 37.93 0 0 0 0-75.861H189.611A113.792 113.792 0 0 1 75.86 735.744V280.661a113.792 113.792 0 0 1 113.75-113.834h417.194a113.792 113.792 0 0 1 113.792 113.792v37.93a37.93 37.93 0 0 0 75.862 0v-37.973a189.61 189.61 0 0 0-189.654-189.61H189.611zm303.446 303.403a75.861 75.861 0 1 0-151.723 0 75.861 75.861 0 0 0 151.723 0zm75.819 0c0 38.826-14.592 74.24-38.571 101.12 25.6 12.074 49.024 28.16 69.333 47.36a37.93 37.93 0 0 1-52.138 55.125A189.61 189.61 0 0 0 227.54 735.744a37.93 37.93 0 0 1-75.818 0 265.515 265.515 0 0 1 152.32-240.213 151.723 151.723 0 1 1 264.832-101.12zm417.194 161.834H767.061l59.136-59.136a37.93 37.93 0 0 0-53.632-53.632L655.872 560.171a37.845 37.845 0 0 0-10.965 30.378 37.93 37.93 0 0 0 37.76 41.558h303.402a37.93 37.93 0 0 0 0-75.862zM1024 727.68a39.253 39.253 0 0 1-.17 3.627 37.845 37.845 0 0 1-10.923 30.378L896.213 878.38a37.93 37.93 0 1 1-53.674-53.632l59.136-59.136H682.667a37.93 37.93 0 1 1 0-75.862h303.402c20.95 0 37.931 16.982 37.931 37.931z"
  }));
};

var SvgAddIcon = function SvgAddIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "add_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M938.667 512c0 235.648-191.019 426.667-426.667 426.667S85.333 747.648 85.333 512 276.352 85.333 512 85.333 938.667 276.352 938.667 512zM512 853.333a341.333 341.333 0 1 0 0-682.666 341.333 341.333 0 0 0 0 682.666zm0-554.666a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgAddSolidIcon = function SvgAddSolidIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "add_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zM512 768a42.667 42.667 0 0 0 42.667-42.667V554.667h170.666a42.667 42.667 0 1 0 0-85.334H554.667V298.667a42.667 42.667 0 1 0-85.334 0v170.666H298.667a42.667 42.667 0 1 0 0 85.334h170.666v170.666A42.667 42.667 0 0 0 512 768z"
  }));
};

var SvgAdddecIcon = function SvgAdddecIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "adddec_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M234.667 469.333a42.667 42.667 0 1 0 85.333 0V362.667h106.667a42.667 42.667 0 1 0 0-85.334H320V170.667a42.667 42.667 0 1 0-85.333 0v106.666H128a42.667 42.667 0 0 0 0 85.334h106.667v106.666zm320 320a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 832H597.333a42.667 42.667 0 0 1-42.666-42.667zm-353.835-8.832a42.667 42.667 0 1 0 60.33 60.331l537.003-537.003a42.667 42.667 0 0 0-60.33-60.33L200.832 780.5z"
  }));
};

var SvgAirdropIcon = function SvgAirdropIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m19.936 1.114-.06-.364-.062.364a2.77 2.77 0 0 1-2.189 2.261c1.13.234 2 1.139 2.192 2.277l.058.348.06-.364a2.77 2.77 0 0 1 2.19-2.261 2.77 2.77 0 0 1-2.19-2.261ZM2 10.857a1.005 1.005 0 0 0 .348.776l7.396 6.432A2 2 0 0 0 8.25 20v1.25a2 2 0 0 0 2 2H13a2 2 0 0 0 2-2V20a2 2 0 0 0-1.494-1.935l7.4-6.435a.997.997 0 0 0 .344-.77C21.24 5.881 16.848 2 11.625 2 6.403 2 2.011 5.88 2 10.857Zm16.815-.059-4.726 4.109 1.465-3.66c.022-.056.039-.113.05-.17a2.26 2.26 0 0 1 .194-.175c.313-.255.815-.527 1.577-.527.659 0 1.123.203 1.44.423Zm-5.669.12c.111.085.207.171.285.248l-1.806 4.516-1.806-4.516a3.1 3.1 0 0 1 .285-.248c.37-.285.88-.543 1.521-.543.64 0 1.15.258 1.521.543Zm-5.45.328 1.465 3.661-4.688-4.076a2.437 2.437 0 0 1 1.402-.456c.64 0 1.15.258 1.521.543.103.079.192.158.267.23.01.033.02.066.034.098Zm-1.82-2.871c-.543 0-1.03.1-1.455.25C5.445 5.97 8.232 4 11.625 4c3.38 0 6.158 1.954 7.192 4.594-.42-.135-.9-.219-1.442-.219-1.292 0-2.227.478-2.838.974l-.074.06a5.236 5.236 0 0 0-.098-.077c-.605-.465-1.532-.957-2.74-.957-1.208 0-2.135.492-2.74.957a5.038 5.038 0 0 0-.135.108 5.07 5.07 0 0 0-.135-.108c-.605-.465-1.532-.957-2.74-.957ZM21.374 6l.008.06c.05.379.36.669.742.69l-.029.006a.895.895 0 0 0-.721.744.834.834 0 0 0-.682-.737l-.068-.013a.79.79 0 0 0 .747-.716L21.375 6Z"
  }));
};

var SvgAlertCircleSolidIcon = function SvgAlertCircleSolidIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "alert_circle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 213.333A42.667 42.667 0 0 0 512 768h.427a42.667 42.667 0 1 0 0-85.333H512a42.667 42.667 0 0 0-42.667 42.666zm85.334-426.666a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 1 0 85.334 0v-256z"
  }));
};

var SvgAlertTriangleSolidIcon = function SvgAlertTriangleSolidIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "alert_triangle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M461.227 115.499a57.77 57.77 0 0 1 101.546 0l410.624 732.586c22.571 40.278-5.632 90.582-50.773 90.582H101.376c-45.141 0-73.344-50.304-50.773-90.539l410.666-732.587zm8.106 695.168A42.667 42.667 0 0 0 512 853.333h.427a42.667 42.667 0 1 0 0-85.333H512a42.667 42.667 0 0 0-42.667 42.667zM554.667 384a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 1 0 85.334 0V384z"
  }));
};

var SvgAngleIcon = function SvgAngleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "angle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658L610.347 463.83A404.096 404.096 0 0 1 724.779 768H896a42.667 42.667 0 1 1 0 85.333H369.621a149.333 149.333 0 1 1-70.656-198.826l355.542-355.542A148.779 148.779 0 0 1 640 234.667zM639.317 768a318.848 318.848 0 0 0-89.301-243.84l-187.69 187.648A149.12 149.12 0 0 1 382.505 768h256.811zm-340.65 21.333a64 64 0 1 0-128 0 64 64 0 0 0 128 0z"
  }));
};

var SvgApplynowIcon = function SvgApplynowIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "applynow_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M853.333 341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334A42.667 42.667 0 0 0 768 170.667H256a42.667 42.667 0 0 0-42.667 42.666v597.334A42.667 42.667 0 0 0 256 853.333h85.333a42.667 42.667 0 1 1 0 85.334H256a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h512a128 128 0 0 1 128 128v85.334a42.667 42.667 0 0 1-42.667 42.666zM341.333 512a42.667 42.667 0 1 0 0 85.333h128a42.667 42.667 0 1 0 0-85.333h-128zm0-213.333a42.667 42.667 0 0 0 0 85.333h256a42.667 42.667 0 1 0 0-85.333h-256zM660.352 820.18l-66.133 17.366 17.365-66.134c2.688-10.282 8.107-19.669 15.573-27.178l230.528-230.528a42.667 42.667 0 0 1 60.374 60.33L687.488 804.565a59.99 59.99 0 0 1-27.136 15.616zM544.128 938.923l137.899-36.267a145.28 145.28 0 0 0 65.834-37.76L978.39 634.368a128 128 0 1 0-181.034-180.992L566.827 683.904a145.28 145.28 0 0 0-37.76 65.792L492.8 887.595a42.027 42.027 0 0 0 51.328 51.328z"
  }));
};

var SvgArrowIcon = function SvgArrowIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrow_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M597.333 128A42.667 42.667 0 0 1 640 85.333h256A42.667 42.667 0 0 1 938.667 128v256a42.667 42.667 0 1 1-85.334 0V229.12L365.355 717.013a149.333 149.333 0 1 1-60.928-59.733l486.698-486.656H640a42.667 42.667 0 0 1-42.667-42.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
  }));
};

var SvgArrowchevron2DownIcon = function SvgArrowchevron2DownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M328.832 225.835a42.667 42.667 0 0 0-60.33 60.33L481.834 499.5a42.667 42.667 0 0 0 60.33 0L755.5 286.165a42.667 42.667 0 0 0-60.331-60.33L512 409.003 328.832 225.835zm0 298.666a42.667 42.667 0 0 0-60.33 60.331l213.333 213.333a42.667 42.667 0 0 0 60.33 0L755.5 584.832a42.667 42.667 0 0 0-60.331-60.33L512 707.668 328.832 524.501z"
  }));
};

var SvgArrowchevron2LeftIcon = function SvgArrowchevron2LeftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M499.499 328.832a42.667 42.667 0 0 0-60.331-60.33L225.835 481.834a42.667 42.667 0 0 0 0 60.33L439.168 755.5a42.667 42.667 0 0 0 60.33-60.331L316.332 512 499.5 328.832zm298.666 0a42.667 42.667 0 0 0-60.33-60.33L524.5 481.834a42.667 42.667 0 0 0 0 60.33L737.835 755.5a42.667 42.667 0 0 0 60.33-60.331L614.997 512l183.168-183.168z"
  }));
};

var SvgArrowchevron2RightIcon = function SvgArrowchevron2RightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M225.835 328.832a42.667 42.667 0 0 1 60.33-60.33L499.5 481.834a42.667 42.667 0 0 1 0 60.33L286.165 755.5a42.667 42.667 0 0 1-60.33-60.331L409.003 512 225.835 328.832zm358.997-60.33a42.667 42.667 0 1 0-60.33 60.33L707.668 512 524.501 695.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333a42.667 42.667 0 0 0 0-60.33L584.832 268.5z"
  }));
};

var SvgArrowchevron2UpIcon = function SvgArrowchevron2UpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M542.165 225.835a42.667 42.667 0 0 0-60.33 0L268.5 439.168a42.667 42.667 0 1 0 60.331 60.33L512 316.332 695.168 499.5a42.667 42.667 0 0 0 60.33-60.331L542.166 225.835zm213.334 512L542.165 524.5a42.667 42.667 0 0 0-60.33 0L268.5 737.835a42.667 42.667 0 1 0 60.331 60.33L512 614.997l183.168 183.168a42.667 42.667 0 0 0 60.33-60.33z"
  }));
};

var SvgArrowchevronDownIcon = function SvgArrowchevronDownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M225.835 353.835a42.667 42.667 0 0 1 60.33 0L512 579.669l225.835-225.834a42.667 42.667 0 1 1 60.33 60.33l-256 256a42.667 42.667 0 0 1-60.33 0l-256-256a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgArrowchevronLeftIcon = function SvgArrowchevronLeftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M670.165 225.835a42.667 42.667 0 0 1 0 60.33L444.331 512l225.834 225.835a42.667 42.667 0 0 1-60.33 60.33l-256-256a42.667 42.667 0 0 1 0-60.33l256-256a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgArrowchevronRightIcon = function SvgArrowchevronRightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M353.835 225.835a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1 0 60.33l-256 256a42.667 42.667 0 0 1-60.33-60.33L579.669 512 353.835 286.165a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgArrowchevronUpIcon = function SvgArrowchevronUpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M481.835 353.835a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L512 444.331 286.165 670.165a42.667 42.667 0 0 1-60.33-60.33l256-256z"
  }));
};

var SvgArrowdownIcon = function SvgArrowdownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowdown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m561.707 657.75 194.389-262.23a60.416 60.416 0 0 0-13.312-85.077 62.165 62.165 0 0 0-36.437-11.776H317.653c-34.048 0-61.653 27.264-61.653 60.885 0 12.928 4.181 25.515 11.904 35.968l194.347 262.23a62.123 62.123 0 0 0 99.498 0z"
  }));
};

var SvgArrowleftIcon = function SvgArrowleftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowleft_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m323.584 462.293 262.23-194.389a60.416 60.416 0 0 1 85.077 13.312c7.68 10.581 11.776 23.339 11.776 36.437v388.694c0 34.048-27.264 61.653-60.886 61.653-12.928 0-25.514-4.181-35.968-11.904L323.584 561.749a62.123 62.123 0 0 1 0-99.498z"
  }));
};

var SvgArrowmoreIcon = function SvgArrowmoreIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowmore_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M883.499 670.165a42.667 42.667 0 0 0 0-60.33L670.165 396.5a42.667 42.667 0 1 0-60.33 60.331l140.501 140.501h-451.67A85.333 85.333 0 0 1 213.334 512V170.667a42.667 42.667 0 0 0-85.333 0V512a170.667 170.667 0 0 0 170.667 170.667h451.669L609.835 823.168a42.667 42.667 0 0 0 60.33 60.33L883.5 670.166z"
  }));
};

var SvgArrowrightIcon = function SvgArrowrightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowright_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m700.416 462.293-262.23-194.389a60.416 60.416 0 0 0-85.077 13.312c-7.68 10.581-11.776 23.339-11.776 36.437v388.694c0 34.048 27.264 61.653 60.886 61.653 12.928 0 25.514-4.181 35.968-11.904l262.229-194.347a62.123 62.123 0 0 0 0-99.498z"
  }));
};

var SvgArrowupIcon = function SvgArrowupIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowup_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m561.707 323.584 194.389 262.23a60.416 60.416 0 0 1-13.312 85.077c-10.581 7.68-23.339 11.776-36.437 11.776H317.653A61.27 61.27 0 0 1 256 621.78c0-12.928 4.181-25.514 11.904-35.968l194.347-262.229a62.123 62.123 0 0 1 99.498 0z"
  }));
};

var SvgAssethistoryIcon = function SvgAssethistoryIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assethistory_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M746.667 640a42.667 42.667 0 1 0-85.334 0v64a42.667 42.667 0 0 0 18.987 35.499l64 42.666a42.667 42.667 0 0 0 47.36-70.997l-45.013-29.995V640z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M448 704a256 256 0 1 1 512 0 256 256 0 0 1-512 0zm256-170.667a170.667 170.667 0 1 0 0 341.334 170.667 170.667 0 0 0 0-341.334z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M810.667 384A42.667 42.667 0 1 0 896 384V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h170.667a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666V384z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M298.667 469.333a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.667zm0-170.666A42.667 42.667 0 0 1 341.333 256h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
  }));
};

var SvgAssetsMoreIcon = function SvgAssetsMoreIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assets_more_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667zm0-469.334a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm-170.667 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm341.334 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334z"
  }));
};

var SvgAssureIcon = function SvgAssureIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assure_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m549.547 919.637-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zm-47.318-750.336-319.018 83.115a18.73 18.73 0 0 0-14.123 18.133c.683 106.966 9.6 259.755 54.101 333.91 9.728 16.213 20.096 31.445 30.934 45.653 66.688-73.6 155.477-109.781 252.245-109.781 103.339 0 197.12 41.472 264.917 123.562 11.691-17.749 22.528-37.461 32.214-59.434 38.528-87.296 50.432-228.011 51.413-333.91a18.688 18.688 0 0 0-14.08-18.133l-319.147-83.115a38.57 38.57 0 0 0-19.413 0zm213.59 560.427C662.997 657.792 588.8 623.915 506.325 623.915c-75.818 0-144.213 28.33-195.626 89.258 66.602 63.19 138.965 100.438 187.605 125.44l.085.043 13.568 6.997c11.435-5.674 24.747-11.306 39.254-17.493 48-20.523 109.653-46.89 164.608-98.432zM512.128 201.515c-86.528 0-156.63 69.29-156.63 154.752 0 85.418 70.102 154.709 156.587 154.709 86.528 0 156.672-69.29 156.672-154.71 0-85.46-70.144-154.709-156.629-154.709zm-71.979 154.752c0-39.296 32.214-71.168 72.022-71.168 39.765 0 72.021 31.872 72.021 71.168 0 39.253-32.256 71.125-72.021 71.125a71.595 71.595 0 0 1-72.022-71.125z"
  }));
};

var SvgBaseIcon = function SvgBaseIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "base_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M640 170.667A21.333 21.333 0 0 1 618.667 192H405.333a21.333 21.333 0 0 1 0-42.667h213.334A21.333 21.333 0 0 1 640 170.667zM618.667 64H405.333a106.667 106.667 0 0 0-97.792 64h-8.874A170.667 170.667 0 0 0 128 298.667v490.666A170.667 170.667 0 0 0 298.667 960h426.666A170.667 170.667 0 0 0 896 789.333V298.667A170.667 170.667 0 0 0 725.333 128h-8.874a106.667 106.667 0 0 0-97.792-64zm97.792 149.333h8.874a85.333 85.333 0 0 1 85.334 85.334v490.666a85.333 85.333 0 0 1-85.334 85.334H298.667a85.333 85.333 0 0 1-85.334-85.334V298.667a85.333 85.333 0 0 1 85.334-85.334h8.874a106.667 106.667 0 0 0 97.792 64h213.334a106.667 106.667 0 0 0 97.792-64zm-417.792 256c0-23.552 17.365-42.666 38.784-42.666h349.098c21.419 0 38.784 19.114 38.784 42.666S707.968 512 686.55 512H337.493c-21.461 0-38.826-19.115-38.826-42.667zm0 170.667c0-23.552 17.365-42.667 38.784-42.667h349.098c21.419 0 38.784 19.115 38.784 42.667s-17.365 42.667-38.784 42.667H337.493c-21.461 0-38.826-19.115-38.826-42.667z"
  }));
};

var SvgBatchIcon = function SvgBatchIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "batch_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M341.333 128A42.667 42.667 0 0 1 384 85.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 128zM256 213.333a42.667 42.667 0 0 0 0 85.334h512a42.667 42.667 0 1 0 0-85.334H256zm0 128A170.667 170.667 0 0 0 85.333 512v256A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V512A170.667 170.667 0 0 0 768 341.333H256zM170.667 512A85.333 85.333 0 0 1 256 426.667h512A85.333 85.333 0 0 1 853.333 512v256A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V512zm490.922 72.832a42.667 42.667 0 0 0-60.33-60.33L482.133 643.668 422.7 584.235a42.667 42.667 0 0 0-60.331 60.33l89.6 89.6a42.667 42.667 0 0 0 60.33 0l149.334-149.333z"
  }));
};

var SvgBellIcon = function SvgBellIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bell_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a298.667 298.667 0 0 0-298.667 298.666c0 143.062-30.592 231.894-58.794 283.563a253.312 253.312 0 0 1-37.547 53.077 129.579 129.579 0 0 1-13.013 12.118l-.128.085A42.667 42.667 0 0 0 128 768h768a42.667 42.667 0 0 0 24.15-77.824l-.086-.085a129.792 129.792 0 0 1-13.056-12.075 253.397 253.397 0 0 1-37.547-53.12c-28.16-51.67-58.794-140.501-58.794-283.563A298.667 298.667 0 0 0 512 42.667zm292.267 640H219.733c3.2-5.334 6.486-10.966 9.728-16.896 35.84-65.664 69.206-168.832 69.206-324.438a213.333 213.333 0 1 1 426.666 0c0 155.606 33.408 258.774 69.206 324.438 3.242 5.973 6.528 11.562 9.77 16.896zM475.093 874.58a42.667 42.667 0 1 0-73.813 42.838 128 128 0 0 0 221.44 0 42.667 42.667 0 0 0-73.813-42.838 42.667 42.667 0 0 1-73.814 0z"
  }));
};

var SvgBookIcon = function SvgBookIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "book_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M277.333 170.667h533.334V640H277.333c-22.912 0-44.586 5.12-64 14.379V224c0-12.587 5.547-25.728 17.11-36.181a70.357 70.357 0 0 1 46.89-17.152zM128 224v576c0 38.315 16.939 74.027 45.355 99.584 28.288 25.43 65.706 39.083 103.978 39.083h533.334A85.333 85.333 0 0 0 896 853.333V170.667a85.333 85.333 0 0 0-85.333-85.334H277.333c-38.229 0-75.69 13.654-103.978 39.083A134.059 134.059 0 0 0 128 224zm149.333 501.333h533.334v128H277.333c-18.346 0-35.157-6.613-46.89-17.152A48.768 48.768 0 0 1 213.333 800v-10.667a64 64 0 0 1 64-64zm128-469.333a42.667 42.667 0 0 0 0 85.333h213.334a42.667 42.667 0 1 0 0-85.333H405.333z"
  }));
};

var SvgBotIcon = function SvgBotIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M298.667 85.333A42.667 42.667 0 0 0 256 128v27.52A149.675 149.675 0 0 0 155.52 256H128a42.667 42.667 0 0 0 0 85.333h27.52A149.675 149.675 0 0 0 256 441.813v140.374a149.675 149.675 0 0 0-100.48 100.48H128A42.667 42.667 0 1 0 128 768h27.52A149.675 149.675 0 0 0 256 868.48V896a42.667 42.667 0 1 0 85.333 0v-27.52A149.675 149.675 0 0 0 441.813 768h140.374a149.675 149.675 0 0 0 100.48 100.48V896A42.667 42.667 0 1 0 768 896v-27.52A149.675 149.675 0 0 0 868.48 768H896a42.667 42.667 0 1 0 0-85.333h-27.52A149.675 149.675 0 0 0 768 582.187V441.813a149.675 149.675 0 0 0 100.48-100.48H896A42.667 42.667 0 1 0 896 256h-27.52A149.675 149.675 0 0 0 768 155.52V128a42.667 42.667 0 1 0-85.333 0v27.52A149.675 149.675 0 0 0 582.187 256H441.813a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 0 0-42.666-42.667zm42.666 356.48a149.675 149.675 0 0 0 100.48-100.48h140.374a149.675 149.675 0 0 0 100.48 100.48v140.374a149.675 149.675 0 0 0-100.48 100.48H441.813a149.675 149.675 0 0 0-100.48-100.48V441.813zm-42.666 219.52a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm362.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-490.666a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-490.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgBottomLeftIcon = function SvgBottomLeftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bottom_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M343.424 620.373V300.928a42.667 42.667 0 0 0-85.333 0v421.973c0 23.766 19.285 43.094 43.093 43.094h421.973a42.667 42.667 0 1 0 0-85.334H403.712L755.2 329.216c15.616-15.616 14.763-41.813-1.92-58.453-16.64-16.64-42.837-17.494-58.453-1.878l-351.36 351.446z"
  }));
};

var SvgBottomRightIcon = function SvgBottomRightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bottom_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M620.245 680.661h-319.36a42.667 42.667 0 1 0 0 85.334H722.86a43.093 43.093 0 0 0 43.093-43.094V300.928a42.667 42.667 0 1 0-85.333 0v319.403L329.13 268.928c-15.616-15.659-41.814-14.805-58.454 1.877-16.64 16.64-17.493 42.838-1.92 58.454L620.203 680.66z"
  }));
};

var SvgBrokenIcon = function SvgBrokenIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "broken_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M203.093 451.84a43.008 43.008 0 1 0 11.094-85.333l-75.094-18.774a42.667 42.667 0 1 0-22.186 82.347L192 450.133a33.323 33.323 0 0 0 11.093 1.707zm164.694-238.507a42.667 42.667 0 0 0 42.666 31.574 34.987 34.987 0 0 0 11.094 0 42.667 42.667 0 0 0 29.866-52.054L431.36 117.76a42.667 42.667 0 1 0-82.347 22.187l18.774 73.386zM573.867 640A42.667 42.667 0 0 0 512 640L362.667 791.893a94.293 94.293 0 0 1-130.56 0 91.733 91.733 0 0 1 0-130.56L384 512a42.667 42.667 0 1 0-60.16-60.16L170.667 600.747a178.603 178.603 0 1 0 252.586 252.586L573.867 702.72a42.667 42.667 0 0 0 0-62.72zM221.013 281.173a42.667 42.667 0 0 0 60.16 0 42.667 42.667 0 0 0 0-60.16l-55.04-55.04a42.667 42.667 0 0 0-60.16 60.16l55.04 55.04zm686.08 312.747L832 573.867a42.667 42.667 0 1 0-21.333 82.346l75.093 20.054h11.093a43.008 43.008 0 1 0 11.094-85.334l-.854 2.987zm-250.88 216.747a42.667 42.667 0 0 0-82.346 22.186l20.053 75.094a42.667 42.667 0 0 0 42.667 31.573 48.19 48.19 0 0 0 11.093 0 42.795 42.795 0 0 0 30.293-52.48l-21.76-76.373zm146.774-66.987a42.667 42.667 0 0 0-60.16 60.16l55.04 55.04a42.667 42.667 0 0 0 60.16 0 42.667 42.667 0 0 0 0-60.16l-55.04-55.04zm101.546-445.013a177.493 177.493 0 0 0-303.786-128L450.133 322.56A43.605 43.605 0 0 0 512 384l149.333-151.893a94.293 94.293 0 0 1 130.56 0 91.733 91.733 0 0 1 0 130.56L640 512a42.667 42.667 0 0 0 0 60.16 42.667 42.667 0 0 0 60.16 0l153.173-148.907a178.773 178.773 0 0 0 51.2-124.586z"
  }));
};

var SvgBuyIcon = function SvgBuyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "buy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 853.333A85.333 85.333 0 0 1 42.667 768V256A85.333 85.333 0 0 1 128 170.667h768A85.333 85.333 0 0 1 981.333 256v512A85.333 85.333 0 0 1 896 853.333H128zM128 768h768V256H128v512zm128-85.333a42.667 42.667 0 1 1 0-85.334h128a42.667 42.667 0 1 1 0 85.334H256zm405.333-312.448a85.333 85.333 0 1 0 0 112.896 85.333 85.333 0 1 0 0-112.896z"
  }));
};

var SvgCalculatorIcon = function SvgCalculatorIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "calculator_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 234.667A170.667 170.667 0 0 1 298.667 64h426.666A170.667 170.667 0 0 1 896 234.667v554.666A170.667 170.667 0 0 1 725.333 960H298.667A170.667 170.667 0 0 1 128 789.333V234.667zm170.667-85.334a85.333 85.333 0 0 0-85.334 85.334v554.666a85.333 85.333 0 0 0 85.334 85.334h426.666a85.333 85.333 0 0 0 85.334-85.334V234.667a85.333 85.333 0 0 0-85.334-85.334H298.667zm0 149.334A85.333 85.333 0 0 1 384 213.333h256a85.333 85.333 0 0 1 85.333 85.334V384A85.333 85.333 0 0 1 640 469.333H384A85.333 85.333 0 0 1 298.667 384v-85.333zm341.333 0H384V384h256v-85.333zM384 597.333a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm170.667 0a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM384 746.667a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.666A42.667 42.667 0 1 0 512 704a42.667 42.667 0 0 0 0 85.333zm213.333-42.666a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0z"
  }));
};

var SvgCexHomeIcon = function SvgCexHomeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cex_home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 149.333a405.333 405.333 0 1 1 0 810.667 405.333 405.333 0 0 1 0-810.667zm0-64C210.133 85.333 0 295.467 0 554.667S210.133 1024 469.333 1024s469.334-210.133 469.334-469.333S728.533 85.333 469.333 85.333zM272.94 646.955c9.898 3.882 20.992 5.845 33.237 5.845 16.64 0 30.592-3.84 41.728-11.435a82.773 82.773 0 0 0 26.88-32.426l-28.459-16.768a48.64 48.64 0 0 1-14.634 20.992c-6.571 5.674-15.062 8.533-25.515 8.533-13.141 0-23.595-4.267-31.403-12.8-7.594-8.661-11.434-21.077-11.434-37.205v-29.227c0-16 3.84-28.373 11.434-37.248 7.808-8.875 18.262-13.312 31.403-13.312 10.453 0 18.688 2.56 24.747 7.723a41.43 41.43 0 0 1 13.013 19.925l30.037-15.915c-6.57-14.378-15.36-25.088-26.325-32.213-10.965-7.083-24.832-10.624-41.472-10.624-12.245 0-23.339 2.133-33.28 6.4-9.728 4.267-18.133 10.539-25.216 18.859-6.912 8.149-12.245 18.346-15.957 30.592-3.755 12.074-5.59 25.898-5.59 41.472 0 15.616 1.835 29.354 5.547 41.216 3.755 11.69 9.088 21.546 16 29.525 7.083 7.979 15.488 13.995 25.259 18.09zM404.736 464v185.6h122.325v-31.104h-87.253v-47.36h77.141v-31.104h-77.141v-44.928h87.253v-31.147H404.736zm307.03 185.6h-40.96l-42.54-71.253h-.81L585.472 649.6h-38.315l60.118-95.19-57.472-90.453h40.96l39.381 65.963h.768L670.805 464h38.315l-57.984 90.41 60.63 95.19zm275.2-260.992a21.333 21.333 0 0 1-36.48-22.101A213.333 213.333 0 0 0 661.332 71.253 21.333 21.333 0 1 1 640 34.304a256 256 0 0 1 346.965 354.304z"
  }));
};

var SvgChartIcon = function SvgChartIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "chart_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm576 234.667a64 64 0 1 0-63.915-60.416L579.584 533.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
  }));
};

var SvgCheckCircleIcon = function SvgCheckCircleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "check_circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448a42.667 42.667 0 1 0-61.1-59.563L453.29 601.344l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781l134.101 127.701c17.067 16.299 44.118 15.787 60.587-1.109l249.301-255.701z"
  }));
};

var SvgCheckIcon = function SvgCheckIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "check_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M883.499 225.835a42.667 42.667 0 0 1 0 60.33L414.165 755.5a42.667 42.667 0 0 1-60.33 0L140.5 542.165a42.667 42.667 0 1 1 60.331-60.33L384 665.003l439.168-439.168a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgCircleIcon = function SvgCircleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448L485.247 690.816a43.093 43.093 0 0 1-60.587 1.11l-134.1-127.703a42.667 42.667 0 1 1 58.88-61.781l103.85 98.901 220.16-225.792a42.667 42.667 0 1 1 61.1 59.563z"
  }));
};

var SvgCirclepromptIcon = function SvgCirclepromptIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "circleprompt_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 170.667A42.667 42.667 0 0 1 512 640h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.666zm85.334-341.334a42.667 42.667 0 1 0-85.334 0V512a42.667 42.667 0 1 0 85.334 0V341.333z"
  }));
};

var SvgClearIcon = function SvgClearIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "clear_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M227.456 938.667A128 128 0 0 1 100.949 791.21l59.094-384a128 128 0 0 1 126.506-108.544h54.784v-85.334a170.667 170.667 0 0 1 341.334 0v85.334h54.784A128 128 0 0 1 863.957 407.21l59.094 384a128 128 0 0 1-126.507 147.456h-569.13zm199.21-725.334V320a64 64 0 0 1-64 64H286.55a42.667 42.667 0 0 0-42.197 36.181L230.272 512h563.499l-14.123-91.819A42.667 42.667 0 0 0 737.451 384h-76.118a64 64 0 0 1-64-64V213.333a85.333 85.333 0 1 0-170.666 0zm-209.535 384L185.3 804.181a42.667 42.667 0 0 0 42.112 49.152h369.92v-128a42.667 42.667 0 1 1 85.334 0v128h113.877a42.667 42.667 0 0 0 42.155-49.152l-31.83-206.848H217.173z"
  }));
};

var SvgCloseIcon = function SvgCloseIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "close_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M723.2 783.53a42.667 42.667 0 0 0 60.33-60.33L572.33 512l211.2-211.2a42.667 42.667 0 0 0-60.33-60.33L512 451.67l-211.2-211.2a42.667 42.667 0 0 0-60.33 60.33L451.67 512l-211.2 211.2a42.667 42.667 0 1 0 60.33 60.33L512 572.33l211.2 211.2z"
  }));
};

var SvgCoinComingIcon = function SvgCoinComingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_coming_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M896 512a384 384 0 1 0-768 0 384 384 0 0 0 768 0zM512 42.667C771.2 42.667 981.333 252.8 981.333 512S771.2 981.333 512 981.333 42.667 771.2 42.667 512 252.8 42.667 512 42.667zM554.667 256a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 0 0 23.595 38.144l170.667 85.333a42.667 42.667 0 1 0 38.144-76.288l-147.072-73.557V256z"
  }));
};

var SvgCoinCountdownIcon = function SvgCoinCountdownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_countdown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a42.667 42.667 0 0 0 0 85.334H256v154.24a128 128 0 0 0 23.467 73.813l77.61 109.995a42.667 42.667 0 0 1 0 49.237l-77.653 109.995A128 128 0 0 0 256 741.76v111.573h-42.667a42.667 42.667 0 1 0 0 85.334h597.334a42.667 42.667 0 1 0 0-85.334H768V741.76a128 128 0 0 0-23.467-73.813l-77.61-109.995a42.667 42.667 0 0 1 0-49.237l77.653-109.995A128 128 0 0 0 768 324.907v-154.24h42.667a42.667 42.667 0 1 0 0-85.334H213.333zm469.334 85.334V256H341.333v-85.333h341.334zm-3.286 170.666a42.539 42.539 0 0 1-4.522 8.192L597.205 459.52a128 128 0 0 0 0 147.627l48.64 68.949h-267.69l48.64-68.95a128 128 0 0 0 0-147.626l-77.611-109.995a42.667 42.667 0 0 1-4.565-8.192H679.38zm3.286 420.096v91.904H341.333V761.43h341.334z"
  }));
};

var SvgCoinIneffectIcon = function SvgCoinIneffectIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_ineffect_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M840.619 254.976c8.277 2.133 12.8 9.088 12.714 15.573-.981 105.728-12.885 245.888-51.114 332.544-63.147 143.104-181.632 193.878-255.232 224.512l-1.579.683c-10.752 4.437-23.125 9.6-33.408 14.677l-14.336-7.381h-.043c-71.21-36.48-193.834-100.395-273.322-232.832-21.931-36.565-35.2-92.8-43.051-153.43-7.85-60.586-10.24-125.397-10.581-178.773a16.299 16.299 0 0 1 12.714-15.573l319.062-83.072a37.973 37.973 0 0 1 19.114 0l319.062 83.072zm-329.6 683.69 38.485-19.029c7.808-3.84 18.133-8.149 30.293-13.226 75.35-31.403 222.806-92.843 300.502-268.886 45.909-104.106 57.386-259.84 58.368-366.208a101.547 101.547 0 0 0-76.544-98.901L543.06 89.301a123.307 123.307 0 0 0-62.122 0l-319.062 83.115a101.632 101.632 0 0 0-76.544 98.688c.342 55.04 2.816 123.69 11.307 189.184 8.107 62.677 22.997 133.845 54.485 186.368C244.14 801.664 386.86 874.709 458.752 911.531l14.208 7.296 38.059 19.84zM712.02 353.025a42.667 42.667 0 0 1 1.622 60.33L511.317 626.689a42.667 42.667 0 0 1-61.909 0l-96.384-101.547a42.667 42.667 0 1 1 61.952-58.752l65.365 68.95 171.35-180.694a42.667 42.667 0 0 1 60.33-1.621z"
  }));
};

var SvgCoinProtectIcon = function SvgCoinProtectIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_protect_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M840.619 254.976c8.277 2.133 12.8 9.088 12.714 15.573-.981 105.728-12.885 245.888-51.114 332.544-63.147 143.104-181.632 193.878-255.232 224.512l-1.579.683c-10.752 4.437-23.125 9.6-33.408 14.677l-14.336-7.381h-.043c-71.21-36.48-193.834-100.395-273.322-232.832-21.931-36.565-35.2-92.8-43.051-153.43-7.85-60.586-10.24-125.397-10.581-178.773a16.299 16.299 0 0 1 12.714-15.573l319.062-83.072a37.973 37.973 0 0 1 19.114 0l319.062 83.072zm-329.6 683.69 38.485-19.029c7.808-3.84 18.133-8.149 30.293-13.226 75.35-31.403 222.806-92.843 300.502-268.886 45.909-104.106 57.386-259.84 58.368-366.208a101.547 101.547 0 0 0-76.544-98.901L543.06 89.301a123.307 123.307 0 0 0-62.122 0l-319.062 83.115a101.632 101.632 0 0 0-76.544 98.688c.342 55.04 2.816 123.69 11.307 189.184 8.107 62.677 22.997 133.845 54.485 186.368C244.14 801.664 386.86 874.709 458.752 911.531l14.208 7.296 38.059 19.84zm-41.686-256a42.667 42.667 0 1 0 85.334 0 42.667 42.667 0 1 0-85.334 0Zm42.667-384a42.667 42.667 0 0 1 42.667 42.667v213.334a42.667 42.667 0 1 1-85.334 0V341.333A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgCoinRemovedIcon = function SvgCoinRemovedIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_removed_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666V640a42.667 42.667 0 0 0 42.666 42.667H256A42.667 42.667 0 1 1 256 768h-42.667a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128V640a128 128 0 0 1-128 128H768a42.667 42.667 0 1 1 0-85.333h42.667A42.667 42.667 0 0 0 853.333 640V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zM298.667 384a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 384zM512 512a42.667 42.667 0 0 1 42.667 42.667v238.336l55.168-55.168a42.667 42.667 0 0 1 60.33 60.33l-128 128a42.667 42.667 0 0 1-60.33 0l-128-128a42.667 42.667 0 1 1 60.33-60.33l55.168 55.168V554.667A42.667 42.667 0 0 1 512 512z"
  }));
};

var SvgCoinWarnIcon = function SvgCoinWarnIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_warn_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M853.333 270.507a16.256 16.256 0 0 0-12.714-15.531l-319.062-83.03a37.973 37.973 0 0 0-19.114 0l-319.062 83.03a16.299 16.299 0 0 0-12.714 15.573c.341 53.376 2.73 118.187 10.581 178.774 7.85 60.629 21.12 116.864 43.093 153.429 79.446 132.437 202.07 196.352 273.28 232.832h.086L512 842.965c10.283-5.077 22.656-10.24 33.408-14.677l1.579-.683c73.6-30.634 192.085-81.408 255.232-224.512 38.229-86.656 50.133-226.816 51.114-332.544zm-303.786 649.13-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zm122.88-498.389a19.2 19.2 0 0 1 7.85 6.827 14.123 14.123 0 0 1-1.706 17.664L507.776 633.045a20.864 20.864 0 0 1-7.595 5.12 25.899 25.899 0 0 1-16.298.982 21.717 21.717 0 0 1-10.667-6.187 14.848 14.848 0 0 1-4.096-9.984V520.832H362.41a25.045 25.045 0 0 1-11.52-3.2 18.133 18.133 0 0 1-7.466-7.68 14.08 14.08 0 0 1 1.707-17.067l170.794-187.221a21.803 21.803 0 0 1 10.71-6.187c4.266-1.109 8.96-1.066 13.226.043 4.438 1.152 8.32 3.413 10.966 6.528a14.635 14.635 0 0 1 3.754 10.496v102.144h106.752c3.926 0 7.808.853 11.136 2.56z"
  }));
};

var SvgCommentIcon = function SvgCommentIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "comment_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 384a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 384zM810.667 85.333H213.333a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128H707.84l157.867 158.293A42.667 42.667 0 0 0 896 938.667a35.84 35.84 0 0 0 16.213-3.414A42.667 42.667 0 0 0 938.667 896V213.333a128 128 0 0 0-128-128zm42.666 707.84-97.706-98.133a42.667 42.667 0 0 0-30.294-12.373h-512A42.667 42.667 0 0 1 170.667 640V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v579.84zM341.333 384a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333zm341.334 0a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333z"
  }));
};

var SvgContinuousdrawingIcon = function SvgContinuousdrawingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "continuousdrawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M895.936 85.312h-512A42.688 42.688 0 0 0 341.248 128v170.688h-85.312a42.688 42.688 0 0 0-42.688 42.688V512h-85.312a42.688 42.688 0 0 0-42.688 42.688V896a42.688 42.688 0 0 0 42.688 42.688h341.312A42.688 42.688 0 0 0 511.936 896v-85.312H682.56A42.688 42.688 0 0 0 725.248 768v-85.312h170.688A42.688 42.688 0 0 0 938.56 640V128A42.688 42.688 0 0 0 896 85.312zm-469.376 768h-256v-256h256v256zm213.376-128h-128v-170.56A42.688 42.688 0 0 0 469.248 512H298.56V384H640v341.376zm213.312-128h-128v-256a42.688 42.688 0 0 0-42.688-42.624h-256v-128h426.688v426.688z"
  }));
};

var SvgCopyIcon = function SvgCopyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "copy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 85.333a128 128 0 0 0-128 128v128h-128a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128h341.334a128 128 0 0 0 128-128v-128h128a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H469.333zm341.334 512H469.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h341.334a42.667 42.667 0 0 1 42.666 42.666v341.334a42.667 42.667 0 0 1-42.666 42.666zM341.333 426.667v128a128 128 0 0 0 128 128h128v128a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V469.333a42.667 42.667 0 0 1 42.666-42.666h128z"
  }));
};

var SvgCopytradingIcon = function SvgCopytradingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "copytrading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M238.933 307.157a341.461 341.461 0 0 1 608.64 142.08 42.667 42.667 0 1 0 83.926-15.573C894.677 235.434 720.896 85.334 512 85.334a425.941 425.941 0 0 0-339.072 167.68l-3.157-18.945a42.667 42.667 0 0 0-84.182 14.08l20.822 124.416a42.667 42.667 0 0 0 49.109 35.072l124.459-20.821a42.667 42.667 0 1 0-14.08-84.181l-26.923 4.522zm-50.048 315.136a42.667 42.667 0 1 0-80.768 27.563C165.42 817.792 324.523 938.666 512 938.666c121.088 0 230.4-50.517 308.01-131.413l2.049 20.694a42.667 42.667 0 0 0 84.906-8.448l-12.501-125.867a42.667 42.667 0 0 0-46.72-38.23L721.92 667.948a42.667 42.667 0 1 0 8.448 84.906l26.027-2.56a341.504 341.504 0 0 1-567.51-128zm122.027 10.24a42.667 42.667 0 0 1-42.667-42.666A170.667 170.667 0 0 1 438.912 419.2a42.667 42.667 0 1 1 0 85.333 85.333 85.333 0 0 0-73.941 42.667h47.274l.256.341a42.667 42.667 0 0 1-5.589 84.95h-96zm170.667-282.709a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm192 32a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm-213.334 224a154.667 154.667 0 0 1 309.334 0v16a42.667 42.667 0 0 1-42.667 42.667h-224a42.667 42.667 0 0 1-42.667-42.667v-15.957zm218.667-26.667a69.376 69.376 0 0 0-128 0h128z"
  }));
};

var SvgCouponIcon = function SvgCouponIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coupon_icon_svg__icon",
    viewBox: "0 0 1066 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M149.333 213.333a64 64 0 0 0-64 64v128c0 37.12 29.227 59.563 54.272 65.28 22.059 5.078 35.712 22.998 35.712 41.387 0 18.39-13.653 36.31-35.712 41.387-25.045 5.674-54.272 28.16-54.272 65.28v128a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V597.419c0-23.638-19.2-42.752-42.752-42.752-28.416 0-47.402-21.248-47.402-42.667s18.986-42.667 47.36-42.667c23.68 0 42.794-19.114 42.794-42.752V277.333a64 64 0 0 0-64-64h-768zm21.334 177.494v-92.16h182.485v17.792a42.667 42.667 0 0 0 85.333 0v-17.792H896v92.16c-51.456 16.81-90.155 63.445-90.155 121.173S844.544 616.363 896 633.173v92.16H438.485v-17.792a42.667 42.667 0 1 0-85.333 0v17.792H170.667v-92.16C221.824 616.363 260.65 569.6 260.65 512s-38.827-104.363-89.984-121.173zm267.818 50.048a42.667 42.667 0 1 0-85.333 0v124.458a42.667 42.667 0 1 0 85.333 0V440.875z"
  }));
};

var SvgCrossIcon = function SvgCrossIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cross_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 655.147V896a42.667 42.667 0 1 0 85.334 0V655.147a149.675 149.675 0 0 0 100.48-100.48H896a42.667 42.667 0 1 0 0-85.334H655.147a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 1 0-85.334 0v240.853a149.675 149.675 0 0 0-100.48 100.48H128a42.667 42.667 0 1 0 0 85.334h240.853a149.675 149.675 0 0 0 100.48 100.48zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgCumulativeincomeIcon = function SvgCumulativeincomeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cumulativeincome_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M746.667 85.333a42.667 42.667 0 1 0 0 85.334h46.336l-128 128h-323.67a42.667 42.667 0 0 0-24.448 7.68L103.552 455.68a42.667 42.667 0 1 0 48.939 69.973L354.773 384h327.894a42.667 42.667 0 0 0 30.165-12.501l213.333-213.334A42.667 42.667 0 0 0 896 85.333H746.667zm149.333 256A42.667 42.667 0 0 1 938.667 384v512a42.667 42.667 0 1 1-85.334 0V384A42.667 42.667 0 0 1 896 341.333zM682.667 512a42.667 42.667 0 1 0-85.334 0v384a42.667 42.667 0 1 0 85.334 0V512zM384 554.667a42.667 42.667 0 0 1 42.667 42.666V896a42.667 42.667 0 1 1-85.334 0V597.333A42.667 42.667 0 0 1 384 554.667zM128 640a42.667 42.667 0 0 1 42.667 42.667V896a42.667 42.667 0 1 1-85.334 0V682.667A42.667 42.667 0 0 1 128 640z"
  }));
};

var SvgCutoverIcon = function SvgCutoverIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cutover_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M496.896 700.501a38.613 38.613 0 0 0-57.813 0l-79.147 85.931V385.365a42.667 42.667 0 0 0-85.333 0v398.55l-76.8-83.414a38.613 38.613 0 0 0-57.814 0 47.147 47.147 0 0 0 0 62.763l149.547 162.39a38.613 38.613 0 0 0 57.813 0l149.547-162.39a47.147 47.147 0 0 0 0-62.763zm387.285-376.746a38.23 38.23 0 0 1-57.514 0l-77.782-85.163v399.701a42.667 42.667 0 0 1-85.333 0V241.067l-75.435 82.645a38.23 38.23 0 0 1-57.557 0 47.616 47.616 0 0 1 0-63.019L678.613 98.56a38.23 38.23 0 0 1 57.558 0l148.053 162.133c15.872 17.408 15.872 45.654 0 63.019z"
  }));
};

var SvgDataIcon = function SvgDataIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "data_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M768 85.333H256A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm554.666 256A42.667 42.667 0 1 0 640 512v213.333a42.667 42.667 0 1 0 85.333 0V512zM512 256a42.667 42.667 0 0 1 42.667 42.667v426.666a42.667 42.667 0 1 1-85.334 0V298.667A42.667 42.667 0 0 1 512 256zM384 426.667a42.667 42.667 0 0 0-85.333 0v298.666a42.667 42.667 0 1 0 85.333 0V426.667z"
  }));
};

var SvgDateIcon = function SvgDateIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "date_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M810.667 170.667h-85.334V128A42.667 42.667 0 0 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128zm42.666 640a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V512h682.666v298.667zm0-384H170.667v-128A42.667 42.667 0 0 1 213.333 256h85.334v42.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 0 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v128z"
  }));
};

var SvgDepositIcon = function SvgDepositIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "deposit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M656 70.144a85.333 85.333 0 0 1 99.243 63.317l43.52 176.598a42.539 42.539 0 0 1-4.352 31.274h16.256A85.333 85.333 0 0 1 896 426.667v143.445h16.47a42.667 42.667 0 1 1 0 85.333H896v197.888a85.333 85.333 0 0 1-85.333 85.334H213.333A85.333 85.333 0 0 1 128 853.333V578.39a42.453 42.453 0 0 1-11.05-20.522L55.082 276.565a85.333 85.333 0 0 1 66.986-102.101L656 70.144zm154.667 499.968V426.667H213.333v426.666h597.334V655.445H616.576l42.581 41.643a42.667 42.667 0 0 1-59.69 61.013l-150.614-147.37 152.662-131.115a42.667 42.667 0 0 1 55.552 64.81l-29.995 25.729h183.595zm-94.72-239.659L672.427 153.9 138.41 258.219l22.272 101.29c14.506-11.392 32.81-18.176 52.65-18.176h506.88a42.837 42.837 0 0 1-4.309-10.88z"
  }));
};

var SvgDetailsIcon = function SvgDetailsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "details_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M192 320a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm64 192a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm128-512a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 256zm0 256a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 512zm42.667 298.667a42.667 42.667 0 1 1 0-85.334h426.666a42.667 42.667 0 1 1 0 85.334H426.667z"
  }));
};

var SvgDirectiondownIcon = function SvgDirectiondownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directiondown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M554.667 707.84 780.5 482.005a42.667 42.667 0 0 1 60.331 60.331L542.464 840.704a43.093 43.093 0 0 1-60.928 0L183.168 542.336a42.667 42.667 0 1 1 60.33-60.33L469.334 707.84V210.859c0-22.102 19.115-40.022 42.667-40.022s42.667 17.92 42.667 40.022V707.84z"
  }));
};

var SvgDirectionleftIcon = function SvgDirectionleftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionleft_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M316.245 469.419 542.08 243.584a42.667 42.667 0 1 0-60.33-60.33L183.38 481.62a43.093 43.093 0 0 0 0 60.928l298.37 298.369a42.667 42.667 0 0 0 60.331-60.33L316.245 554.752h496.982c22.101 0 40.021-19.115 40.021-42.667s-17.92-42.666-40.021-42.666H316.245z"
  }));
};

var SvgDirectionrightIcon = function SvgDirectionrightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionright_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M707.755 554.752 481.92 780.587a42.667 42.667 0 1 0 60.33 60.33L840.62 542.55a43.093 43.093 0 0 0 0-60.928L542.293 183.253a42.667 42.667 0 1 0-60.33 60.331l225.834 225.835H210.773c-22.101 0-40.021 19.114-40.021 42.666s17.92 42.667 40.021 42.667h496.982z"
  }));
};

var SvgDirectionupIcon = function SvgDirectionupIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionup_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M554.667 316.33 780.5 542.166a42.667 42.667 0 0 0 60.331-60.33L542.464 183.467a43.093 43.093 0 0 0-60.928 0L183.168 481.835a42.667 42.667 0 1 0 60.33 60.33l225.835-225.834v496.981c0 22.101 19.115 40.021 42.667 40.021s42.667-17.92 42.667-40.021V316.331z"
  }));
};

var SvgDiscordIcon = function SvgDiscordIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M20.857 5.384s-1.72-1.82-5.623-2.084v.575s2.141-.125 4.792 2.485C18.025 4.92 15.17 4.018 12 4.018c-3.17 0-6.025.902-8.026 2.342 2.651-2.61 4.792-2.485 4.792-2.485V3.3c-3.904.264-5.623 2.084-5.623 2.084C.168 9.216 0 17.599 0 17.599c2.802 3.378 6.323 2.947 6.323 2.947l1.294-1.869c-1.668-.45-2.86-1.487-3.575-2.293 1.997 1.411 4.823 2.293 7.958 2.293s5.96-.882 7.958-2.293c-.716.806-1.907 1.842-3.575 2.293l1.294 1.869s3.52.43 6.323-2.947c0 0-.168-8.383-3.143-12.215ZM8.264 15.228c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Zm7.473 0c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Z"
  }));
};

var SvgDisplayIcon = function SvgDisplayIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M1.984 4.5a1 1 0 0 1 1-1h18.032a1 1 0 1 1 0 2H2.984a1 1 0 0 1-1-1ZM1.984 11.325a1 1 0 0 1 1-1h5.295a1 1 0 1 1 0 2H2.984a1 1 0 0 1-1-1ZM2.984 17.649a1 1 0 1 0 0 2h5.295a1 1 0 1 0 0-2H2.984ZM16.333 16.458a1.379 1.379 0 1 0 0-2.757 1.379 1.379 0 0 0 0 2.757Z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M10.7 14.48a1.53 1.53 0 0 0 0 1.2 5.98 5.98 0 0 0 11.005.001 1.53 1.53 0 0 0 0-1.2 5.98 5.98 0 0 0-11.005 0Zm1.924.6a3.98 3.98 0 0 1 7.157.001 3.979 3.979 0 0 1-7.157 0Z"
  }));
};

var SvgDownload2Icon = function SvgDownload2Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M8.29 13.29a1 1 0 0 0 0 1.42l3 3a1.002 1.002 0 0 0 1.42 0l3-3a1.004 1.004 0 1 0-1.42-1.42L13 14.59V3a1 1 0 0 0-2 0v11.59l-1.29-1.3a1 1 0 0 0-1.42 0ZM18 9h-2a1 1 0 1 0 0 2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3Z"
  }));
};

var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "download_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m610.56 737.579-55.083 55.466V554.411a42.667 42.667 0 0 0-85.418 0v238.634l-55.083-55.466a42.88 42.88 0 0 0-60.672 60.586l128.128 128.128a42.667 42.667 0 0 0 14.08 8.96 40.107 40.107 0 0 0 32.47 0 42.667 42.667 0 0 0 14.08-8.96l128.127-128.085a42.837 42.837 0 1 0-60.586-60.63zm176.384-472.662a298.88 298.88 0 0 0-486.699-90.837 298.837 298.837 0 0 0-83.882 171.605 170.837 170.837 0 0 0-73.472 293.888 170.88 170.88 0 0 0 113.621 42.966 42.71 42.71 0 1 0 0-85.419 85.419 85.419 0 1 1 0-170.752 42.71 42.71 0 0 0 42.71-42.667 213.419 213.419 0 0 1 178.687-210.176 213.59 213.59 0 0 1 236.843 141.398 42.667 42.667 0 0 0 33.323 28.586 128.128 128.128 0 0 1 10.24 249.387 42.752 42.752 0 1 0 21.333 82.773 213.547 213.547 0 0 0 118.059-332.074 213.504 213.504 0 0 0-110.763-78.635z"
  }));
};

var SvgDragdropIcon = function SvgDragdropIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "dragdrop_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M384 298.667A85.333 85.333 0 1 0 384 128a85.333 85.333 0 0 0 0 170.667zm256 0A85.333 85.333 0 1 0 640 128a85.333 85.333 0 0 0 0 170.667zM469.333 512a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 597.333a85.333 85.333 0 1 0 0-170.666 85.333 85.333 0 0 0 0 170.666zM469.333 810.667a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 896a85.333 85.333 0 1 0 0-170.667A85.333 85.333 0 0 0 640 896z"
  }));
};

var SvgDrawingIcon = function SvgDrawingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "drawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M853.312 690.368V333.632a128 128 0 1 0-163.008-162.944H333.632a128 128 0 1 0-163.008 162.944v356.736a128 128 0 1 0 163.008 162.944h356.672a128 128 0 1 0 163.008-162.944zm-42.688-519.68a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm-597.312 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm0 682.624a42.624 42.624 0 1 1 0-85.248 42.624 42.624 0 0 1 0 85.248zM690.304 768H333.632A128 128 0 0 0 256 690.368V333.632A128 128 0 0 0 333.632 256h356.672A128.064 128.064 0 0 0 768 333.632v356.736A128 128 0 0 0 690.368 768zm120.32 85.312a42.688 42.688 0 1 1 0-85.312 42.688 42.688 0 0 1 0 85.312z"
  }));
};

var SvgEarnestMoneyIcon = function SvgEarnestMoneyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 6.34a.381.381 0 0 0-.298-.364L12.224 4.03a.89.89 0 0 0-.448 0L4.298 5.976A.382.382 0 0 0 4 6.341c.008 1.251.064 2.77.248 4.19.184 1.421.495 2.739 1.01 3.596 1.862 3.104 4.736 4.602 6.405 5.457h.002l.335.173c.241-.119.531-.24.783-.344l.037-.016c1.725-.718 4.502-1.908 5.982-5.262.896-2.031 1.175-5.316 1.198-7.794Zm-7.12 15.214-.903.446-.892-.465-.334-.171c-1.684-.863-5.029-2.575-7.209-6.208-.738-1.231-1.087-2.9-1.277-4.368C2.066 9.253 2.008 7.644 2 6.354A2.382 2.382 0 0 1 3.794 4.04l7.478-1.948a2.89 2.89 0 0 1 1.456 0l7.478 1.948A2.38 2.38 0 0 1 22 6.359c-.023 2.493-.292 6.144-1.368 8.583-1.82 4.126-5.277 5.566-7.042 6.301-.286.12-.528.22-.71.31ZM12 5.25a1 1 0 0 1 1 1v.875h.969a1 1 0 0 1 0 2h-2.953c-.161 0-.321.065-.444.191a.712.712 0 0 0-.197.496c0 .192.074.37.197.497a.618.618 0 0 0 .444.191h1.968c.71 0 1.385.29 1.877.797.492.506.764 1.187.764 1.89 0 .704-.272 1.385-.764 1.89a2.618 2.618 0 0 1-1.861.798v.875a1 1 0 1 1-2 0v-.875h-.969a1 1 0 0 1 0-2h2.953c.161 0 .321-.065.444-.191a.712.712 0 0 0 .197-.496.712.712 0 0 0-.197-.497.618.618 0 0 0-.444-.191h-1.968c-.71 0-1.385-.29-1.877-.797a2.712 2.712 0 0 1-.764-1.89c0-.704.272-1.385.764-1.89A2.618 2.618 0 0 1 11 7.124V6.25a1 1 0 0 1 1-1Z",
    clipRule: "evenodd"
  }));
};

var SvgEarningstodayIcon = function SvgEarningstodayIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "earningstoday_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 512a341.333 341.333 0 1 1 182.528 302.208 42.667 42.667 0 0 0-39.766 75.52A424.96 424.96 0 0 0 512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512c0 63.147 13.739 123.136 38.4 177.152a42.667 42.667 0 0 0 73.942 6.528l145.792-97.195 96.853 64.598a42.667 42.667 0 0 0 53.845-5.334l241.067-241.066a42.667 42.667 0 0 0-30.165-72.832H584.533a42.667 42.667 0 0 0 0 85.333h17.494L458.58 572.672l-91.434-60.97a42.667 42.667 0 0 0-47.36 0l-136.875 91.306A341.76 341.76 0 0 1 170.667 512z"
  }));
};

var SvgEarphoneIcon = function SvgEarphoneIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "earphone_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M258.56 247.637c34.304-43.818 102.57-76.97 253.44-76.97 150.912 0 219.179 33.152 253.44 76.97 33.195 42.496 43.477 105.216 45.013 195.2A128.043 128.043 0 0 0 682.667 570.88v95.573a128 128 0 0 0 84.181 120.32c-1.963 14.336-6.144 23.168-10.752 29.099-6.4 8.277-18.005 16.512-41.13 23.04-23.467 6.699-54.955 10.496-96.854 12.459-41.643 1.962-90.71 1.962-148.779 1.962a42.667 42.667 0 1 0 0 85.334h.854c57.045 0 108.074 0 151.893-2.048 43.776-2.048 83.157-6.23 116.181-15.574 33.366-9.429 63.787-25.173 85.248-52.906 17.878-23.04 26.582-50.475 29.056-80.768a128 128 0 0 0 86.102-120.918V570.88c0-37.717-16.427-72.107-43.094-95.744.299-1.92.427-3.84.427-5.803 0-101.888-6.656-201.728-63.36-274.261C773.76 119.765 671.36 85.333 512 85.333c-159.403 0-261.803 34.432-320.64 109.739C134.656 267.605 128 367.445 128 469.333c0 1.963.128 3.926.427 5.803a127.915 127.915 0 0 0-43.094 95.787v95.53a128 128 0 0 0 256 0V570.88a128.043 128.043 0 0 0-127.786-128c1.536-90.027 11.818-152.747 45.056-195.243zM256 570.88v95.53a42.667 42.667 0 0 1-85.333 0v-95.573a42.667 42.667 0 1 1 85.333 0zm562.005 137.515A42.667 42.667 0 0 1 768 666.453V570.88a42.667 42.667 0 0 1 85.333 0v95.573a42.667 42.667 0 0 1-35.328 41.984z"
  }));
};

var SvgEditIcon = function SvgEditIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "edit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M819.499 136.832a47.83 47.83 0 0 1 67.669 67.67l-396.97 396.97-90.24 22.57 22.57-90.24 396.97-396.97zm33.834-99.285a133.182 133.182 0 0 0-94.165 38.997L353.835 481.877a42.667 42.667 0 0 0-11.222 19.84l-42.666 170.667a42.667 42.667 0 0 0 51.754 51.712l170.667-42.667a42.624 42.624 0 0 0 19.797-11.221L947.5 264.875a133.163 133.163 0 0 0-94.166-227.328zm-640 47.786a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V512a42.667 42.667 0 1 0-85.334 0v298.667a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666H512a42.667 42.667 0 1 0 0-85.334H213.333z"
  }));
};

var SvgEmptyIcon = function SvgEmptyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "empty_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zM353.835 353.835a42.667 42.667 0 0 1 60.33 0L512 451.669l97.835-97.834a42.667 42.667 0 1 1 60.33 60.33L572.331 512l97.834 97.835a42.667 42.667 0 0 1-60.33 60.33L512 572.331l-97.835 97.834a42.667 42.667 0 0 1-60.33-60.33L451.669 512l-97.834-97.835a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgExchangeIcon = function SvgExchangeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "exchange_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M656.213 661.76h193.28A42.667 42.667 0 0 1 890.88 704v192a42.667 42.667 0 0 1-85.333 0v-75.52A426.667 426.667 0 0 1 85.333 512a42.667 42.667 0 1 1 85.334 0 341.333 341.333 0 0 0 587.946 235.093h-102.4a42.667 42.667 0 0 1 0-85.333zm-437.76-458.24A426.667 426.667 0 0 1 512 85.333 426.667 426.667 0 0 1 938.667 512a42.667 42.667 0 0 1-85.334 0 341.333 341.333 0 0 0-587.946-234.667h102.4a42.667 42.667 0 0 1 0 85.334h-192A42.667 42.667 0 0 1 133.12 320V128a42.667 42.667 0 0 1 85.333 0v75.52zM469.333 512a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 384a128 128 0 1 0 0 256 128 128 0 0 0 0-256z"
  }));
};

var SvgExitDrawingIcon = function SvgExitDrawingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "exit-drawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M151.723 430.165a85.333 85.333 0 0 1 20.053-31.616l269.91-269.952a178.176 178.176 0 1 1 251.989 251.947L423.68 650.496a85.333 85.333 0 0 1-31.616 20.053l-204.33 72.918C119.935 767.7 54.442 702.25 78.676 634.41l73.003-204.288zm80.341 28.715-72.96 204.288 204.288-73.003 269.952-269.952a92.843 92.843 0 0 0-131.328-131.285L232.106 458.88z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M390.997 199.125a42.667 42.667 0 0 1 60.331 0l156.587 156.587a42.667 42.667 0 0 1-60.331 60.33L390.997 259.457a42.667 42.667 0 0 1 0-60.33zM174.08 416.085a42.667 42.667 0 0 1 60.33 0l156.587 156.587a42.667 42.667 0 1 1-60.33 60.33L174.08 476.417a42.667 42.667 0 0 1 0-60.33zM721.664 512a42.667 42.667 0 0 1 42.667-42.667h89.002a85.333 85.333 0 0 1 85.334 85.334v309.632a85.333 85.333 0 0 1-85.334 85.333h-89.002a42.667 42.667 0 1 1 0-85.333h89.002V554.667h-89.002A42.667 42.667 0 0 1 721.664 512zm-51.499 55.168a42.667 42.667 0 0 1 0 60.33l-128 128a42.667 42.667 0 0 1-60.33-60.33l128-128a42.667 42.667 0 0 1 60.33 0z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M481.835 695.168a42.667 42.667 0 0 1 60.33 0l128 128a42.667 42.667 0 0 1-60.33 60.33l-128-128a42.667 42.667 0 0 1 0-60.33z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M469.333 725.333A42.667 42.667 0 0 1 512 682.667h213.333a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667z"
  }));
};

var SvgExpandIcon = function SvgExpandIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "expand_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M85.333 874.667A42.667 42.667 0 0 1 128 832h768a42.667 42.667 0 1 1 0 85.333H128a42.667 42.667 0 0 1-42.667-42.666zm292.48-213.334H896A42.667 42.667 0 1 0 896 576H377.813a149.675 149.675 0 0 0-100.48-100.48v-33.707a149.632 149.632 0 0 0 101.12-102.741l276.779-17.28a149.333 149.333 0 1 0-14.08-84.608l-264.064 16.512a149.419 149.419 0 0 0-291.755 44.97A149.376 149.376 0 0 0 192 441.814v33.707A149.419 149.419 0 0 0 234.667 768a149.419 149.419 0 0 0 143.146-106.667zm-79.146-42.666a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm0-320.299v.512a64 64 0 1 1 0-.512zM789.333 192a64 64 0 1 1 0 128 64 64 0 0 1 0-128z"
  }));
};

var SvgExtendIcon = function SvgExtendIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "extend_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zM512 298.667a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgEyeoffIcon = function SvgEyeoffIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "eyeoff_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M93.61 93.653a43.093 43.093 0 0 1 60.886 0l128.597 128.64c63.19-39.466 138.454-66.56 226.688-66.56 245.888 0 391.254 210.219 454.955 313.472a81.493 81.493 0 0 1 0 85.675c-31.445 50.944-82.773 127.915-156.245 192.853l121.77 121.728a43.05 43.05 0 1 1-60.885 60.886L739.115 800.128c-63.744 40.363-139.904 68.181-229.334 68.181-245.888 0-391.253-210.176-454.954-313.472a81.536 81.536 0 0 1 0-85.632c31.744-51.498 83.797-129.578 158.506-194.858L93.611 154.58a43.093 43.093 0 0 1 0-60.928zm181.25 242.134-3.584 3.072C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 62.635 0 117.803-17.493 166.059-44.714l-85.632-85.675a160.725 160.725 0 0 1-219.605-219.605l-95.787-95.744zm162.218 162.218a73.941 73.941 0 0 0 86.614 86.614l-86.614-86.614zm309.931 188.16 1.28-1.024C810.411 631.04 856.832 564.181 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-61.398 0-115.67 16.81-163.286 43.178l400.555 400.555z"
  }));
};

var SvgEyeonIcon = function SvgEyeonIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "eyeon_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M271.275 338.859C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 96.555 0 175.488-41.557 238.507-96.426C810.411 631.04 856.832 564.18 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-96.555 0-175.446 41.557-238.464 96.384zM125.355 512C190.293 406.741 313.94 238.208 509.78 238.208c-195.84 0-319.488 168.533-384.426 273.792zm-70.528-42.837c63.701-103.254 209.066-313.43 454.954-313.43s391.254 210.176 454.955 313.43a81.493 81.493 0 0 1 0 85.674c-63.701 103.254-209.067 313.43-454.955 313.43S118.528 658.09 54.827 554.795a81.536 81.536 0 0 1 0-85.632zm454.954-31.147a73.941 73.941 0 1 0 0 147.925 73.941 73.941 0 0 0 0-147.882zM349.013 512a160.725 160.725 0 1 1 321.451 0 160.725 160.725 0 0 1-321.45 0z"
  }));
};

var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M1.002 11.998a11.005 11.005 0 0 0 9.28 10.867v-7.688h-2.79v-3.179h2.794v-2.42a3.88 3.88 0 0 1 4.15-4.29c.826.014 1.65.087 2.464.22v2.705h-1.39a1.59 1.59 0 0 0-1.79 1.72v2.065h3.047l-.487 3.18h-2.56v7.687a11 11 0 0 0-2.291-21.85A11 11 0 0 0 1.002 11.998Z"
  }));
};

var SvgFiatdepositIcon = function SvgFiatdepositIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fiatdeposit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 512A341.333 341.333 0 0 1 568.96 175.36a42.667 42.667 0 0 0 14.08-84.139A429.355 429.355 0 0 0 512 85.333C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512c0-24.192-2.006-47.915-5.888-71.04a42.667 42.667 0 0 0-84.182 14.08A341.333 341.333 0 1 1 170.667 512zM640 213.333a42.667 42.667 0 1 0 0 85.334h85.333V384a42.667 42.667 0 1 0 85.334 0v-85.333H896a42.667 42.667 0 1 0 0-85.334h-85.333V128a42.667 42.667 0 1 0-85.334 0v85.333H640zM554.667 288a42.667 42.667 0 1 0-85.334 0v37.333a111.701 111.701 0 0 0-79.402 34.006 115.712 115.712 0 0 0-32.598 80.64c0 30.037 11.606 59.093 32.598 80.64a111.701 111.701 0 0 0 80.085 34.048h83.968c6.87 0 13.696 2.773 18.944 8.149a30.379 30.379 0 0 1 8.405 21.163c0 8.192-3.157 15.786-8.405 21.205a26.368 26.368 0 0 1-18.944 8.15H427.989a42.667 42.667 0 0 0 0 85.333h41.344V736a42.667 42.667 0 1 0 85.334 0v-37.333a111.701 111.701 0 0 0 79.402-34.006 115.712 115.712 0 0 0 32.598-80.64c0-30.037-11.606-59.093-32.598-80.64a111.701 111.701 0 0 0-80.085-34.048h-83.968a26.368 26.368 0 0 1-18.944-8.149 30.379 30.379 0 0 1-8.405-21.163c0-8.192 3.157-15.786 8.405-21.205a26.368 26.368 0 0 1 18.944-8.15h125.995a42.667 42.667 0 0 0 0-85.333h-41.344V288z"
  }));
};

var SvgFilterIcon = function SvgFilterIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "filter_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M46.635 110.08a42.667 42.667 0 0 1 38.698-24.747h853.334a42.667 42.667 0 0 1 32.597 70.23L640 547.243V896a42.667 42.667 0 0 1-61.739 38.144l-170.666-85.333A42.667 42.667 0 0 1 384 810.667V547.243L52.736 155.563a42.667 42.667 0 0 1-6.101-45.526zm130.645 60.587 281.984 333.397a42.667 42.667 0 0 1 10.07 27.563v252.672l85.333 42.666V531.627a42.667 42.667 0 0 1 10.069-27.563L846.72 170.667H177.28z"
  }));
};

var SvgFilterPressed1Icon = function SvgFilterPressed1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "filter_pressed1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M46.635 110.08a42.667 42.667 0 0 1 38.698-24.747h853.334a42.667 42.667 0 0 1 32.597 70.23L640 547.243V896a42.667 42.667 0 0 1-61.739 38.144l-170.666-85.333A42.667 42.667 0 0 1 384 810.667V547.243L52.736 155.563a42.667 42.667 0 0 1-6.101-45.526z"
  }));
};

var SvgFluctuationIcon = function SvgFluctuationIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fluctuation_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M406.997 298.667c17.11-.128 32.683 10.197 39.51 26.154L552.32 572.544l70.57-143.701a42.667 42.667 0 0 1 38.4-24.064 42.667 42.667 0 0 1 38.23 24.405l100.693 209.067h95.702c23.594 0 42.752 19.498 42.752 43.52 0 24.064-19.158 43.562-42.752 43.562H773.547a42.667 42.667 0 0 1-38.4-24.362l-74.411-154.539-72.875 148.395a42.667 42.667 0 0 1-39.381 24.021c-16.64-.427-31.445-10.667-38.059-26.155l-102.4-239.616-100.906 245.547c-6.656 16.213-22.187 26.71-39.424 26.71H128.085a43.136 43.136 0 0 1-42.752-43.52c0-24.065 19.158-43.52 42.752-43.52h111.147l128.64-312.918c6.613-16.085 22.016-26.581 39.125-26.71z"
  }));
};

var SvgFoldIcon = function SvgFoldIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fold_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M298.667 512a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 512zM85.333 256A170.667 170.667 0 0 1 256 85.333h512A170.667 170.667 0 0 1 938.667 256v512A170.667 170.667 0 0 1 768 938.667H256A170.667 170.667 0 0 1 85.333 768V256zM256 170.667A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h512A85.333 85.333 0 0 0 853.333 768V256A85.333 85.333 0 0 0 768 170.667H256z"
  }));
};

var SvgFollowersIcon = function SvgFollowersIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "followers_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M256 234.667a106.667 106.667 0 1 1 213.333 0 106.667 106.667 0 0 1-213.333 0zm106.667-192a192 192 0 1 0 0 384 192 192 0 0 0 0-384zm362.666 362.666a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 0 298.667 149.333 149.333 0 0 0 0-298.667zM128 789.333a234.667 234.667 0 1 1 469.333 0V896a42.667 42.667 0 1 0 85.334 0V789.333a106.667 106.667 0 0 1 213.333 0V896a42.667 42.667 0 1 0 85.333 0V789.333a192 192 0 0 0-328.49-135.04 320 320 0 0 0-610.176 135.04V896A42.667 42.667 0 1 0 128 896V789.333z"
  }));
};

var SvgFullscreenOffIcon = function SvgFullscreenOffIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fullscreen_off_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 426.667a42.667 42.667 0 0 1-42.666 42.666H256A42.667 42.667 0 1 1 256 384h67.67l-97.835-97.835a42.667 42.667 0 0 1 60.33-60.33L384 323.669V256a42.667 42.667 0 0 1 85.333 0v170.667zm97.92 140.373a42.539 42.539 0 0 1 30.08-12.373H768A42.667 42.667 0 1 1 768 640h-67.67l97.835 97.835a42.667 42.667 0 0 1-60.33 60.33L640 700.331V768a42.667 42.667 0 1 1-85.333 0V597.333a42.539 42.539 0 0 1 12.373-30.08l.213-.17z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M810.667 170.667a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
  }));
};

var SvgFullscreenOnIcon = function SvgFullscreenOnIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fullscreen_on_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 256A42.667 42.667 0 0 1 256 213.333h170.667a42.667 42.667 0 1 1 0 85.334h-67.67l97.835 97.834a42.667 42.667 0 0 1-60.33 60.331l-97.835-97.835v67.67a42.667 42.667 0 1 1-85.334 0V256zM798.08 798.293A42.539 42.539 0 0 1 768 810.667H597.333a42.667 42.667 0 1 1 0-85.334h67.67L567.168 627.5a42.667 42.667 0 0 1 60.33-60.331l97.835 97.835v-67.67a42.667 42.667 0 1 1 85.334 0V768a42.539 42.539 0 0 1-12.374 30.08l-.213.17zm12.587-627.626a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
  }));
};

var SvgGiftIcon = function SvgGiftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "gift_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M514.603 171.435C546.432 113.579 605.61 42.667 704 42.667A149.333 149.333 0 0 1 838.912 256h99.755a42.667 42.667 0 0 1 42.666 42.667V512a42.667 42.667 0 0 1-42.666 42.667H896v384a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 938.667v-384H85.333A42.667 42.667 0 0 1 42.667 512V298.667A42.667 42.667 0 0 1 85.333 256h99.755A149.333 149.333 0 0 1 320 42.667c98.39 0 157.568 70.912 189.397 128.768l2.603 4.821 2.603-4.821zm-45.27 169.898H128v128h341.333v-128zM454.571 256a350.208 350.208 0 0 0-19.968-43.435C407.765 163.755 370.944 128 320 128a64 64 0 0 0 0 128h134.57zm294.698-18.773A64 64 0 0 0 704 128c-50.944 0-87.765 35.755-114.603 84.565A350.208 350.208 0 0 0 569.43 256H704a64 64 0 0 0 45.227-18.773zM554.667 469.333H896v-128H554.667v128zm0 426.667h256V554.667h-256V896zm-85.334-341.333h-256V896h256V554.667z"
  }));
};

var SvgGithubIcon = function SvgGithubIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M12.01 1C18.078 1 23.017 5.958 23 12.09c0 4.904-3.153 9.053-7.528 10.523-.546.11-.747-.24-.747-.533 0-.367.018-1.56.018-3.048 0-1.047-.346-1.708-.747-2.057 2.46-.275 5.03-1.212 5.03-5.472 0-1.212-.419-2.203-1.13-2.974.11-.276.493-1.414-.109-2.938 0 0-.93-.294-3.026 1.138a10.588 10.588 0 0 0-2.752-.367c-.93 0-1.855.124-2.752.367C7.16 5.297 6.23 5.591 6.23 5.591c-.601 1.524-.219 2.662-.11 2.938a4.342 4.342 0 0 0-1.13 2.974c0 4.26 2.57 5.215 5.013 5.472-.31.276-.601.771-.693 1.488-.637.293-2.223.77-3.207-.919 0 0-.584-1.064-1.696-1.138 0 0-1.075 0-.073.68 0 0 .73.33 1.222 1.615 0 0 .637 1.983 3.7 1.322 0 .919.018 1.8.018 2.057 0 .294-.2.643-.747.532A11.082 11.082 0 0 1 1 12.091C1 5.958 5.921 1 12.01 1Z"
  }));
};

var SvgGlobeIcon = function SvgGlobeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "globe_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M406.187 187.392a341.717 341.717 0 0 0-232.918 281.941h127.872c9.686-100.821 45.995-197.418 104.96-281.941zm211.626 0c59.008 84.523 95.318 181.12 105.003 281.941h127.872a341.717 341.717 0 0 0-232.832-281.941zm19.2 281.941C625.536 368.085 582.4 271.275 512 190.293c-70.4 80.939-113.536 177.75-125.013 279.04h250.026zm-250.026 85.334C398.464 655.915 441.6 752.725 512 833.707c70.4-80.982 113.536-177.792 125.013-279.04H386.987zm-85.803 0H173.312a341.717 341.717 0 0 0 232.832 281.941c-58.965-84.523-95.275-181.12-104.917-281.941zm316.672 281.941a341.675 341.675 0 0 0 232.832-281.941H722.816c-9.685 100.821-45.995 197.418-104.96 281.941zM85.333 512C85.333 276.352 276.352 85.333 512 85.333S938.667 276.352 938.667 512 747.648 938.667 512 938.667 85.333 747.648 85.333 512z"
  }));
};

var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "google_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M964.352 426.837a42.667 42.667 0 0 0-41.984-35.072H520.533a42.667 42.667 0 0 0-42.666 42.667v165.035a42.667 42.667 0 0 0 42.666 42.666H689.58a155.973 155.973 0 0 1-48.256 50.646 215.893 215.893 0 0 1-120.79 33.536 210.56 210.56 0 0 1-198.229-146.688v-.086a209.237 209.237 0 0 1 0-135.125v-.085a210.603 210.603 0 0 1 198.23-146.603 186.795 186.795 0 0 1 133.589 51.925 42.667 42.667 0 0 0 59.69-.64l122.368-122.368a42.667 42.667 0 0 0-1.066-61.397A453.29 453.29 0 0 0 520.533 42.667a467.2 467.2 0 0 0-419.37 258.517l-.043.085A466.005 466.005 0 0 0 51.2 512a472.704 472.704 0 0 0 49.92 210.773l.043.043a467.2 467.2 0 0 0 419.37 258.517 449.11 449.11 0 0 0 311.254-114.645l.042-.043A460.203 460.203 0 0 0 972.8 521.728a536 536 0 0 0-8.448-94.89zM520.533 128a370.475 370.475 0 0 1 222.251 71.381l-62.037 61.995a275.755 275.755 0 0 0-160.214-48.981A293.845 293.845 0 0 0 264.96 363.86l-45.568-35.328-24.96-19.37A381.995 381.995 0 0 1 520.533 128zm-363.52 507.861a385.28 385.28 0 0 1 0-247.722l76.032 58.965a292.437 292.437 0 0 0 0 129.792l-76.074 58.965zM520.533 896A381.952 381.952 0 0 1 194.39 714.837l16.171-12.544 54.443-42.24a293.76 293.76 0 0 0 255.53 151.595 310.485 310.485 0 0 0 141.056-32.043l72.15 56.022A379.264 379.264 0 0 1 520.533 896zm278.443-117.76-7.808-6.101-58.752-45.611a239.19 239.19 0 0 0 59.733-119.253 42.667 42.667 0 0 0-41.984-50.475H563.2v-79.701h322.09a455.654 455.654 0 0 1 2.177 44.629 386.219 386.219 0 0 1-88.491 256.47z"
  }));
};

var SvgGuideIcon = function SvgGuideIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "guide_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M256 149.333a85.333 85.333 0 0 0-85.333 85.334v449.792c17.92-8.022 37.76-12.459 58.666-12.459h624V234.667A85.333 85.333 0 0 0 768 149.333H256zM229.333 960a144 144 0 0 1-143.53-132.352 43.05 43.05 0 0 1-.47-6.315V234.667A170.667 170.667 0 0 1 256 64h512a170.667 170.667 0 0 1 170.667 170.667v480A42.667 42.667 0 0 1 896 757.333H229.333a58.667 58.667 0 1 0 0 117.334H768A42.667 42.667 0 1 1 768 960H229.333z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M444.672 302.379c4.224-12.587 22.101-28.032 51.157-30.123 26.539-1.92 54.358 8.533 71.467 37.12 9.045 15.061 10.837 26.965 9.984 36.352-.896 9.813-5.12 20.01-12.8 30.55-16.128 21.93-43.648 39.68-64.683 48.725a38.4 38.4 0 1 0 30.251 70.613c28.715-12.33 69.461-37.248 96.341-73.941 13.824-18.774 24.832-41.942 27.35-68.822 2.56-27.306-4.011-55.381-20.566-82.986-34.048-56.747-91.605-77.952-142.933-74.24-48.81 3.541-101.29 31.104-118.443 82.474a38.4 38.4 0 0 0 72.875 24.32zM512.085 608a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333z"
  }));
};

var SvgHalfscreenOffIcon = function SvgHalfscreenOffIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "halfscreen_off_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M926.165 158.165 742.997 341.333h96.128a42.667 42.667 0 1 1 0 85.334H640A42.667 42.667 0 0 1 597.333 384V184.875a42.667 42.667 0 1 1 85.334 0v96.128L865.835 97.835a42.667 42.667 0 1 1 60.33 60.33zm-828.33 768a42.667 42.667 0 0 0 60.33 0l183.04-183.04v96.128a42.667 42.667 0 1 0 85.334 0V643.456a42.581 42.581 0 0 0-45.995-45.995H184.747a42.667 42.667 0 1 0 0 85.334h96.128l-183.04 183.04a42.667 42.667 0 0 0 0 60.33z"
  }));
};

var SvgHalfscreenOnIcon = function SvgHalfscreenOnIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "halfscreen_on_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m609.835 353.835 183.168-183.168h-96.128a42.667 42.667 0 1 1 0-85.334H896A42.667 42.667 0 0 1 938.667 128v199.125a42.667 42.667 0 1 1-85.334 0v-96.128L670.165 414.165a42.667 42.667 0 0 1-60.33-60.33zm-195.67 256a42.667 42.667 0 0 0-60.33 0l-183.04 183.04v-96.128a42.667 42.667 0 1 0-85.334 0v195.797a42.581 42.581 0 0 0 46.038 45.995h195.754a42.667 42.667 0 1 0 0-85.334h-96.085l183.04-183.04a42.667 42.667 0 0 0 0-60.33z"
  }));
};

var SvgHelpCircleSolidIcon = function SvgHelpCircleSolidIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "help_circle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zm7.168-638.762a85.333 85.333 0 0 0-94.89 55.765 42.667 42.667 0 1 1-80.513-28.288 170.667 170.667 0 0 1 331.648 56.832c0 65.28-48.426 108.416-82.986 131.456a343.723 343.723 0 0 1-71.936 36.224l-1.494.512-.426.17-.214.043h-.042l-.086.043a42.667 42.667 0 0 1-27.008-80.939l.683-.213a250.88 250.88 0 0 0 15.53-6.272c10.54-4.693 24.235-11.605 37.675-20.565 29.44-19.627 44.971-40.448 44.971-60.502v-.042a85.333 85.333 0 0 0-70.912-84.224zm-53.675 382.976a42.667 42.667 0 0 1 42.667-42.667h.427a42.667 42.667 0 1 1 0 85.333h-.427a42.667 42.667 0 0 1-42.667-42.666z"
  }));
};

var SvgHelpIcon = function SvgHelpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "help_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 213.333A42.667 42.667 0 0 1 512 682.667h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667zm-3.968-372.437a85.333 85.333 0 0 1 128.555 73.685v.086c0 20.053-15.573 40.874-45.013 60.501a258.133 258.133 0 0 1-53.163 26.795l-.683.256a42.667 42.667 0 0 0 27.008 80.938l-13.482-40.49c13.482 40.49 13.525 40.448 13.568 40.448h.042l.171-.086.47-.128 1.493-.512 4.949-1.834a343.467 343.467 0 0 0 66.987-34.39c34.56-23.04 82.944-66.133 82.986-131.456a170.667 170.667 0 0 0-331.648-56.874 42.667 42.667 0 0 0 80.47 28.33 85.333 85.333 0 0 1 37.29-45.226z"
  }));
};

var SvgHighindexIcon = function SvgHighindexIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "highindex_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 170.667a426.667 426.667 0 0 0-369.493 640A42.837 42.837 0 0 0 216.747 768a337.92 337.92 0 0 1-46.08-170.667A341.333 341.333 0 1 1 807.68 768a42.667 42.667 0 1 0 73.813 42.667 426.667 426.667 0 0 0-369.493-640zm121.173 245.76-66.133 65.706a124.16 124.16 0 0 0-55.04-12.8 128 128 0 1 0 128 128 123.733 123.733 0 0 0-12.8-54.613l66.133-65.707a42.752 42.752 0 0 0-30.08-72.96 42.667 42.667 0 0 0-30.08 12.374zM512 640a42.667 42.667 0 0 1 0-85.333 42.667 42.667 0 0 1 29.867 11.946 42.667 42.667 0 0 1 12.8 30.72A42.667 42.667 0 0 1 512 640z"
  }));
};

var SvgHomeIcon = function SvgHomeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M704 640H320v85.333h384V640zM559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301z"
  }));
};

var SvgHotkeyIcon = function SvgHotkeyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "hotkey_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M71.168 213.333A85.333 85.333 0 0 1 156.501 128h711.126a85.333 85.333 0 0 1 85.333 85.333v597.334A85.333 85.333 0 0 1 867.627 896H156.5a85.333 85.333 0 0 1-85.333-85.333V213.333zm796.459 0H156.5v597.334h711.126V213.333zm-568.96 227.584a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm0 170.667a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128-128a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM640 440.917a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zm42.667 128a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm-384-42.667a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667z"
  }));
};

var SvgIconCompassIcon = function SvgIconCompassIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "icon-compass_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M723.243 341.205a32 32 0 0 0-40.448-40.49l-271.36 90.453a32 32 0 0 0-20.267 20.267l-90.453 271.36a32 32 0 0 0 40.533 40.448l271.36-90.454a32 32 0 0 0 20.181-20.224l90.454-271.36zM381.696 642.304l65.152-195.456 195.456-65.152-65.152 195.413-195.456 65.195zM512 53.333C258.688 53.333 53.333 258.688 53.333 512S258.688 970.667 512 970.667 970.667 765.312 970.667 512 765.312 53.333 512 53.333zM117.333 512a394.667 394.667 0 1 1 789.334 0 394.667 394.667 0 0 1-789.334 0z"
  }));
};

var SvgImportIcon = function SvgImportIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "import_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M786.944 307.627a298.88 298.88 0 0 0-486.699-90.88 298.837 298.837 0 0 0-83.882 171.52A170.837 170.837 0 0 0 142.89 682.24a170.837 170.837 0 0 0 113.621 42.923 42.667 42.667 0 1 0 0-85.376 85.419 85.419 0 0 1 0-170.795 42.667 42.667 0 0 0 42.71-42.667A213.419 213.419 0 0 1 622.207 243.5a213.461 213.461 0 0 1 92.587 114.048 42.667 42.667 0 0 0 33.28 28.586 128.128 128.128 0 0 1 79.701 201.387c-17.067 23.381-41.557 40.277-69.461 48a42.795 42.795 0 0 0 21.333 82.773 213.547 213.547 0 0 0 118.06-332.074 213.504 213.504 0 0 0-110.763-78.592zm-243.84 216.49a42.667 42.667 0 0 0-14.08-8.96c-10.41-4.266-22.101-4.266-32.47 0a42.667 42.667 0 0 0-14.08 8.96l-128.17 128.086a42.88 42.88 0 1 0 60.672 60.586l55.083-55.466v238.634a42.667 42.667 0 1 0 85.418 0V657.323l55.083 55.466a42.752 42.752 0 0 0 69.973-13.866 42.624 42.624 0 0 0-9.344-46.72L543.104 524.117z"
  }));
};

var SvgIndicatorsIcon = function SvgIndicatorsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M3 2a1 1 0 0 1 1 1v17h17a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M20.155 6.745a1 1 0 0 1 .1 1.41l-1.16 1.339a2.686 2.686 0 0 1-3.259 3.742l-2.086 2.417a1 1 0 0 1-1.502.014L9.196 12.26l-2.459 2.683a1 1 0 0 1-1.474-1.352l3.205-3.496a1 1 0 0 1 1.482.008l3.029 3.382 1.331-1.544a2.686 2.686 0 0 1 3.293-3.78l1.142-1.316a1 1 0 0 1 1.41-.1Zm-3.766 4.56a.686.686 0 1 0-.26-.22 1.012 1.012 0 0 1 .26.22Z"
  }));
};

var SvgInformationdisclosureIcon = function SvgInformationdisclosureIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "informationdisclosure_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M426.667 341.333h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0 0 85.333zM341.333 512h341.334a42.667 42.667 0 0 0 0-85.333H341.333a42.667 42.667 0 0 0 0 85.333zm0 170.667h341.334a42.667 42.667 0 0 0 0-85.334H341.333a42.667 42.667 0 0 0 0 85.334zm512-597.334H170.667A42.667 42.667 0 0 0 128 128v768a42.667 42.667 0 0 0 68.267 34.133L284.587 864l87.893 66.133a42.667 42.667 0 0 0 51.2 0L512 864l88.32 66.133a42.667 42.667 0 0 0 51.2 0L739.413 864l88.32 66.133a42.667 42.667 0 0 0 61.867-11.818A42.667 42.667 0 0 0 896 896V128a42.667 42.667 0 0 0-42.667-42.667zm-42.666 725.334-45.654-34.134a42.667 42.667 0 0 0-51.2 0l-87.893 66.134-88.32-66.134a42.667 42.667 0 0 0-51.2 0l-88.32 66.134-87.893-66.134a42.667 42.667 0 0 0-51.2 0l-45.654 34.134v-640h597.334v640z"
  }));
};

var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15Zm5-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.94 2.24a7.51 7.51 0 0 0-.48-2.5 5.56 5.56 0 0 0-3.2-3.2 7.51 7.51 0 0 0-2.5-.48C14.79 2 14.47 2 12 2c-2.47 0-2.79 0-3.76.06a7.51 7.51 0 0 0-2.5.48 5.56 5.56 0 0 0-3.2 3.2 7.51 7.51 0 0 0-.48 2.5C2 9.22 2 9.54 2 12s0 2.78.06 3.76c.017.855.179 1.7.48 2.5a5.56 5.56 0 0 0 3.2 3.2 7.51 7.51 0 0 0 2.5.48c1 0 1.29.06 3.76.06 2.47 0 2.79 0 3.76-.06a7.51 7.51 0 0 0 2.5-.48 5.56 5.56 0 0 0 3.2-3.2 7.51 7.51 0 0 0 .48-2.5c0-1 .06-1.3.06-3.76s0-2.78-.06-3.76Zm-2 7.43a6 6 0 0 1-.35 1.86 3.4 3.4 0 0 1-.82 1.25 3.26 3.26 0 0 1-1.25.81 5.75 5.75 0 0 1-1.87.36c-.94 0-1.23.05-3.66.05H8.34a6 6 0 0 1-1.87-.35 3.4 3.4 0 0 1-1.25-.82 3.26 3.26 0 0 1-.81-1.25 5.74 5.74 0 0 1-.36-1.86V8.38a5.86 5.86 0 0 1 .36-1.87 3.3 3.3 0 0 1 .81-1.24 3.26 3.26 0 0 1 1.25-.81 5.75 5.75 0 0 1 1.87-.36C9.28 4 9.57 4 12 4h3.66a5.87 5.87 0 0 1 1.88.36 3.3 3.3 0 0 1 1.24.81c.363.349.64.776.81 1.25A5.74 5.74 0 0 1 20 8.33c0 1 .05 1.25.05 3.67S20 14.71 20 15.67h-.06Z"
  }));
};

var SvgJobmanagementIcon = function SvgJobmanagementIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "jobmanagement_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M320 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v79.659h45.44A146.56 146.56 0 0 1 896 439.595a42.667 42.667 0 1 1-85.333 0c0-33.835-27.435-61.27-61.227-61.27H256a85.333 85.333 0 0 0-85.333 85.334V768A85.333 85.333 0 0 0 256 853.333h128.299a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V463.659A170.667 170.667 0 0 1 256 292.992h64v-79.659zm298.667 0A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666v79.659h213.334v-79.659zM486.955 672l62.336-107.947a106.667 106.667 0 0 1 92.373-53.333h124.715a106.667 106.667 0 0 1 92.373 53.333L921.131 672a106.667 106.667 0 0 1 0 106.667l-62.379 107.989a106.667 106.667 0 0 1-92.373 53.333H641.707a106.667 106.667 0 0 1-92.374-53.333L487.04 778.709a106.667 106.667 0 0 1 0-106.666zm73.898 42.667a21.333 21.333 0 0 0 0 21.333l62.336 107.99a21.333 21.333 0 0 0 18.475 10.666h124.715a21.333 21.333 0 0 0 18.474-10.667l62.336-107.946a21.333 21.333 0 0 0 0-21.334l-62.293-108.032a21.333 21.333 0 0 0-18.517-10.666H641.707a21.333 21.333 0 0 0-18.475 10.666l-62.293 107.99zM704 789.333a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM341.333 512A42.667 42.667 0 1 0 256 512v128a42.667 42.667 0 1 0 85.333 0V512z"
  }));
};

var SvgKlineEntranceAppIcon = function SvgKlineEntranceAppIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "kline_entrance_app_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M480 85.333a42.667 42.667 0 1 1 85.333 0v85.334c0 .853 0 1.621-.085 2.432A120.32 120.32 0 0 1 661.333 290.9v442.2a120.32 120.32 0 0 1-96.085 117.8 41.813 41.813 0 0 1 .085 2.432v85.334a42.667 42.667 0 1 1-85.333 0v-85.334c0-.853 0-1.621.085-2.432A120.32 120.32 0 0 1 384 733.1V290.9a120.32 120.32 0 0 1 96.085-117.8 41.728 41.728 0 0 1-.085-2.432V85.333zM504.235 256a34.901 34.901 0 0 0-34.902 34.901V733.1c0 19.285 15.616 34.901 34.902 34.901h36.864A34.901 34.901 0 0 0 576 733.099V290.9a34.901 34.901 0 0 0-34.901-34.9h-36.864zM160 170.667a42.667 42.667 0 0 1 85.333 0V256c0 .853 0 1.621-.085 2.432a120.32 120.32 0 0 1 96.085 117.803v271.53a120.32 120.32 0 0 1-96.085 117.803l.085 2.432v85.333a42.667 42.667 0 1 1-85.333 0V768c0-.853 0-1.621.085-2.432A120.32 120.32 0 0 1 64 647.765v-271.53a120.32 120.32 0 0 1 96.085-117.803A43.307 43.307 0 0 1 160 256v-85.333zm24.235 170.666a34.901 34.901 0 0 0-34.902 34.902v271.53c0 19.286 15.616 34.902 34.902 34.902h36.864A34.901 34.901 0 0 0 256 647.765v-271.53a34.901 34.901 0 0 0-34.901-34.902h-36.864zm770.389 163.03-87.467 118.016a27.947 27.947 0 0 1-44.757 0l-87.467-118.016a27.136 27.136 0 0 1-5.333-16.171c0-15.104 12.416-27.392 27.733-27.392h174.934a27.903 27.903 0 0 1 16.384 5.29c12.373 8.96 15.018 26.07 5.973 38.273z"
  }));
};

var SvgKtvAreaIcon = function SvgKtvAreaIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_area_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M806.272 163.925a42.667 42.667 0 0 1 64.256 56.192l-134.4 153.6A42.667 42.667 0 0 1 704 388.267h-96L467.072 546.73a42.667 42.667 0 0 1-59.179 4.437l-85.333-71.04-126.037 126.037a42.667 42.667 0 0 1-60.331-60.33l153.6-153.6a42.667 42.667 0 0 1 57.472-2.603l83.456 69.547 126.165-141.91a42.667 42.667 0 0 1 31.915-14.336h95.83l121.642-139.008zm18.432 167.296a42.667 42.667 0 0 1 75.563 27.179v460.8a42.667 42.667 0 0 1-42.667 42.667H166.4a42.667 42.667 0 0 1-42.667-42.667v-80.64a42.667 42.667 0 0 1 14.422-32l167.594-147.84a42.667 42.667 0 0 1 58.496 1.963l74.454 75.05 179.157-180.65a42.667 42.667 0 0 1 30.293-12.63H732.8l91.904-111.232zm-9.77 145.792L785.748 512.3a42.667 42.667 0 0 1-32.853 15.488h-1.28l63.317 74.24V477.013zM605.78 588.416l151.851 188.16h57.301v-43.179L651.648 542.165l-45.867 46.251zM499.627 695.509l64.341 77.184a47.072 47.072 0 0 1 2.859 3.84h81.152L545.323 649.387l-45.654 46.08zm-203.819-14.208 76.16 91.392c1.067 1.238 2.005 2.56 2.859 3.84h81.28l-34.134-40.96a42.667 42.667 0 0 1-13.568-9.216l-76.373-77.013-36.224 31.957zm-86.741 76.459v18.773h55.04l-32.299-38.826-22.741 20.053z"
  }));
};

var SvgKtvBarsIcon = function SvgKtvBarsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_bars_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M725.333 85.333A42.667 42.667 0 0 1 768 128v469.333h85.333a42.667 42.667 0 1 1 0 85.334H768v128a42.667 42.667 0 1 1-85.333 0V341.333h-85.334a42.667 42.667 0 1 1 0-85.333h85.334V128a42.667 42.667 0 0 1 42.666-42.667zm-426.666 85.334A42.667 42.667 0 0 0 256 213.333v512h-85.333a42.667 42.667 0 1 0 0 85.334H256V896a42.667 42.667 0 1 0 85.333 0V469.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334V213.333a42.667 42.667 0 0 0-42.666-42.666z"
  }));
};

var SvgKtvBaselineIcon = function SvgKtvBaselineIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_baseline_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M462.336 213.333a42.667 42.667 0 0 1 38.101 24.406l119.68 252.928h-94.464L460.8 353.536l-36.821 73.6a42.667 42.667 0 0 1-74.24 3.627l-6.528-10.368-38.4 70.272h-97.28l95.658-175.019a42.667 42.667 0 0 1 73.558-2.219l4.821 7.68 42.112-84.181a42.667 42.667 0 0 1 38.656-23.595zm252.16 476.928-33.835-71.594H586.24l89.77 189.781a42.667 42.667 0 0 0 77.185-.085l89.429-189.696h-94.336l-33.75 71.594zm-576.81-71.594h97.28l-69.462 127.146a42.667 42.667 0 0 1-74.88-40.96l47.104-86.186zm670.975-128h94.294l31.701-67.158a42.667 42.667 0 0 0-77.227-36.352l-48.768 103.51zm-642.346 29.866H93.867V588.8h72.405v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0H550.57V588.8h76.544v-68.267zm153.6 0H704.17V588.8h76.544v-68.267zm149.461 0h-72.405V588.8h72.362v-68.267z"
  }));
};

var SvgKtvCandlesIcon = function SvgKtvCandlesIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_candles_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M362.667 128a42.667 42.667 0 0 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25v341.334a128 128 0 0 0 106.666 126.25V896a42.667 42.667 0 1 0 85.334 0v-87.083a128 128 0 0 0 106.666-126.25V341.333a128 128 0 0 0-106.666-126.25V128zm-21.334 597.333h-42.666A42.667 42.667 0 0 1 256 682.667V341.333a42.667 42.667 0 0 1 42.667-42.666h42.666A42.667 42.667 0 0 1 384 341.333v341.334a42.667 42.667 0 0 1-42.667 42.666zm405.334-512a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25V640a128 128 0 0 0 106.666 126.25v87.083a42.667 42.667 0 1 0 85.334 0v-87.082A128 128 0 0 0 853.333 640V426.667a128 128 0 0 0-106.666-126.251v-87.083zm-21.334 469.334h-42.666A42.667 42.667 0 0 1 640 640V426.667A42.667 42.667 0 0 1 682.667 384h42.666A42.667 42.667 0 0 1 768 426.667V640a42.667 42.667 0 0 1-42.667 42.667z"
  }));
};

var SvgKtvHeikinashiIcon = function SvgKtvHeikinashiIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_heikinashi_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M704 85.333A42.667 42.667 0 0 1 746.667 128v87.083a128 128 0 0 1 106.666 126.25v213.334a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V341.333a128 128 0 0 1 106.666-126.25V128A42.667 42.667 0 0 1 704 85.333zm21.333 213.334h-42.666A42.667 42.667 0 0 0 640 341.333v213.334a42.667 42.667 0 0 0 42.667 42.666h42.666A42.667 42.667 0 0 0 768 554.667V341.333a42.667 42.667 0 0 0-42.667-42.666zM320 128a42.667 42.667 0 0 1 42.667 42.667v87.082A128 128 0 0 1 469.333 384v384a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V384a128 128 0 0 1 106.666-126.25v-87.083A42.667 42.667 0 0 1 320 128zm21.333 213.333h-42.666A42.667 42.667 0 0 0 256 384v384a42.667 42.667 0 0 0 42.667 42.667h42.666A42.667 42.667 0 0 0 384 768V384a42.667 42.667 0 0 0-42.667-42.667z"
  }));
};

var SvgKtvHollowcandlesIcon = function SvgKtvHollowcandlesIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_hollowcandles_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M362.667 128a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25v341.334a128 128 0 0 0 106.666 126.25V896a42.667 42.667 0 1 0 85.334 0v-87.083a128 128 0 0 0 106.666-126.25V341.333a128 128 0 0 0-106.666-126.25V128zm-21.334 597.333h-42.666a42.667 42.667 0 0 1-11.648-1.621L384 669.867v12.8a42.667 42.667 0 0 1-42.667 42.666zm-85.333-384a42.667 42.667 0 0 1 42.667-42.666h42.666a42.667 42.667 0 0 1 11.648 1.621L256 354.133v-12.8zm128 39.339v43.179l-128 76.8v-48.896l128-71.083zM256 643.328v-43.179l128-76.8v48.896l-128 71.083zm490.667-429.995a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25V640a128 128 0 0 0 106.666 126.25v87.083a42.667 42.667 0 1 0 85.334 0v-87.082A128 128 0 0 0 853.333 640V426.667a128 128 0 0 0-106.666-126.251v-87.083zm-21.334 469.334h-42.666A42.667 42.667 0 0 1 640 640V426.667A42.667 42.667 0 0 1 682.667 384h42.666A42.667 42.667 0 0 1 768 426.667V640a42.667 42.667 0 0 1-42.667 42.667z"
  }));
};

var SvgKtvLineIcon = function SvgKtvLineIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_line_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M924.33 309.461a42.667 42.667 0 0 1 3.542 60.203l-170.667 192A42.667 42.667 0 0 1 725.333 576H593.664L414.165 755.499a42.667 42.667 0 0 1-62.933-2.859l-76.8-92.117-116.267 116.309a42.667 42.667 0 0 1-60.33-60.33l149.333-149.334a42.667 42.667 0 0 1 62.933 2.859l76.8 92.117 158.934-158.976A42.667 42.667 0 0 1 576 490.667h130.133l157.995-177.664a42.667 42.667 0 0 1 60.203-3.542z"
  }));
};

var SvgLabelUpgradeIcon = function SvgLabelUpgradeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "label_upgrade_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m536.661 94.976 392.534 395.093a33.024 33.024 0 0 1 6.954 35.755 32.768 32.768 0 0 1-30.25 20.224H728.747v196.053a65.707 65.707 0 0 1-65.622 65.622H363.904A65.707 65.707 0 0 1 298.24 742.1V546.133H118.23a32.853 32.853 0 0 1-23.297-56.064L490.155 94.976a32.768 32.768 0 0 1 46.506 0zM298.667 853.333a42.667 42.667 0 1 0 0 85.334h426.666a42.667 42.667 0 1 0 0-85.334H298.667z"
  }));
};

var SvgLayerIcon = function SvgLayerIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "layer_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M897.877 255.275c80.64 24.576 80.64 138.752 0 163.285L549.291 524.672a128 128 0 0 1-74.582 0L126.165 418.56c-80.64-24.533-80.64-138.71 0-163.285l348.587-106.07a128 128 0 0 1 74.581 0l348.587 106.07zm-24.832 81.664L524.46 230.827a42.667 42.667 0 0 0-24.875 0l-348.63 106.112 348.587 106.069a42.667 42.667 0 0 0 24.875 0l348.63-106.07z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M949.76 522.07a42.667 42.667 0 0 1-27.008 53.973L552.491 699.435a128 128 0 0 1-80.939 0L101.291 576.043a42.667 42.667 0 1 1 26.965-80.982l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M949.76 698.581a42.667 42.667 0 0 1-27.008 53.974L552.491 875.989a128 128 0 0 1-80.982 0L101.248 752.555a42.667 42.667 0 1 1 27.008-80.939l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
  }));
};

var SvgLevelIcon = function SvgLevelIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "level_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M448 512a64 64 0 1 0 128 0 64 64 0 0 0-128 0zm-79.147 42.667H85.333a42.667 42.667 0 1 1 0-85.334h283.52a149.419 149.419 0 0 1 286.294 0h283.52a42.667 42.667 0 1 1 0 85.334h-283.52a149.419 149.419 0 0 1-286.294 0z"
  }));
};

var SvgLine1Icon = function SvgLine1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM106.667 768a21.333 21.333 0 0 0 0 42.667h810.666a21.333 21.333 0 0 0 0-42.667H106.667z"
  }));
};

var SvgLine2Icon = function SvgLine2Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_2_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM128 768a42.667 42.667 0 1 0 0 85.333h768A42.667 42.667 0 1 0 896 768H128z"
  }));
};

var SvgLineBoldIcon = function SvgLineBoldIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_bold_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM138.667 768a53.333 53.333 0 1 0 0 106.667h746.666a53.333 53.333 0 1 0 0-106.667H138.667z"
  }));
};

var SvgLineDottedIcon = function SvgLineDottedIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_dotted_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M289.579 397.568a86.825 86.825 0 0 1 18.56-28.075L540.672 133.12c58.197-59.093 154.667-67.499 219.136-1.963a161.536 161.536 0 0 1 0 225.835l-.128.128-232.533 235.392c-9.131 9.173-20.054 16.17-32.171 20.48l-162.048 58.155a85.163 85.163 0 0 1-91.307-22.443 88.576 88.576 0 0 1-16.81-93.867l64.768-157.226zm79.445 33.792-19.925 48.341-44.8 108.886 109.525-39.254 52.48-18.858 232.619-235.35a72.96 72.96 0 0 0 0-102.058c-27.734-28.16-69.547-26.24-97.28 1.962L369.024 431.403zM128 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H128zm213.333 0a42.667 42.667 0 1 0 0 85.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334zM512 810.667A42.667 42.667 0 0 1 554.667 768H640a42.667 42.667 0 1 1 0 85.333h-85.333A42.667 42.667 0 0 1 512 810.667zM768 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H768z"
  }));
};

var SvgLinePointIcon = function SvgLinePointIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_point_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM128 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 128 768zm128 0a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 256 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM768 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 768 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0z"
  }));
};

var SvgLinkIcon = function SvgLinkIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "link_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M516.693 656.64 351.147 822.187a107.52 107.52 0 0 1-149.334 0 105.387 105.387 0 0 1 0-149.334L367.36 507.307a42.837 42.837 0 0 0-60.587-60.587L141.227 612.693a191.147 191.147 0 0 0 270.08 270.08L577.28 717.227a42.837 42.837 0 1 0-60.587-60.587zm366.08-515.413a191.573 191.573 0 0 0-270.08 0L446.72 306.773a42.837 42.837 0 1 0 60.587 60.587l165.546-165.547a107.52 107.52 0 0 1 149.334 0 105.387 105.387 0 0 1 0 149.334L656.64 516.693a42.539 42.539 0 0 0-9.344 46.72c2.133 5.163 5.333 9.899 9.344 13.867a42.667 42.667 0 0 0 60.587 0l165.546-165.973a191.573 191.573 0 0 0 0-270.08zM376.747 647.253a42.581 42.581 0 0 0 30.293 12.374 42.667 42.667 0 0 0 30.293-12.374l209.92-209.92a42.837 42.837 0 0 0-60.586-60.586l-209.92 209.92a42.624 42.624 0 0 0 0 60.586z"
  }));
};

var SvgLinkinIcon = function SvgLinkinIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M2 7.714h3.81V22H2V7.714ZM3.893 5.81h-.02C2.734 5.81 2 4.962 2 3.904 2 2.823 2.758 2 3.915 2c1.16 0 1.873.823 1.895 1.904 0 1.058-.736 1.906-1.917 1.906ZM22 12.952a5.238 5.238 0 0 0-5.238-5.238 5.229 5.229 0 0 0-4.286 2.233V7.714h-3.81V22h3.81v-7.619a2.857 2.857 0 1 1 5.714 0V22H22v-9.048Z"
  }));
};

var SvgListIcon = function SvgListIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "list_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M85.333 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.666a42.667 42.667 0 0 0-42.666 42.666v128A42.667 42.667 0 0 0 213.333 384h128A42.667 42.667 0 0 0 384 341.333v-128a42.667 42.667 0 0 0-42.667-42.666h-128zm-128 512a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.667a42.667 42.667 0 0 0-42.666 42.667v128a42.667 42.667 0 0 0 42.666 42.666h128A42.667 42.667 0 0 0 384 810.667v-128A42.667 42.667 0 0 0 341.333 640h-128zm341.334-469.333A42.667 42.667 0 0 1 597.333 128H896a42.667 42.667 0 1 1 0 85.333H597.333a42.667 42.667 0 0 1-42.666-42.666zm0 469.333a42.667 42.667 0 0 1 42.666-42.667H896a42.667 42.667 0 1 1 0 85.334H597.333A42.667 42.667 0 0 1 554.667 640zm42.666-298.667a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H597.333zm-42.666 512a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 896H597.333a42.667 42.667 0 0 1-42.666-42.667z"
  }));
};

var SvgLoadingIcon = function SvgLoadingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "loading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M373.077 200.235a341.333 341.333 0 1 1-202.41 311.978v-35.328a42.667 42.667 0 0 0-85.334 0v35.328a426.71 426.71 0 0 0 784.598 232.022 426.667 426.667 0 0 0-531.584-621.952 42.667 42.667 0 0 0 34.73 77.952z"
  }));
};

var SvgLockIcon = function SvgLockIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "lock_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M341.333 341.333V384h341.334v-42.667a170.667 170.667 0 0 0-341.334 0zM256 384v-42.667a256 256 0 1 1 512 0V384h42.667a128 128 0 0 1 128 128v298.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V512a128 128 0 0 1 128-128H256zm-42.667 85.333A42.667 42.667 0 0 0 170.667 512v298.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V512a42.667 42.667 0 0 0-42.666-42.667H213.333zm341.334 197.035v58.965a42.667 42.667 0 1 1-85.334 0v-58.965a64 64 0 1 1 85.334 0z"
  }));
};

var SvgLogOutIcon = function SvgLogOutIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "log-out_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M371.499 755.499a42.667 42.667 0 0 1-60.331 0L97.835 542.165a42.667 42.667 0 0 1 0-60.33L311.168 268.5a42.667 42.667 0 0 1 60.33 60.331L188.332 512 371.5 695.168a42.667 42.667 0 0 1 0 60.33z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M682.667 512A42.667 42.667 0 0 1 640 554.667H128a42.667 42.667 0 1 1 0-85.334h512A42.667 42.667 0 0 1 682.667 512z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M810.667 853.333a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H640a42.667 42.667 0 1 1 0-85.334h170.667a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H640a42.667 42.667 0 1 1 0-85.334h170.667z"
  }));
};

var SvgLowindexIcon = function SvgLowindexIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "lowindex_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 170.667a426.667 426.667 0 0 1 369.493 640A42.795 42.795 0 0 1 807.253 768a337.92 337.92 0 0 0 46.08-170.667A341.333 341.333 0 1 0 216.32 768a42.667 42.667 0 1 1-73.813 42.667 426.667 426.667 0 0 1 369.493-640zm-121.173 245.76 66.133 65.706a124.16 124.16 0 0 1 55.04-12.8 128 128 0 1 1-128 128 123.733 123.733 0 0 1 12.8-54.613l-66.133-65.707a42.667 42.667 0 1 1 60.16-60.586zM512 640a42.667 42.667 0 0 0 0-85.333 42.667 42.667 0 0 0-29.867 11.946 42.752 42.752 0 0 0-12.8 30.72A42.667 42.667 0 0 0 512 640z"
  }));
};

var SvgMagneticIcon = function SvgMagneticIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "magnetic_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M775.296 124.16a38.827 38.827 0 1 0-77.568 0v155.093a38.827 38.827 0 0 0 43.605 38.528l111.574-13.952v111.19a38.827 38.827 0 1 0 77.568 0V259.883a38.827 38.827 0 0 0-43.606-38.486L775.296 235.35V124.117zM620.459 337.835 417.067 134.443 182.4 369.109a331.904 331.904 0 0 0 469.333 469.419l234.71-234.71-203.393-203.39-234.666 234.665a44.245 44.245 0 1 1-62.592-62.549l234.667-234.71zM244.992 431.7l172.075-172.074 78.25 78.208L323.2 509.952a132.779 132.779 0 1 0 187.733 187.733l172.118-172.117 78.25 78.25-172.117 172.118a243.413 243.413 0 0 1-344.235-344.235z"
  }));
};

var SvgMailIcon = function SvgMailIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "mail_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a128 128 0 0 0-128 128v426.666a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H213.333zm-42.666 138.666 315.477 236.63c15.36 11.477 36.395 11.477 51.712 0l315.477-236.63v416A42.667 42.667 0 0 1 810.667 768H213.333a42.667 42.667 0 0 1-42.666-42.667v-416zM782.208 256 512 458.667 241.792 256h540.416z"
  }));
};

var SvgManualIcon = function SvgManualIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "manual_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M768 64H256A170.667 170.667 0 0 0 85.333 234.667v554.666A170.667 170.667 0 0 0 256 960h512a170.667 170.667 0 0 0 170.667-170.667V234.667A170.667 170.667 0 0 0 768 64zM170.667 234.667A85.333 85.333 0 0 1 256 149.333v256a42.667 42.667 0 0 0 68.267 34.134l59.733-44.8 59.733 44.8A42.667 42.667 0 0 0 512 405.333v-256h256a85.333 85.333 0 0 1 85.333 85.334v554.666A85.333 85.333 0 0 1 768 874.667H256a85.333 85.333 0 0 1-85.333-85.334V234.667zm256-85.334V320L409.6 307.2a42.667 42.667 0 0 0-51.2 0L341.333 320V149.333h85.334z"
  }));
};

var SvgMapPinIcon = function SvgMapPinIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "map-pin_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M270.636 185.3a341.331 341.331 0 0 1 582.695 241.364c0 132.18-86.015 260.436-180.308 359.976A1254.904 1254.904 0 0 1 512 928.976a1255.203 1255.203 0 0 1-161.023-142.293c-94.293-99.626-180.308-227.881-180.308-360.019A341.331 341.331 0 0 1 270.636 185.3zm217.684 831.526L512 981.327l23.68 35.499a42.666 42.666 0 0 1-47.36 0zm0 0L512 981.327c23.68 35.499 23.723 35.456 23.723 35.456l.085-.043.299-.213.98-.64 3.5-2.432c3.071-2.133 7.423-5.12 12.885-9.13a1341.133 1341.133 0 0 0 181.503-159.018c97.706-103.04 203.689-252.116 203.689-418.643a426.664 426.664 0 0 0-853.328 0c0 166.484 105.983 315.56 203.69 418.685a1340.92 1340.92 0 0 0 181.502 158.975 805.84 805.84 0 0 0 16.384 11.52l.981.683.3.213.127.086zm-61.653-590.162a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zM512 255.998a170.666 170.666 0 1 0 0 341.332 170.666 170.666 0 0 0 0-341.332z"
  }));
};

var SvgMarketIcon = function SvgMarketIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "market_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M551.68 216.277c-57.899-30.89-109.227-45.61-182.4-45.61-42.24 0-83.285 6.229-117.803 16.512a45.653 45.653 0 0 0-80.81 29.098V807.68a45.653 45.653 0 0 0 91.264 0V574.89c34.73-6.357 77.482-10.24 107.306-10.24 55.51 0 93.867 10.582 140.544 35.457 45.782 24.405 99.414 36.266 163.414 36.266 67.242 0 125.994-13.184 165.376-37.461a32.853 32.853 0 0 0 10.88-10.624 25.43 25.43 0 0 0 3.882-13.355v-333.44l-.341-4.266a27.733 27.733 0 0 0-7.68-14.336 38.4 38.4 0 0 0-15.616-9.387 46.805 46.805 0 0 0-19.328-2.005c-6.57.725-12.8 2.773-18.005 5.973-25.302 15.616-68.864 24.832-119.254 24.832-49.621 0-87.978-8.277-121.386-26.027z"
  }));
};

var SvgMediumIcon = function SvgMediumIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("g", {
    clipPath: "url(#medium_icon_svg__a)"
  }, createElement("path", {
    fill: "currentColor",
    d: "M13.538 11.815c0 3.764-3.031 6.816-6.77 6.816C3.032 18.63 0 15.579 0 11.815S3.03 5 6.769 5c3.738 0 6.769 3.051 6.769 6.815Zm7.428.002c0 3.543-1.515 6.416-3.384 6.416-1.87 0-3.385-2.873-3.385-6.416S15.712 5.4 17.581 5.4c1.87 0 3.385 2.872 3.385 6.416Zm1.845 5.752c.658 0 1.19-2.575 1.19-5.748 0-3.175-.533-5.748-1.19-5.748-.657 0-1.19 2.574-1.19 5.748 0 3.174.533 5.748 1.19 5.748Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "medium_icon_svg__a"
  }, createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var SvgMenuIcon = function SvgMenuIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "menu_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 256zm0 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 512zm42.667 213.333a42.667 42.667 0 1 0 0 85.334h682.666a42.667 42.667 0 1 0 0-85.334H170.667z"
  }));
};

var SvgMoonIcon = function SvgMoonIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "moon_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M487.595 101.845a42.667 42.667 0 0 1 5.546 42.88A298.667 298.667 0 0 0 873.9 541.1a42.667 42.667 0 0 1 57 48.04C892.843 785.792 719.787 934.315 512 934.315c-235.648 0-426.667-191.062-426.667-426.667 0-213.76 157.099-390.699 362.112-421.845a42.667 42.667 0 0 1 40.15 16.042zm-96.598 86.486a341.333 341.333 0 1 0 435.115 453.034A384 384 0 0 1 391.04 188.331z"
  }));
};

var SvgMorehorizontalIcon = function SvgMorehorizontalIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "morehorizontal_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 426.667a85.333 85.333 0 1 0 0 170.666 85.333 85.333 0 0 0 0-170.666zM426.667 512a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zm298.666 0A85.333 85.333 0 1 1 896 512a85.333 85.333 0 0 1-170.667 0z"
  }));
};

var SvgNewcomerIcon = function SvgNewcomerIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "newcomer_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M48.853 321.579c-30.677 16.213-30.72 62.464-.042 78.506l406.528 213.462a118.187 118.187 0 0 0 106.197 2.09L883.072 462.72v131.413L853.589 624a22.827 22.827 0 0 0-.682 30.976l37.12 41.088a19.925 19.925 0 0 0 29.354.683l38.912-39.382a22.827 22.827 0 0 0 .683-30.976l-27.861-30.805.085-1.707V439.851l43.35-20.608c31.231-14.891 33.023-61.099 3.029-78.507l-403.2-233.643a118.272 118.272 0 0 0-115.2-2.261L48.853 321.579zm424.918 383.445L225.237 578.987V776.66a42.667 42.667 0 0 0 23.979 38.315L465.237 920.49a128 128 0 0 0 115.627-1.707l197.376-103.51a42.667 42.667 0 0 0 22.87-37.76V578.988L550.783 705.195a85.333 85.333 0 0 1-77.013-.128z"
  }));
};

var SvgNewsIcon = function SvgNewsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "news_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M200.622 81.92c-73.318 0-139.182 63.652-139.182 150.692v517.734c0 87.04 65.864 150.774 139.182 150.774h242.36c1.23.082 2.458.164 3.687.164h375.44c75.325 0 140.492-63.734 140.492-147.784V252.928H801.382v-20.275c0-87.081-65.863-150.733-139.223-150.733H200.622zm600.76 262.062h79.053V753.46c0 27.976-22.937 56.73-58.327 56.73h-20.726V343.982zM719.258 810.19h-57.099v-.164H200.622c-32.194 0-57.057-27.443-57.057-59.679V232.653c0-32.236 24.863-59.679 57.057-59.679H662.16c32.236 0 57.099 27.443 57.099 59.679v577.536zm-452.65-409.6c0-25.109 18.35-45.466 40.96-45.466h246.498c22.65 0 41 20.357 41 45.466 0 25.108-18.35 45.465-40.96 45.465H307.61c-22.651 0-41.001-20.398-41.001-45.465zM471.9 537.109c22.692 0 41.083 20.357 41.083 45.465 0 25.15-18.432 45.548-41.083 45.548H307.65c-22.65 0-41.041-20.398-41.041-45.507 0-25.15 18.39-45.507 41.042-45.507H471.9z"
  }));
};

var SvgOrderIcon = function SvgOrderIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "order_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M682.667 64H341.333A213.333 213.333 0 0 0 128 277.333v469.334A213.333 213.333 0 0 0 341.333 960h341.334A213.333 213.333 0 0 0 896 746.667V277.333A213.333 213.333 0 0 0 682.667 64zM213.333 277.333a128 128 0 0 1 128-128h341.334a128 128 0 0 1 128 128v469.334a128 128 0 0 1-128 128H341.333a128 128 0 0 1-128-128V277.333zm128 21.334a42.667 42.667 0 0 0 0 85.333h341.334a42.667 42.667 0 1 0 0-85.333H341.333zm0 170.666a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333zm-42.666 213.334A42.667 42.667 0 0 1 341.333 640h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
  }));
};

var SvgOrdersIcon = function SvgOrdersIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "orders_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M256 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H256zm-42.667 128A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v597.334A42.667 42.667 0 0 1 768 853.333H256a42.667 42.667 0 0 1-42.667-42.666V213.333zm128 426.667A42.667 42.667 0 0 1 384 597.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 640zm0-256A42.667 42.667 0 0 1 384 341.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 384z"
  }));
};

var SvgOriginalorderIcon = function SvgOriginalorderIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "originalorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M277.333 234.667h8.875a106.667 106.667 0 0 0 97.792 64h213.333a106.667 106.667 0 0 0 97.792-64H704A85.333 85.333 0 0 1 789.333 320v113.792a42.667 42.667 0 1 0 85.334 0V320A170.667 170.667 0 0 0 704 149.333h-8.875a106.667 106.667 0 0 0-97.792-64H384a106.667 106.667 0 0 0-97.792 64h-8.875A170.667 170.667 0 0 0 106.667 320v469.333A170.667 170.667 0 0 0 277.333 960h128a42.667 42.667 0 1 0 0-85.333h-128A85.333 85.333 0 0 1 192 789.333V320a85.333 85.333 0 0 1 85.333-85.333zm106.667-64h213.333a21.333 21.333 0 0 1 0 42.666H384a21.333 21.333 0 0 1 0-42.666zM277.333 405.333A42.667 42.667 0 0 1 320 362.667h341.333a42.667 42.667 0 1 1 0 85.333H320a42.667 42.667 0 0 1-42.667-42.667zM320 576a42.667 42.667 0 1 0 0 85.333h64A42.667 42.667 0 1 0 384 576h-64zm366.933 0a153.6 153.6 0 1 0 0 307.2 153.6 153.6 0 0 0 0-307.2zm-230.4 153.6a230.4 230.4 0 1 1 460.8 0 230.4 230.4 0 0 1-460.8 0zm220.8-96a38.4 38.4 0 0 1 38.4 38.4v56.235l40.534 27.008a38.4 38.4 0 0 1-42.667 63.914l-57.6-38.4a38.4 38.4 0 0 1-17.067-31.957V672a38.4 38.4 0 0 1 38.4-38.4z"
  }));
};

var SvgOverviewIcon = function SvgOverviewIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "overview_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M180.139 128c-71.595 0-137.472 55.339-137.472 133.163v506.069c0 77.824 65.877 133.163 137.472 133.163h218.538a8.107 8.107 0 0 1 4.694 1.365L512 981.333l108.672-79.573a8.064 8.064 0 0 1 4.65-1.365h218.54c71.594 0 137.471-55.339 137.471-133.12V261.12c0-77.781-65.877-133.12-137.472-133.12H618.155c-8.576 0-17.152.768-25.6 2.304l-5.547 1.024L512 167.808l-75.008-36.48-5.547-1.024a142.165 142.165 0 0 0-25.6-2.304H180.14zM128 261.163c0-20.224 19.03-44.374 52.139-44.374h225.706c2.006 0 3.968.086 5.931.299l57.557 27.947v596.48L452.48 829.14a91.05 91.05 0 0 0-53.76-17.493H180.096c-33.152 0-52.139-24.192-52.139-44.373V261.12zm426.667 580.352v-596.48l57.557-27.947a60.16 60.16 0 0 1 5.93-.299h225.707c33.152 0 52.139 24.15 52.139 44.374v506.069c0 20.224-18.987 44.373-52.139 44.373H625.323c-19.03 0-37.974 5.974-53.76 17.536l-16.896 12.374z"
  }));
};

var SvgPadIcon = function SvgPadIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pad_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 853.333A42.667 42.667 0 1 1 512 768a42.667 42.667 0 0 1 0 85.333zM256 42.71A170.667 170.667 0 0 0 85.333 213.376v597.333A170.667 170.667 0 0 0 256 981.376h512a170.667 170.667 0 0 0 170.667-170.667V213.376A170.667 170.667 0 0 0 768 42.709H256zm-85.333 170.667A85.333 85.333 0 0 1 256 128.043h512a85.333 85.333 0 0 1 85.333 85.333v597.333A85.333 85.333 0 0 1 768 896.043H256a85.333 85.333 0 0 1-85.333-85.334V213.376z"
  }));
};

var SvgParallelIcon = function SvgParallelIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "parallel_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M506.07 710.4 346.367 870.059a42.667 42.667 0 1 0 60.33 60.373L566.4 770.731A149.333 149.333 0 0 0 768.81 568.32l156.033-156.032a42.667 42.667 0 0 0-60.331-60.33L708.48 507.946a149.333 149.333 0 0 0-202.41 202.41zM336.596 559.787 559.104 337.28a149.333 149.333 0 1 0-57.77-62.933L273.108 502.528a149.333 149.333 0 1 0 63.531 57.259zM145.024 637.44a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm490.667-492.373a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-62.251 494.25a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgPcIcon = function SvgPcIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pc_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 64A170.667 170.667 0 0 0 0 234.667v384a170.667 170.667 0 0 0 170.667 170.666h298.666v85.334h-256V960h597.334v-85.333h-256v-85.334h298.666A170.667 170.667 0 0 0 1024 618.667v-384A170.667 170.667 0 0 0 853.333 64H170.667zM85.333 234.667a85.333 85.333 0 0 1 85.334-85.334h682.666a85.333 85.333 0 0 1 85.334 85.334v384A85.333 85.333 0 0 1 853.333 704H170.667a85.333 85.333 0 0 1-85.334-85.333v-384z"
  }));
};

var SvgPencilIcon = function SvgPencilIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pencil_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M580.565 149.59c83.286-83.329 212.736-86.785 296.064-3.5 83.286 83.329 83.371 216.577 0 301.74L448 874.666a42.667 42.667 0 0 1-22.485 11.776l-289.835 57.6a42.667 42.667 0 0 1-49.664-49.664l54.101-293.675a42.667 42.667 0 0 1 11.819-22.485l428.63-428.63zM816.3 206.463c-50.006-50.005-125.44-46.507-175.403 3.456l-16.64 16.64 176.47 176.427 15.573-15.531a128 128 0 0 0 0-180.992zM275.627 575.147 451.328 750.89l288.896-287.702L563.925 286.89 275.627 575.146zm-55.894 64.768-38.57 209.066 205.653-41.984-167.083-167.082z"
  }));
};

var SvgPerpIcon = function SvgPerpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "perp_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zm-42.666 128a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333zm128 85.334a42.667 42.667 0 0 0 0 85.333h426.666a42.667 42.667 0 1 0 0-85.333H298.667zM512 512a42.667 42.667 0 0 1 42.667-42.667h170.666a42.667 42.667 0 1 1 0 85.334H554.667A42.667 42.667 0 0 1 512 512zm0 170.667A42.667 42.667 0 0 1 554.667 640h170.666a42.667 42.667 0 1 1 0 85.333H554.667A42.667 42.667 0 0 1 512 682.667zM371.499 478.165a42.667 42.667 0 0 0-60.331 60.331l60.33 60.33-59.647 59.649a42.667 42.667 0 1 0 60.33 60.33l87.467-87.466a42.667 42.667 0 0 0 2.347-62.635l-90.454-90.539z"
  }));
};

var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "phone_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M426.667 725.333a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667zm-128-682.666A170.667 170.667 0 0 0 128 213.333v597.334a170.667 170.667 0 0 0 170.667 170.666h426.666A170.667 170.667 0 0 0 896 810.667V213.333A170.667 170.667 0 0 0 725.333 42.667H298.667zm-85.334 170.666A85.333 85.333 0 0 1 298.667 128h426.666a85.333 85.333 0 0 1 85.334 85.333v597.334A85.333 85.333 0 0 1 725.333 896H298.667a85.333 85.333 0 0 1-85.334-85.333V213.333z"
  }));
};

var SvgPinIcon = function SvgPinIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M14.383 3.287a1.2 1.2 0 0 0-1.987.47l-.884 2.65-2.396 2.396-4.488.3c-1.029.068-1.498 1.316-.769 2.045l3.578 3.578-3.182 3.181a1 1 0 0 0 1.414 1.415l3.182-3.182 3.577 3.578c.73.729 1.977.26 2.046-.77l.3-4.488 2.395-2.396 2.651-.883a1.2 1.2 0 0 0 .47-1.987l-5.907-5.907Zm-1.123 4.2.624-1.87 4.076 4.076-1.871.623-3.261 3.261-.232 3.48L6.52 10.98l3.48-.232 3.26-3.261Z"
  }));
};

var SvgPlacardIcon = function SvgPlacardIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "placard_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m446.507 743.85-3.84-18.645 311.168 149.718c84.394 40.576 184.832-18.134 184.832-110.422v-555.69c0-92.288-100.438-151.04-184.832-110.422L373.973 281.173H213.12c-70.187 0-127.787 54.827-127.787 123.35v164.266c0 48.214 28.587 89.728 69.974 110.038l43.221 166.442c14.379 55.126 65.621 93.398 124.032 93.398h12.245c84.395 0 146.432-77.995 122.88-157.355l-11.093-37.419zm-165.718 81.238-34.56-132.907h102.955l14.507 69.632a40.49 40.49 0 0 0 .81 3.286l11.606 39.04c7.594 25.6-12.288 52.053-41.387 52.053h-12.16a42.624 42.624 0 0 1-41.728-31.104zm121.942-211.072a43.05 43.05 0 0 0-18.774-4.267H213.12c-24.107 0-42.965-18.688-42.965-40.96V404.523c0-22.272 18.858-40.96 42.965-40.96h170.752c6.528 0 12.97-1.451 18.816-4.267l388.779-187.008c29.141-14.08 62.293 6.656 62.293 36.523V764.5c0 29.867-33.152 50.56-62.293 36.566L402.73 613.973z"
  }));
};

var SvgPlaceanorderIcon = function SvgPlaceanorderIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "placeanorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M810.667 426.667a42.667 42.667 0 1 0 85.333 0V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h256a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v213.334zm-512 128A42.667 42.667 0 0 1 341.333 512h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.666zm0-213.334a42.667 42.667 0 0 1 42.666-42.666h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.667zm311.253 462.72 127.872 122.923c4.053 3.755 8.832 6.656 14.08 8.619 10.325 4.096 21.973 4.096 32.341 0 5.248-1.963 10.027-4.864 14.08-8.619l127.83-122.923a40.363 40.363 0 0 0 12.544-29.098 40.363 40.363 0 0 0-12.544-29.099 43.69 43.69 0 0 0-30.251-12.075c-11.35 0-22.187 4.352-30.25 12.075l-54.955 53.29v-229.12c0-10.837-4.523-21.29-12.502-28.97a43.52 43.52 0 0 0-30.122-11.99 43.52 43.52 0 0 0-30.123 11.99 40.192 40.192 0 0 0-12.501 29.013v229.078l-54.955-53.334a42.795 42.795 0 0 0-30.293-12.074 44.032 44.032 0 0 0-30.251 12.117 39.637 39.637 0 0 0 0 58.197z"
  }));
};

var SvgPlusIcon = function SvgPlusIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "plus_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M554.667 213.333a42.667 42.667 0 1 0-85.334 0v256h-256a42.667 42.667 0 1 0 0 85.334h256v256a42.667 42.667 0 1 0 85.334 0v-256h256a42.667 42.667 0 1 0 0-85.334h-256v-256z"
  }));
};

var SvgPm1Icon = function SvgPm1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pm1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M853.333 170.667A42.667 42.667 0 0 1 896 213.333v469.334a42.667 42.667 0 0 1-42.667 42.666H298.667A42.667 42.667 0 0 1 256 682.667V213.333a42.667 42.667 0 0 1 42.667-42.666h554.666zM298.667 85.333a128 128 0 0 0-128 128v469.334a128 128 0 0 0 128 128h554.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H298.667zm119.381 200.534c33.45 0 61.867 10.538 82.133 29.184 20.31 18.73 31.488 44.842 31.488 74.24 0 29.354-11.178 55.466-31.488 74.24-20.224 18.602-48.725 29.141-82.133 29.141h-58.795v117.461h-73.386V285.867h132.266zm213.333 0 83.883 169.557 82.304-169.557h68.565v324.266h-73.386v-158.08l-51.755 103.979h-51.157l-53.632-105.13v159.231h-73.387V285.867h68.523zM359.168 425.984h56.192c14.379 0 25.045-3.925 31.915-9.856 6.656-5.717 11.008-14.421 11.008-26.88 0-12.416-4.352-21.248-11.094-27.093-6.826-6.016-17.536-9.984-31.829-9.984h-56.15v73.813zM128 384a42.667 42.667 0 0 0-85.333 0v341.333A213.333 213.333 0 0 0 256 938.667h341.333a42.667 42.667 0 1 0 0-85.334H256a128 128 0 0 1-128-128V384z"
  }));
};

var SvgPutawayIcon = function SvgPutawayIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M14.334 3a.667.667 0 0 0-.667-.667H2.333a.667.667 0 0 0 0 1.334h11.334A.667.667 0 0 0 14.334 3Zm0 10a.667.667 0 0 0-.667-.667H2.333a.667.667 0 0 0 0 1.334h11.334a.667.667 0 0 0 .667-.667ZM11.31 5.643a.667.667 0 0 0 0 .943l.747.747H2.333a.667.667 0 0 0 0 1.334h9.724l-.747.747a.667.667 0 0 0 .943.943l1.885-1.886a.667.667 0 0 0 0-.942l-1.885-1.886a.667.667 0 0 0-.943 0Z"
  }));
};

var SvgPutawayLeftIcon = function SvgPutawayLeftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M1.667 3c0-.368.298-.667.667-.667h11.333a.667.667 0 1 1 0 1.334H2.334A.667.667 0 0 1 1.667 3Zm0 10c0-.368.298-.667.667-.667h11.333a.667.667 0 0 1 0 1.334H2.334A.667.667 0 0 1 1.667 13Zm3.024-7.357c.26.26.26.682 0 .943l-.748.747h9.724a.667.667 0 1 1 0 1.334H3.943l.748.747a.667.667 0 0 1-.943.943L1.862 8.471a.667.667 0 0 1 0-.942l1.886-1.886c.26-.26.682-.26.943 0Z"
  }));
};

var SvgQuickjumpIcon = function SvgQuickjumpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "quickjump_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M764.587 282.453a42.667 42.667 0 0 0-23.04-23.04A42.667 42.667 0 0 0 725.333 256H298.667a42.667 42.667 0 0 0 0 85.333h323.84L268.373 695.04a42.667 42.667 0 0 0 13.867 69.93 42.667 42.667 0 0 0 46.72-9.343l353.707-354.134v323.84a42.667 42.667 0 0 0 85.333 0V298.667a42.539 42.539 0 0 0-3.413-16.214z"
  }));
};

var SvgQuoraIcon = function SvgQuoraIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M22.146 18.127h-1.373c-.07.632-.492 1.443-1.547 1.443-.961 0-1.655-.665-2.32-1.678 2.071-1.603 3.501-4.101 3.501-7.172.005-5.508-4.528-9.22-9.3-9.22-4.673 0-9.267 3.736-9.267 9.22 0 6.286 6.155 10.388 11.672 8.86.923 1.575 2.142 2.92 4.462 2.92 3.835 0 4.256-3.53 4.172-4.373ZM15.42 15.43c-.914-1.368-2.048-2.447-4.289-2.447-1.43 0-2.545.47-3.234 1.07l.572 1.138c.29-.14.61-.187.928-.187 1.664 0 2.517 1.443 3.244 2.873-.469.14-.97.197-1.533.197-3.516 0-5.039-2.484-5.039-7.345 0-4.894 1.523-7.402 5.039-7.402 3.572 0 5.095 2.508 5.095 7.392.005 1.96-.253 3.544-.783 4.711Z"
  }));
};

var SvgQuotesCutoverIcon = function SvgQuotesCutoverIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "quotes_cutover_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M725.333 85.333A42.667 42.667 0 0 0 682.667 128v85.333a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128V896A42.667 42.667 0 1 0 768 896v-85.333a128 128 0 0 0 128-128V341.333a128 128 0 0 0-128-128V128a42.667 42.667 0 0 0-42.667-42.667zm-85.333 256a42.667 42.667 0 0 1 42.667-42.666H768a42.667 42.667 0 0 1 42.667 42.666v341.334A42.667 42.667 0 0 1 768 725.333h-85.333A42.667 42.667 0 0 1 640 682.667V341.333zM298.667 170.667A42.667 42.667 0 0 0 256 213.333v85.334a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128v85.333a42.667 42.667 0 1 0 85.333 0V768a128 128 0 0 0 128-128V426.667a128 128 0 0 0-128-128v-85.334a42.667 42.667 0 0 0-42.666-42.666zm-85.334 256A42.667 42.667 0 0 1 256 384h85.333A42.667 42.667 0 0 1 384 426.667V640a42.667 42.667 0 0 1-42.667 42.667H256A42.667 42.667 0 0 1 213.333 640V426.667z"
  }));
};

var SvgRateIcon = function SvgRateIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rate_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M153.6 512c0 198.101 160.299 358.4 358.4 358.4 198.101 0 358.4-160.299 358.4-358.4 0-198.101-160.299-358.4-358.4-358.4A358.187 358.187 0 0 0 153.6 512zm806.4 0c0 247.595-200.405 448-448 448S64 759.595 64 512 264.405 64 512 64s448 200.405 448 448zM591.36 663.68a29.653 29.653 0 1 1 59.307 0 29.653 29.653 0 0 1-59.307 0zm29.61-93.653a93.653 93.653 0 1 0 0 187.306 93.653 93.653 0 0 0 0-187.306zm-217.983-239.36a29.653 29.653 0 1 0 0 59.306 29.653 29.653 0 0 0 0-59.306zm-93.654 29.653a93.653 93.653 0 1 1 187.307 0 93.653 93.653 0 0 1-187.307 0zm.768 282.325c-19.669 19.67-22.144 49.152-5.504 65.835 16.683 16.64 46.166 14.208 65.878-5.504l340.949-340.992c19.712-19.67 22.187-49.152 5.547-65.835-16.683-16.64-46.166-14.208-65.878 5.547L310.101 642.603z"
  }));
};

var SvgRaysIcon = function SvgRaysIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rays_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M905.259 176.085a42.667 42.667 0 0 0-60.331-60.33L559.744 400.896A149.333 149.333 0 0 0 355.84 597.632l-56.875 56.875a149.333 149.333 0 1 0 63.36 57.301l50.859-50.773a149.333 149.333 0 0 0 207.787-200.662l284.288-284.288zM234.667 725.333a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm192-192a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgRectangleIcon = function SvgRectangleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rectangle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M796.16 166.784a61.056 61.056 0 1 0 0 122.112 61.056 61.056 0 0 0 0-122.112zm-467.03 83.115a79.232 79.232 0 0 0-79.23 79.231v326.23a142.635 142.635 0 0 1 118.74 118.741h326.23a79.232 79.232 0 0 0 79.23-79.231V368.64a142.635 142.635 0 0 1-118.74-118.741H329.13zm-164.565 418.56V329.088a164.565 164.565 0 0 1 164.566-164.565h339.285A142.507 142.507 0 1 1 859.435 355.54v339.286a164.565 164.565 0 0 1-164.566 164.565H355.584a142.507 142.507 0 1 1-191.019-191.019zm2.219 127.701a61.056 61.056 0 1 0 122.112 0 61.056 61.056 0 0 0-122.112 0z"
  }));
};

var SvgRecurringbuyIcon = function SvgRecurringbuyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "recurringbuy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M725.333 128A42.667 42.667 0 1 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128h-85.334V128zM298.667 298.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 1 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v512a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666v-512A42.667 42.667 0 0 1 213.333 256h85.334v42.667zm448 256a64 64 0 1 0-63.915-60.416L579.584 597.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
  }));
};

var SvgRedditIcon = function SvgRedditIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M9.478 12c.63 0 1.145.515 1.145 1.145s-.514 1.145-1.145 1.145c-.63 0-1.145-.515-1.145-1.145S8.848 12 9.478 12ZM12.013 17.005c.437 0 1.93-.052 2.714-.837a.33.33 0 0 0 .026-.424.303.303 0 0 0-.424 0c-.502.489-1.544.669-2.303.669-.76 0-1.814-.18-2.303-.67a.303.303 0 0 0-.425 0 .303.303 0 0 0 0 .425c.772.772 2.277.837 2.715.837ZM13.377 13.145c0 .63.514 1.145 1.145 1.145.63 0 1.145-.515 1.145-1.145S15.152 12 14.522 12s-1.145.515-1.145 1.145Z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-5.275-1.608c-.437 0-.823.167-1.106.45-1.094-.785-2.612-1.3-4.284-1.364l.733-3.435 2.38.502a1.146 1.146 0 0 0 2.29-.051c0-.63-.515-1.145-1.145-1.145-.45 0-.836.257-1.016.643l-2.664-.566a.32.32 0 0 0-.218.038.313.313 0 0 0-.129.18l-.81 3.834c-1.712.052-3.243.554-4.349 1.364a1.623 1.623 0 0 0-1.106-.45 1.609 1.609 0 0 0-.657 3.075 3.01 3.01 0 0 0-.038.489c0 2.47 2.869 4.464 6.42 4.464 3.55 0 6.42-1.994 6.42-4.465 0-.167-.013-.321-.039-.476.527-.257.926-.823.926-1.479 0-.888-.72-1.608-1.608-1.608Z"
  }));
};

var SvgReduceIcon = function SvgReduceIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "reduce_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 512a42.667 42.667 0 0 1 42.666-42.667h597.334a42.667 42.667 0 1 1 0 85.334H213.333A42.667 42.667 0 0 1 170.667 512z"
  }));
};

var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "refresh_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M262.912 139.008a426.667 426.667 0 0 1 507.435 70.912l125.61 118.059V170.667a42.667 42.667 0 1 1 85.334 0v256.896a42.539 42.539 0 0 1-42.667 41.77h-256a42.667 42.667 0 1 1 0-85.333h148.31L711.466 271.744a341.333 341.333 0 1 0 79.872 354.09 42.667 42.667 0 0 1 80.426 28.331 426.667 426.667 0 1 1-608.853-515.157z"
  }));
};

var SvgRemoveIcon = function SvgRemoveIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "remove_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512 276.352 938.667 512 938.667zM853.333 512a341.333 341.333 0 1 1-682.666 0 341.333 341.333 0 0 1 682.666 0zm-512-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
  }));
};

var SvgRemoveSolidIcon = function SvgRemoveSolidIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "remove_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zm-640-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
  }));
};

var SvgResourceIcon = function SvgResourceIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "resource_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M715.093 128H308.907a128.085 128.085 0 0 0-114.56 70.997v.043L47.573 492.16A42.496 42.496 0 0 0 42.667 512v256a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V510.379a42.496 42.496 0 0 0-4.906-18.262L829.653 199.04v-.043A128 128 0 0 0 715.093 128zm154.454 341.333h-186.88a42.667 42.667 0 0 0-35.499 18.987l-72.661 109.013H449.493L376.832 488.32a42.667 42.667 0 0 0-35.499-18.987h-186.88l116.224-232.192L256 234.667l14.763 2.346a42.667 42.667 0 0 1 38.144-23.68h406.186a42.667 42.667 0 0 1 38.144 23.68l.086.128 116.224 232.192zM128 554.667h190.507l72.661 109.013a42.667 42.667 0 0 0 35.499 18.987h170.666a42.667 42.667 0 0 0 35.499-18.987l72.661-109.013H896V768a42.667 42.667 0 0 1-42.667 42.667H170.667A42.667 42.667 0 0 1 128 768V554.667z"
  }));
};

var SvgRetraceIcon = function SvgRetraceIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "retrace_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M234.667 725.333a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm0-85.333a149.419 149.419 0 0 1 143.146 106.667H896A42.667 42.667 0 1 1 896 832H377.813a149.419 149.419 0 0 1-292.48-42.667A149.333 149.333 0 0 1 234.667 640zM85.333 576A42.667 42.667 0 0 1 128 533.333h768a42.667 42.667 0 1 1 0 85.334H128A42.667 42.667 0 0 1 85.333 576zm0-426.667A42.667 42.667 0 0 1 128 106.667h768A42.667 42.667 0 1 1 896 192H128a42.667 42.667 0 0 1-42.667-42.667zM128 320a42.667 42.667 0 1 0 0 85.333h390.187a149.419 149.419 0 0 0 286.293 0H896A42.667 42.667 0 1 0 896 320h-91.52a149.419 149.419 0 0 0-286.293 0H128zm597.333 42.667a64 64 0 1 1-128 0 64 64 0 0 1 128 0z"
  }));
};

var SvgRewardsIcon = function SvgRewardsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m10.827 7.148 4.178-2.412 1.393 2.412h-5.571Zm-4 0 7.178-4.144a2 2 0 0 1 2.732.732l1.97 3.412H20a2 2 0 0 1 2 2v2c0 .553-.474.98-.959 1.245a2 2 0 0 0 0 3.511c.485.265.959.692.959 1.244v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V17c0-.552.475-.98.959-1.245a2 2 0 0 0 0-3.51C2.475 11.978 2 11.551 2 11V9.148a2 2 0 0 1 2-2h2.827Zm4.898 4.198a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.03.575 1.69a.29.29 0 0 1-.441.333L12 15.588l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.032a.29.29 0 0 1 .166-.53h1.85l.584-1.715ZM20 10.684V9.148H4v1.387a3.999 3.999 0 0 1 0 6.93v1.683h16v-1.535a4 4 0 0 1 0-6.929Z"
  }));
};

var SvgRmIcon = function SvgRmIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rm_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M42.667 262.656c0-99.03 73.6-177.323 162.133-177.323h614.4c88.533 0 162.133 78.294 162.133 177.323v498.688c0 99.03-73.6 177.323-162.133 177.323H204.8c-88.533 0-162.133-78.294-162.133-177.323V262.656zm85.333 0v498.688c0 46.08 34.39 83.456 76.8 83.456h614.4c42.41 0 76.8-37.376 76.8-83.456V262.656c0-46.08-34.39-83.456-76.8-83.456H204.8c-42.41 0-76.8 37.376-76.8 83.456zm361.259 105.643h100.693l69.205 185.6h3.499l69.248-185.6h100.65v327.68h-79.146v-189.44h-2.304l-66.347 186.88h-47.701l-66.347-188.16h-2.304v190.72H489.26v-327.68zm-34.219 122.88h-82.005a66.176 66.176 0 0 0-4.694-20.31 46.08 46.08 0 0 0-25.728-25.941 55.467 55.467 0 0 0-20.778-3.67c-13.568 0-25.088 3.627-34.475 10.88-9.301 7.254-16.384 17.665-21.248 31.19-4.736 13.568-7.125 29.824-7.125 48.81 0 20.054 2.432 36.865 7.253 50.39 4.95 13.44 12.075 23.595 21.419 30.421 9.301 6.699 20.48 10.07 33.578 10.07 7.467 0 14.166-1.024 20.054-3.03a45.91 45.91 0 0 0 26.026-23.381c2.859-5.632 4.736-11.99 5.718-19.03l82.005.64a131.84 131.84 0 0 1-10.581 42.411 138.325 138.325 0 0 1-26.027 39.68c-11.179 12.032-25.003 21.76-41.472 29.099-16.512 7.381-35.627 11.05-57.472 11.05-27.307 0-51.883-6.442-73.6-19.37-21.632-12.885-38.741-31.872-51.328-56.96-12.501-25.045-18.773-55.723-18.773-91.99 0-36.48 6.4-67.2 19.2-92.16 12.8-25.087 30.08-43.989 51.797-56.789a139.648 139.648 0 0 1 72.704-19.37c18.816 0 36.139 2.816 51.925 8.49 15.787 5.632 29.696 13.91 41.6 24.79 11.947 10.752 21.547 24.064 28.8 39.85 7.254 15.787 11.691 33.835 13.227 54.23z"
  }));
};

var SvgRulerIcon = function SvgRulerIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ruler_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M898.56 253.568 774.357 129.28a165.973 165.973 0 0 0-234.752 0L129.28 539.563a165.973 165.973 0 0 0 0 234.752l124.288 124.288a165.973 165.973 0 0 0 234.752 0L898.603 488.32a165.973 165.973 0 0 0 0-234.752zm-60.33 60.33a80.64 80.64 0 0 1 0 114.091L427.99 838.23a80.64 80.64 0 0 1-114.091 0L189.61 713.984a80.64 80.64 0 0 1 0-114.09l3.242-3.2c1.579 2.474 3.499 4.82 5.675 6.997l106.496 106.496a42.667 42.667 0 0 0 60.33-60.331L258.86 543.36a43.05 43.05 0 0 0-6.998-5.675l63.574-63.573a42.667 42.667 0 0 0 2.261 2.475l54.827 54.869a42.667 42.667 0 0 0 60.373-60.373l-54.87-54.87a43.264 43.264 0 0 0-2.474-2.261L431.19 358.4a42.581 42.581 0 0 0 5.675 6.997L543.36 471.893a42.667 42.667 0 0 0 60.33-60.33L497.196 305.067a43.008 43.008 0 0 0-6.998-5.675l55.595-55.637c.725.853 1.493 1.706 2.304 2.474l54.827 54.827a42.667 42.667 0 1 0 60.373-60.33l-54.87-54.87a43.008 43.008 0 0 0-2.133-2.005 80.683 80.683 0 0 1 107.691 5.76L838.23 313.899z"
  }));
};

var SvgSafetyIcon = function SvgSafetyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "safety_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m549.547 919.637-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zM485.248 648.15l249.301-255.701a42.667 42.667 0 1 0-61.098-59.563L453.29 558.677l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781L424.661 649.26c17.067 16.298 44.118 15.786 60.587-1.11z"
  }));
};

var SvgScanIcon = function SvgScanIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "scan_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v128a42.667 42.667 0 0 0 85.334 0v-128a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 0 0 0-85.334h-128zm469.334 0a42.667 42.667 0 1 0 0 85.334h128a42.667 42.667 0 0 1 42.666 42.666v128a42.667 42.667 0 1 0 85.334 0v-128a128 128 0 0 0-128-128h-128zm-512 597.334a42.667 42.667 0 1 0-85.334 0v128a128 128 0 0 0 128 128h128a42.667 42.667 0 1 0 0-85.334h-128a42.667 42.667 0 0 1-42.666-42.666v-128zm768 0a42.667 42.667 0 1 0-85.334 0v128a42.667 42.667 0 0 1-42.666 42.666h-128a42.667 42.667 0 1 0 0 85.334h128a128 128 0 0 0 128-128v-128zM128 469.333a42.667 42.667 0 1 0 0 85.334h768a42.667 42.667 0 1 0 0-85.334H128z"
  }));
};

var SvgScreenshotIcon = function SvgScreenshotIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "screenshot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M412.16 128a128 128 0 0 0-111.104 64.512l-48.47 84.821h-39.253a128 128 0 0 0-128 128V768a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V405.333a128 128 0 0 0-128-128h-39.254l-48.469-84.821A128 128 0 0 0 611.84 128H412.203zm-37.035 106.837a42.667 42.667 0 0 1 37.078-21.504h199.594a42.667 42.667 0 0 1 37.078 21.504l60.757 106.326a42.667 42.667 0 0 0 37.035 21.504h64a42.667 42.667 0 0 1 42.666 42.666V768a42.667 42.667 0 0 1-42.666 42.667H213.333A42.667 42.667 0 0 1 170.667 768V405.333a42.667 42.667 0 0 1 42.666-42.666h64a42.667 42.667 0 0 0 37.035-21.504l60.757-106.326zM512 768a213.333 213.333 0 1 0 0-426.667A213.333 213.333 0 0 0 512 768zm128-213.333a128 128 0 1 1-256 0 128 128 0 0 1 256 0z"
  }));
};

var SvgSearchIcon = function SvgSearchIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "search_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 469.333a298.667 298.667 0 1 1 597.333 0 298.667 298.667 0 0 1-597.333 0zm298.666-384a384 384 0 1 0 239.702 684.032l156.8 156.8a42.667 42.667 0 0 0 60.33-60.33l-156.8-156.8A384 384 0 0 0 469.333 85.333z"
  }));
};

var SvgSectorIcon = function SvgSectorIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sector_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "m635.733 388.267 60.459-213.334a386.219 386.219 0 0 1 152.875 152.918l-213.248 60.416zm314.454-44.715A470.784 470.784 0 0 0 680.448 73.813c-21.973-8.448-45.653 4.907-52.053 27.563l-95.574 337.11a42.667 42.667 0 0 0 52.694 52.693l337.109-95.574c22.699-6.4 36.01-30.08 27.563-52.053zM170.667 512A341.333 341.333 0 0 1 512 170.667a42.667 42.667 0 1 0 0-85.334C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512a42.667 42.667 0 1 0-85.334 0 341.333 341.333 0 1 1-682.666 0z"
  }));
};

var SvgServiceIcon = function SvgServiceIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "service_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 554.667V576a64 64 0 0 1-128 0v-85.333a64 64 0 0 1 50.944-62.678C132.608 232.576 305.109 85.333 512 85.333c206.933 0 379.392 147.243 418.39 342.656a64 64 0 0 1 50.943 62.678V576a64 64 0 0 1-50.944 62.677 427.221 427.221 0 0 1-205.44 285.824 64 64 0 1 1-10.794-43.306 384.427 384.427 0 0 0 173.866-248.32A64 64 0 0 1 853.333 576v-64a341.333 341.333 0 1 0-682.666 0v42.667z"
  }), createElement("path", {
    fill: "currentColor",
    d: "M810.752 512a298.667 298.667 0 0 1-457.387 253.013l-137.984 34.475a21.333 21.333 0 0 1-24.32-30.08l57.472-116.779A298.667 298.667 0 1 1 810.752 512zM512.085 682.667a170.752 170.752 0 0 0 165.291-128h-44.587a128.043 128.043 0 0 1-241.408 0h-44.586c18.944 73.6 85.76 128 165.29 128z"
  }));
};

var SvgSettingIcon = function SvgSettingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "setting_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M719.53 193.067a42.752 42.752 0 0 0-37.034-21.547H341.504a42.611 42.611 0 0 0-37.035 21.547L133.973 490.453c-7.68 13.355-7.68 29.782 0 43.094L304.47 830.933c7.638 13.355 21.76 21.547 37.035 21.547h340.992a42.611 42.611 0 0 0 37.035-21.547l170.496-297.386c7.68-13.355 7.68-29.782 0-43.094L719.53 193.067zM230.4 149.973a128.213 128.213 0 0 1 111.104-64.64h340.992c45.867 0 88.235 24.619 111.147 64.64L964.139 447.36a130.048 130.048 0 0 1 0 129.28L793.643 874.027a128.213 128.213 0 0 1-111.147 64.64H341.504a128.213 128.213 0 0 1-111.104-64.64L59.904 576.64a130.048 130.048 0 0 1 0-129.28L230.4 149.973zm195.243 361.174c0-47.574 38.314-86.187 85.546-86.187 47.275 0 85.59 38.613 85.59 86.187 0 47.616-38.315 86.186-85.59 86.186a85.888 85.888 0 0 1-85.546-86.186zm85.546-172.374c-94.506 0-171.136 77.184-171.136 172.374S416.683 683.52 511.19 683.52s171.136-77.184 171.136-172.373-76.629-172.374-171.093-172.374z"
  }));
};

var SvgSettingKlineIcon = function SvgSettingKlineIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "setting_kline_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M341.333 256a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334H548.48a149.419 149.419 0 0 0-143.147-106.666zM213.333 256a42.667 42.667 0 0 1-42.666 42.667H128a42.667 42.667 0 0 1 0-85.334h42.667A42.667 42.667 0 0 1 213.333 256zM640 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334h-48.853A149.419 149.419 0 0 0 704 362.667zM512 512a42.667 42.667 0 0 1-42.667 42.667H128a42.667 42.667 0 1 1 0-85.334h341.333A42.667 42.667 0 0 1 512 512zM320 704a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM128 810.667h48.853A149.419 149.419 0 0 0 469.333 768a149.333 149.333 0 0 0-292.48-42.667H128a42.667 42.667 0 1 0 0 85.334zm426.667-85.334a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H554.667z"
  }));
};

var SvgShareIcon = function SvgShareIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "share_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M640 85.333h256l42.667 42.88V384a42.667 42.667 0 1 1-85.334 0V230.997L456.832 627.5a42.667 42.667 0 0 1-60.33-60.331l396.5-396.501H640a42.667 42.667 0 1 1 0-85.334zm256 0L938.667 128c0-1.024 0-2.048-.128-3.072A42.496 42.496 0 0 0 896 85.333zM183.168 311.168a42.667 42.667 0 0 1 30.165-12.501h256a42.667 42.667 0 1 0 0-85.334h-256a128 128 0 0 0-128 128v469.334a128 128 0 0 0 128 128h469.334a128 128 0 0 0 128-128v-256a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V341.333a42.667 42.667 0 0 1 12.501-30.165z"
  }));
};

var SvgSortDefault1Icon = function SvgSortDefault1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sort_default1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M465.579 105.43 230.656 356.01c-38.101 40.662-9.259 107.137 46.421 107.137h469.846c55.68 0 84.48-66.475 46.421-107.094L558.421 105.387a63.616 63.616 0 0 0-92.842 0zm91.818 815.829 230.187-204.63c46.933-41.728 17.45-119.381-45.355-119.381H281.771c-62.806 0-92.331 77.653-45.355 119.381l230.187 204.63c25.898 23.04 64.896 23.04 90.794 0z"
  }));
};

var SvgSortIcon = function SvgSortIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sort_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 149.333a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm0 426.667a42.667 42.667 0 1 0 0 85.333H896A42.667 42.667 0 1 0 896 576H469.333zm-42.666-170.667a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 448H469.333a42.667 42.667 0 0 1-42.666-42.667zm42.666 384a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm-234.666-704a42.667 42.667 0 0 1 30.165 12.502L371.499 204.5a42.667 42.667 0 0 1-60.331 60.331l-33.835-33.835V384A42.667 42.667 0 0 1 192 384V230.997l-33.835 33.835a42.667 42.667 0 0 1-60.33-60.33L204.5 97.834a42.667 42.667 0 0 1 30.166-12.502zm0 853.334a42.667 42.667 0 0 0 30.165-12.502L371.499 819.5a42.667 42.667 0 1 0-60.331-60.331l-33.835 33.835V640A42.667 42.667 0 1 0 192 640v153.003l-33.835-33.835a42.667 42.667 0 0 0-60.33 60.33L204.5 926.166a42.667 42.667 0 0 0 30.166 12.502z"
  }));
};

var SvgSpotIcon = function SvgSpotIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M785.92 128.939A158.805 158.805 0 0 1 901.12 281.6V320a43.52 43.52 0 0 1-87.04 0v-38.4a71.68 71.68 0 0 0-71.68-71.68H704a43.52 43.52 0 0 1-30.72-74.283l38.4-38.4a43.52 43.52 0 0 1 74.24 31.702zM263.253 679.168a312.32 312.32 0 1 1 416-416 43.52 43.52 0 0 1-13.952 54.016 312.363 312.363 0 1 1-348.16 348.16 43.52 43.52 0 0 1-53.888 13.824zm52.011-67.285A312.32 312.32 0 0 1 612.011 315.22a43.392 43.392 0 0 1-11.435-14.762 225.28 225.28 0 1 0-300.032 300.074c5.845 2.774 10.795 6.656 14.72 11.35zM852.437 627.2a225.28 225.28 0 1 0-450.517 0 225.28 225.28 0 0 0 450.56 0zm-729.6 76.8a43.52 43.52 0 0 1 87.04 0v38.4c0 39.595 32.128 71.68 71.68 71.68h38.4a43.52 43.52 0 0 1 30.806 74.283l-38.4 38.4a43.52 43.52 0 0 1-74.24-31.659A158.805 158.805 0 0 1 122.795 742.4V704z"
  }));
};

var SvgSpsxNew1Icon = function SvgSpsxNew1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spsx-new1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192h603.562a42.667 42.667 0 1 0 0-85.334H335.147A149.419 149.419 0 0 0 192 362.667zM351.317 384v-43.35h67.414V172.886h-3.286l-50.858 66.688-34.432-26.88 59.861-78.848h82.432v206.806h53.035V384H351.317zm378.752 0H553.003v-49.067l77.098-65.962c6.912-5.974 12.8-11.35 17.579-16.128 4.736-5.035 8.576-9.814 11.435-14.336 3.114-4.779 5.248-9.43 6.485-13.995 1.408-4.523 2.133-9.43 2.133-14.677V204.8a26.283 26.283 0 0 0-10.41-21.504 39.424 39.424 0 0 0-22.614-7.168 40.363 40.363 0 0 0-15.701 2.859 37.803 37.803 0 0 0-11.52 7.893 42.325 42.325 0 0 0-7.85 11.093 60.975 60.975 0 0 0-5.035 13.27l-46.934-17.92a104.25 104.25 0 0 1 11.819-24.32c5.035-7.936 11.221-14.72 18.645-20.48 7.68-5.974 16.64-10.624 26.88-13.952 10.24-3.371 21.846-5.035 34.774-5.035 13.61 0 25.685 1.92 36.181 5.76 10.539 3.84 19.37 9.045 26.539 15.787 7.381 6.656 13.013 14.677 16.853 23.978 3.84 9.088 5.717 18.987 5.717 29.739 0 10.752-1.792 20.565-5.376 29.397a102.912 102.912 0 0 1-14.72 25.088c-5.973 7.68-13.013 14.934-21.12 21.846-8.106 6.954-16.64 13.994-25.429 21.162l-46.635 36.566H730.07V384zm111.275-151.253c13.355 0 23.04-2.475 29.013-7.51a24.405 24.405 0 0 0 9.302-19.37v-2.475a28.288 28.288 0 0 0-8.96-21.888c-5.718-5.504-13.952-8.235-24.747-8.235-9.984 0-19.456 2.646-28.288 7.894a65.579 65.579 0 0 0-22.57 21.845l-33.707-31.573c4.821-6.187 9.941-11.776 15.445-16.811 5.461-5.248 11.69-9.685 18.603-13.227a87.04 87.04 0 0 1 23.296-8.618 119.893 119.893 0 0 1 29.013-3.243c13.397 0 25.472 1.579 36.267 4.693 10.965 3.072 20.266 7.638 27.904 13.611 7.893 5.717 13.866 12.63 17.92 20.779 4.309 8.106 6.485 17.194 6.485 27.221 0 7.893-1.323 15.061-3.968 21.504a48.725 48.725 0 0 1-10.368 16.853 55.893 55.893 0 0 1-15.061 11.819 68.565 68.565 0 0 1-18.262 6.101v2.134c7.382 1.45 14.208 3.84 20.395 7.168 6.443 3.114 11.947 7.168 16.512 12.202 4.779 5.035 8.448 11.008 11.093 17.92 2.646 6.699 3.968 14.336 3.968 22.955 0 11.221-2.304 21.333-6.826 30.464a67.03 67.03 0 0 1-19.371 23.296 93.653 93.653 0 0 1-30.08 15.019 140.587 140.587 0 0 1-38.699 5.034c-12.672 0-23.893-1.28-33.706-3.925a105.813 105.813 0 0 1-25.814-10.41 100.992 100.992 0 0 1-18.986-15.403 127.744 127.744 0 0 1-13.995-18.304l39.808-30.806c5.461 10.24 12.16 18.774 20.053 25.43 8.107 6.485 18.987 9.685 32.64 9.685 12.16 0 21.59-2.987 28.288-8.96a32 32 0 0 0 10.411-25.088v-2.133c0-10.283-3.968-17.92-11.819-22.955-7.68-5.248-18.304-7.893-31.914-7.893h-22.614v-44.8h23.339z"
  }));
};

var SvgSpsxIcon = function SvgSpsxIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spsx_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192h603.52a42.667 42.667 0 1 0 0-85.334h-603.52A149.419 149.419 0 0 0 192 362.667z"
  }));
};

var SvgSquareIcon = function SvgSquareIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "square_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666v597.334a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zm-128 42.666a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V213.333z"
  }));
};

var SvgStarnoIcon = function SvgStarnoIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "starno_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a42.667 42.667 0 0 1 38.272 23.765l121.899 247.04 272.64 39.85a42.667 42.667 0 0 1 23.637 72.747L771.2 618.197l46.507 271.446a42.667 42.667 0 0 1-61.867 44.97L512 806.4 268.16 934.613a42.667 42.667 0 0 1-61.867-44.97L252.8 618.197 55.552 426.07a42.667 42.667 0 0 1 23.595-72.746l272.64-39.894L473.728 66.432A42.667 42.667 0 0 1 512 42.667zm0 139.093-93.568 189.525a42.667 42.667 0 0 1-32.085 23.296L176.98 425.216l151.467 147.499a42.667 42.667 0 0 1 12.288 37.76L304.98 818.816l187.179-98.432a42.667 42.667 0 0 1 39.68 0l187.179 98.432-35.755-208.341a42.667 42.667 0 0 1 12.288-37.76l151.467-147.499-209.366-30.635a42.667 42.667 0 0 1-32.085-23.296L512 181.717z"
  }));
};

var SvgStaryesIcon = function SvgStaryesIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "staryes_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a42.667 42.667 0 0 1 38.272 23.765l121.899 247.04 272.64 39.85a42.667 42.667 0 0 1 23.637 72.747L771.2 618.197l46.507 271.446a42.667 42.667 0 0 1-61.867 44.97L512 806.4 268.16 934.613a42.667 42.667 0 0 1-61.867-44.97L252.8 618.197 55.552 426.07a42.667 42.667 0 0 1 23.595-72.746l272.64-39.894L473.728 66.432A42.667 42.667 0 0 1 512 42.667z"
  }));
};

var SvgStrategyIcon = function SvgStrategyIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "strategy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M298.667 85.333h426.666a213.333 213.333 0 0 1 213.334 213.334V512a213.333 213.333 0 0 1-213.334 213.333H298.667A213.333 213.333 0 0 1 85.333 512V298.667A213.333 213.333 0 0 1 298.667 85.333zm0 85.334a128 128 0 0 0-128 128V512a128 128 0 0 0 128 128h426.666a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H298.667zm246.528 128A42.667 42.667 0 0 1 587.86 256h137.472a42.667 42.667 0 0 1 30.166 72.832l-189.61 189.653a42.667 42.667 0 0 1-53.845 5.334l-71.168-47.446-118.528 79.019a42.667 42.667 0 1 1-47.36-70.997l142.293-94.806a42.667 42.667 0 0 1 47.36 0l65.707 43.819 91.946-92.075H587.82a42.667 42.667 0 0 1-42.667-42.666zM294.784 927.445a1536.085 1536.085 0 0 1 434.432 0l75.435 10.795a42.667 42.667 0 1 0 12.032-84.48l-75.392-10.795a1621.419 1621.419 0 0 0-458.582 0l-75.392 10.795a42.667 42.667 0 1 0 12.075 84.48l75.392-10.795z"
  }));
};

var SvgStrategyhistoryIcon = function SvgStrategyhistoryIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "strategyhistory_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M554.667 729.6a153.6 153.6 0 1 1 307.2 0 153.6 153.6 0 0 1-307.2 0zm153.6-230.4a230.4 230.4 0 1 0 0 460.8 230.4 230.4 0 0 0 0-460.8zm28.8 172.8a38.4 38.4 0 1 0-76.8 0v76.8c0 12.8 6.4 24.832 17.066 31.957l57.6 38.4a38.4 38.4 0 1 0 42.667-63.914l-40.533-27.008V672zM85.333 256A170.667 170.667 0 0 1 256 85.333h426.667A170.667 170.667 0 0 1 853.333 256v128A42.667 42.667 0 1 1 768 384V256a85.333 85.333 0 0 0-85.333-85.333H256A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h128a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V256zm587.435 112.64a42.667 42.667 0 1 0-65.536-54.613l-79.019 94.72-116.48-99.84a42.667 42.667 0 0 0-60.586 5.12l-106.667 128a42.667 42.667 0 0 0 65.579 54.613l79.061-94.72 116.48 99.84a42.667 42.667 0 0 0 60.587-5.12l106.666-128z"
  }));
};

var SvgStratrgyorderIcon = function SvgStratrgyorderIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "stratrgyorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M341.333 234.667a85.333 85.333 0 0 1 85.334-85.334h218.581a85.333 85.333 0 0 1 59.221 23.894l122.752 118.4a85.333 85.333 0 0 1 26.112 61.44V640A85.333 85.333 0 0 1 768 725.333H426.667A85.333 85.333 0 0 1 341.333 640V234.667zM426.667 64A170.667 170.667 0 0 0 256 234.667 170.667 170.667 0 0 0 85.333 405.333v384A170.667 170.667 0 0 0 256 960h302.507a166.827 166.827 0 0 0 165.93-149.333H768A170.667 170.667 0 0 0 938.667 640V353.067a170.667 170.667 0 0 0-52.224-122.88l-122.71-118.358A170.667 170.667 0 0 0 645.205 64H426.667zm211.456 746.667a81.536 81.536 0 0 1-79.616 64H256a85.333 85.333 0 0 1-85.333-85.334v-384A85.333 85.333 0 0 1 256 320v320a170.667 170.667 0 0 0 170.667 170.667h211.456zm-168.79-405.334a42.667 42.667 0 1 1 0-85.333H640a42.667 42.667 0 1 1 0 85.333H469.333zm-42.666 128A42.667 42.667 0 0 0 469.333 576h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0-42.666 42.666z"
  }));
};

var SvgSubtractIcon = function SvgSubtractIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "subtract_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zM755.5 398.507 456.832 682.965a44.203 44.203 0 0 1-60.33 0l-128-121.898a39.253 39.253 0 0 1 0-57.472 44.203 44.203 0 0 1 60.33 0l97.835 93.141 268.501-255.701a44.203 44.203 0 0 1 60.33 0 39.253 39.253 0 0 1 0 57.472z"
  }));
};

var SvgSunIcon = function SvgSunIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sun_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 0a42.667 42.667 0 0 1 42.667 42.667V128a42.667 42.667 0 1 1-85.334 0V42.667A42.667 42.667 0 0 1 512 0zm362.112 149.888a42.667 42.667 0 0 1 0 60.33l-60.587 60.587a42.667 42.667 0 1 1-60.33-60.33l60.586-60.587a42.667 42.667 0 0 1 60.331 0zM341.333 512a170.667 170.667 0 1 1 341.334 0 170.667 170.667 0 0 1-341.334 0zM512 256a256 256 0 1 0 0 512 256 256 0 0 0 0-512zM0 512a42.667 42.667 0 0 1 42.667-42.667H128a42.667 42.667 0 1 1 0 85.334H42.667A42.667 42.667 0 0 1 0 512zm896-42.667a42.667 42.667 0 1 0 0 85.334h85.333a42.667 42.667 0 1 0 0-85.334H896zM270.805 753.195a42.667 42.667 0 0 1 0 60.33l-60.586 60.587a42.667 42.667 0 0 1-60.331-60.33l60.587-60.587a42.667 42.667 0 0 1 60.33 0zm482.39 0a42.667 42.667 0 0 1 60.33 0l60.587 60.586a42.667 42.667 0 0 1-60.33 60.331l-60.587-60.587a42.667 42.667 0 0 1 0-60.33zM210.219 149.888a42.667 42.667 0 0 0-60.331 60.33l60.587 60.587a42.667 42.667 0 0 0 60.33-60.33l-60.586-60.587zM554.667 896a42.667 42.667 0 1 0-85.334 0v85.333a42.667 42.667 0 1 0 85.334 0V896z"
  }));
};

var SvgSystemExchangeAppIcon = function SvgSystemExchangeAppIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "system_exchange_app_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm277.845 320C402.347 469.333 384 488.448 384 512s18.347 42.667 41.045 42.667h451.243c22.699 0 41.045-19.115 41.045-42.667s-18.346-42.667-41.045-42.667H425.045zM106.667 832c0-23.552 18.133-42.667 40.533-42.667h729.6c22.4 0 40.533 19.115 40.533 42.667S899.2 874.667 876.8 874.667H147.2c-22.4 0-40.533-19.115-40.533-42.667zM266.24 487.125l-116.48-97.152c-12.075-10.069-29.013-7.082-37.845 6.656a33.792 33.792 0 0 0-5.206 18.176v194.39c0 17.024 12.118 30.805 27.051 30.805a24.917 24.917 0 0 0 16-5.973l116.523-97.152c12.074-10.07 14.677-29.355 5.845-43.094a29.312 29.312 0 0 0-5.845-6.656z"
  }));
};

var SvgSystemExchangeWebIcon = function SvgSystemExchangeWebIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "system_exchange_web_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm0 640c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 789.333 876.8 789.333H147.2zm764.16-319.616L814.208 586.24a29.397 29.397 0 0 1-6.656 5.845c-13.739 8.832-33.024 6.23-43.093-5.845l-97.152-116.48a24.917 24.917 0 0 1-5.931-16c0-14.933 13.781-27.05 30.805-27.05h194.39c6.528 0 12.928 1.834 18.176 5.247 13.738 8.79 16.725 25.728 6.656 37.803zm-762.027-.384a42.667 42.667 0 1 0 0 85.334h384a42.667 42.667 0 1 0 0-85.334h-384z"
  }));
};

var SvgTacticsIcon = function SvgTacticsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "tactics_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M558.507 42.667a42.667 42.667 0 1 0-85.334 0v42.666a42.667 42.667 0 0 0 85.334 0V42.667zM42.667 495.36a42.667 42.667 0 1 0 0 85.333h31.061a42.667 42.667 0 0 0 0-85.333H42.667zm115.2-361.301a41.515 41.515 0 0 1 59.605 0l29.867 30.506a43.861 43.861 0 0 1 0 61.014 41.515 41.515 0 0 1-59.691 0l-29.781-30.464a43.861 43.861 0 0 1 0-61.014zm691.84 106.794 29.824-30.506a43.861 43.861 0 0 0 0-61.014 41.515 41.515 0 0 0-59.648 0l-29.867 30.507a43.861 43.861 0 0 0 0 61.013 41.515 41.515 0 0 0 59.69 0zm46.122 297.174a42.667 42.667 0 0 1 42.667-42.667h36.992a42.667 42.667 0 1 1 0 85.333h-36.992a42.667 42.667 0 0 1-42.667-42.666zm-153.856 268.97 20.224-20.736c138.24-141.44 138.24-370.773 0-512.17a348.288 348.288 0 0 0-500.522 0c-138.24 141.44-138.24 370.773 0 512.17l20.224 20.736c1.749 1.75 2.73 4.182 2.73 6.656 0 55.211 43.734 100.011 97.707 100.011h259.2c53.973 0 97.707-44.8 97.707-100.01 0-2.475.981-4.907 2.73-6.657zM702.55 335.104c105.302 107.733 105.302 282.41 0 390.144l-20.224 20.693c-17.536 17.963-27.434 42.326-27.434 67.712 0 7.552-5.974 13.654-13.355 13.654h-259.2a13.525 13.525 0 0 1-13.355-13.654c0-25.386-9.856-49.749-27.434-67.712l-20.224-20.693c-105.302-107.733-105.302-282.41 0-390.144a265.301 265.301 0 0 1 381.226 0zM381.141 938.667a42.667 42.667 0 1 0 0 85.333h256a42.667 42.667 0 0 0 0-85.333h-256zm299.35-474.71a42.667 42.667 0 0 1 2.517 60.288l-98.56 107.179a42.667 42.667 0 0 1-65.28-2.944l-51.243-66.859-64.298 69.846a42.667 42.667 0 1 1-62.806-57.771l98.56-107.136a42.667 42.667 0 0 1 65.28 2.901l51.243 66.859 64.213-69.803A42.667 42.667 0 0 1 680.405 464z"
  }));
};

var SvgTaskIcon = function SvgTaskIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M6 1.5a1 1 0 0 0-2 0V21H2.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H6v-6h12.43a2 2 0 0 0 1.812-2.846L18.77 9l1.472-3.154A2 2 0 0 0 18.43 3H6V1.5ZM18.43 13H6V5h12.43l-1.472 3.154a2 2 0 0 0 0 1.692L18.43 13ZM10.5 8a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Z"
  }));
};

var SvgTelegramIcon = function SvgTelegramIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm3.498 16.668a.777.777 0 0 1-1.103.386l-2.986-2.32-1.916 1.768a.33.33 0 0 1-.314.043l.367-3.287.012.01.008-.066s5.373-4.892 5.592-5.1c.222-.208.149-.254.149-.254.012-.253-.398 0-.398 0l-7.12 4.58-2.965-1.009s-.455-.163-.498-.522c-.045-.357.513-.55.513-.55l11.789-4.684s.969-.431.969.284l-2.1 10.72Z"
  }));
};

var SvgTerminateIcon = function SvgTerminateIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.287 5.355a1 1 0 0 1-.12 1.41 7.5 7.5 0 1 0 9.665 0 1 1 0 1 1 1.29-1.53 9.5 9.5 0 1 1-12.245 0 1 1 0 0 1 1.41.12Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z",
    clipRule: "evenodd"
  }));
};

var SvgThumbsDownIcon = function SvgThumbsDownIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "thumbs_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M810.667 85.333H267.52a128 128 0 0 0-125.867 104.96L87.467 488.96A128 128 0 0 0 213.333 640h194.56L384 701.013a176.213 176.213 0 0 0 165.973 237.654 42.667 42.667 0 0 0 38.827-25.174L710.4 640h100.267a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128zM640 588.373l-116.053 261.12a90.88 90.88 0 0 1-58.88-118.613l22.613-61.013a85.333 85.333 0 0 0-79.787-115.2h-194.56a42.667 42.667 0 0 1-32.853-15.36 42.667 42.667 0 0 1-9.813-34.987l54.186-298.667a42.667 42.667 0 0 1 42.667-34.986H640v417.706zM853.333 512a42.667 42.667 0 0 1-42.666 42.667h-85.334v-384h85.334a42.667 42.667 0 0 1 42.666 42.666V512z"
  }));
};

var SvgThumbsUpIcon = function SvgThumbsUpIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "thumbs_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M908.8 430.08A128 128 0 0 0 810.667 384h-194.56L640 322.987A176.213 176.213 0 0 0 474.027 85.333a42.667 42.667 0 0 0-38.827 25.174L313.6 384H213.333a128 128 0 0 0-128 128v298.667a128 128 0 0 0 128 128H756.48a128 128 0 0 0 125.867-104.96l54.186-298.667A128 128 0 0 0 908.8 430.08zM298.667 853.333h-85.334a42.667 42.667 0 0 1-42.666-42.666V512a42.667 42.667 0 0 1 42.666-42.667h85.334v384zM853.333 519.68l-54.186 298.667a42.667 42.667 0 0 1-42.667 34.986H384V435.627l116.053-261.12a90.027 90.027 0 0 1 58.88 118.613l-22.613 61.013a85.333 85.333 0 0 0 79.787 115.2h194.56a42.667 42.667 0 0 1 32.853 15.36 42.667 42.667 0 0 1 9.813 34.987z"
  }));
};

var SvgTogglechartIcon = function SvgTogglechartIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "togglechart_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666v597.334a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zm-128 42.666a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V213.333zM896 554.667H128v-85.334h768v85.334zM469.333 896V128h85.334v768h-85.334z"
  }));
};

var SvgTopLeftIcon = function SvgTopLeftIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "top_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M403.755 343.467h319.36a42.667 42.667 0 1 0 0-85.334H301.14a43.093 43.093 0 0 0-43.093 43.094V723.2a42.667 42.667 0 0 0 85.333 0V403.84l351.446 351.445c15.616 15.616 41.813 14.763 58.453-1.92 16.64-16.64 17.493-42.794 1.92-58.453L403.755 343.509z"
  }));
};

var SvgTopRightIcon = function SvgTopRightIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "top_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M680.576 403.84V723.2a42.667 42.667 0 1 0 85.333 0V301.227a43.093 43.093 0 0 0-43.093-43.094H300.843a42.667 42.667 0 1 0 0 85.334h319.402L268.8 694.955c-15.616 15.658-14.763 41.813 1.92 58.453 16.64 16.683 42.837 17.493 58.453 1.92l351.403-351.445z"
  }));
};

var SvgTradingIcon = function SvgTradingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667z"
  }), createElement("path", {
    fill: "currentColor",
    d: "m588.373 633.6 182.912-174.933a44.394 44.394 0 0 0 10.07-14.08 42.07 42.07 0 0 0-9.686-48.086 46.635 46.635 0 0 0-63.957.555l-149.76 143.317-87.51-90.922a46.507 46.507 0 0 0-65.365-.768l-136.32 134.741A42.539 42.539 0 0 0 256 614.485a42.667 42.667 0 0 0 13.91 30.55c8.66 7.936 20.138 12.245 32 12.032 11.775-.214 23.125-4.864 31.445-13.142l103.21-101.973 86.998 90.325c4.096 4.31 9.088 7.723 14.592 10.112a46.507 46.507 0 0 0 50.218-8.789z"
  }));
};

var SvgTradingbotIcon = function SvgTradingbotIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "tradingbot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M468.992 120.917a42.667 42.667 0 0 1 42.667-42.666h78.208a42.667 42.667 0 1 1 0 85.333H554.41l-.171 67.541h153.088a163.541 163.541 0 0 1 163.584 163.542v39.338a117.333 117.333 0 0 1 110.25 117.12v78.251a117.333 117.333 0 0 1-110.25 117.12v39.296a163.541 163.541 0 0 1-163.584 163.541H316.203A163.541 163.541 0 0 1 152.66 785.792v-39.296A117.333 117.333 0 0 1 42.496 629.333v-78.208a117.333 117.333 0 0 1 110.165-117.12v-39.338a163.541 163.541 0 0 1 163.542-163.542h152.746l.214-106.496a42.496 42.496 0 0 1-.171-3.712zm433.92 508.459v-78.208a39.125 39.125 0 0 0-32-38.485V667.86a39.125 39.125 0 0 0 32-38.485zm-750.25 38.443V512.683a39.125 39.125 0 0 0-31.958 38.485v78.208c0 19.157 13.781 35.072 32 38.443zm85.333.682v117.291c0 43.179 34.986 78.208 78.208 78.208h391.125c43.221 0 78.25-34.987 78.25-78.208V394.667c0-43.179-35.029-78.208-78.25-78.208H316.203c-43.179 0-78.208 34.986-78.208 78.208V512h.042v156.501zM417.707 512a42.667 42.667 0 1 0-85.334 0v156.459a42.667 42.667 0 1 0 85.334 0V512zm230.997-42.667A42.667 42.667 0 0 1 691.371 512v156.459a42.667 42.667 0 1 1-85.334 0V512a42.667 42.667 0 0 1 42.667-42.667z"
  }));
};

var SvgTransferassetsIcon = function SvgTransferassetsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transferassets_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M776.96 682.667 636.501 823.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333-2.901-1.194c9.557-7.595 15.403-17.792 15.403-28.971 0-23.552-25.942-42.667-57.899-42.667h-694.87c-32 0-57.898 19.115-57.898 42.667s25.941 42.667 57.899 42.667h607.104zM398.208 200.832 257.707 341.333H864.81c32 0 57.898 19.115 57.898 42.667s-25.941 42.667-57.898 42.667H169.899c-32 0-57.899-19.115-57.899-42.667 0-11.179 5.845-21.333 15.36-28.97l-2.859-1.195L337.835 140.5a42.667 42.667 0 0 1 60.33 60.331z"
  }));
};

var SvgTransforIcon = function SvgTransforIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transfor_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M730.112 96.256a41.216 41.216 0 0 0-58.667 2.816 42.283 42.283 0 0 0 2.816 59.307l72.747 66.858H321.749a200.533 200.533 0 0 0-135.594 51.883C149.46 310.827 128 357.504 128 407.083v69.973c0 23.168 18.603 41.941 41.515 41.941s41.514-18.773 41.514-41.941V407.04c0-24.619 10.582-49.11 30.976-67.84a118.059 118.059 0 0 1 79.744-30.08h425.259l-72.747 66.859a42.283 42.283 0 0 0-2.816 59.306 41.216 41.216 0 0 0 58.667 2.816L880.64 299.733c9.387-7.68 15.36-19.413 15.36-32.597a42.07 42.07 0 0 0-15.232-32.427L730.112 96.213zM896 546.986a41.728 41.728 0 0 0-41.515-41.983 41.728 41.728 0 0 0-41.514 41.984v69.93c0 24.619-10.582 49.11-30.976 67.84a118.059 118.059 0 0 1-79.744 30.08H276.907l72.789-66.858a42.283 42.283 0 0 0 2.773-59.307 41.216 41.216 0 0 0-58.624-2.816L141.568 725.76A42.027 42.027 0 0 0 128 756.139v.682a42.08 42.08 0 0 0 14.08 31.488l151.723 139.435a41.216 41.216 0 0 0 58.624-2.816 42.283 42.283 0 0 0-2.774-59.307l-72.746-66.858h425.386a200.533 200.533 0 0 0 135.552-51.883C874.54 713.173 896 666.496 896 616.917v-69.973z"
  }));
};

var SvgTransmitterIcon = function SvgTransmitterIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transmitter_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M860.587 393.813 263.253 147.2A128 128 0 0 0 92.587 305.067L158.293 512 90.88 718.933a128 128 0 0 0 34.56 134.4 128 128 0 0 0 85.333 34.134c16.854 0 33.536-3.328 49.067-9.814L859.307 631.04a128 128 0 0 0 0-236.373l1.28-.854zM228.693 797.867a42.667 42.667 0 0 1-45.226-8.107 42.667 42.667 0 0 1-11.52-42.667l62.293-192.426h585.813l-591.36 243.2zm5.547-328.534-63.573-190.72a42.667 42.667 0 0 1 11.52-42.666 42.667 42.667 0 0 1 47.786-9.814l590.08 243.2H234.24z"
  }));
};

var SvgTrashIcon = function SvgTrashIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trash_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M405.333 213.333V256h213.334v-42.667A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666zM320 256v-42.667a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128V256h192a42.667 42.667 0 1 1 0 85.333h-42.667V768a170.667 170.667 0 0 1-170.666 170.667H341.333A170.667 170.667 0 0 1 170.667 768V341.333H128A42.667 42.667 0 0 1 128 256h192zm341.333 85.333H256V768a85.333 85.333 0 0 0 85.333 85.333h341.334A85.333 85.333 0 0 0 768 768V341.333H661.333zm-234.666 128A42.667 42.667 0 0 1 469.333 512v170.667a42.667 42.667 0 1 1-85.333 0V512a42.667 42.667 0 0 1 42.667-42.667zM640 512a42.667 42.667 0 1 0-85.333 0v170.667a42.667 42.667 0 1 0 85.333 0V512z"
  }));
};

var SvgTrendlIcon = function SvgTrendlIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trendl_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658l-349.44 349.483a149.333 149.333 0 1 1-63.36-57.301l355.499-355.542A148.779 148.779 0 0 1 640 234.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
  }));
};

var SvgUnblockIcon = function SvgUnblockIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "unblock_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M42.667 512a42.667 42.667 0 0 0 42.666 42.667h451.84l-98.133 97.706a42.752 42.752 0 0 0 13.867 69.931 42.667 42.667 0 0 0 46.72-9.344l170.666-170.667a42.667 42.667 0 0 0 8.96-14.08 42.667 42.667 0 0 0 0-32.426 42.667 42.667 0 0 0-8.96-14.08L499.627 311.04a42.795 42.795 0 1 0-60.587 60.587l98.133 97.706H85.333A42.667 42.667 0 0 0 42.667 512zm768-426.667H341.333a128 128 0 0 0-128 128v85.334a42.667 42.667 0 0 0 85.334 0v-85.334a42.667 42.667 0 0 1 42.666-42.666h469.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334a42.667 42.667 0 1 0-85.334 0v85.334a128 128 0 0 0 128 128h469.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128z"
  }));
};

var SvgUpcomingIcon = function SvgUpcomingIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "upcoming_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 0 0-384 384 382.72 382.72 0 0 0 115.2 274.219l-59.733 60.928A468.053 468.053 0 0 1 42.667 512C42.667 252.8 252.8 42.667 512 42.667V128zm0-85.333c15.53 0 30.848.768 45.995 2.218l-8.278 84.907A389.12 389.12 0 0 0 512.085 128V42.667zm136.32 20.096a468.376 468.376 0 0 1 85.035 35.242l-40.278 75.264a381.44 381.44 0 0 0-69.546-28.842l24.746-81.664zm161.493 86.442a472.984 472.984 0 0 1 65.024 65.024l-65.92 54.187a386.56 386.56 0 0 0-53.29-53.29l54.186-65.92zm116.182 141.483a465.505 465.505 0 0 1 35.285 85.035l-81.664 24.746a381.525 381.525 0 0 0-28.843-69.504l75.222-40.277zm53.162 175.36a474.837 474.837 0 0 1 0 91.904l-84.906-8.235a390.101 390.101 0 0 0 0-75.434l84.906-8.235zm-17.92 182.187a461.552 461.552 0 0 1-35.242 85.077l-75.222-40.277a382.002 382.002 0 0 0 28.843-69.547l81.664 24.747zm-86.4 161.536a472.405 472.405 0 0 1-65.024 65.024l-54.186-65.92a386.56 386.56 0 0 0 53.29-53.291l65.92 54.187zm-657.365 67.626c-11.819-9.557-23.168-19.626-33.963-30.25l59.734-60.928c8.874 8.704 18.133 16.981 27.818 24.746l-53.589 66.432zm515.84 48.598c-26.88 14.378-55.296 26.24-84.992 35.242l-24.747-81.664a381.61 381.61 0 0 0 69.504-28.8l40.278 75.179zm-355.84 35.754a466.347 466.347 0 0 1-84.139-34.389l39.808-75.52A379.96 379.96 0 0 0 401.877 880l-24.405 81.75zm180.523 17.366a473.387 473.387 0 0 1-91.307.042l8.107-84.906a388.48 388.48 0 0 0 74.922-.086l8.278 84.907zm-3.328-637.782a42.667 42.667 0 1 0-85.334 0v213.334A42.667 42.667 0 0 0 512 597.333h170.667a42.667 42.667 0 1 0 0-85.333h-128V341.333z"
  }));
};

var SvgUptoIcon = function SvgUptoIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "upto_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 128a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 128zm384 810.667A42.667 42.667 0 0 1 469.333 896V401.664L286.165 584.832a42.667 42.667 0 0 1-60.33-60.33l256-256a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L554.667 401.664V896A42.667 42.667 0 0 1 512 938.667z"
  }));
};

var SvgUsdcIcon = function SvgUsdcIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "usdc_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M917.333 512a405.333 405.333 0 1 1-810.666 0 405.333 405.333 0 0 1 810.666 0zM512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zm101.675-817.92a22.741 22.741 0 0 0-20.95 2.944 23.552 23.552 0 0 0-9.088 19.328v27.904a29.44 29.44 0 0 0 4.992 15.787 27.435 27.435 0 0 0 12.886 10.795c108.032 40.448 185.258 146.688 185.258 271.445 0 124.373-77.525 230.955-185.173 271.403-11.563 4.053-17.92 15.53-17.92 26.624v27.904c0 7.722 2.901 14.848 8.875 19.328 5.973 4.522 13.653 5.29 21.077 2.986l.085-.042c144.214-47.318 248.15-185.259 248.15-348.587 0-162.859-103.894-301.227-248.192-347.776zM431.488 166.4c5.93 4.437 8.875 11.605 8.875 19.285v27.904a29.44 29.44 0 0 1-4.992 15.787 27.477 27.477 0 0 1-12.886 10.795C314.453 281.003 237.227 387.584 237.227 512c0 124.8 77.226 230.997 185.258 271.445 5.547 2.091 9.942 6.315 12.886 10.795a29.44 29.44 0 0 1 4.992 15.787v28.288c0 7.808-3.115 14.933-9.088 19.328a22.741 22.741 0 0 1-20.992 2.901C266.069 813.269 162.133 675.285 162.133 512c0-162.901 103.936-301.227 248.15-348.587h.085a22.912 22.912 0 0 1 21.077 2.987zm49.835 132.224c0-12.715 10.154-23.424 23.04-23.424h29.013c12.885 0 23.04 10.71 23.04 23.424v40.277c21.59 4.95 39.936 14.08 54.315 27.478 15.957 14.89 26.624 34.645 31.829 58.794a22.101 22.101 0 0 1-21.76 26.71h-30.464a22.955 22.955 0 0 1-21.973-16.939c-3.755-12.8-9.814-21.205-18.091-26.624-8.533-5.547-20.352-8.533-36.821-8.533-17.92 0-30.379 4.437-38.187 10.88a32.64 32.64 0 0 0-11.69 26.368c0 12.928 2.517 20.394 9.813 26.197 8.234 6.613 23.765 12.075 53.205 16.341 40.15 5.59 72.363 14.507 94.592 31.915 22.87 17.92 33.877 43.99 33.877 80.683 0 55.424-38.912 99.968-98.261 112.384v49.066h-1.963a23.04 23.04 0 0 1-21.461 14.891h-29.013a23.253 23.253 0 0 1-23.04-23.424v-39.595c-29.568-5.333-52.566-16.725-69.462-33.28-18.218-17.92-28.672-41.173-33.066-67.456a22.187 22.187 0 0 1 21.845-25.941h32.981c11.35 0 20.31 8.448 22.486 18.603v.085c2.901 13.653 7.978 24.576 17.194 32.256 9.259 7.637 23.894 13.056 48.128 13.056 17.067 0 31.104-4.95 40.662-12.843a40.533 40.533 0 0 0 14.976-32.213c0-14.421-3.414-22.443-11.307-28.501-8.96-6.827-24.704-11.99-52.181-16.64-40.875-5.632-72.747-14.976-94.336-32.342-22.272-17.877-32.598-43.221-32.598-77.653 0-52.992 37.974-94.165 94.678-105.088v-38.912z"
  }));
};

var SvgUserIcon = function SvgUserIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "user_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 896c99.328 0 189.867-37.717 258.005-99.584a266.795 266.795 0 0 0-516.01 0A382.592 382.592 0 0 0 512 896zm133.035-357.973A353.28 353.28 0 0 1 833.92 721.408a384 384 0 1 0-643.84 0 353.28 353.28 0 0 1 188.885-183.424 195.541 195.541 0 1 1 266.07 0zM981.333 512c0 120.192-45.184 229.845-119.466 312.875l-1.494 1.621-.981 1.067a472.107 472.107 0 0 1-83.115 72.362A467.2 467.2 0 0 1 512 981.333a467.2 467.2 0 0 1-271.701-86.613 471.979 471.979 0 0 1-78.166-69.803A467.584 467.584 0 0 1 42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512zM622.208 394.667a110.208 110.208 0 1 0-220.416 0 110.208 110.208 0 0 0 220.416 0z"
  }));
};

var SvgVerticalIcon = function SvgVerticalIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "vertical_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M469.333 655.147v283.52a42.667 42.667 0 1 0 85.334 0v-283.52a149.419 149.419 0 0 0 0-286.294V85.333a42.667 42.667 0 1 0-85.334 0v283.52a149.419 149.419 0 0 0 0 286.294zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgVideoIcon = function SvgVideoIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "video_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 512c0 188.672 152.661 341.333 341.333 341.333 188.672 0 341.333-152.661 341.333-341.333 0-188.672-152.661-341.333-341.333-341.333-188.672 0-341.333 152.661-341.333 341.333zm768 0c0 235.776-190.891 426.667-426.667 426.667S85.333 747.776 85.333 512 276.224 85.333 512 85.333 938.667 276.224 938.667 512zM373.333 624.939a85.333 85.333 0 0 0 130.56 72.362L667.52 595.03a85.333 85.333 0 0 0 0-144.725L503.893 348.032a85.333 85.333 0 0 0-130.56 72.363v204.544zm248.96-102.272L458.667 624.939V420.395l163.626 102.272z"
  }));
};

var SvgViewProfileIcon = function SvgViewProfileIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "view_profile_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M938.667 213.333c0-34.133-12.8-68.266-38.4-89.6-21.334-25.6-55.467-38.4-89.6-38.4H213.333c-34.133 0-64 17.067-89.6 38.4-25.6 21.334-38.4 55.467-38.4 89.6v597.334c0 34.133 12.8 68.266 38.4 89.6 21.334 25.6 55.467 38.4 89.6 38.4h213.334c4.266 0 12.8 0 17.066-4.267 4.267 0 8.534-4.267 12.8-8.533 2.134-2.134 3.2-4.267 4.267-6.4 1.067-2.134 2.133-4.267 4.267-6.4 4.266-4.267 4.266-12.8 4.266-17.067 0-4.267 0-12.8-4.266-17.067 0-4.266-4.267-8.533-8.534-12.8-2.133-2.133-4.266-3.2-6.4-4.266a22.315 22.315 0 0 1-6.4-4.267c-4.266-4.267-12.8-4.267-17.066-4.267H213.333c-12.8 0-21.333-4.266-29.866-12.8-8.534-8.533-12.8-17.066-12.8-29.866V213.333c0-12.8 4.266-21.333 12.8-29.866 8.533-8.534 17.066-12.8 29.866-12.8h597.334c12.8 0 21.333 4.266 29.866 12.8 8.534 8.533 12.8 17.066 12.8 29.866v213.334c0 12.8 4.267 21.333 12.8 29.866 8.534 8.534 17.067 12.8 29.867 12.8s21.333-4.266 29.867-12.8c8.533-8.533 12.8-17.066 12.8-29.866V213.333zM341.333 593.067c0 136.533 110.934 247.466 247.467 247.466a246.101 246.101 0 0 0 129.707-36.693l92.16 92.16c17.066 12.8 42.666 17.067 59.733 0s17.067-42.667 0-59.733l-88.533-88.534a246.357 246.357 0 0 0 54.4-154.666c0-136.534-110.934-247.467-247.467-247.467-136.533 0-247.467 110.933-247.467 247.467zm85.334 0c0-89.6 72.533-162.134 162.133-162.134 89.6 0 162.133 72.534 162.133 162.134 0 89.6-72.533 162.133-162.133 162.133-89.6 0-162.133-72.533-162.133-162.133z"
  }));
};

var SvgVipIcon = function SvgVipIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "vip_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M742.315 245.461a106.555 106.555 0 0 1 87.125 45.184l131.584 186.71a106.581 106.581 0 0 1-18.347 142.805L580.736 925.653a106.539 106.539 0 0 1-137.472 0L81.365 620.16A106.539 106.539 0 0 1 63.02 477.355l131.541-186.71a106.539 106.539 0 0 1 87.125-45.226h112L352 136.064l102.827 35.968L512 64l57.173 107.99L672 136.02l-41.685 109.44h112zm-460.63 85.078a21.419 21.419 0 0 0-17.536 9.13L132.565 526.38a21.419 21.419 0 0 0 3.712 28.757L498.176 860.63a21.461 21.461 0 0 0 27.648 0l361.899-305.493c8.533-7.168 10.112-19.627 3.712-28.757L759.85 339.669a21.461 21.461 0 0 0-17.494-9.13H281.643zm106.411 94.89L512 623.701 635.904 425.43a42.581 42.581 0 0 1 72.192 45.142L564.352 700.544a61.781 61.781 0 0 1-104.704 0L315.904 470.571a42.581 42.581 0 0 1 72.192-45.184z"
  }));
};

var SvgVolumeIcon = function SvgVolumeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "volume_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M743.253 118.741 381.44 291.84H228.267a121.6 121.6 0 0 0-121.6 121.685v147.371a121.6 121.6 0 0 0 121.6 121.643h157.226L742.06 857.94c80.81 39.766 175.274-19.072 175.274-109.184V228.48c0-89.515-93.354-148.395-174.08-109.739zm-496.81 725.59-40.406-128.086c5.12.64 10.24.982 15.531.982h186.027l26.581 87.168c15.744 51.541-13.013 99.84-66.005 110.933-50.347 10.581-106.283-22.059-121.728-70.997z"
  }));
};

var SvgWalletIcon = function SvgWalletIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "wallet_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 128a85.333 85.333 0 0 0-85.334 85.333v597.334A85.333 85.333 0 0 0 170.667 896h682.666a85.333 85.333 0 0 0 85.334-85.333V213.333A85.333 85.333 0 0 0 853.333 128H170.667zm682.666 256h-128a128 128 0 1 0 0 256h128v170.667H170.667V213.333h682.666V384zm0 170.667h-128a42.667 42.667 0 1 1 0-85.334h128v85.334z"
  }));
};

var SvgWeb3AssetsIcon = function SvgWeb3AssetsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_assets_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zM896 384H746.667a149.333 149.333 0 1 0 0 298.667H896v128a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333V384zm0 213.333H746.667a64 64 0 0 1 0-128H896v128z"
  }));
};

var SvgWeb3DappsIcon = function SvgWeb3DappsIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_dapps_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M927.317 386.56a85.333 85.333 0 0 0 0-120.661L791.552 130.133a85.333 85.333 0 0 0-120.661 0L535.125 265.9a85.333 85.333 0 0 0 0 120.661l135.766 135.765a85.333 85.333 0 0 0 120.661 0L927.317 386.56zM731.221 190.464l135.766 135.765L731.22 461.995 595.456 326.229l135.765-135.765zm-560.554-57.301a85.333 85.333 0 0 0-85.334 85.333v192a85.333 85.333 0 0 0 85.334 85.333h163.882A113.45 113.45 0 0 0 448 382.421V218.453a85.333 85.333 0 0 0-85.333-85.333h-192zm0 85.333h192v163.925a28.117 28.117 0 0 1-28.118 28.075H170.667v-192zm0 715.05a85.333 85.333 0 0 1-85.334-85.333v-192a85.333 85.333 0 0 1 85.334-85.333h163.882A113.45 113.45 0 0 1 448 684.33v163.883a85.333 85.333 0 0 1-85.333 85.334h-192zm0-85.333h192V684.331a28.117 28.117 0 0 0-28.118-28.118H170.667v192zm629.674 85.334a85.333 85.333 0 0 0 85.334-85.334v-192a85.333 85.333 0 0 0-85.334-85.333H636.46a113.45 113.45 0 0 0-113.494 113.45v163.883a85.333 85.333 0 0 0 85.334 85.334h192zm0-85.334h-192V684.331c0-15.531 12.587-28.118 28.118-28.118h163.84v192z"
  }));
};

var SvgWeb3Home1Icon = function SvgWeb3Home1Icon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_home1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M554.667 874.667a405.333 405.333 0 1 1 0-810.667 405.333 405.333 0 0 1 0 810.667zm0 64c259.2 0 469.333-210.134 469.333-469.334S813.867 0 554.667 0 85.333 210.133 85.333 469.333s210.134 469.334 469.334 469.334zm89.258-563.2h-37.802v188.928h37.802v-22.443h1.28a35.03 35.03 0 0 0 12.758 18.347c3.2 2.218 6.826 3.925 10.709 5.12 3.925 1.365 8.107 2.048 12.501 2.048 17.067 0 29.867-5.974 38.571-17.878 8.661-12.074 13.013-29.525 13.013-52.309 0-22.827-4.352-40.192-13.013-52.096-8.704-11.947-21.547-17.92-38.57-17.92a39.552 39.552 0 0 0-23.211 7.168 31.573 31.573 0 0 0-12.8 18.39h-1.28v-77.355zm42.368 153.941a23.04 23.04 0 0 1-17.621 7.424 29.995 29.995 0 0 1-17.877-5.12 17.493 17.493 0 0 1-6.87-14.507v-39.594c0-6.144 2.262-10.923 6.87-14.294a28.97 28.97 0 0 1 17.877-5.376 22.613 22.613 0 0 1 17.621 7.68c4.779 4.907 7.168 11.648 7.168 20.139v23.253c0 8.534-2.389 15.318-7.168 20.438zm-408.746 34.219-40.32-178.219h38.314l16.854 85.547 9.429 49.536h.768l11.221-49.494 19.67-85.546h42.368l19.925 85.504 10.965 49.536h.768l9.472-49.494 17.067-85.546h36.821l-41.386 178.176h-44.16l-22.486-96.512-8.661-39.04h-.768l-8.96 39.04-22.443 96.512H277.59zm249.13 3.072c-10.24 0-19.328-1.622-27.306-4.864a59.99 59.99 0 0 1-20.48-14.038 62.976 62.976 0 0 1-12.459-22.186 97.024 97.024 0 0 1-4.096-29.099c0-10.581 1.365-20.096 4.096-28.587 2.73-8.704 6.699-16.128 11.99-22.229 5.46-6.144 12.074-10.837 19.925-14.08 7.808-3.413 16.768-5.12 26.794-5.12 11.094 0 20.48 1.92 28.331 5.675 8.021 3.712 14.507 8.746 19.413 15.061 5.12 6.272 8.79 13.61 10.966 21.93 2.389 8.193 3.584 16.769 3.584 25.814v11.221h-86.059v2.048c0 8.832 2.39 15.915 7.168 21.163 4.779 5.12 12.245 7.68 22.485 7.68a35.84 35.84 0 0 0 19.158-4.608c4.906-3.2 9.514-7.04 13.781-11.477l18.859 23.466c-5.974 6.998-13.782 12.459-23.467 16.384a85.376 85.376 0 0 1-32.683 5.846zm-.768-112.342c-7.68 0-13.696 2.56-18.133 7.68-4.267 4.907-6.4 11.563-6.4 19.883v2.048h47.019v-2.261a31.744 31.744 0 0 0-5.632-19.67c-3.584-5.12-9.216-7.68-16.854-7.68zm275.627 1.536c9.557 0 16.47-1.792 20.693-5.376a17.408 17.408 0 0 0 6.656-13.781v-1.792a20.139 20.139 0 0 0-6.4-15.573c-4.096-3.883-9.941-5.846-17.621-5.846a38.827 38.827 0 0 0-20.139 5.59 46.677 46.677 0 0 0-16.085 15.573l-24.021-22.443c3.413-4.437 7.082-8.448 10.965-11.989 3.925-3.755 8.363-6.912 13.27-9.472 4.949-2.73 10.495-4.779 16.64-6.101 6.1-1.536 13.013-2.304 20.65-2.304 9.557 0 18.133 1.109 25.813 3.285 7.808 2.219 14.464 5.461 19.883 9.728a40.79 40.79 0 0 1 12.8 14.805 40.832 40.832 0 0 1 4.565 19.414 40.235 40.235 0 0 1-20.906 35.712 48.768 48.768 0 0 1-13.056 4.352v1.536c5.29 1.024 10.154 2.73 14.549 5.12 4.608 2.218 8.533 5.12 11.776 8.661 3.413 3.584 6.016 7.85 7.893 12.8 1.878 4.736 2.816 10.197 2.816 16.341 0 7.979-1.621 15.19-4.864 21.675a47.744 47.744 0 0 1-13.781 16.64c-5.973 4.565-13.099 8.107-21.419 10.667a100.267 100.267 0 0 1-27.605 3.584c-9.003 0-17.024-.939-23.979-2.816a75.179 75.179 0 0 1-18.389-7.382 72.107 72.107 0 0 1-13.525-10.965 90.752 90.752 0 0 1-9.984-13.056l28.373-21.93c3.883 7.295 8.661 13.354 14.293 18.133 5.76 4.565 13.526 6.869 23.211 6.869 8.704 0 15.403-2.133 20.181-6.4a22.827 22.827 0 0 0 7.424-17.835v-1.536c0-7.338-2.816-12.8-8.448-16.341-5.418-3.755-13.013-5.632-22.698-5.632H784.98v-31.915h16.598zm-727.979 201.6a21.333 21.333 0 0 0-36.48-22.101A256 256 0 0 0 384 989.696a21.333 21.333 0 0 0-21.333-36.95A213.333 213.333 0 0 1 73.515 657.494z"
  }));
};

var SvgWeb3HomeIcon = function SvgWeb3HomeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301 24.107-35.2-24.15 35.2zM362.667 640a42.667 42.667 0 1 0 0 85.333h298.666a42.667 42.667 0 1 0 0-85.333H362.667z"
  }));
};

var SvgWeb3RankIcon = function SvgWeb3RankIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_rank_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zm-42.667 128a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333v597.334a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333zM682.667 384A42.667 42.667 0 1 1 768 384v256a42.667 42.667 0 1 1-85.333 0V384zM512 426.667a42.667 42.667 0 0 0-42.667 42.666V640a42.667 42.667 0 1 0 85.334 0V469.333A42.667 42.667 0 0 0 512 426.667zM298.667 512A42.667 42.667 0 0 0 256 554.667V640a42.667 42.667 0 1 0 85.333 0v-85.333A42.667 42.667 0 0 0 298.667 512z"
  }));
};

var SvgWeb3SwapIcon = function SvgWeb3SwapIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_swap_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm187.563 437.077a10.667 10.667 0 0 0 7.509-18.219L554.667 309.333v85.334H341.333a42.667 42.667 0 0 0 0 85.333h256a42.59 42.59 0 0 0 4.694-.256h97.536zm-373.931 74.923a10.667 10.667 0 0 0-7.253 18.432l150.954 141.568V640h213.334a42.667 42.667 0 1 0 0-85.333H325.632z"
  }));
};

var SvgWechartIcon = function SvgWechartIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M16.247 8.253c.276 0 .548.02.818.05C16.33 4.916 12.67 2.4 8.495 2.4 3.825 2.4 0 5.55 0 9.549c0 2.308 1.273 4.204 3.4 5.674l-.85 2.529 2.969-1.474c1.063.208 1.915.422 2.976.422.266 0 .53-.013.792-.034a6.191 6.191 0 0 1-.262-1.76c0-3.673 3.187-6.653 7.222-6.653Zm-4.567-2.28c.64 0 1.063.418 1.063 1.05 0 .63-.423 1.052-1.063 1.052-.637 0-1.275-.422-1.275-1.052 0-.632.638-1.05 1.275-1.05ZM5.735 8.076c-.637 0-1.28-.422-1.28-1.052 0-.632.643-1.05 1.28-1.05s1.06.418 1.06 1.05c0 .63-.423 1.052-1.06 1.052ZM24 14.805c0-3.361-3.398-6.1-7.215-6.1-4.042 0-7.225 2.739-7.225 6.1 0 3.365 3.183 6.099 7.225 6.099.845 0 1.699-.21 2.548-.421l2.33 1.262-.639-2.1C22.73 18.379 24 16.7 24 14.805Zm-9.558-1.053c-.423 0-.85-.416-.85-.84 0-.42.427-.84.85-.84.643 0 1.063.42 1.063.84 0 .424-.42.84-1.063.84Zm4.672 0c-.42 0-.843-.416-.843-.84 0-.42.424-.84.843-.84.637 0 1.063.42 1.063.84 0 .424-.426.84-1.063.84Z"
  }));
};

var SvgWifiIcon = function SvgWifiIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "wifi_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M556.245 486.357a95.147 95.147 0 0 0-134.57 0l-1.878 1.92-178.773-178.773a32.597 32.597 0 0 0-46.08 0C54.827 449.621 61.739 683.691 210.347 832.341c148.65 148.651 382.72 155.563 522.837 15.446a32.597 32.597 0 0 0 0-46.123L554.368 622.805l1.877-1.877a95.147 95.147 0 0 0 0-134.57zM463.36 96.597a42.667 42.667 0 0 1 41.813-43.52 469.333 469.333 0 0 1 478.55 459.776 42.667 42.667 0 0 1-85.334 1.707 384 384 0 0 0-391.552-376.15 42.667 42.667 0 0 1-43.52-41.813zm4.267 212.95a42.667 42.667 0 0 1 41.813-43.52A256 256 0 0 1 770.475 516.82a42.667 42.667 0 1 1-85.334 1.707A170.667 170.667 0 0 0 511.104 351.36a42.667 42.667 0 0 1-43.52-41.813z"
  }));
};

var SvgWithdrawIcon = function SvgWithdrawIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "withdraw_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M128 597.333A42.667 42.667 0 0 1 170.667 640v170.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V640a42.667 42.667 0 1 1 85.334 0v170.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V640A42.667 42.667 0 0 1 128 597.333zM268.501 371.5a42.667 42.667 0 0 0 60.331 0l140.501-140.502V640a42.667 42.667 0 1 0 85.334 0V230.997L695.168 371.5a42.667 42.667 0 1 0 60.33-60.331L542.166 97.835A42.496 42.496 0 0 0 512 85.333m-.427 0a42.539 42.539 0 0 0-29.738 12.502L268.5 311.168a42.667 42.667 0 0 0 0 60.33"
  }));
};

var SvgXCircleIcon = function SvgXCircleIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "x_circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm627.498-158.165a42.667 42.667 0 0 1 0 60.33L572.331 512l97.834 97.835a42.667 42.667 0 0 1-60.33 60.33L512 572.331l-97.835 97.834a42.667 42.667 0 0 1-60.33-60.33L451.669 512l-97.834-97.835a42.667 42.667 0 0 1 60.33-60.33L512 451.669l97.835-97.834a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgXIcon = function SvgXIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M17.751 3h3.067l-6.7 7.625L22 21h-6.172l-4.833-6.293L5.464 21h-3.07l7.167-8.155L2 3h6.328l4.37 5.752L17.75 3Zm-1.076 16.172h1.7L7.404 4.732H5.58l11.094 14.44Z"
  }));
};

var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), createElement("path", {
    fill: "currentColor",
    d: "M22.581 7.07c-.466-1.53-.832-2.378-2.375-2.562 0 0-4.132-.208-8.241-.208-4.062 0-8.102.208-8.102.208-1.636.184-2.025 1.079-2.444 2.563 0 0-.419 2.363-.419 4.756 0 2.454.419 4.94.419 4.94.326 1.438.995 2.379 2.444 2.563 0 0 4.484.278 8.754.278 3.883 0 7.59-.278 7.59-.278 1.45-.277 1.955-1.032 2.374-2.562 0 0 .419-2.273.419-4.618 0-2.499-.419-5.08-.419-5.08ZM9.801 16.01V7.836l6.355 4.086L9.8 16.01Z"
  }));
};

export { SvgAccountswitchIcon as AccountswitchIcon, SvgAddIcon as AddIcon, SvgAddSolidIcon as AddSolidIcon, SvgAdddecIcon as AdddecIcon, SvgAirdropIcon as AirdropIcon, SvgAlertCircleSolidIcon as AlertCircleSolidIcon, SvgAlertTriangleSolidIcon as AlertTriangleSolidIcon, SvgAngleIcon as AngleIcon, SvgApplynowIcon as ApplynowIcon, SvgArrowIcon as ArrowIcon, SvgArrowchevron2DownIcon as Arrowchevron2DownIcon, SvgArrowchevron2LeftIcon as Arrowchevron2LeftIcon, SvgArrowchevron2RightIcon as Arrowchevron2RightIcon, SvgArrowchevron2UpIcon as Arrowchevron2UpIcon, SvgArrowchevronDownIcon as ArrowchevronDownIcon, SvgArrowchevronLeftIcon as ArrowchevronLeftIcon, SvgArrowchevronRightIcon as ArrowchevronRightIcon, SvgArrowchevronUpIcon as ArrowchevronUpIcon, SvgArrowdownIcon as ArrowdownIcon, SvgArrowleftIcon as ArrowleftIcon, SvgArrowmoreIcon as ArrowmoreIcon, SvgArrowrightIcon as ArrowrightIcon, SvgArrowupIcon as ArrowupIcon, SvgAssethistoryIcon as AssethistoryIcon, SvgAssetsMoreIcon as AssetsMoreIcon, SvgAssureIcon as AssureIcon, SvgBaseIcon as BaseIcon, SvgBatchIcon as BatchIcon, SvgBellIcon as BellIcon, SvgBookIcon as BookIcon, SvgBotIcon as BotIcon, SvgBottomLeftIcon as BottomLeftIcon, SvgBottomRightIcon as BottomRightIcon, SvgBrokenIcon as BrokenIcon, SvgBuyIcon as BuyIcon, SvgCalculatorIcon as CalculatorIcon, SvgCexHomeIcon as CexHomeIcon, SvgChartIcon as ChartIcon, SvgCheckCircleIcon as CheckCircleIcon, SvgCheckIcon as CheckIcon, SvgCircleIcon as CircleIcon, SvgCirclepromptIcon as CirclepromptIcon, SvgClearIcon as ClearIcon, SvgCloseIcon as CloseIcon, SvgCoinComingIcon as CoinComingIcon, SvgCoinCountdownIcon as CoinCountdownIcon, SvgCoinIneffectIcon as CoinIneffectIcon, SvgCoinProtectIcon as CoinProtectIcon, SvgCoinRemovedIcon as CoinRemovedIcon, SvgCoinWarnIcon as CoinWarnIcon, SvgCommentIcon as CommentIcon, SvgContinuousdrawingIcon as ContinuousdrawingIcon, SvgCopyIcon as CopyIcon, SvgCopytradingIcon as CopytradingIcon, SvgCouponIcon as CouponIcon, SvgCrossIcon as CrossIcon, SvgCumulativeincomeIcon as CumulativeincomeIcon, SvgCutoverIcon as CutoverIcon, SvgDAppsIcon as DAppsIcon, SvgDataIcon as DataIcon, SvgDateIcon as DateIcon, SvgDepositIcon as DepositIcon, SvgDetailsIcon as DetailsIcon, SvgDirectiondownIcon as DirectiondownIcon, SvgDirectionleftIcon as DirectionleftIcon, SvgDirectionrightIcon as DirectionrightIcon, SvgDirectionupIcon as DirectionupIcon, SvgDiscordIcon as DiscordIcon, SvgDisplayIcon as DisplayIcon, SvgDownload2Icon as Download2Icon, SvgDownloadIcon as DownloadIcon, SvgDragdropIcon as DragdropIcon, SvgDrawingIcon as DrawingIcon, SvgEarnestMoneyIcon as EarnestMoneyIcon, SvgEarningstodayIcon as EarningstodayIcon, SvgEarphoneIcon as EarphoneIcon, SvgEditIcon as EditIcon, SvgEmptyIcon as EmptyIcon, SvgExchangeIcon as ExchangeIcon, SvgExitDrawingIcon as ExitDrawingIcon, SvgExpandIcon as ExpandIcon, SvgExtendIcon as ExtendIcon, SvgEyeoffIcon as EyeoffIcon, SvgEyeonIcon as EyeonIcon, SvgFacebookIcon as FacebookIcon, SvgFiatdepositIcon as FiatdepositIcon, SvgFilterIcon as FilterIcon, SvgFilterPressed1Icon as FilterPressed1Icon, SvgFluctuationIcon as FluctuationIcon, SvgFoldIcon as FoldIcon, SvgFollowersIcon as FollowersIcon, SvgFullscreenOffIcon as FullscreenOffIcon, SvgFullscreenOnIcon as FullscreenOnIcon, SvgGiftIcon as GiftIcon, SvgGithubIcon as GithubIcon, SvgGlobeIcon as GlobeIcon, SvgGoogleIcon as GoogleIcon, SvgGuideIcon as GuideIcon, SvgHalfscreenOffIcon as HalfscreenOffIcon, SvgHalfscreenOnIcon as HalfscreenOnIcon, SvgHelpCircleSolidIcon as HelpCircleSolidIcon, SvgHelpIcon as HelpIcon, SvgHighindexIcon as HighindexIcon, SvgHomeIcon as HomeIcon, SvgHotkeyIcon as HotkeyIcon, SvgIconCompassIcon as IconCompassIcon, SvgImIcon as ImIcon, SvgImportIcon as ImportIcon, SvgIndicatorsIcon as IndicatorsIcon, SvgInformationdisclosureIcon as InformationdisclosureIcon, SvgInstagramIcon as InstagramIcon, SvgJobmanagementIcon as JobmanagementIcon, SvgKlineEntranceAppIcon as KlineEntranceAppIcon, SvgKtvAreaIcon as KtvAreaIcon, SvgKtvBarsIcon as KtvBarsIcon, SvgKtvBaselineIcon as KtvBaselineIcon, SvgKtvCandlesIcon as KtvCandlesIcon, SvgKtvHeikinashiIcon as KtvHeikinashiIcon, SvgKtvHollowcandlesIcon as KtvHollowcandlesIcon, SvgKtvLineIcon as KtvLineIcon, SvgLabelUpgradeIcon as LabelUpgradeIcon, SvgLayerIcon as LayerIcon, SvgLevelIcon as LevelIcon, SvgLine1Icon as Line1Icon, SvgLine2Icon as Line2Icon, SvgLineBoldIcon as LineBoldIcon, SvgLineDottedIcon as LineDottedIcon, SvgLinePointIcon as LinePointIcon, SvgLinkIcon as LinkIcon, SvgLinkinIcon as LinkinIcon, SvgListIcon as ListIcon, SvgLoadingIcon as LoadingIcon, SvgLockIcon as LockIcon, SvgLogOutIcon as LogOutIcon, SvgLowindexIcon as LowindexIcon, SvgMagneticIcon as MagneticIcon, SvgMailIcon as MailIcon, SvgManualIcon as ManualIcon, SvgMapPinIcon as MapPinIcon, SvgMarketIcon as MarketIcon, SvgMediumIcon as MediumIcon, SvgMenuIcon as MenuIcon, SvgMoonIcon as MoonIcon, SvgMorehorizontalIcon as MorehorizontalIcon, SvgNewcomerIcon as NewcomerIcon, SvgNewsIcon as NewsIcon, SvgOrderIcon as OrderIcon, SvgOrdersIcon as OrdersIcon, SvgOriginalorderIcon as OriginalorderIcon, SvgOverviewIcon as OverviewIcon, SvgPadIcon as PadIcon, SvgParallelIcon as ParallelIcon, SvgPcIcon as PcIcon, SvgPencilIcon as PencilIcon, SvgPerpIcon as PerpIcon, SvgPhoneIcon as PhoneIcon, SvgPinIcon as PinIcon, SvgPlacardIcon as PlacardIcon, SvgPlaceanorderIcon as PlaceanorderIcon, SvgPlusIcon as PlusIcon, SvgPm1Icon as Pm1Icon, SvgPutawayIcon as PutawayIcon, SvgPutawayLeftIcon as PutawayLeftIcon, SvgQrCodeIcon as QrCodeIcon, SvgQuickjumpIcon as QuickjumpIcon, SvgQuoraIcon as QuoraIcon, SvgQuotesCutoverIcon as QuotesCutoverIcon, SvgRateIcon as RateIcon, SvgRaysIcon as RaysIcon, SvgRectangleIcon as RectangleIcon, SvgRecurringbuyIcon as RecurringbuyIcon, SvgRedditIcon as RedditIcon, SvgReduceIcon as ReduceIcon, SvgRefreshIcon as RefreshIcon, SvgRemoveIcon as RemoveIcon, SvgRemoveSolidIcon as RemoveSolidIcon, SvgResourceIcon as ResourceIcon, SvgRetraceIcon as RetraceIcon, SvgRewardsIcon as RewardsIcon, SvgRmIcon as RmIcon, SvgRulerIcon as RulerIcon, SvgSafetyIcon as SafetyIcon, SvgScanIcon as ScanIcon, SvgScreenshotIcon as ScreenshotIcon, SvgSearchIcon as SearchIcon, SvgSectorIcon as SectorIcon, SvgServiceIcon as ServiceIcon, SvgSettingIcon as SettingIcon, SvgSettingKlineIcon as SettingKlineIcon, SvgShareIcon as ShareIcon, SvgSortDefault1Icon as SortDefault1Icon, SvgSortIcon as SortIcon, SvgSpotIcon as SpotIcon, SvgSpsxIcon as SpsxIcon, SvgSpsxNew1Icon as SpsxNew1Icon, SvgSquareIcon as SquareIcon, SvgStarnoIcon as StarnoIcon, SvgStaryesIcon as StaryesIcon, SvgStrategyIcon as StrategyIcon, SvgStrategyhistoryIcon as StrategyhistoryIcon, SvgStratrgyorderIcon as StratrgyorderIcon, SvgSubtractIcon as SubtractIcon, SvgSunIcon as SunIcon, SvgSystemExchangeAppIcon as SystemExchangeAppIcon, SvgSystemExchangeWebIcon as SystemExchangeWebIcon, SvgTacticsIcon as TacticsIcon, SvgTaskIcon as TaskIcon, SvgTelegramIcon as TelegramIcon, SvgTerminateIcon as TerminateIcon, SvgThumbsDownIcon as ThumbsDownIcon, SvgThumbsUpIcon as ThumbsUpIcon, SvgTogglechartIcon as TogglechartIcon, SvgTopLeftIcon as TopLeftIcon, SvgTopRightIcon as TopRightIcon, SvgTradingIcon as TradingIcon, SvgTradingbotIcon as TradingbotIcon, SvgTransferassetsIcon as TransferassetsIcon, SvgTransforIcon as TransforIcon, SvgTransmitterIcon as TransmitterIcon, SvgTrashIcon as TrashIcon, SvgTrendlIcon as TrendlIcon, SvgTwoColor0Risk as TwoColor0Risk, SvgTwoColorActiveOrders as TwoColorActiveOrders, SvgTwoColorAdd as TwoColorAdd, SvgTwoColorAddOrders as TwoColorAddOrders, SvgTwoColorAffiliate as TwoColorAffiliate, SvgTwoColorAiScan as TwoColorAiScan, SvgTwoColorAirdrop as TwoColorAirdrop, SvgTwoColorAlert as TwoColorAlert, SvgTwoColorAnnouncement as TwoColorAnnouncement, SvgTwoColorAnnouncements as TwoColorAnnouncements, SvgTwoColorApex as TwoColorApex, SvgTwoColorApi as TwoColorApi, SvgTwoColorAprBoost as TwoColorAprBoost, SvgTwoColorApyCalculator as TwoColorApyCalculator, SvgTwoColorAssetHistory as TwoColorAssetHistory, SvgTwoColorAssetUp as TwoColorAssetUp, SvgTwoColorAssetsTools as TwoColorAssetsTools, SvgTwoColorAssettOrders as TwoColorAssettOrders, SvgTwoColorAudit as TwoColorAudit, SvgTwoColorAutoSavings as TwoColorAutoSavings, SvgTwoColorBail as TwoColorBail, SvgTwoColorBill as TwoColorBill, SvgTwoColorBiometrics as TwoColorBiometrics, SvgTwoColorBirthday as TwoColorBirthday, SvgTwoColorBlockTrade as TwoColorBlockTrade, SvgTwoColorBlog as TwoColorBlog, SvgTwoColorBonusDerivatives as TwoColorBonusDerivatives, SvgTwoColorBotChart as TwoColorBotChart, SvgTwoColorBroker as TwoColorBroker, SvgTwoColorBuilding as TwoColorBuilding, SvgTwoColorBuy as TwoColorBuy, SvgTwoColorBuyCrypto as TwoColorBuyCrypto, SvgTwoColorBvn as TwoColorBvn, SvgTwoColorBybitCard as TwoColorBybitCard, SvgTwoColorBybitCardBonus as TwoColorBybitCardBonus, SvgTwoColorBybitEarn as TwoColorBybitEarn, SvgTwoColorBybitMall as TwoColorBybitMall, SvgTwoColorBybitSaving as TwoColorBybitSaving, SvgTwoColorBystart as TwoColorBystart, SvgTwoColorCalendar as TwoColorCalendar, SvgTwoColorCalendarChart as TwoColorCalendarChart, SvgTwoColorCamera as TwoColorCamera, SvgTwoColorCampaignList as TwoColorCampaignList, SvgTwoColorCandleChart as TwoColorCandleChart, SvgTwoColorCapital as TwoColorCapital, SvgTwoColorCelebration as TwoColorCelebration, SvgTwoColorChartScreen as TwoColorChartScreen, SvgTwoColorChaseLimitOrders as TwoColorChaseLimitOrders, SvgTwoColorClaimYields as TwoColorClaimYields, SvgTwoColorCnpj as TwoColorCnpj, SvgTwoColorCollateral as TwoColorCollateral, SvgTwoColorColumnChart as TwoColorColumnChart, SvgTwoColorCommunity as TwoColorCommunity, SvgTwoColorConnection as TwoColorConnection, SvgTwoColorContactSupport as TwoColorContactSupport, SvgTwoColorContracttransaction as TwoColorContracttransaction, SvgTwoColorConvert as TwoColorConvert, SvgTwoColorCopyTrading as TwoColorCopyTrading, SvgTwoColorCouponBuyCrypto as TwoColorCouponBuyCrypto, SvgTwoColorCouponDerivatives as TwoColorCouponDerivatives, SvgTwoColorCpf as TwoColorCpf, SvgTwoColorCreateBot as TwoColorCreateBot, SvgTwoColorCsLiveChat as TwoColorCsLiveChat, SvgTwoColorCtAutomatedStrategy as TwoColorCtAutomatedStrategy, SvgTwoColorCtMySubscriber as TwoColorCtMySubscriber, SvgTwoColorCtProfitShare as TwoColorCtProfitShare, SvgTwoColorCtWatchlist as TwoColorCtWatchlist, SvgTwoColorDcaTrading as TwoColorDcaTrading, SvgTwoColorDcaTradingBot as TwoColorDcaTradingBot, SvgTwoColorDemoTrading as TwoColorDemoTrading, SvgTwoColorDeposit as TwoColorDeposit, SvgTwoColorDerivatives as TwoColorDerivatives, SvgTwoColorDerivatves as TwoColorDerivatves, SvgTwoColorDiscountBuy as TwoColorDiscountBuy, SvgTwoColorDocuments as TwoColorDocuments, SvgTwoColorDoubleWin as TwoColorDoubleWin, SvgTwoColorDownTrend as TwoColorDownTrend, SvgTwoColorDriver as TwoColorDriver, SvgTwoColorDualAsset as TwoColorDualAsset, SvgTwoColorEdit as TwoColorEdit, SvgTwoColorEmail as TwoColorEmail, SvgTwoColorEndedBots as TwoColorEndedBots, SvgTwoColorEth20 as TwoColorEth20, SvgTwoColorEvents as TwoColorEvents, SvgTwoColorExplore as TwoColorExplore, SvgTwoColorFaceId as TwoColorFaceId, SvgTwoColorFeeDiscountMaker as TwoColorFeeDiscountMaker, SvgTwoColorFeeDiscountRewards as TwoColorFeeDiscountRewards, SvgTwoColorFeeDiscountTaker as TwoColorFeeDiscountTaker, SvgTwoColorFeedbacks as TwoColorFeedbacks, SvgTwoColorFiatDeposit as TwoColorFiatDeposit, SvgTwoColorFile as TwoColorFile, SvgTwoColorFingerprint as TwoColorFingerprint, SvgTwoColorFunding as TwoColorFunding, SvgTwoColorFuturesComboBot as TwoColorFuturesComboBot, SvgTwoColorFuturesGrid as TwoColorFuturesGrid, SvgTwoColorFuturesMartingale as TwoColorFuturesMartingale, SvgTwoColorGeneralRewards as TwoColorGeneralRewards, SvgTwoColorGift as TwoColorGift, SvgTwoColorGiveaway as TwoColorGiveaway, SvgTwoColorGiveawayCreate as TwoColorGiveawayCreate, SvgTwoColorGiveawayJoin as TwoColorGiveawayJoin, SvgTwoColorGlobe as TwoColorGlobe, SvgTwoColorGoUp as TwoColorGoUp, SvgTwoColorGrade as TwoColorGrade, SvgTwoColorGuide as TwoColorGuide, SvgTwoColorGuideBook as TwoColorGuideBook, SvgTwoColorHelp as TwoColorHelp, SvgTwoColorHelpCenter as TwoColorHelpCenter, SvgTwoColorHighLeverage as TwoColorHighLeverage, SvgTwoColorHigherDiagram as TwoColorHigherDiagram, SvgTwoColorHistory as TwoColorHistory, SvgTwoColorHnwi as TwoColorHnwi, SvgTwoColorHoldMoney as TwoColorHoldMoney, SvgTwoColorHourgrass as TwoColorHourgrass, SvgTwoColorIceberg as TwoColorIceberg, SvgTwoColorId as TwoColorId, SvgTwoColorInfo as TwoColorInfo, SvgTwoColorInstitutes as TwoColorInstitutes, SvgTwoColorInviteFriends as TwoColorInviteFriends, SvgTwoColorKey as TwoColorKey, SvgTwoColorKyc as TwoColorKyc, SvgTwoColorKycId as TwoColorKycId, SvgTwoColorLaunch as TwoColorLaunch, SvgTwoColorLaunchpad as TwoColorLaunchpad, SvgTwoColorLaunchpool as TwoColorLaunchpool, SvgTwoColorLeaderboard as TwoColorLeaderboard, SvgTwoColorLearn as TwoColorLearn, SvgTwoColorLending as TwoColorLending, SvgTwoColorLendingCoinList as TwoColorLendingCoinList, SvgTwoColorLeveragedTokens as TwoColorLeveragedTokens, SvgTwoColorLineChart as TwoColorLineChart, SvgTwoColorLiquidityMining as TwoColorLiquidityMining, SvgTwoColorLock as TwoColorLock, SvgTwoColorLowerDiagram as TwoColorLowerDiagram, SvgTwoColorLpYields as TwoColorLpYields, SvgTwoColorMap as TwoColorMap, SvgTwoColorMarginTrading as TwoColorMarginTrading, SvgTwoColorMenuOverview as TwoColorMenuOverview, SvgTwoColorMore as TwoColorMore, SvgTwoColorMt4 as TwoColorMt4, SvgTwoColorMyFeeRates as TwoColorMyFeeRates, SvgTwoColorNetwork as TwoColorNetwork, SvgTwoColorNews as TwoColorNews, SvgTwoColorNft as TwoColorNft, SvgTwoColorNotificationCenter as TwoColorNotificationCenter, SvgTwoColorOneClickBuy as TwoColorOneClickBuy, SvgTwoColorOptions as TwoColorOptions, SvgTwoColorOtcFeeRate as TwoColorOtcFeeRate, SvgTwoColorOtcPremiumPricing as TwoColorOtcPremiumPricing, SvgTwoColorOtcTrading as TwoColorOtcTrading, SvgTwoColorP2P as TwoColorP2P, SvgTwoColorPassport as TwoColorPassport, SvgTwoColorPayout as TwoColorPayout, SvgTwoColorPhone as TwoColorPhone, SvgTwoColorPicture as TwoColorPicture, SvgTwoColorPledgedEth as TwoColorPledgedEth, SvgTwoColorPositionBuilder as TwoColorPositionBuilder, SvgTwoColorProtection as TwoColorProtection, SvgTwoColorPublicInformation as TwoColorPublicInformation, SvgTwoColorReceive as TwoColorReceive, SvgTwoColorRedeem as TwoColorRedeem, SvgTwoColorReduce as TwoColorReduce, SvgTwoColorReferral as TwoColorReferral, SvgTwoColorReferral1 as TwoColorReferral1, SvgTwoColorReferral2 as TwoColorReferral2, SvgTwoColorRepayment as TwoColorRepayment, SvgTwoColorReset as TwoColorReset, SvgTwoColorResidence as TwoColorResidence, SvgTwoColorReturns as TwoColorReturns, SvgTwoColorRewards as TwoColorRewards, SvgTwoColorRewardsHub as TwoColorRewardsHub, SvgTwoColorScaledOrder as TwoColorScaledOrder, SvgTwoColorSearch as TwoColorSearch, SvgTwoColorSecurity as TwoColorSecurity, SvgTwoColorSecurityAlert as TwoColorSecurityAlert, SvgTwoColorSecurityKey as TwoColorSecurityKey, SvgTwoColorSecurityLock as TwoColorSecurityLock, SvgTwoColorSend as TwoColorSend, SvgTwoColorSettings as TwoColorSettings, SvgTwoColorSettlement as TwoColorSettlement, SvgTwoColorSharkfin as TwoColorSharkfin, SvgTwoColorSmartContract as TwoColorSmartContract, SvgTwoColorSmartLeverage as TwoColorSmartLeverage, SvgTwoColorSpeedAction as TwoColorSpeedAction, SvgTwoColorSpot as TwoColorSpot, SvgTwoColorSpotGrid as TwoColorSpotGrid, SvgTwoColorSpotX as TwoColorSpotX, SvgTwoColorStakeAssets as TwoColorStakeAssets, SvgTwoColorStaking as TwoColorStaking, SvgTwoColorStakingAssets as TwoColorStakingAssets, SvgTwoColorStrategyAlert as TwoColorStrategyAlert, SvgTwoColorSubaccount as TwoColorSubaccount, SvgTwoColorTarget as TwoColorTarget, SvgTwoColorTasks as TwoColorTasks, SvgTwoColorTerminate as TwoColorTerminate, SvgTwoColorThumbsUp as TwoColorThumbsUp, SvgTwoColorTime as TwoColorTime, SvgTwoColorToPledgeMoney as TwoColorToPledgeMoney, SvgTwoColorTokenSplash as TwoColorTokenSplash, SvgTwoColorToolsDiscovery as TwoColorToolsDiscovery, SvgTwoColorTradingBot as TwoColorTradingBot, SvgTwoColorTradingGpt as TwoColorTradingGpt, SvgTwoColorTradingVoucher as TwoColorTradingVoucher, SvgTwoColorTransfer as TwoColorTransfer, SvgTwoColorTransfer1 as TwoColorTransfer1, SvgTwoColorTransferIn as TwoColorTransferIn, SvgTwoColorTransferOut as TwoColorTransferOut, SvgTwoColorTwap as TwoColorTwap, SvgTwoColorUnlock as TwoColorUnlock, SvgTwoColorUpTrend as TwoColorUpTrend, SvgTwoColorUpdates as TwoColorUpdates, SvgTwoColorUpgrade as TwoColorUpgrade, SvgTwoColorUsdc as TwoColorUsdc, SvgTwoColorUta as TwoColorUta, SvgTwoColorVerifiedAd as TwoColorVerifiedAd, SvgTwoColorVip as TwoColorVip, SvgTwoColorVolatileMarket as TwoColorVolatileMarket, SvgTwoColorVotes as TwoColorVotes, SvgTwoColorVotingVoucher as TwoColorVotingVoucher, SvgTwoColorWeathManagement as TwoColorWeathManagement, SvgTwoColorWeb3 as TwoColorWeb3, SvgTwoColorWebhookSignal as TwoColorWebhookSignal, SvgTwoColorWithdraw as TwoColorWithdraw, SvgTwoColorYield as TwoColorYield, SvgTwoColorbot as TwoColorbot, SvgUnblockIcon as UnblockIcon, SvgUpcomingIcon as UpcomingIcon, SvgUptoIcon as UptoIcon, SvgUsdcIcon as UsdcIcon, SvgUserIcon as UserIcon, SvgVerticalIcon as VerticalIcon, SvgVideoIcon as VideoIcon, SvgViewProfileIcon as ViewProfileIcon, SvgVipIcon as VipIcon, SvgVolumeIcon as VolumeIcon, SvgWalletIcon as WalletIcon, SvgWeb3AssetsIcon as Web3AssetsIcon, SvgWeb3DappsIcon as Web3DappsIcon, SvgWeb3Home1Icon as Web3Home1Icon, SvgWeb3HomeIcon as Web3HomeIcon, SvgWeb3RankIcon as Web3RankIcon, SvgWeb3SwapIcon as Web3SwapIcon, SvgWechartIcon as WechartIcon, SvgWifiIcon as WifiIcon, SvgWithdrawIcon as WithdrawIcon, SvgXCircleIcon as XCircleIcon, SvgXIcon as XIcon, SvgYoutubeIcon as YoutubeIcon };
//# sourceMappingURL=moly-icons.esm.js.map
